(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    function closeAccordion(acc) {
    var t = acc.querySelector('[data-accordion-trigger]');
    var c = acc.querySelector('[data-accordion-content]');
    var i = acc.querySelector('[data-accordion-icon]');
    var l = acc.querySelector('[data-accordion-list]');
    if (t) t.setAttribute('aria-expanded', 'false');
    if (i) i.style.transform = '';
    if (l) { l.style.transitionDelay = '0s'; l.style.opacity = '0'; }
    if (c) {
      clearTimeout(c._closeTimer);
      c._closeTimer = setTimeout(function() {
        if (t && t.getAttribute('aria-expanded') !== 'true') {
          c.style.gridTemplateRows = '';
        }
      }, 300);
    }
  }

  function openAccordion(acc) {
    var t = acc.querySelector('[data-accordion-trigger]');
    var c = acc.querySelector('[data-accordion-content]');
    var i = acc.querySelector('[data-accordion-icon]');
    var l = acc.querySelector('[data-accordion-list]');
    if (t) t.setAttribute('aria-expanded', 'true');
    if (c) {
      clearTimeout(c._closeTimer);
      c.style.gridTemplateRows = '1fr';
    }
    if (i) {
      i.style.transform = 'rotate(180deg)';
    }
    if (l) {
      l.style.opacity = '0';
      l.style.transitionDelay = '300ms';
      l.style.opacity = '1';
    }
  }
  document.querySelectorAll('[data-accordion]').forEach(function(accordion) {
    var trigger = accordion.querySelector('[data-accordion-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function() {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      if (open) {
        closeAccordion(accordion);
      } else {
        accordion.parentElement.querySelectorAll('[data-accordion]').forEach(function(sibling) {
          if (sibling !== accordion) closeAccordion(sibling);
        });
        openAccordion(accordion);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["background-video-script"] && !Shopify.designMode) return;
  try {
    /*
   * Background-video playback gate.
   *
   * A section with both a desktop and a mobile video renders BOTH <video> elements and
   * lets the breakpoint classes (`hidden md:block` / `md:hidden`) hide one. That hides
   * it visually only: an autoplaying <video> is downloaded and played even while its
   * container is display:none, and `preload` is ignored once `autoplay` is set. Measured
   * on staging 2026-09-14 at a 390x844 viewport, the homepage pulled BOTH files —
   * 20.5 MB + 20.8 MB = 41.3 MB — and the off-screen one reported paused:false with 24s
   * buffered.
   *
   * So `autoplay` is gone from the markup and `preload` is 'none'; nothing is fetched
   * until play() is called here. Behaviour on screen is unchanged — the visible video
   * still starts on its own, muted and looping, over the poster
   * snippets/background-video.liquid renders beneath it.
   *
   * Three gates, all of which must pass:
   *   - the wrapper's breakpoint is the active one (offsetParent is null under
   *     display:none, which is exactly what the hidden variant has)
   *   - the wrapper is at or near the viewport (a section further down the page no
   *     longer downloads its video before anyone has scrolled to it)
   *   - no ancestor carries data-background-video-inactive
   *
   * prefers-reduced-motion: reduce suppresses the hero's playback (the only caller that
   * sets data-background-video-reduced-motion) and leaves the poster frame showing — the
   * treatment the other 20 files in this theme already give motion.
   * That is a partial answer to WCAG 2.2.2, not a complete one: these videos loop
   * indefinitely under content, and a real pause control is new UI with no Figma frame,
   * so it is raised in the PR notes rather than invented here.
   */
  (function () {
    if (window.__backgroundVideoGateReady) return;
    window.__backgroundVideoGateReady = true;

    function init() {
      var wrappers = [];
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var inView = new WeakSet();

      function sync(wrapper) {
        // data-background-video sits on a wrapper (snippets/background-video.liquid) or on
        // the <video> itself (product-about, brewing guide).
        var video = wrapper.tagName === 'VIDEO' ? wrapper : wrapper.querySelector('video');
        if (!video) return;
        // Reduced motion suppresses the hero only, as on main. Every other background video
        // keeps the reduced-motion behaviour it had while it autoplayed: product-about.liquid
        // hides its video itself (motion-reduce:hidden, caught by the offsetParent check
        // below) and colour-promo, flavour-category, whittards-wisdom-content and the
        // brewing guide never opted out, so none of them changes here.
        var motionAllowed = !reduceMotion.matches || !wrapper.hasAttribute('data-background-video-reduced-motion');
        // offsetParent is null when this wrapper (or an ancestor) is display:none.
        var active = wrapper.offsetParent !== null &&
          inView.has(wrapper) &&
          !wrapper.closest('[data-background-video-inactive]') &&
          motionAllowed;
        if (active) {
          if (video.preload !== 'auto') video.preload = 'auto';
          if (video.paused) {
            var played = video.play();
            // Autoplay policy can still reject; the poster frame stays, so swallow it.
            if (played && typeof played.catch === 'function') played.catch(function () {});
          }
        } else if (!video.paused) {
          video.pause();
        }
      }

      function syncAll() {
        wrappers.forEach(sync);
      }

      var io = 'IntersectionObserver' in window
        ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              inView.add(entry.target);
            } else {
              inView.delete(entry.target);
            }
            sync(entry.target);
          });
        }, { rootMargin: '200px 0px' })
        : null;

      function track(root) {
        var found = root.querySelectorAll('[data-background-video]');
        for (var i = 0; i < found.length; i++) {
          if (wrappers.indexOf(found[i]) !== -1) continue;
          wrappers.push(found[i]);
          if (io) {
            io.observe(found[i]);
          } else {
            inView.add(found[i]);
            sync(found[i]);
          }
        }
      }

      track(document);

      /* Theme editor: a re-rendered section arrives as new markup with no autoplay, so
         without this its video would sit on the poster until the page was reloaded.
         Wrappers the editor removed are dropped first so they are not held in memory. */
      document.addEventListener('shopify:section:load', function (event) {
        wrappers = wrappers.filter(function (w) {
          if (w.isConnected) return true;
          if (io) io.unobserve(w);
          return false;
        });
        track(event.target);
      });

      /* The observer does re-fire when a target or an ancestor toggles display:none (it
         reports a display:none target as not intersecting; checked in Chrome and WebKit),
         which is what plays and pauses the brewing guide's per-recipe videos as recipes
         are switched. Re-syncing on resize as well covers a breakpoint crossing cheaply. */
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncAll, 150);
      }, { passive: true });

      document.addEventListener('background-video:sync', syncAll);

      if (typeof reduceMotion.addEventListener === 'function') {
        reduceMotion.addEventListener('change', syncAll);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-article-products-script"] && !Shopify.designMode) return;
  try {
    ;(function () {
    function main() {
      if (!window.ProductCarouselEngine) return;
      document.querySelectorAll('[data-blog-pc]').forEach(function (el) {
        window.ProductCarouselEngine(el, { prefix: 'data-blog-pc' });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', main);
    } else {
      main();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-article-video-script"] && !Shopify.designMode) return;
  try {
    ;(function () {

    var IDLE_MS = 2000;

    function init(root) {
      if (root.__blogArticleVideoReady) return;
      root.__blogArticleVideoReady = true;

      // A player renders one media element, or two when the entry supplies a
      // mobile source (one per breakpoint, the other display:none). Take the
      // one actually laid out, so the controller never binds to a hidden
      // element; offsetParent is null for a display:none subtree. Falls back
      // to the first match if none reports a layout box, which covers the
      // single-element case running before layout.
      var mediaAll      = root.querySelectorAll('[data-blog-article-video-media]');
      var media         = null;
      for (var m = 0; m < mediaAll.length; m++) {
        if (mediaAll[m].offsetParent !== null) {
          media = mediaAll[m];
          break;
        }
      }
      if (!media) media = mediaAll[0] || null;
      var wash          = root.querySelector('[data-blog-article-video-wash]');
      var customPoster  = root.querySelector('[data-blog-article-video-custom-poster]');
      var poster        = root.querySelector('[data-blog-article-video-poster-btn]');
      var controls      = root.querySelector('[data-blog-article-video-controls]');
      var toggle        = root.querySelector('[data-blog-article-video-toggle]');
      var muteBtn       = root.querySelector('[data-blog-article-video-mute]');
      var fsBtn         = root.querySelector('[data-blog-article-video-fullscreen]');
      var progress      = root.querySelector('[data-blog-article-video-progress]');

      if (!media || !wash || !poster || !controls || !toggle || !muteBtn || !fsBtn || !progress) return;

      var track = progress.parentElement;
      var playGlyph = toggle.children[0];
      var pauseGlyph = toggle.children[1];
      if (!track || !playGlyph || !pauseGlyph) return;

      media.controls = false;

      var playLabel   = toggle.getAttribute('aria-label') || '';
      var pauseLabel  = toggle.getAttribute('data-blog-article-video-toggle') || '';
      var soundOnLbl  = muteBtn.getAttribute('aria-label') || '';
      var soundOffLbl = muteBtn.getAttribute('data-blog-article-video-mute') || '';

      var idleTimer = null;

      function activate(el) {
        el.classList.remove('opacity-0');
        el.classList.add('opacity-100');
      }

      function deactivate(el) {
        el.classList.remove('opacity-100');
        el.classList.add('opacity-0');
      }

      // inert's own hit-test bypass (letting a tap on an inert element fall
      // through to whatever is beneath it) is not reliable on every engine —
      // notably WebKit, which iOS Chrome also runs on. pointer-events-none is
      // toggled alongside inert/aria-hidden so a concealed element is always
      // transparent to hit-testing via the well-supported CSS mechanism,
      // never relying on inert alone for that part of the job.
      function expose(el) {
        el.removeAttribute('aria-hidden');
        el.removeAttribute('inert');
        el.classList.remove('pointer-events-none');
      }

      function conceal(el) {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('inert', '');
        el.classList.add('pointer-events-none');
      }

      function clearIdle() {
        if (idleTimer) {
          window.clearTimeout(idleTimer);
          idleTimer = null;
        }
      }

      // Auto-fade is a desktop/hover behaviour only. Below 1024 there is no
      // reliable pointer gesture to bring the bar back once it fades (see
      // the snag-13 record in docs/snags/), so the bar simply never fades
      // there — it shows for the whole of playback instead.
      function isDesktop() {
        return window.matchMedia('(min-width: 1024px)').matches;
      }

      // Keep the control bar's opacity and its aria-hidden/inert state in
      // lockstep — it must never be focusable/AT-visible while opacity-0
      // (invisible). All opacity-0/100 toggling for `controls` goes through
      // these two, never bare activate(controls)/deactivate(controls).
      function showControls() {
        activate(controls);
        expose(controls);
      }

      // True only for focus the browser itself considers worth showing a ring
      // for, i.e. keyboard focus. A mouse or touch press on the pause button
      // leaves it :focus but not :focus-visible. Unsupported-selector engines
      // fall back to true, which is the pre-existing behaviour.
      function isKeyboardFocus(el) {
        if (!el || typeof el.matches !== 'function') return false;
        try {
          return el.matches(':focus-visible');
        } catch (e) {
          return true;
        }
      }

      function hideControls() {
        if (isKeyboardFocus(document.activeElement) && controls.contains(document.activeElement)) return;
        deactivate(controls);
        conceal(controls);
      }

      function hideBar() {
        if (!isDesktop()) return;
        clearIdle();
        hideControls();
      }

      function showBar() {
        showControls();
        clearIdle();
        if (!media.paused && isDesktop()) idleTimer = window.setTimeout(hideBar, IDLE_MS);
      }

      function toPaused() {
        clearIdle();
        activate(wash);
        if (customPoster) activate(customPoster);
        activate(poster);
        expose(poster);
        hideControls();
        playGlyph.classList.remove('hidden');
        pauseGlyph.classList.add('hidden');
        toggle.setAttribute('aria-pressed', 'false');
        toggle.setAttribute('aria-label', playLabel);
      }

      function toPlaying() {
        deactivate(wash);
        if (customPoster) deactivate(customPoster);
        deactivate(poster);
        conceal(poster);
        playGlyph.classList.add('hidden');
        pauseGlyph.classList.remove('hidden');
        toggle.setAttribute('aria-pressed', 'true');
        toggle.setAttribute('aria-label', pauseLabel);
        showBar();
      }

      function requestPlay() {
        var playback = media.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(function () {});
        }
      }

      poster.addEventListener('click', requestPlay);

      toggle.addEventListener('click', function () {
        if (media.paused) {
          requestPlay();
        } else {
          media.pause();
        }
      });

      muteBtn.addEventListener('click', function () {
        media.muted = !media.muted;
        muteBtn.setAttribute('aria-label', media.muted ? soundOffLbl : soundOnLbl);
        showBar();
      });

      fsBtn.addEventListener('click', function () {
        if (document.fullscreenElement) {
          if (typeof document.exitFullscreen === 'function') document.exitFullscreen();
          return;
        }
        if (typeof root.requestFullscreen === 'function') {
          root.requestFullscreen();
          return;
        }
        if (typeof media.webkitEnterFullscreen === 'function') media.webkitEnterFullscreen();
      });

      media.addEventListener('play', toPlaying);
      media.addEventListener('pause', toPaused);
      media.addEventListener('ended', toPaused);

      media.addEventListener('timeupdate', function () {
        var total = media.duration;
        if (!total || !isFinite(total)) return;
        var pct = Math.min(100, Math.max(0, (media.currentTime / total) * 100));
        progress.style.width = pct + '%';
        track.setAttribute('aria-valuenow', String(Math.round(pct)));
      });

      root.addEventListener('pointermove', function () {
        if (media.paused) return;
        showBar();
      });

      root.addEventListener('pointerleave', function () {
        if (media.paused) return;
        hideBar();
      });

      controls.addEventListener('focusin', function () {
        activate(controls);
        clearIdle();
      });

      controls.addEventListener('focusout', function () {
        if (media.paused) return;
        showBar();
      });

      // controls starts aria-hidden + inert in server markup (matching its
      // opacity-0 default) — left alone here, only showControls()/
      // hideControls() ever touch it, so it can never drift out of sync
      // with its own visibility again. poster is opacity-100 by default
      // (the native-controls-off fallback), so it alone is exposed now.
      expose(poster);
    }

    function main() {
      var roots = document.querySelectorAll('[data-blog-article-video]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', main);
    } else {
      main();
    }

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-filter-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var BP_MD = 1024;
    var _reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var _activeLinkRevealed = false;

    function _computeTop() {
      var header = document.getElementById('site-header');
      var offset = window.innerWidth >= BP_MD ? 12 : 8;
      if (!header || header.style.transform) return offset + 'px';
      return (offset + header.offsetHeight - 1) + 'px';
    }

    function _setLinkSize(bar, stuck) {
      bar.querySelectorAll('a').forEach(function (link) {
        link.classList.toggle('text-d6', stuck);
        link.classList.toggle('text-d5-step', !stuck);
      });
      _lockLinkWidths(bar);
    }

    // Lock each link's min-width to the wider of normal/italic to prevent
    // hover-italic layout jitter. Re-run when font size changes (_setLinkSize).
    function _lockLinkWidths(bar) {
      bar.querySelectorAll('a').forEach(function (link) {
        link.style.minWidth = '';
        var normal = link.offsetWidth;
        link.style.fontStyle = 'italic';
        var italic = link.offsetWidth;
        link.style.fontStyle = '';
        link.style.minWidth = Math.max(normal, italic) + 'px';
      });
    }

    // Suppress the header's sticky shadow while this bar is stuck below it.
    function _syncHeaderShadow(bar) {
      var header = document.getElementById('site-header');
      if (!header) return;
      var filterSticky = bar.classList.contains('is-sticky');
      var headerVisible = filterSticky && !header.style.transform;
      if (headerVisible) {
        header.setAttribute('data-filter-below', '');
      } else {
        header.removeAttribute('data-filter-below');
      }
    }

    /* Horizontal analogue of animateScrollTop() in plp-scroll-helpers.liquid
       (mirrored, not reused: that file is rendered only by the PLP templates
       and its own view test is keyed to a PLP-only attribute). Never
       scrollIntoView, for two reasons: WebKit silently drops a programmatic
       smooth scroll inside a nested overflow container instead of painting it,
       AND scrollIntoView walks every scrolling ancestor, so it can move the
       PAGE's vertical offset as a side effect. Writing one element's
       scrollLeft cannot. Full rationale in D73. */
    function _animateScrollLeft(scroller, target) {
      var start = scroller.scrollLeft;
      var change = target - start;
      if (!change) return;
      if (_reducedMotion.matches) { scroller.scrollLeft = target; return; }

      // Reads --duration-a3 rather than hardcoding 300 so this stays in sync
      // with the token. Same fallback and same quad in/out curve as the PLP
      // helper: no --ease-* token maps onto it, they are all cubic-bezier().
      var duration = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--duration-a3')) * 1000 || 300;
      var startTime = null;
      function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
      function step(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / duration, 1);
        scroller.scrollLeft = start + change * ease(progress);
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    /*
      Brings the current filter into view, at most ONCE per page load. An
      on-load correction, not a tap handler: these links are real <a href>
      navigations (nothing here calls preventDefault or the History API), so a
      scroll fired on tap would be discarded with the outgoing document. D73.

      Guarded on the row actually overflowing rather than on a viewport width,
      so it cannot drift out of step with the breakpoint at which the scroller
      stops scrolling, and so it also no-ops below 1024 with few links.

      The latch is set ahead of every guard, so a missing link or a row that
      fits still spends the one attempt. That is what stops later sticky
      toggles re-firing this AND stops the listing bar getting a second turn
      once it sticks, which would re-measure against _setLinkSize()'s smaller
      links. Do not replace it with a stickyOnly check: the split would then be
      encoded in two places.

      Call sites differ because the two consumers become measurable at
      different moments. The listing bar is in flow and fine at init. The
      article bar (sticky_only) is reduced to a 1px box by
      .filter-bar--sticky-only:not(.is-sticky), so its scroll dimensions mean
      NOTHING until .is-sticky lands; it is called from the end of _setStuck()
      instead, which must stay after _setLinkSize() there because that call
      swaps the link font size this measures.
    */
    function _revealActiveLink(bar) {
      if (_activeLinkRevealed) return;
      _activeLinkRevealed = true;

      var scroller = bar.querySelector('.filter-bar__scroll');
      if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;

      var link = bar.querySelector('a[aria-current="page"]');
      if (!link) return;

      // Rect DIFFERENCES, as scrollIntoViewIfNeeded() does it on the block
      // axis, so the stuck bar's slide-in translation cancels out rather than
      // skewing the result. Start/end here are that helper's top/bottom.
      var scrollerRect = scroller.getBoundingClientRect();
      var linkRect = link.getBoundingClientRect();
      var linkStart = (linkRect.left - scrollerRect.left) + scroller.scrollLeft;
      var linkEnd = linkStart + linkRect.width;
      var viewStart = scroller.scrollLeft;
      var viewEnd = viewStart + scroller.clientWidth;
      if (linkStart >= viewStart && linkEnd <= viewEnd) return;

      // Centred, not edge-aligned: a tab hard against the scrollport edge
      // reads as the end of the row, and it is the visible neighbours that
      // tell the reader it scrolls. The clamp degrades centring to a start/end
      // alignment by itself for the first and last tab.
      var target = linkStart - (scroller.clientWidth - linkRect.width) / 2;
      var maxScroll = scroller.scrollWidth - scroller.clientWidth;
      _animateScrollLeft(scroller, Math.max(0, Math.min(target, maxScroll)));
    }

    function _setStuck(bar, placeholder, stuck, stickyOnly) {
      var wasStuck = bar.classList.contains('is-sticky');
      if (stuck === wasStuck) {
        if (stuck) {
          bar.style.top = _computeTop();
          _syncHeaderShadow(bar);
        }
        return;
      }

      if (stuck) {
        if (!stickyOnly) {
          placeholder.style.height = bar.offsetHeight + 'px';
          placeholder.style.display = '';
        }
        bar.style.top = _computeTop();
        bar.classList.add('is-sticky', 'filter-bar--stuck');
      } else {
        bar.classList.remove('is-sticky', 'filter-bar--stuck');
        bar.style.top = '';
        placeholder.style.display = 'none';
        placeholder.style.height = '';
      }
      _setLinkSize(bar, stuck);
      _syncHeaderShadow(bar);

      // First false-to-true change only (the early return above means reaching
      // here at all is a state change; the latch handles the rest). MUST stay
      // below _setLinkSize() — see _revealActiveLink().
      if (stuck) _revealActiveLink(bar);
    }

    /* The ONE mechanism deciding this bar's stuck state — both consumers, every
       determination including the first — via the syncStuck callback each
       _init* injects. The intersection-observation primitive this file used to
       depend on is gone; its name is kept out of these comments so a plain
       grep still proves it absent. Its callback timing AND firing frequency
       both vary by engine, and two rounds of patching that (D74, D75) left the
       article bar wrong on Windows Chrome anyway. Full reasoning in D76.

       Three things here are load-bearing. syncStuck() runs FIRST and
       unconditionally, so state is decided from current layout before anything
       acts on it. The top/shadow half re-reads classList AFTER it, so an
       unstick in the same frame skips it; that gated body is unchanged from
       when this function did only that. And the closing tick() is the
       mechanism's first run, not a backstop bolted on beside it —
       getBoundingClientRect() forces a synchronous layout flush whenever it is
       called, so it cannot read pre-layout geometry. */
    function _bindStickyScroll(bar, syncStuck) {
      var raf = null;
      function tick() {
        raf = null;
        syncStuck();
        if (bar.classList.contains('is-sticky')) {
          bar.style.top = _computeTop();
          _syncHeaderShadow(bar);
        }
      }
      window.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(tick);
      }, { passive: true });
      tick();
    }

    function _initListing(bar, placeholder) {
      // In flow, so measurable now. The article bar is not, and reaches this
      // from _setStuck() instead; see _revealActiveLink().
      _revealActiveLink(bar);

      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none';
      bar.parentNode.insertBefore(sentinel, bar);

      /* Predicate unchanged by D76: the geometry was never the problem here,
         only what drove it. Two-sided containment, preserving the old
         threshold:1 semantics (this 1px sentinel WHOLLY inside the viewport).
         BLOCK axis only — its horizontal extent cannot change under a vertical
         scroll, and testing it would risk a permanent stuck state from a
         sub-pixel 100vw overhang (snag 21). clientHeight excludes a scrollbar;
         innerHeight is a degenerate-zero fallback only. */
      function _syncStuck() {
        var rect = sentinel.getBoundingClientRect();
        var viewportH = document.documentElement.clientHeight || window.innerHeight;
        _setStuck(bar, placeholder, !(rect.top >= 0 && rect.bottom <= viewportH), false);
      }

      _bindStickyScroll(bar, _syncStuck);

      window.addEventListener('resize', function () {
        _lockLinkWidths(bar);
        if (bar.classList.contains('is-sticky')) {
          bar.style.top = _computeTop();
          placeholder.style.height = bar.offsetHeight + 'px';
        }
      }, { passive: true });
    }

    /*
      Article (sticky_only): hidden in flow. Stick after the first section
      (hero) leaves view — same as listing. Stay stuck and animate `top` with
      the header on scroll direction (PLP/blog transition: top + slide-in).
    */
    function _initStickyOnly(bar, placeholder) {
      var sentinel = document.querySelector('[data-hero-end]');
      if (!sentinel) {
        sentinel = document.querySelector('[data-article-hero-overlay], [data-article-hero-split]');
      }
      if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none';
        var hero = bar.previousElementSibling;
        if (hero) {
          hero.insertBefore(sentinel, hero.firstChild);
        } else {
          bar.parentNode.insertBefore(sentinel, bar);
        }
      }

      /* Also unchanged by D76, and deliberately a DIFFERENT predicate rather
         than a shared helper: this sentinel spans the whole hero (D74), so
         "the hero has passed" is its bottom edge crossing the top of the
         viewport — one-sided, with no viewport-height term at all where
         _initListing's has one. A shared helper would only re-encode that
         divergence as a parameter. Holds for all three sentinel shapes this
         function can end up with. */
      function _syncStuck() {
        _setStuck(bar, placeholder, sentinel.getBoundingClientRect().bottom <= 0, true);
      }

      _bindStickyScroll(bar, _syncStuck);

      window.addEventListener('resize', function () {
        _lockLinkWidths(bar);
        if (bar.classList.contains('is-sticky')) {
          bar.style.top = _computeTop();
        }
      }, { passive: true });
    }

    function _init() {
      var bar = document.querySelector('[data-blog-filter-bar]');
      if (!bar) return;

      _lockLinkWidths(bar);

      var placeholder = document.createElement('div');
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.style.cssText = 'display:none;pointer-events:none';
      bar.parentNode.insertBefore(placeholder, bar);

      if (bar.hasAttribute('data-sticky-only')) {
        _initStickyOnly(bar, placeholder);
      } else {
        _initListing(bar, placeholder);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', _init);
    } else {
      _init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-grid-script"] && !Shopify.designMode) return;
  try {
    ;(function () {

    var TIMEOUT_MS = 8000;

    function init(root) {
      if (root.__blogGridReady) return;
      root.__blogGridReady = true;

      var grid = root.querySelector('[data-blog-grid]');
      var button = root.querySelector('[data-blog-load-more]');
      var viewedOf = root.querySelector('[data-blog-viewed-of]');
      var errorEl = root.querySelector('[data-blog-grid-error]');
      if (!grid || !button) return;

      var errorMessage = errorEl ? errorEl.getAttribute('data-blog-load-error') || '' : '';
      var timeoutMessage = errorEl ? errorEl.getAttribute('data-blog-load-timeout') || '' : '';

      button.addEventListener('click', function (e) {
        e.preventDefault();
        if (button.dataset.loading) return;

        var url = button.getAttribute('data-blog-next-url');
        if (!url) return;

        button.dataset.loading = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (errorEl) errorEl.textContent = '';

        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, TIMEOUT_MS);

        fetch(url, { signal: controller.signal })
          .then(function (response) {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');

            var newGrid = doc.querySelector('[data-blog-grid]');
            if (newGrid) {
              // newGrid.children is a live HTMLCollection: appendChild below removes
              // each child from newGrid as a side effect, which shifts every remaining
              // index down by one and makes forEach skip every other child. Snapshot
              // to a static array first so every child actually moves across.
              var newRows = Array.prototype.slice.call(newGrid.children);
              newRows.forEach(function (child) {
                grid.appendChild(child);
              });
            }

            if (viewedOf) {
              var format = viewedOf.getAttribute('data-format') || '';
              // The Latest Articles Carousel block also renders inside [data-blog-grid]
              // (it's a movable break block like featured_article) and reuses
              // blog-article-card.liquid, so its cards carry [data-blog-article-card]
              // too. Excluding anything inside [data-blog-carousel] keeps this a count
              // of real paginated articles only.
              var cards = grid.querySelectorAll('[data-blog-article-card]');
              var count = Array.prototype.filter.call(cards, function (card) {
                return !card.closest('[data-blog-carousel]');
              }).length;
              viewedOf.textContent = format.replace('__VIEWED__', count);
            }

            var nextButton = doc.querySelector('[data-blog-load-more]');
            if (nextButton) {
              button.setAttribute('data-blog-next-url', nextButton.getAttribute('data-blog-next-url') || '');
            } else {
              button.remove();
            }
          })
          .catch(function (err) {
            if (errorEl) errorEl.textContent = err.name === 'AbortError' ? timeoutMessage : errorMessage;
          })
          .finally(function () {
            clearTimeout(timeout);
            delete button.dataset.loading;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          });
      });
    }

    function main() {
      document.querySelectorAll('[data-blog-listing]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', main);
    } else {
      main();
    }

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-latest-articles-carousel"] && !Shopify.designMode) return;
  try {
    ;(function () {
    function main() {
      if (!window.ProductCarouselEngine) return;
      // Shared with sections/blog-article-related.liquid's own guard: both
      // target [data-blog-carousel], and a merchant can place "Latest
      // articles carousel" on an article template that already has that
      // section, so the guard property must be the same name in both files —
      // whichever script runs first claims the element, the other skips it.
      document.querySelectorAll('[data-blog-carousel]').forEach(function (el) {
        if (el.__blogCarouselReady) return;
        el.__blogCarouselReady = true;
        window.ProductCarouselEngine(el, { prefix: 'data-blog-carousel' });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', main);
    } else {
      main();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys-api"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.PlpFilters = {
      update: function (activeCount, total, hasFacets) {
        var resultEl = document.querySelector('[data-result-count]');
        if (resultEl) {
          var gridEl = document.querySelector('.tagalys-grid-init');
          var fmt    = (gridEl && gridEl.getAttribute('data-i18n-result-count')) || '__COUNT__ results';
          resultEl.textContent = total != null ? fmt.replace('__COUNT__', total) : '';
        }

        // Hide only when the page itself has nothing to filter — a zero-result
        // filter combination must leave the bar (and its Clear control) in place,
        // otherwise a shopper who lands on a bookmarked filtered URL that now
        // matches nothing has no way back except editing the URL by hand.
        var filterBar = document.querySelector('[data-filter-bar]');
        if (filterBar) {
          filterBar.classList.toggle('hidden', total === 0 && activeCount === 0);
        }

        // Only the filter/sort controls disappear when Tagalys has nothing to
        // filter by — the result count is still meaningful with zero facets
        // and must stay visible.
        var filterControls = document.querySelector('[data-filter-controls]');
        if (filterControls) {
          filterControls.classList.toggle('hidden', hasFacets === false);
        }

        var badge   = document.querySelector('[data-filter-count-badge]');
        var countEl = document.querySelector('[data-filter-count]');
        if (badge && countEl) {
          countEl.textContent = activeCount;
          badge.classList.toggle('hidden', activeCount === 0);
        }

        var clearBtn = document.querySelector('[data-inline-clear]');
        if (clearBtn) {
          clearBtn.classList.toggle('hidden', activeCount === 0);
          clearBtn.classList.toggle('flex', activeCount > 0);
        }

        var activeFiltersRow = document.querySelector('[data-active-filters]');
        if (activeFiltersRow) {
          activeFiltersRow.classList.toggle('hidden', activeCount === 0);
          activeFiltersRow.classList.toggle('flex', activeCount > 0);
        }

        var resultsCount = document.querySelector('[data-results-count]');
        if (resultsCount) {
          resultsCount.textContent = total > 0 ? '(' + total + ')' : '';
          resultsCount.classList.toggle('hidden', total === 0);
        }

        var drawerClear = document.querySelector('#filters-drawer [data-clear-filters]');
        if (drawerClear) {
          if (activeCount > 0) {
            drawerClear.removeAttribute('aria-disabled');
          } else {
            drawerClear.setAttribute('aria-disabled', 'true');
          }
        }
      }
    };

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys-badges"] && !Shopify.designMode) return;
  try {
    ;(function () {
    'use strict';

    var MAX_TARGETS = 100;
    // Shared with TagalysCard, which reads it to render badges inline. handle -> labels[] (key present = resolved, [] = no badges).
    var CACHE = window.WhittardBadgeCache = window.WhittardBadgeCache || {};
    // handle -> 'in' | 'out' | 'unknown'. Shared with TagalysCard, which reads it at
    // call time: 'out' disables a card outright (warehouse is the only shipping
    // origin); 'in'/'unknown' never force a card available on their own, they only
    // leave the live/blended baseline in place. Written only here, and always in
    // the same pass as CACHE, so a handle present in one is present in the other.
    var WH_CACHE = window.WhittardWarehouseCache = window.WhittardWarehouseCache || {};
    // handle -> true | false. Live Storefront availableForSale, preferred over
    // Tagalys's own cached `available` field by collection-tagalys-card.liquid
    // (that field is a known-unreliable snapshot - see the doc block above).
    var AVAIL_CACHE = window.WhittardAvailabilityCache = window.WhittardAvailabilityCache || {};
    var WH_MAX_VARIANTS = 25;
    var observed = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
    var scheduled = false;

    function escHtml(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // Numeric metaobject id (tail of the gid), matching window.WhittardBadges keys.
    function badgeId(gid) {
      var s = String(gid == null ? '' : gid);
      var slash = s.lastIndexOf('/');
      return slash >= 0 ? s.slice(slash + 1) : s;
    }

    // Card-variant pill markup, byte-identical to product-badges.liquid (variant: card).
    function pillsHtml(labels) {
      if (!labels || !labels.length) return '';
      var out = '';
      for (var i = 0; i < labels.length && i < 2; i++) {
        out += '<span class="flex items-center justify-center bg-surface-primary px-8 py-4 rounded-xs">' +
          '<span class="text-f3 uppercase text-primary">' + escHtml(labels[i]) + '</span></span>';
      }
      return '<div class="absolute top-8 left-8 flex items-center gap-4" data-badges>' + out + '</div>';
    }

    // Resolve up to two visible badge labels from a metafield value (JSON array of gids).
    function labelsFor(value) {
      var dict = window.WhittardBadges || {};
      var gids;
      try { gids = JSON.parse(value); } catch (e) { return []; }
      if (!Array.isArray(gids)) return [];
      var labels = [];
      for (var i = 0; i < gids.length && labels.length < 2; i++) {
        var label = dict[badgeId(gids[i])];
        if (label) labels.push(label);
      }
      return labels;
    }

    /* Product-level warehouse roll-up. The metafield is per variant; a card is per
       product. Any populated value above zero wins. `out` requires EVERY variant to
       be populated and zero - a half-backfilled product must never look out of stock.
       Storefront metafield values arrive as strings even for a number_integer type.
       hasNextPage means we did not see every variant, so we cannot assert `out`. */
    function whProductState(node) {
      var conn = node && node.variants;
      var nodes = conn && conn.nodes;
      if (!nodes || !nodes.length) return 'unknown';

      var anyStock = false, anyKnown = false, anyUnset = false;
      for (var i = 0; i < nodes.length; i++) {
        var mf = nodes[i] && nodes[i].metafield;
        var raw = (mf && mf.value !== null && mf.value !== undefined && mf.value !== '') ? Number(mf.value) : null;
        if (raw === null || !isFinite(raw)) { anyUnset = true; continue; }
        anyKnown = true;
        if (raw > 0) anyStock = true;
      }

      if (anyStock) return 'in';
      if (conn.pageInfo && conn.pageInfo.hasNextPage) return 'unknown';
      if (anyKnown && !anyUnset) return 'out';
      return 'unknown';
    }

    // Re-apply cached badges to every card lacking them. Idempotent (guarded by data-badges), so it safely survives Tagalys grid rebuilds.
    function injectAll(container) {
      var cards = container.querySelectorAll('[data-product-card]');
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        if (card.querySelector('[data-badges]')) continue;
        var href = card.getAttribute('data-product-url') || '';
        var m = href.match(/\/products\/([^/?#]+)/);
        if (!m || !Object.prototype.hasOwnProperty.call(CACHE, m[1])) continue;
        var html = pillsHtml(CACHE[m[1]]);
        if (!html) continue;
        var media = card.querySelector('.aspect-square');
        // beforeend: the badge must sit after the absolute image layers to render on top (afterbegin would hide it behind them).
        if (media) media.insertAdjacentHTML('beforeend', html);
      }
    }

    /* Corrects a card Tagalys rendered as Notify/unavailable when the live
       Storefront availableForSale check disagrees - one direction only, exactly
       mirroring collection-tagalys-bundle-availability.liquid's own patchCard()
       (which does the same thing for bundle products via its own scoped query).
       Never re-renders the card, never touches aria-hidden. The replacement
       markup comes from window.TagalysCard's own exported builders, so no
       class, string or SVG path is hand-copied here.

       Per the confirmed client decision, 'out' is authoritative and forces
       Notify regardless of Tagalys's own cached data or the live Storefront
       check - warehouse is the only shipping origin, so zero stock there means
       unavailable full stop. 'in' does NOT force Quick View on its own - a
       positive warehouse figure says nothing about market exclusion,
       scheduled release or sales-channel removal, so it must not override an
       independently-false baseline. Both 'in' and unknown therefore fall back
       to the live check, and only ever upgrade Notify to Quick View (never the
       reverse) once that check positively confirms it.

       Idempotent via data-availability-applied, storing the boolean state last
       written, stamped on the CTA box's FIRST ELEMENT CHILD (never the box
       itself - innerHTML replaces children but leaves the box's own attributes
       intact, so a box-level marker would survive a foreign rewrite - e.g.
       collection-tagalys-bundle-availability.liquid's own patchCard() flipping
       a card back the other way - and wrongly suppress re-correcting it). Any
       foreign rewrite destroys the marked child, so the next
       observer-triggered pass always sees no marker, re-evaluates, and
       re-applies the correct state - converging rather than looping, since the
       marker write itself is an ATTRIBUTE mutation this snippet's observer
       does not watch. */
    function applyAvailability(container) {
      var notifyBuild = window.TagalysCard && window.TagalysCard.notifyCtaHtml;
      var quickViewBuild = window.TagalysCard && window.TagalysCard.quickViewCtaHtml;
      if (typeof notifyBuild !== 'function' || typeof quickViewBuild !== 'function') return;

      var notifyHost = (container.closest && container.closest('[data-i18n-notify]')) || document.querySelector('[data-i18n-notify]');
      var notifyLabel = notifyHost ? notifyHost.getAttribute('data-i18n-notify') : '';
      var qvHost = (container.closest && container.closest('[data-i18n-quick-view]')) || document.querySelector('[data-i18n-quick-view]');
      var quickViewLabel = qvHost ? qvHost.getAttribute('data-i18n-quick-view') : '';
      if (!notifyLabel || !quickViewLabel) return;

      var cards = container.querySelectorAll('[data-product-card][data-product-handle]');
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var handle = card.getAttribute('data-product-handle') || '';

        var wh = WH_CACHE[handle];
        var desired;
        if (wh === 'out') {
          desired = false;
        } else {
          desired = (AVAIL_CACHE[handle] === true) ? true : null;
        }
        if (desired === null) continue;

        var ctaBox = card.querySelector('[data-product-card-cta]');
        if (!ctaBox) continue;
        var marked = ctaBox.querySelector('[data-availability-applied]');
        var current = marked ? marked.getAttribute('data-availability-applied') : null;
        if (current === String(desired)) continue;

        var label = desired ? quickViewLabel : notifyLabel;
        ctaBox.innerHTML = desired ? quickViewBuild(quickViewLabel) : notifyBuild(notifyLabel);
        if (ctaBox.firstElementChild) ctaBox.firstElementChild.setAttribute('data-availability-applied', String(desired));

        var link = card.querySelector('a[aria-label]');
        var title = link ? link.getAttribute('aria-label') : '';
        var trigger = card.querySelector('[data-quick-view-open]');
        if (trigger) trigger.setAttribute('aria-label', title ? label + ' — ' + title : label);
      }
    }

    function schedule(container) {
      if (scheduled) return;
      scheduled = true;
      var run = function () { scheduled = false; injectAll(container); applyAvailability(container); };
      if (window.requestAnimationFrame) window.requestAnimationFrame(run); else setTimeout(run, 16);
    }

    function observe(container) {
      if (!window.MutationObserver || !observed || observed.has(container)) return;
      observed.add(container);
      new MutationObserver(function () { schedule(container); }).observe(container, { childList: true, subtree: true });
    }

    window.TagalysBadgeHydration = {
      pillsHtml: pillsHtml,
      hydrate: function (products, gridEl) {
        if (!gridEl) return;
        // The inner grid div is recreated on each Tagalys render; observe the stable wrapper.
        var container = (gridEl.closest && gridEl.closest('.tagalys-grid-init')) || gridEl;
        observe(container);
        injectAll(container); // re-apply anything already resolved (instant, no fetch)
        applyAvailability(container);

        var cfg = window.WhittardStorefront || {};
        var token = cfg.token;
        if (!token) return;

        var seen = {}, toFetch = [];
        (Array.isArray(products) ? products : []).forEach(function (p) {
          var h = p && p.handle ? String(p.handle) : '';
          if (h && !seen[h]) { seen[h] = 1; if (!Object.prototype.hasOwnProperty.call(CACHE, h)) toFetch.push(h); }
        });
        // No silent cap: if a single render has more uncached handles than one batch allows, log the drop so it is visible in QA instead of silently badge-less.
        if (toFetch.length > MAX_TARGETS && window.console) console.warn('[tagalys-badges]', (toFetch.length - MAX_TARGETS) + ' handles dropped, exceeded MAX_TARGETS (' + MAX_TARGETS + ')');
        toFetch = toFetch.slice(0, MAX_TARGETS);
        if (!toFetch.length) return;

        /* availableForSale is market-dependent - an unscoped query silently
           resolves against the shop's default market rather than the
           shopper's own, which would make a product excluded from the
           shopper's market read as available. Scope with @inContext(country:)
           using the market attribute layout/theme.liquid already renders. */
        var country = (document.body && document.body.getAttribute('data-market-country')) || '';

        var variables = {};
        var fieldDecls = toFetch.map(function (h, idx) {
          variables['h' + idx] = h;
          return 'p' + idx + ': product(handle: $h' + idx + ') { handle availableForSale isGiftCard metafield(namespace: "custom", key: "badges") { value } bundleMf: metafield(namespace: "custom", key: "is_bundle") { value } customBundleMf: metafield(namespace: "custom", key: "is_custom_bundle") { value } variants(first: ' + WH_MAX_VARIANTS + ') { pageInfo { hasNextPage } nodes { metafield(namespace: "custom", key: "warehouse_stock") { value } } } }';
        });
        var varDecls = toFetch.map(function (h, idx) { return '$h' + idx + ': String!'; });
        var contextDirective = country ? ' @inContext(country: ' + country + ')' : '';
        var query = 'query Badges(' + varDecls.join(', ') + ')' + contextDirective + ' { ' + fieldDecls.join(' ') + ' }';

        var endpoint = '/api/' + (cfg.version || '2026-07') + '/graphql.json';
        var ac = window.AbortController ? new AbortController() : null;
        var timeout = setTimeout(function () { if (ac) ac.abort(); }, 8000);

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({ query: query, variables: variables }),
          signal: ac ? ac.signal : undefined
        })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (json) {
            if (!json || !json.data) return;
            var data = json.data;
            Object.keys(data).forEach(function (k) {
              var node = data[k];
              if (!node || !node.handle) return;
              CACHE[node.handle] = (node.metafield && node.metafield.value) ? labelsFor(node.metafield.value) : [];
              // A bundle (fixed or custom) always ships as one gift-wrapped unit
              // regardless of any one line's own stock, so the warehouse-only rule
              // never applies to it - 'unknown' makes applyAvailability() fall back
              // to AVAIL_CACHE (live blended availableForSale) alone, same exception
              // as warehouse-available.liquid. A native gift-card product gets the
              // same 'unknown' treatment for the same reason - it is never held in
              // the Warehouse location.
              var isBundleProduct = (node.bundleMf && node.bundleMf.value === 'true') || (node.customBundleMf && node.customBundleMf.value === 'true');
              WH_CACHE[node.handle] = (isBundleProduct || node.isGiftCard === true) ? 'unknown' : whProductState(node);
              AVAIL_CACHE[node.handle] = node.availableForSale === true;
            });
            injectAll(container);
            applyAvailability(container);
          })
          .catch(function (err) {
            if (window.console) console.warn('[tagalys-badges]', err && err.name === 'AbortError' ? 'timeout' : err);
          })
          .finally(function () { clearTimeout(timeout); });
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys-bundle-availability"] && !Shopify.designMode) return;
  try {
    ;(function () {
    'use strict';

    var MAX_TARGETS = 100;

    function escHtml(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // Swap ONLY the CTA branch on the matching card. Never re-render the card;
    // never touch the container's aria-hidden. Reproduces the eye/quick-view branch
    // from the TagalysCard renderer verbatim.
    function patchCard(grid, handle, quickView) {
      var cards = grid.querySelectorAll('[data-product-card][data-product-handle="' + handle + '"]');
      if (!cards.length) return;
      var ctaBox = cards[0].querySelector('[data-product-card-cta]');
      if (!ctaBox) return;
      ctaBox.innerHTML =
        '<span class="text-b3 uppercase leading-none whitespace-nowrap hidden md:inline">' + escHtml(quickView) + '</span>' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="size-16 relative bottom-px" aria-hidden="true" focusable="false"><path d="M2.5 12C2.5 12 5.95833 5.5 12 5.5C18.0417 5.5 21.5 12 21.5 12C21.5 12 18.0417 18.5 12 18.5C5.95833 18.5 2.5 12 2.5 12Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 14.8333C13.5648 14.8333 14.8333 13.5648 14.8333 12C14.8333 10.4352 13.5648 9.16667 12 9.16667C10.4352 9.16667 9.16667 10.4352 9.16667 12C9.16667 13.5648 10.4352 14.8333 12 14.8333Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      if (ctaBox.hasAttribute('aria-label')) ctaBox.setAttribute('aria-label', quickView);
    }

    window.TagalysBundleAvailability = {
      correct: function (products, gridId) {
        var grid = document.getElementById(gridId || 'tagalys-product-grid');
        if (!grid) return;
        var token = grid.getAttribute('data-bundle-token');
        if (!token) return; // fail-safe: no credential -> no-op (mirror product-bundle-items gate)
        var version = grid.getAttribute('data-bundle-api-version') || '2026-07';
        var quickView = grid.getAttribute('data-i18n-quick-view') || 'Quick view';
        var hasHandleList = grid.hasAttribute('data-bundle-handles');
        var bundleHandles = {};
        if (hasHandleList) {
          (grid.getAttribute('data-bundle-handles') || '').split(',').forEach(function (h) {
            h = h.trim();
            if (h) bundleHandles[h] = true;
          });
          if (!Object.keys(bundleHandles).length) return;
        }

        var targets = (Array.isArray(products) ? products : [])
          .filter(function (p) { return p && p.available === false && p.handle && (!hasHandleList || bundleHandles[String(p.handle)]); })
          .slice(0, MAX_TARGETS)
          .map(function (p) { return String(p.handle); });
        if (!targets.length) return; // common case: nothing to correct -> no fetch

        // Storefront API has no "products by list of handles" field, and products(query:)
        // silently ignores "handle:" as a filter term rather than erroring — product(handle:)
        // is the only reliable per-handle lookup, so batch it as one aliased field per
        // target; each handle value still travels through its own named variable rather
        // than being concatenated into the query text.
        //
        // @inContext(country:) is required — without it this always resolves
        // availableForSale against the shop's default market, not the shopper's
        // actual one, so a product genuinely excluded from this market by its
        // shipping profile would be misread as available (same defect confirmed
        // live in assets/tagalys-recommendations.js's correctAvailability).
        var marketCountry = (document.body && document.body.getAttribute('data-market-country')) || 'GB';
        var variables = { country: marketCountry };
        var fieldDecls = targets.map(function (h, idx) {
          var varName = 'h' + idx;
          variables[varName] = h;
          return 'p' + idx + ': product(handle: $' + varName + ') { handle availableForSale }';
        });
        var varDecls = targets.map(function (h, idx) { return '$h' + idx + ': String!'; });
        var query = 'query BundleAvail($country: CountryCode!, ' + varDecls.join(', ') + ') @inContext(country: $country) { ' + fieldDecls.join(' ') + ' }';

        var endpoint = '/api/' + version + '/graphql.json';
        var ac = window.AbortController ? new AbortController() : null;
        var timeout = setTimeout(function () { if (ac) ac.abort(); }, 8000);

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({ query: query, variables: variables }),
          signal: ac ? ac.signal : undefined
        })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (json) {
            if (!json || !json.data) return;
            var data = json.data;
            Object.keys(data).forEach(function (k) {
              var node = data[k];
              if (!node || node.availableForSale !== true || !node.handle) return;
              patchCard(grid, String(node.handle), quickView);
            });
          })
          .catch(function (err) {
            // Passive safety net (mirror product-bundle-items): leave Tagalys's state.
            if (window.console) console.warn('[tagalys-bundle-availability]', err && err.name === 'AbortError' ? 'timeout' : err);
          })
          .finally(function () { clearTimeout(timeout); });
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys-card"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    // Shared with mini-bag-recommendations-card-script.liquid via
    // assets/tagalys-recommendations.js (window.TagalysProductFormat) — was a
    // byte-for-byte duplicate of escHtml/money/readValue/shopifySrcset in both
    // files before this extraction (TASK-47920).
    var escHtml = window.TagalysProductFormat.escHtml;

    // No silent cap: bundle-price-cache.liquid sets this when the configured
    // collection held more custom-bundle products than it reads — surfaced once
    // (shared flag with mini-bag-recommendations-card-script.liquid's identical check)
    // rather than a card just quietly keeping its placeholder price.
    if (window.WhittardBundlePriceCacheTruncated && window.console && !window.__whittardBundleCacheWarned) {
      window.__whittardBundleCacheWarned = true;
      console.warn('[bundle-price-cache]', 'window.WhittardBundlePriceCache is truncated — some bundle cards may show their placeholder Shopify price.');
    }

    function _shopifySrcset(src) {
      return window.TagalysProductFormat.shopifySrcset(src);
    }

    /* The card's out-of-stock CTA branch, used by ctaDefault below. Exported so
       collection-tagalys-badges.liquid's applyAvailability() can correct an
       already-rendered card to Notify without hand-copying the SVG. */
    function notifyCtaHtml(notifyLabel) {
      return '<span class="text-b3 uppercase leading-none whitespace-nowrap hidden md:inline">' + escHtml(notifyLabel) + '</span>' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="size-16 relative bottom-px" aria-hidden="true" focusable="false"><path d="M3.5 5.5H20.5C20.7761 5.5 21 5.72386 21 6V18C21 18.2761 20.7761 18.5 20.5 18.5H3.5C3.22386 18.5 3 18.2761 3 18V6C3 5.72386 3.22386 5.5 3.5 5.5Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.20801 6.16699L12.0002 12.75L20.7923 6.16699" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    /* The card's available/quick-view CTA branch, used by ctaDefault below.
       Exported so collection-tagalys-badges.liquid's applyAvailability() can
       correct an already-rendered card to Quick View without hand-copying the
       SVG (mirrors the same pattern the off-limits
       collection-tagalys-bundle-availability.liquid file already uses). */
    function quickViewCtaHtml(quickViewLabel) {
      return '<span class="text-b3 uppercase leading-none whitespace-nowrap hidden md:inline">' + escHtml(quickViewLabel) + '</span>' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="size-16 relative bottom-px" aria-hidden="true" focusable="false"><path d="M2.5 12C2.5 12 5.95833 5.5 12 5.5C18.0417 5.5 21.5 12 21.5 12C21.5 12 18.0417 18.5 12 18.5C5.95833 18.5 2.5 12 2.5 12Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 14.8333C13.5648 14.8333 14.8333 13.5648 14.8333 12C14.8333 10.4352 13.5648 9.16667 12 9.16667C10.4352 9.16667 9.16667 10.4352 9.16667 12C9.16667 13.5648 10.4352 14.8333 12 14.8333Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    window.TagalysCard = function (p, eager, i18n, cta, priority) {
      function _money(pounds) {
        return window.TagalysProductFormat.money(pounds, i18n && i18n.currency);
      }

      var load  = eager ? 'eager' : 'lazy';
      // Featured image only, never the hover copy: the hover image sits behind
      // the featured one until pointer-over, so marking it high would put a
      // never-painted image ahead of the visible LCP candidate.
      var fprio = priority ? ' fetchpriority="high"' : '';
      var imgs  = p.images || [], img0 = imgs[0] || {}, img1 = imgs[1] || {};
      /* Baseline availability comes from the live Storefront availableForSale
         check (window.WhittardAvailabilityCache, populated by
         collection-tagalys-badges.liquid's own batched query), falling back to
         Tagalys's own cached `available` field only until the live check
         resolves - that field is a known-unreliable snapshot, the exact reason
         the off-limits collection-tagalys-bundle-availability.liquid file
         exists for bundle products.
         A known warehouse state (window.WhittardWarehouseCache) then only ever
         NARROWS this baseline, never widens it: 'out' forces unavailable
         regardless of the baseline (warehouse is the only shipping origin, so
         zero stock there is authoritative); 'in' or unknown leaves the baseline
         untouched - a positive warehouse figure must not override a baseline
         that is independently false for reasons warehouse stock knows nothing
         about (market exclusion, scheduled release, sales-channel removal). */
      var liveAvail = (window.WhittardAvailabilityCache || {})[p.handle];
      var avail = (liveAvail === true || liveAvail === false) ? liveAvail : (p.available !== false);
      var whState = (window.WhittardWarehouseCache || {})[p.handle];
      if (whState === 'out') {
        avail = false;
      }

      /* Custom Events Tracking impression payload, read by
         assets/analytics-product.js for quickview_open and dl_view_item_list.
         Mirrors the same attribute product-card.liquid renders for the Liquid
         cards, so the tracker has one contract for both.

         `id` is GA's product key, normally the SKU. Tagalys's index does not
         carry a SKU on every product, so the product id is the documented
         fallback — product_id/variant_id are always populated regardless.
         Tagalys prices are already in major units (see TagalysProductFormat.money),
         so they are formatted, not divided. */
      var tVariant = (p.variants && p.variants[0]) || {};
      var trackAttr = ' data-track-item="' + escHtml(JSON.stringify({
        id: String(tVariant.sku || p.sku || p.id || ''),
        name: p.name || p.title || '',
        brand: p.vendor || '',
        category: p.product_type || '',
        variant: tVariant.title || '',
        price: parseFloat(p.price_min || 0).toFixed(2),
        product_id: String(p.id || ''),
        variant_id: String(tVariant.id || ''),
        compare_at_price: parseFloat(p.compare_at_price_min || 0).toFixed(2),
        image: img0.src || ''
      })) + '"';
      // Custom-bundle entry is [from_total, from_sum] pence (discounted,
      // undiscounted) — same shape/order product-custom-bundle-from-total.liquid
      // outputs. Mirrors product-card.liquid's own display_price/
      // display_compare_price resolution so a bundle card looks identical
      // wherever it renders, server or Tagalys-JS.
      var bundleEntry = (window.WhittardBundlePriceCache || {})[p.handle || ''];
      var cmp, minP, isBundleFrom = false;
      if (bundleEntry) {
        minP = bundleEntry[0] / 100;
        cmp = bundleEntry[1] > bundleEntry[0] ? bundleEntry[1] / 100 : 0;
        isBundleFrom = true;
      } else {
        cmp = p.compare_at_price_min || 0;
        minP = p.price_min || 0;
      }
      var price = cmp > minP
        ? '<span class="line-through">' + _money(cmp) + '</span><span>' + _money(minP) + '</span>'
        : (p.price_varies || isBundleFrom) ? '<span>' + escHtml(i18n.fromPrice.replace('__PRICE__', _money(minP))) + '</span>' : '<span>' + _money(minP) + '</span>';
      // Tagalys's own index carries no rating field and no product metafields
      // (FAILS_INDEX.md §12), so this can never be filled synchronously here.
      // Always rendered, hidden until snippets/tagalys-rating-hydration.liquid
      // resolves a live Yotpo rating for this card's data-product-id and
      // reveals it — same architecture as snippets/product-rating.liquid's
      // async-fill pattern, just with no server-rendered fallback value since
      // Tagalys has none to give it.
      var ratHtml = '<div class="hidden items-center gap-4 shrink-0 order-2 md:order-2 md:ml-auto" data-product-rating aria-live="polite">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="size-16 text-brand-primary-blue" aria-hidden="true" focusable="false">' +
        '<path d="M20.5463 10.7802L16.9281 13.8368L18.0305 18.4078C18.0913 18.656 18.0756 18.9162 17.9854 19.1556C17.8953 19.3951 17.7347 19.6029 17.5239 19.7531C17.3131 19.9032 17.0616 19.9887 16.8011 19.999C16.5407 20.0092 16.283 19.9436 16.0606 19.8106L12.0002 17.364L7.93735 19.8106C7.71498 19.9429 7.45759 20.0078 7.19759 19.9972C6.93759 19.9866 6.68661 19.9009 6.47625 19.7509C6.2659 19.6009 6.10557 19.3934 6.01546 19.1544C5.92535 18.9154 5.90949 18.6556 5.96987 18.4078L7.07623 13.8368L3.45805 10.7802C3.2613 10.6137 3.11901 10.3942 3.04894 10.149C2.97888 9.90385 2.98414 9.64389 3.06408 9.40163C3.14403 9.15936 3.2951 8.94553 3.49844 8.78682C3.70178 8.62811 3.94837 8.53157 4.20742 8.50925L8.95125 8.13456L10.7812 3.79886C10.8803 3.56257 11.0489 3.36045 11.2656 3.2182C11.4823 3.07595 11.7373 3 11.9982 3C12.259 3 12.514 3.07595 12.7307 3.2182C12.9474 3.36045 13.116 3.56257 13.2151 3.79886L15.0443 8.13456L19.7881 8.50925C20.0476 8.53074 20.295 8.62674 20.499 8.78523C20.7031 8.94372 20.8549 9.15764 20.9353 9.4002C21.0158 9.64276 21.0213 9.90316 20.9512 10.1488C20.8812 10.3944 20.7386 10.6143 20.5415 10.781L20.5463 10.7802Z" fill="currentColor"/></svg>' +
        '<span class="text-b3 uppercase leading-none text-primary" data-rating-value></span></div>';
      var ss0 = _shopifySrcset(img0.src), ss1 = _shopifySrcset(img1.src);
      var sizes = '(min-width:1024px) 25vw,50vw';
      var hImg = img1.src
        ? '<div class="absolute inset-0 isolate bg-surface-tertiary"><img src="' + escHtml(img1.src) + '"' + (ss1 ? ' srcset="' + ss1 + '"' : '') + ' sizes="' + sizes + '" alt="' + escHtml(img1.alt || '') + '" loading="' + load + '" class="absolute inset-0 w-full h-full object-contain mix-blend-multiply" aria-hidden="true"></div>'
        : '';
      var fImg = img0.src
        ? '<div class="absolute inset-0 isolate bg-surface-tertiary' + (img1.src ? ' transition-fade group-hover:opacity-0' : '') + '">' +
          '<img src="' + escHtml(img0.src) + '"' + (ss0 ? ' srcset="' + ss0 + '"' : '') + ' sizes="' + sizes + '" alt="' + escHtml(img0.alt || '') + '" loading="' + load + '"' + fprio + ' class="absolute inset-0 w-full h-full object-contain mix-blend-multiply"></div>'
        : '';
      var ctaDefault = avail
        ? quickViewCtaHtml(i18n.quickView)
        : notifyCtaHtml(i18n.notify);

      // Additive CTA mode (Phase 2 / Mini-Bag). Default (cta undefined) is unchanged
      // — existing PLP consumers keep quick-view/notify. In 'add_to_bag' mode the bag
      // icon is PERSISTENT (opacity 100, outside the reveal span) and only the label
      // sits behind the opacity reveal (per-part reveal — the label is invisible at
      // rest and revealed on desktop card hover). The bag path is taken verbatim from
      // snippets/icon-bag.liquid (FAILS §7). Desktop hover has no Figma backing (OQ8).
      var isAddToBag = cta === 'add_to_bag';
      var ctaContent = isAddToBag
        ? '<span class="text-b3 uppercase leading-none whitespace-nowrap transition-fade opacity-0 md:group-hover:opacity-100">' + escHtml(i18n.addToBag || 'Add to bag') + '</span>' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="size-16 relative bottom-px" aria-hidden="true" focusable="false"><path d="M12.001 2.90039C14.0699 2.90039 15.7606 4.4273 15.7607 6.33398V7.21289H16.5713C17.4373 7.21289 18.1912 7.79452 18.3232 8.5918L20.0791 19.1924C20.2465 20.2006 19.3812 21.0996 18.291 21.0996H5.70801C4.61789 21.0994 3.75436 20.2003 3.9209 19.1924L5.67773 8.5918C5.80972 7.79477 6.56155 7.21311 7.42676 7.21289H8.2373V6.33398C8.23746 4.42715 9.93233 2.9005 12.001 2.90039ZM9.05469 9.67578L9.04785 9.75293C9.03176 9.82821 8.9908 9.89629 8.93359 9.94922V9.9502C8.85635 10.0206 8.75316 10.0585 8.64746 10.0586C8.54247 10.0586 8.43906 10.0218 8.36133 9.95117C8.28445 9.88106 8.23614 9.78276 8.2373 9.67578V7.97559H7.42676C6.97589 7.97577 6.60349 8.25381 6.50195 8.63184L6.48535 8.70898L4.72754 19.3096C4.63962 19.8454 5.08566 20.3377 5.70801 20.3379H18.292C18.9147 20.3379 19.3621 19.8453 19.2734 19.3096L17.5176 8.70898C17.448 8.2922 17.0537 7.97461 16.5732 7.97461H15.7627V9.67676C15.7626 9.78158 15.7159 9.87843 15.6387 9.94922L15.6396 9.9502C15.5815 10.0039 15.5079 10.038 15.4307 10.0518L15.3525 10.0586C15.136 10.0576 14.9442 9.89512 14.9453 9.67578V7.97461H9.05469V9.67578ZM12.001 3.66309C10.3555 3.66319 9.05476 4.85764 9.05469 6.33398V7.21289H14.9443V6.33398C14.9443 4.85749 13.6473 3.66309 12.001 3.66309Z" fill="currentColor" stroke="currentColor" stroke-width="0.2"/></svg>'
        : ctaDefault;
      var ctaWrapClass = isAddToBag
        ? 'flex items-center gap-4 shrink-0 text-primary opacity-100 cursor-pointer md:group-hover/cta:text-invert'
        : 'flex items-center gap-4 shrink-0 text-primary opacity-100 transition-fade md:opacity-0 md:group-hover:opacity-100 md:group-hover/cta:text-invert';
      var title = escHtml(p.name || p.title || '');
      var rawHref = (p.url && /^(\/|https?:\/\/)/.test(String(p.url))) ? p.url : ('/products/' + (p.handle || ''));
      /* Tagalys's own product URLs (and our /products/handle fallback) are
         root-relative with no market prefix. On a path-based Markets setup
         (e.g. /en-int/, /en-eu/) that resolves to the domain root and drops
         the shopper back into the default market/currency on click — so
         prefix with the CURRENT request's market root (i18n.rootUrl, sourced
         from routes.root_url, which already resolves to the right market
         segment for wherever this page itself is), skipping absolute URLs
         and anything already inside that root. */
      var rootUrl = (i18n && i18n.rootUrl) || '';
      var href = rawHref;
      if (rootUrl && rootUrl !== '/' && /^\//.test(rawHref) && rawHref.indexOf(rootUrl) !== 0) {
        href = rootUrl.replace(/\/$/, '') + rawHref;
      }
      // Badges render inline from window.WhittardBadgeCache (populated by collection-tagalys-badges.liquid), reusing its pillsHtml so the card-pill markup lives in one place and survives Tagalys grid rebuilds.
      var bLabels = (window.WhittardBadgeCache || {})[p.handle] || [];
      var badge = (window.TagalysBadgeHydration && window.TagalysBadgeHydration.pillsHtml) ? window.TagalysBadgeHydration.pillsHtml(bLabels) : '';
      var imageBlock = '<div class="relative z-10 pointer-events-none aspect-square overflow-hidden shrink-0 border-b border-border-secondary">' + hImg + fImg +
        badge +
        '</div>' +
        '<div class="relative z-10 pointer-events-none flex flex-col gap-8 pl-12 pr-16 pt-16 flex-1 md:flex-row md:flex-wrap md:items-center md:gap-x-12 md:gap-y-8">' +
        '<p class="text-b2 text-primary line-clamp-4 order-1 md:order-1 md:flex-1 md:min-w-0">' + title + '</p>' +
        ratHtml + '</div>';

      var priceBlock = '<div class="relative z-10 flex items-center gap-4 flex-1 min-w-0 text-b3 uppercase text-secondary md:group-hover/cta:text-invert pointer-events-none" data-product-card-price>' + price + '</div>';

      // 'add_to_bag' mode needs a REAL interactive control for the CTA (a button that
      // adds to cart, not a link to the PDP) — but a <button> cannot validly nest
      // inside the surrounding <a> (invalid HTML, inconsistent browser parsing). Split
      // into two siblings instead: an <a> wrapping just the image/text for "view
      // product", and a real <button data-add-to-bag> for the CTA bar, wired up by the
      // consuming section (sections/mini-bag.liquid), not this shared renderer. The
      // <a> is a real flex flex-col box itself (not display:contents — that value has
      // known inconsistent cross-browser behaviour with aspect-ratio sizing on
      // grandchildren, confirmed live: it collapsed the image area to zero height) so
      // its image/text children get the exact same width/stretch context the original
      // single-anchor card gave them.
      if (isAddToBag) {
        var variantId = (p.variants && p.variants[0] && p.variants[0].id) || '';
        var addLabel = escHtml(i18n.addToBag || 'Add to bag') + ' — ' + title;
        return '<div class="product-card group flex flex-col bg-surface-tertiary" data-product-card' + trackAttr + ' data-product-id="' + escHtml(p.id) + '" data-product-url="' + escHtml(href) + '" data-product-handle="' + escHtml(p.handle || '') + '">' +
          '<a href="' + escHtml(href) + '" class="flex flex-col flex-1 min-w-0 no-underline" aria-label="' + title + '">' + imageBlock + '</a>' +
          '<div class="group/cta flex items-center gap-24 mt-24 border-t border-border-secondary px-12 py-16 transition-colours md:mt-32 md:hover:bg-surface-secondary-blue">' +
          priceBlock +
          '<button type="button" class="' + ctaWrapClass + ' focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" data-add-to-bag data-variant-id="' + escHtml(variantId) + '" aria-label="' + addLabel + '">' + ctaContent + '</button>' +
          '</div></div>';
      }

      var quickViewLabel = escHtml(avail ? i18n.quickView : i18n.notify) + ' — ' + title;
      return '<div class="product-card group relative flex flex-col bg-surface-tertiary" data-product-card' + trackAttr + ' data-product-id="' + escHtml(p.id) + '" data-product-url="' + escHtml(href) + '" data-product-handle="' + escHtml(p.handle || '') + '">' +
        '<a href="' + escHtml(href) + '" class="absolute inset-0 z-0" aria-label="' + title + '"></a>' +
        imageBlock +
        '<div class="group/cta relative z-10 isolate flex items-center gap-24 mt-24 border-t border-border-secondary px-12 py-16 transition-colours md:mt-32 md:hover:bg-surface-secondary-blue">' +
        priceBlock +
        '<button type="button" class="absolute inset-0 z-0 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" data-quick-view-open data-product-url="' + escHtml(href) + '" data-product-handle="' + escHtml(p.handle || '') + '" aria-haspopup="dialog" aria-controls="QuickViewDrawer" aria-label="' + quickViewLabel + '"></button>' +
        '<div class="' + ctaWrapClass + ' pointer-events-none" aria-hidden="true" data-product-card-cta>' + ctaContent + '</div>' +
        '</div></div>';
    };

    window.TagalysCard.notifyCtaHtml = notifyCtaHtml;
    window.TagalysCard.quickViewCtaHtml = quickViewCtaHtml;

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys-facet-format"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.TagalysFacetFormat = {
      parseFacetValues: function (raw) {
        if (raw && raw.charAt(0) === '[') {
          try {
            var arr = JSON.parse(raw);
            if (Array.isArray(arr)) return arr;
          } catch (e) {}
        }
        return [raw];
      },
      titleCaseBoolLabel: function (lbl) {
        var lower = String(lbl || '').toLowerCase();
        if (lower === 'true') return 'True';
        if (lower === 'false') return 'False';
        return lbl;
      },
      isFormatLabelFacet: function (key) {
        return String(key || '').slice(-'format_label'.length) === 'format_label';
      },
      truncateFormatLabel: function (key, lbl) {
        if (!window.TagalysFacetFormat.isFormatLabelFacet(key)) return lbl;
        var str = String(lbl || '').split(/,|\s=\s/)[0].trim();
        return str
          .replace(/^\d+\s*/, '')
          .replace(/\s*\d+(\.\d+)?\s*(g|kg)$/i, '')
          .replace(/\s+pouch$/i, '')
          .trim() || str;
      },
      groupFacetItems: function (state, key, items) {
        var titleCaseBoolLabel = window.TagalysFacetFormat.titleCaseBoolLabel;
        var truncateFormatLabel = window.TagalysFacetFormat.truncateFormatLabel;
        var order = [], byLabel = {};
        (items || []).forEach(function (o) {
          var val = o.id || '';
          var rawLbl = titleCaseBoolLabel(o.name || o.label || val);
          var lbl = truncateFormatLabel(key, rawLbl);
          var g = byLabel[lbl];
          if (!g) {
            g = byLabel[lbl] = { label: lbl, ids: [], rawLabels: [], count: 0, hasCount: false, selected: false };
            order.push(lbl);
          }
          g.ids.push(val);
          g.rawLabels.push(rawLbl);
          if (o.count != null) { g.hasCount = true; g.count += Number(o.count) || 0; }
          if (o.selected || (state.filters[key] || []).indexOf(val) >= 0) g.selected = true;
        });
        return order.map(function (lbl) { return byLabel[lbl]; });
      }
    };

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys-facet-tiles"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var escHtml = window.TagalysProductFormat.escHtml;

    window.TagalysFacetTiles = function (options) {
      options = options || {};
      var state = options.state || { filters: {}, sort: null };

      /* custom.product_type is a metaobject reference — Tagalys's facet response only
         ever returns the raw, unresolved gid://shopify/Metaobject/... value it got from
         the Storefront API, with no name or image. snippets/product-type-lookup.liquid
         renders every metaobject entry's { name, image } keyed by its numeric id into a
         <script data-product-type-lookup> JSON blob — resolved here, client-side, so
         the rest of the facet-rendering pipeline never needs to know a GID was ever
         involved. Cached after first read since the lookup never changes mid-session. */
      var productTypeLookup = null;
      function getProductTypeLookup() {
        if (productTypeLookup) return productTypeLookup;
        var el = document.querySelector('[data-product-type-lookup]');
        try { productTypeLookup = el ? JSON.parse(el.textContent) : {}; }
        catch (e) { productTypeLookup = {}; }
        return productTypeLookup;
      }

      function numericIdFromGid(value) {
        var match = String(value || '').match(/Metaobject\/(\d+)/);
        return match ? match[1] : null;
      }

      function resolveProductTypeItems(items) {
        var lookup = getProductTypeLookup();
        return (items || []).map(function (o) {
          var candidates = [o.id, o.name, o.label];
          var resolved = null;
          for (var i = 0; i < candidates.length; i++) {
            var numericId = numericIdFromGid(candidates[i]);
            if (numericId && lookup[numericId]) { resolved = lookup[numericId]; break; }
          }
          if (!resolved) return o;
          return Object.assign({}, o, {
            name: resolved.name || o.name,
            image_url: resolved.image || o.image_url
          });
        });
      }

      /* Tagalys prefixes facet ids inconsistently (confirmed live: the price facet's
         real id is "sale_price", this one is "p.m.custom.product_type", not the bare
         "product_type" the dashboard label alone would suggest) — match on the key
         ending in "product_type" rather than an exact string so this survives
         whatever prefix convention is actually in use. Also matches the
         multi-value custom.product_types (list of the same product_type
         metaobject), so it resolves and renders as tiles too (TASK-54855). */
      function isProductTypeFacet(key) {
        return /product_types?$/.test(String(key || ''));
      }

      function imageTiles(f) {
        var key = f.id || '';
        return '<div class="flex flex-wrap gap-4 items-stretch w-full">' +
          (f.items || []).map(function (o) {
            var val = o.id || '';
            var sel = o.selected || (state.filters[key] || []).indexOf(val) >= 0;
            var unavailable = !sel && !o.count;
            /* Selected tile: border-primary + the same 3%-black-over-tertiary tint
               already used for hover elsewhere (bg-surface-tile-hover), and the
               image drops its mix-blend-multiply so it renders at full colour —
               both confirmed against the Figma "selected" state directly. Hover
               (unselected, available tiles only) reuses that identical
               border/bg-tile-hover treatment — the same pattern button.liquid's
               chip buttons already use for their own hover state. */
            var hoverClass = (!sel && !unavailable) ? ' transition-btn-primary hover:border-border-primary hover:bg-surface-tile-hover' : '';
            return '<button type="button" class="flex flex-col items-center justify-start gap-8 shrink-0 w-111 px-20 py-12 border md:gap-12 md:w-120 md:px-8' +
              (sel ? ' border-border-primary bg-surface-tile-hover' : ' border-border-secondary bg-surface-tertiary') +
              hoverClass +
              ' rounded-xs' + (unavailable ? ' opacity-40 cursor-not-allowed' : ' cursor-pointer') + '" data-facet-key="' + escHtml(key) + '" data-facet-value="' + escHtml(val) + '" data-facet-label="' + escHtml(o.name || val) + '" data-image-tile aria-pressed="' + sel + '"' + (unavailable ? ' disabled' : '') + '>' +
              '<div class="relative size-68">' +
              // alt="" — decorative: the adjacent <span> below already renders
              // o.name/val as visible text, so a real alt would announce it twice.
              (o.image_url && (/^https:\/\//.test(String(o.image_url)) || /^\/(?!\/)/.test(String(o.image_url))) ? '<img src="' + escHtml(o.image_url) + '" alt="" width="68" height="68" loading="lazy" class="w-full h-full object-cover' + (sel ? '' : ' mix-blend-multiply') + '">' : '') +
              '</div><span class="text-f2 text-primary text-center leading-tight">' + escHtml(o.name || val) + '</span></button>';
          }).join('') + '</div>';
      }

      return {
        isProductTypeFacet: isProductTypeFacet,
        resolveProductTypeItems: resolveProductTypeItems,
        imageTiles: imageTiles
      };
    };

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys-facets"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    // Shared with collection-tagalys.liquid, collection-tagalys-card.liquid, and
    // mini-bag-recommendations-script.liquid via assets/tagalys-recommendations.js
    // (window.TagalysProductFormat) — was a byte-for-byte duplicate here before
    // this dedupe (TASK-47920).
    var escHtml = window.TagalysProductFormat.escHtml;
    // Page-scoped, not sitewide window.TagalysProductFormat (code review,
    // TASK-54365) — see collection-tagalys-facet-format.liquid's doc comment.
    var titleCaseBoolLabel = window.TagalysFacetFormat.titleCaseBoolLabel;
    var truncateFormatLabel = window.TagalysFacetFormat.truncateFormatLabel;
    var groupFacetItems = window.TagalysFacetFormat.groupFacetItems;

    // Same query plp-option-tooltips.liquid's click handler checks — read here too
    // so tooltipMarkup can decide whether aria-expanded reflects a real state.
    var _hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

    window.TagalysFacets = function (options) {
      options = options || {};
      var i18n        = options.i18n || {};
      var state       = options.state || { filters: {}, sort: null };
      var priceMinKey = options.priceMinKey || 'selected_min';
      var priceMaxKey = options.priceMaxKey || 'selected_max';
      var facetPriority = options.facetPriority || [];
      var maxFacetLinks = options.maxFacetLinks || 0;

      // Same options object this factory received — already carries i18n/state/
      // priceMinKey/priceMaxKey, all TagalysPriceRender needs.
      var priceRender = window.TagalysPriceRender(options);
      // Same options object — TagalysFacetTiles only needs state.
      var facetTiles = window.TagalysFacetTiles(options);

      /* Every checkbox/tile option ever seen per facet, keyed by facet id then
         option id. Tagalys drops options from a facet's `items` once they'd
         return zero results under the current filters — merging into this
         cache keeps them visible (greyed out) instead of letting them vanish. */
      var facetOptionCache = {};
      /* Tagalys also drops an entire facet (accordion section) once none of
         its options would return a result — cached separately, in first-seen
         order, so whole sections stay visible too instead of disappearing. */
      var facetCache = {};
      var facetOrder = [];

      /* Merges this response's facets into the running cache: updates the
         definition for anything still present, and keeps (flagged
         _unavailable) any facet the response dropped entirely, in its
         original first-seen order — so a whole section (e.g. "Origin")
         stays visible instead of disappearing when nothing in it matches.

         caffeine_free is deliberately NOT excluded here — treated like every
         other custom.* facet (tea_type, taste_notes, format, flavour,
         organic) even though the client hasn't populated the metafield on
         any products yet. The facet-dropping behaviour this function already
         handles (a whole section disappearing once nothing in it matches)
         covers that "no data yet" state on its own — the merchant needs no
         theme change once the metafield is populated. */
      function mergeFacets(facets) {
        var seen = {};
        (facets || []).forEach(function (f) {
          var key = f.id || '';
          if (!facetCache[key]) facetOrder.push(key);
          facetCache[key] = f;
          seen[key] = true;
        });
        return facetOrder.map(function (key) {
          var f = facetCache[key];
          return seen[key] ? f : Object.assign({}, f, { _unavailable: true });
        });
      }

      function facetSuffix(f) {
        return String((f && f.id) || '').split('.').pop();
      }

      function isBooleanFacet(f) {
        var segment = facetSuffix(f);
        return f.type === 'boolean' || segment === 'organic' || segment === 'limited_edition';
      }

      /* Count of currently-active selections within this facet, shown as the small
         blue "Counter" badge next to its label (Figma: bg-surface-blue, size-16,
         rounded-full) whenever > 0. Checks state.filters as well as the
         response's own "selected" flags — merged/cached facets (see
         mergeFacets/mergeFacetItems) can carry forward a stale "selected" value
         from an earlier response, so state.filters is the source of truth. */
      function facetActiveCount(f) {
        var key = f.id || '';
        if (f.type === 'range' || key === 'price') {
          var applied = state.filters[key] || {};
          var hasMin = applied[priceMinKey] != null || f.selected_min != null;
          var hasMax = applied[priceMaxKey] != null || f.selected_max != null;
          return (hasMin || hasMax) ? 1 : 0;
        }
        if (isBooleanFacet(f)) {
          return (f.selected || !!state.filters[key]) ? 1 : 0;
        }
        // Dedupes by display label, not raw id — a selected group whose ids
        // collapsed onto one checkbox (TagalysFacetFormat.groupFacetItems)
        // still counts as a single active selection here.
        var seenLabels = {}, count = 0;
        (f.items || []).forEach(function (o) {
          var val = o.id || '';
          if (o.selected || (state.filters[key] || []).indexOf(val) >= 0) {
            var lbl = truncateFormatLabel(key, titleCaseBoolLabel(o.name || o.label || val));
            if (!seenLabels[lbl]) { seenLabels[lbl] = true; count++; }
          }
        });
        return count;
      }

      function accordion(f) {
        var key = f.id || '';
        var panelId = 'accordion-panel-' + escHtml(key);
        var triggerId = panelId + '-trigger';
        var count = facetActiveCount(f);
        var counterHtml = count > 0
          ? '<span class="flex flex-col items-center justify-center shrink-0 size-16 rounded-full bg-surface-blue" aria-hidden="true"><span class="text-counter text-center text-invert leading-none">' + count + '</span></span>'
          : '';
        var el  = document.createElement('div');
        // border-b on the accordion item itself, not a shared divide-y on the
        // parent list — an accordion always trails its own hairline (Figma:
        // every FilterAccordion, including the last, Price, renders one), but
        // the flat boolean rows after it never should (see flatFacetRow).
        el.className = 'border-b border-border-secondary';
        el.setAttribute('data-accordion-item', '');
        el.setAttribute('data-filter-key', key);
        // Display name of the facet, read by assets/analytics.js as the
        // filters_apply `type` parameter — the report wants "Format", not the
        // raw Tagalys key. Kept here because this is the only place the label
        // and the key are both in scope.
        el.setAttribute('data-filter-label', f.label || f.name || key);
        el.innerHTML =
          '<button type="button" id="' + triggerId + '" class="group w-full flex items-center justify-between gap-16 cursor-pointer select-none bg-transparent border-0 p-0 focus-visible:outline-2 focus-visible:outline-offset-xs focus-visible:outline-primary" aria-expanded="false" aria-controls="' + panelId + '" data-accordion-trigger>' +
          '<span class="flex flex-1 items-center gap-8 min-w-0 py-20 text-f2 leading-f4 uppercase text-primary text-left">' + escHtml(f.label || f.name || key) + counterHtml + '</span>' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="size-16 shrink-0 opacity-75 transition-transform-a7 group-aria-expanded:rotate-180" aria-hidden="true" focusable="false"><path d="M19 8.5L12 15.5L5 8.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>' +
          '<div id="' + panelId + '" class="grid grid-rows-closed transition-grid-rows-eb" role="region" aria-labelledby="' + triggerId + '" data-accordion-wrapper inert>' +
          '<div class="min-h-0 overflow-hidden" data-accordion-clip><div class="pt-12 pb-32 md:pt-20 md:pb-40">' + facetContent(f) + '</div></div></div>';
        return el;
      }

      /* facet-option-tooltip-lookup.liquid renders a lowercased-value -> tooltip
         JSON blob from the "facet_option_tooltip" metaobject — merchant-editable
         help copy for any facet option, resolved client-side. */
      var tooltipLookup = null;
      function getTooltipLookup() {
        if (tooltipLookup) return tooltipLookup;
        var el = document.querySelector('[data-facet-tooltip-lookup]');
        try { tooltipLookup = el ? JSON.parse(el.textContent) : {}; }
        catch (e) { tooltipLookup = {}; }
        return tooltipLookup;
      }

      function facetContent(f) {
        var key = f.id || '';
        if (f.type === 'range' || key === 'price') return priceRender.render(f);
        if (isBooleanFacet(f))                     return boolFacet(f);
        if (!facetTiles.isProductTypeFacet(key))    return checkboxFacet(f);

        var items = facetTiles.resolveProductTypeItems(f.items);
        if ((items || [])[0] && items[0].image_url) {
          // Merged here (not inside TagalysFacetTiles) — facetOptionCache is
          // this file's own private state, needed to keep a dropped-but-
          // previously-seen tile visible (greyed out) across responses.
          // Passed via a shallow copy, never written back onto `f` itself
          // (facetCache[key] === f, the same object mergeFacets caches) —
          // mutating it would leak already-merged items back through
          // mergeFacets' _unavailable branch on a later response where this
          // facet is dropped (code review, TASK-54365).
          var mergedItems = mergeFacetItems(key, f._unavailable ? [] : items);
          return facetTiles.imageTiles(Object.assign({}, f, { items: mergedItems }));
        }
        return checkboxFacet(Object.assign({}, f, { items: items }));
      }

      /* Merges this response's items into the running per-facet cache: updates
         count/name/image for anything still present, and keeps (at count: 0)
         anything the response dropped, in its original first-seen order. */
      function mergeFacetItems(key, items) {
        var cache = facetOptionCache[key] || (facetOptionCache[key] = { order: [], byId: {} });
        var seen = {};
        (items || []).forEach(function (o) {
          var val = o.id || '';
          seen[val] = true;
          if (!cache.byId[val]) cache.order.push(val);
          cache.byId[val] = o;
        });
        return cache.order.map(function (val) {
          var o = cache.byId[val];
          return seen[val] ? o : Object.assign({}, o, { count: 0 });
        });
      }

      /* Shared "i" info-badge + popover for both checkboxFacet and boolFacet
         option tooltips, sourced from the facet_option_tooltip metaobject
         (optionTooltip/getTooltipLookup below). Styling matches Figma node
         7132:58331 (Filters Drawer, State=Tooltip, 1366px): 215px bubble,
         bg-surface-blue, text-b2, rounded-s, 25px backdrop blur, arrow.

         A real <button>, not a <span> — touch has no hover state, so it needs
         a tap target toggling aria-expanded (see plp-option-tooltips.liquid's
         click handler); keyboard focus reveals it too (group-focus-within/tt,
         WCAG 1.4.13). Rendered as a SIBLING immediately after </label>, never
         nested inside it — <button> is labelable content, so a <label> may
         not validly contain one. The popover text is aria-hidden — the
         button's own aria-label already carries it.

         aria-expanded is omitted on hover-capable pointers: there the popover
         is a pure CSS reveal (group-hover/tt, group-focus-within/tt) with no
         JS state change, so an announced collapsed/expanded value would be
         actively wrong once revealed. Only touch (plp-option-tooltips.liquid's
         hover check) toggles a real state, so only there does it apply.

         The focus-within reveal also requires data-tooltip-dismissed to be
         absent — plp-option-tooltips.liquid sets that attribute on Escape (so
         a focus-triggered popover can be dismissed per WCAG 1.4.13 without
         also blurring the trigger, which would break WCAG 2.4.3) and clears
         it on blur, so the popover shows again on the next focus-in.

         data-option-tooltip-popover/-arrow are read by plp-option-tooltips.liquid
         to clamp the bubble 8px clear of the drawer's left edge on short-label
         options, where the centred bubble would otherwise overshoot it. */
      function tooltipMarkup(text) {
        if (!text) return '';
        var expandedAttr = _hoverCapable.matches ? '' : ' aria-expanded="false"';
        return '<button type="button" class="group/tt relative cursor-default" data-option-tooltip-trigger' + expandedAttr + ' aria-label="' + escHtml(text) + '">' +
          '<span class="flex flex-col items-center justify-center shrink-0 size-16 rounded-full bg-surface-blue" aria-hidden="true"><span class="text-f2 text-center text-invert">i</span></span>' +
          '<span class="absolute bottom-full left-1/2 -translate-x-1/2 mb-8 flex flex-col items-center w-215 opacity-0 pointer-events-none group-hover/tt:opacity-100 group-[:focus-within:not([data-tooltip-dismissed])]/tt:opacity-100 group-aria-expanded/tt:opacity-100 transition-fade z-10" data-option-tooltip-popover>' +
            '<span class="backdrop-blur-frosted bg-surface-blue flex items-center justify-center px-16 py-12 rounded-s w-full">' +
              '<span class="text-b2 text-invert text-center" aria-hidden="true">' + escHtml(text) + '</span>' +
            '</span>' +
            '<svg width="21" height="9" viewBox="0 0 21 9" fill="none" aria-hidden="true" class="shrink-0 -mt-1" data-option-tooltip-arrow><path d="M0 0H21L10.5 9L0 0Z" fill="var(--color-surface-blue)"/></svg>' +
          '</span>' +
          '</button>';
      }

      /* Admin-editable help tooltip on a facet option, sourced from the
         "facet_option_tooltip" metaobject (see getTooltipLookup above) and
         matched on the option's own label text — independent of which facet
         it belongs to or what Tagalys itself knows about it. Accepts either
         a single label or an array of candidates tried in order: a grouped
         checkbox (groupFacetItems) tries its truncated display label first,
         then each pre-truncation raw label, so a tooltip entry a merchant
         authored against the OLD full label ("Loose Leaf Tea, 100g") still
         matches after truncation started hiding that text (code review,
         TASK-54365) — otherwise the "i" badge would just silently vanish. */
      function optionTooltip(labels) {
        var candidates = Array.isArray(labels) ? labels : [labels];
        var lookup = getTooltipLookup();
        for (var i = 0; i < candidates.length; i++) {
          var text = lookup[String(candidates[i] || '').trim().toLowerCase()];
          if (text) return tooltipMarkup(text);
        }
        return '';
      }

      /* TASK-54857: the Gift Type facet's "Tea" option covers most of the
         catalogue on every tea collection (e.g. 131 of 142 results), where its
         admin-authored tooltip reads as noise rather than help. Scoped to this
         exact facet id + label pair only — every other facet, including a
         "Tea" label anywhere else, keeps rendering its tooltip as before.

         Compared against facetSuffix(f), not the raw f.id: f.id is a dotted
         path (e.g. "metafields.custom.gift_type"), and facetSuffix is this
         file's own established way of reading the meaningful part of it
         (see its own definition above). */
      function isSuppressedOptionTooltip(f, labels) {
        if (facetSuffix(f) !== 'gift_type') return false;
        return labels.some(function (label) {
          return String(label || '').trim().toLowerCase() === 'tea';
        });
      }

      function checkboxFacet(f) {
        var key = f.id || '';
        var items = mergeFacetItems(key, f._unavailable ? [] : (f.items || []));
        return groupFacetItems(state, key, items).map(function (g) {
          var lbl = g.label;
          // Only if some underlying item actually carried a count field —
          // a facet whose items never carry one previously rendered no
          // count span at all; summing an always-present g.count regardless
          // would show a false "(0)" (code review, TASK-54365).
          var cnt = g.hasCount ? ' <span class="text-secondary ml-4">(' + g.count + ')</span>' : '';
          var chk = g.selected;
          var unavailable = !chk && !g.count;
          // JSON array when a group merges more than one underlying id,
          // otherwise the bare id string — parsed back out by the checkbox
          // change handlers in collection-tagalys.liquid/search-tagalys.liquid
          // (window.TagalysFacetFormat.parseFacetValues).
          var val = g.ids.length > 1 ? JSON.stringify(g.ids) : g.ids[0];
          return '<div class="flex items-center gap-8 py-8 first:pt-0 last:pb-0">' +
            '<label class="group flex items-center gap-8 select-none' + (unavailable ? ' cursor-not-allowed' : ' cursor-pointer') + '">' +
            '<span class="relative size-16 shrink-0 inline-flex">' +
            /* data-facet-label carries the option name on its own, without the
               "(3)" product count the visible label appends. assets/analytics-collection.js
               reports it as the filters_apply `option`; reading the label's text
               instead swept the count in with it (QA, 2026-09-01), and stripping a
               trailing "(n)" would corrupt any option whose name legitimately ends
               in brackets. */
            '<input type="checkbox" class="sr-only peer" data-facet-key="' + escHtml(key) + '" data-facet-value="' + escHtml(val) + '" data-facet-label="' + escHtml(lbl) + '"' + (chk ? ' checked' : '') + (unavailable ? ' disabled' : '') + '>' +
            '<span class="absolute inset-0 border border-border-secondary rounded-px transition-btn-primary peer-checked:border-surface-secondary-blue peer-disabled:opacity-40' + (unavailable ? '' : ' group-hover:border-border-primary group-hover:delay-200') + '" aria-hidden="true"></span>' +
            '<span class="absolute inset-0 m-auto size-8 rounded-px bg-surface-secondary-blue opacity-0 peer-checked:opacity-100" aria-hidden="true"></span>' +
            '</span>' +
            '<span class="text-f2 leading-f4 text-primary' + (unavailable ? ' opacity-40' : '') + '">' + escHtml(lbl) + cnt + '</span>' +
            '</label>' +
            (isSuppressedOptionTooltip(f, [lbl].concat(g.rawLabels)) ? '' : optionTooltip([lbl].concat(g.rawLabels))) +
            '</div>';
        }).join('');
      }

      function boolFacet(f) {
        var key = f.id || '';
        var sel = f.selected || !!state.filters[key];
        var unavailable = !sel && f._unavailable;
        // Admin-editable via the same facet_option_tooltip metaobject every other
        // facet option tooltip reads (optionTooltip/getTooltipLookup above) —
        // renders nothing until a merchant actually adds an entry for this
        // facet's label. Previously hardcoded to a fixed i18n string that showed
        // regardless of whether anything was configured in admin.
        var tip = optionTooltip(f.label || key);
        return '<div class="flex items-center gap-8">' +
          '<label class="group flex items-center gap-8 select-none' + (unavailable ? ' cursor-not-allowed' : ' cursor-pointer') + '">' +
          '<span class="relative size-16 shrink-0 inline-flex">' +
          '<input type="checkbox" class="sr-only peer" data-facet-key="' + escHtml(key) + '" data-facet-value="true" data-facet-label="' + escHtml(f.label || key) + '"' + (sel ? ' checked' : '') + (unavailable ? ' disabled' : '') + '>' +
          '<span class="absolute inset-0 border border-border-secondary rounded-px transition-btn-primary peer-checked:border-surface-secondary-blue peer-disabled:opacity-40' + (unavailable ? '' : ' group-hover:border-border-primary group-hover:delay-200') + '" aria-hidden="true"></span>' +
          '<span class="absolute inset-0 m-auto size-8 rounded-px bg-surface-secondary-blue opacity-0 peer-checked:opacity-100" aria-hidden="true"></span>' +
          '</span>' +
          '<span class="text-f2 leading-f4 text-primary' + (unavailable ? ' opacity-40' : '') + '">' + escHtml(f.label || key) + '</span>' +
          '</label>' + tip +
          '</div>';
      }

      /* Dual-checks state.sort against the response's own "selected" flag (the
         same reasoning as facetActiveCount): falls back to the server's echoed
         selection only when local state.sort hasn't been set yet (initial load
         before any sort interaction). */
      function renderSort(opts) {
        if (!opts.length) return;
        document.querySelectorAll('[data-sort-options]').forEach(function (lb) {
          lb.innerHTML = opts.map(function (o) {
            var id = o.id || o.value || '';
            var sel = state.sort === id || (!state.sort && o.selected);
            return '<div>' +
              '<button type="button" role="radio" class="group flex items-center gap-8 cursor-pointer bg-transparent border-0 p-0 focus-visible:outline-2 focus-visible:outline-offset-xs focus-visible:outline-primary" aria-checked="' + sel + '"' +
              (sel ? ' data-selected' : '') + ' data-sort-option="' + escHtml(id) + '">' +
              '<span class="shrink-0 size-16 rounded-full border border-border-secondary group-data-[selected]:border-surface-secondary-blue flex items-center justify-center" aria-hidden="true">' +
              '<span class="size-8 rounded-full bg-surface-secondary-blue opacity-0 group-data-[selected]:opacity-100"></span></span>' +
              '<span class="text-f4 text-primary xl:text-f2 xl:leading-f4">' + escHtml(o.label || o.name || id) + '</span></button></div>';
          }).join('');
        });
      }

      function flatFacetRow(f) {
        var el = document.createElement('div');
        el.className = 'pt-20';
        el.setAttribute('data-filter-key', f.id || '');
        el.innerHTML = boolFacet(f);
        return el;
      }

      function renderFacets(facets) {
        var cont = document.querySelector('[data-facets-container]');
        if (!cont) return;

        var merged = mergeFacets(facets);

        merged = merged.slice().sort(function (a, b) {
          return (isBooleanFacet(a) ? 1 : 0) - (isBooleanFacet(b) ? 1 : 0);
        });

        var openKeys = [];
        cont.querySelectorAll('[data-accordion-item][data-filter-key]').forEach(function (item) {
          var t = item.querySelector('[data-accordion-trigger]');
          if (t && t.getAttribute('aria-expanded') === 'true') {
            openKeys.push(item.getAttribute('data-filter-key'));
          }
        });

        var wrap = document.createElement('div');
        wrap.className = 'flex flex-col';
        wrap.setAttribute('data-facets-live', '');
        merged.forEach(function (f) { wrap.appendChild(isBooleanFacet(f) ? flatFacetRow(f) : accordion(f)); });
        var old = cont.querySelector('[data-facets-live], [data-facets-placeholder]');
        old ? old.replaceWith(wrap) : cont.insertBefore(wrap, cont.firstChild);

        openKeys.forEach(function (key) {
          var item = wrap.querySelector('[data-filter-key="' + key + '"]');
          if (!item) return;
          var wrapper = item.querySelector('[data-accordion-wrapper]');
          var trigger = item.querySelector('[data-accordion-trigger]');
          if (wrapper) { wrapper.style.gridTemplateRows = '1fr'; wrapper.removeAttribute('inert'); }
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
          /* Restoring straight to open, same as plp-ui.liquid's _openAccordion
             — lift the collapse-animation clip so a facet-option tooltip
             popping outside the panel's box isn't cut off after a re-render. */
          var clip = item.querySelector('[data-accordion-clip]');
          if (clip) clip.style.overflow = 'visible';
        });

        var linksEl = document.querySelector('[data-facet-links]');
        if (linksEl) {
          var linkFacets = merged;
          if (facetPriority.length) {
            linkFacets = linkFacets.slice().sort(function (a, b) {
              var aRank = facetPriority.indexOf(facetSuffix(a));
              var bRank = facetPriority.indexOf(facetSuffix(b));
              if (aRank === -1) aRank = facetPriority.length;
              if (bRank === -1) bRank = facetPriority.length;
              return aRank - bRank;
            });
          }
          if (maxFacetLinks > 0) linkFacets = linkFacets.slice(0, maxFacetLinks);
          linksEl.innerHTML = linkFacets.map(function (f) {
            var key = f.id || '';
            var label = f.label || f.name || key;
            return '<button type="button" class="shrink-0 text-f4 text-primary cursor-pointer bg-transparent border-0 p-0 focus-visible:outline-2 focus-visible:outline-offset-xs focus-visible:outline-primary hover:opacity-75 transition-fade" data-drawer-open="filters-drawer" data-filter-trigger="' + escHtml(key) + '">' + escHtml(label) + '</button>';
          }).join('');
        }

        return merged;
      }

      return {
        renderFacets: renderFacets,
        renderSort: renderSort,
        facetActiveCount: facetActiveCount,
        syncPriceRange: priceRender.sync
      };
    };

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys-price-events"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.TagalysPriceEvents = function (options) {
      options = options || {};
      var state          = options.state || { filters: {}, sort: null };
      var priceMinKey     = options.priceMinKey || 'selected_min';
      var priceMaxKey     = options.priceMaxKey || 'selected_max';
      var syncPriceRange  = options.syncPriceRange || function () {};
      var priceTimer;

      function bind(reload) {
        document.addEventListener('input', function (e) {
          var el = e.target;
          if (!el.hasAttribute('data-price-min') && !el.hasAttribute('data-price-max')) return;
          var root = el.closest('[data-price-range]');
          if (!root) return;
          var minE = root.querySelector('[data-price-min]'), maxE = root.querySelector('[data-price-max]');
          if (el.hasAttribute('data-price-min') && parseInt(minE.value, 10) > parseInt(maxE.value, 10)) minE.value = maxE.value;
          if (el.hasAttribute('data-price-max') && parseInt(maxE.value, 10) < parseInt(minE.value, 10)) maxE.value = minE.value;
          syncPriceRange(root);

          clearTimeout(priceTimer);
          priceTimer = setTimeout(function () {
            var key  = el.getAttribute('data-facet-key') || 'price';
            var minV = minE && minE.value !== '' ? parseInt(minE.value, 10) : null;
            var maxV = maxE && maxE.value !== '' ? parseInt(maxE.value, 10) : null;
            delete state.filters[key];
            /* An open-ended range (the quiz's "Under £20" / "£40+") leaves its
               missing bound out rather than sending it as null: the Tagalys API
               rejects an empty bound outright but filters correctly on a lone
               min or max. The slider always writes both, so it is unaffected. */
            if (minV != null || maxV != null) {
              var range = {};
              if (minV != null) range[priceMinKey] = minV;
              if (maxV != null) range[priceMaxKey] = maxV;
              state.filters[key] = range;
            }
            reload();
          }, 600);
        });

        /* Typed min/max price entry — parses the digits out of the input (typed
           over the currency-formatted display), sets it on the matching slider,
           and lets the slider's own value sanitisation clamp anything outside
           its min/max back to that bound, then replays the same 'input'
           pipeline above (thumb-vs-thumb clamp, display sync, debounced
           reload) via a dispatched event rather than duplicating it. */
        document.addEventListener('change', function (e) {
          var el = e.target;
          if (!el.hasAttribute('data-price-min-display') && !el.hasAttribute('data-price-max-display')) return;
          var root = el.closest('[data-price-range]');
          if (!root) return;
          var slider = el.hasAttribute('data-price-min-display')
            ? root.querySelector('[data-price-min]')
            : root.querySelector('[data-price-max]');
          if (!slider) return;
          var typed = parseFloat(String(el.value).replace(/[^0-9.-]/g, ''));
          slider.value = isNaN(typed) ? slider.value : Math.round(typed);
          slider.dispatchEvent(new Event('input', { bubbles: true }));
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && e.target.hasAttribute && (e.target.hasAttribute('data-price-min-display') || e.target.hasAttribute('data-price-max-display'))) {
            e.preventDefault();
            e.target.blur();
          }
        });

        /* Bring whichever thumb the user grabs to the front, so two overlapping
           range inputs near the same value don't trap one thumb beneath the other. */
        document.addEventListener('pointerdown', function (e) {
          var el = e.target.closest('[data-price-min], [data-price-max]');
          if (!el) return;
          var root = el.closest('[data-price-range]');
          if (!root) return;
          var minE = root.querySelector('[data-price-min]'), maxE = root.querySelector('[data-price-max]');
          var top = el.hasAttribute('data-price-min') ? minE : maxE;
          var other = top === minE ? maxE : minE;
          top.style.zIndex = '2';
          other.style.zIndex = '1';
        });
      }

      return { bind: bind };
    };

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys-price-render"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var escHtml = window.TagalysProductFormat.escHtml;

    window.TagalysPriceRender = function (options) {
      options = options || {};
      var i18n        = options.i18n || {};
      var state       = options.state || { filters: {}, sort: null };
      var priceMinKey = options.priceMinKey || 'selected_min';
      var priceMaxKey = options.priceMaxKey || 'selected_max';

      function money(pounds) {
        return window.TagalysProductFormat.money(pounds, i18n.currency, true);
      }

      /* Track padding compensation: the native range thumb's own centring
         already accounts for its own width, but the custom-painted fill/thumb
         hit-box — .range-slider-input overflows 8px past the track on each
         side specifically so the painted dot still lands flush with the
         track edges (matching Figma) despite the bigger click target.
         frac is 0–1. */
      function thumbPos(frac) {
        return 'calc(' + frac + ' * (100% - 16px) + 8px)';
      }

      function render(f) {
        /* Tagalys sends price facet bounds already in whole currency units (pounds),
           not pence — e.g. { min: 0, max: 90 } for a £0-£90 range, confirmed via its
           raw API response (display_format template concatenates the currency
           label directly onto this value). Do not divide by 100. */
        var min = f.min || 0, max = f.max || 1000;
        var applied = state.filters[f.id || 'price'] || {};
        var sMin = applied[priceMinKey] != null ? applied[priceMinKey] : (f.selected_min != null ? f.selected_min : min);
        var sMax = applied[priceMaxKey] != null ? applied[priceMaxKey] : (f.selected_max != null ? f.selected_max : max);
        var key  = f.id || 'price';
        var eKey = escHtml(key);
        var minP = Math.round(min), maxP = Math.round(max);
        var sMinP = Math.round(sMin), sMaxP = Math.round(sMax);
        var range = (maxP - minP) || 1;
        var fracMin = (sMinP - minP) / range;
        var fracMax = (sMaxP - minP) / range;
        return '<div class="flex flex-col gap-16" data-price-range>' +
          '<div class="flex items-center gap-4">' +
          '<div class="flex flex-1 flex-col min-w-0 gap-8 pt-1.5 pb-4 px-8 bg-surface-input border border-border-secondary">' +
          '<span class="text-b3 text-secondary uppercase">' + escHtml(i18n.priceMin) + '</span>' +
          '<input type="text" inputmode="decimal" class="text-b2 text-primary bg-transparent border-0 p-0 w-full min-w-0 outline-none" data-price-min-display value="' + escHtml(money(sMinP)) + '" aria-label="' + escHtml(i18n.priceMin) + '">' +
          '</div>' +
          '<div class="flex flex-1 flex-col min-w-0 gap-8 pt-1.5 pb-4 px-8 bg-surface-input border border-border-secondary">' +
          '<span class="text-b3 text-secondary uppercase">' + escHtml(i18n.priceMax) + '</span>' +
          '<input type="text" inputmode="decimal" class="text-b2 text-primary bg-transparent border-0 p-0 w-full min-w-0 outline-none" data-price-max-display value="' + escHtml(money(sMaxP)) + '" aria-label="' + escHtml(i18n.priceMax) + '">' +
          '</div>' +
          '</div>' +
          '<div class="relative h-24" data-price-slider>' +
          '<div class="absolute inset-x-0 top-1/2 -translate-y-1/2 h-2 bg-surface-grey" aria-hidden="true"></div>' +
          '<div class="absolute top-1/2 -translate-y-1/2 h-2 bg-surface-blue" style="left:' + thumbPos(fracMin) + ';right:calc(100% - ' + thumbPos(fracMax) + ')" data-price-fill aria-hidden="true"></div>' +
          '<input type="range" class="range-slider-input" min="' + minP + '" max="' + maxP + '" value="' + sMinP + '" data-facet-key="' + eKey + '" data-price-min aria-label="' + escHtml(i18n.priceMin) + '">' +
          '<input type="range" class="range-slider-input" min="' + minP + '" max="' + maxP + '" value="' + sMaxP + '" data-facet-key="' + eKey + '" data-price-max aria-label="' + escHtml(i18n.priceMax) + '">' +
          '</div></div>';
      }

      function sync(root) {
        var minEl = root.querySelector('[data-price-min]'), maxEl = root.querySelector('[data-price-max]');
        if (!minEl || !maxEl) return;
        var lo = parseInt(minEl.min, 10), hi = parseInt(minEl.max, 10);
        var minV = parseInt(minEl.value, 10), maxV = parseInt(maxEl.value, 10);
        var range = (hi - lo) || 1;
        var fracMin = (minV - lo) / range;
        var fracMax = (maxV - lo) / range;
        var fill = root.querySelector('[data-price-fill]');
        if (fill) { fill.style.left = thumbPos(fracMin); fill.style.right = 'calc(100% - ' + thumbPos(fracMax) + ')'; }
        var minDisplay = root.querySelector('[data-price-min-display]'), maxDisplay = root.querySelector('[data-price-max-display]');
        if (minDisplay) minDisplay.value = money(minV);
        if (maxDisplay) maxDisplay.value = money(maxV);
        minEl.setAttribute('aria-valuetext', money(minV));
        maxEl.setAttribute('aria-valuetext', money(maxV));
      }

      return { render: render, sync: sync };
    };

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys-url-state"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    // Query-string keys that are never Tagalys facets, regardless of what the
    // merchant's facet config contains — Shopify's own params, click-tracking
    // params from ad/email campaign links, and pagination. Without this, a
    // campaign link like ?utm_source=email or ?gclid=... into a collection
    // gets parsed as a facet filter and can land the shopper on an empty
    // result set.
    var RESERVED_KEYS = ['page', 'sort_by', 'ref', 'gclid', 'fbclid', 'msclkid', 'ttclid'];

    function isReservedKey(key) {
      return RESERVED_KEYS.indexOf(key) >= 0 || key.slice(0, 4) === 'utm_';
    }

    window.TagalysUrlState = function (options) {
      options = options || {};
      var priceMinKey  = options.priceMinKey  || 'min';
      var priceMaxKey  = options.priceMaxKey  || 'max';
      var preserveKeys = options.preserveKeys || [];

      function filtersFromURL() {
        var params = new URLSearchParams(window.location.search);
        var filters = {}, priceKeys = {};
        params.forEach(function (value, key) {
          if (key === 'sort' || preserveKeys.indexOf(key) >= 0 || isReservedKey(key)) return;
          if (key.slice(-4) === '_min' || key.slice(-4) === '_max') { priceKeys[key.slice(0, -4)] = true; return; }
          filters[key] = value.split(',').filter(Boolean);
        });
        Object.keys(priceKeys).forEach(function (key) {
          var min = params.get(key + '_min'), max = params.get(key + '_max');
          filters[key] = {};
          if (min != null && min !== '') filters[key][priceMinKey] = parseInt(min, 10);
          if (max != null && max !== '') filters[key][priceMaxKey] = parseInt(max, 10);
        });
        return filters;
      }

      function sortFromURL() {
        return new URLSearchParams(window.location.search).get('sort') || null;
      }

      function syncURL(filtersObj, sort) {
        var params = new URLSearchParams();
        var existing = new URLSearchParams(window.location.search);
        preserveKeys.forEach(function (key) {
          var v = existing.get(key);
          if (v) params.set(key, v);
        });
        Object.keys(filtersObj).forEach(function (key) {
          var v = filtersObj[key];
          if (Array.isArray(v)) {
            if (v.length) params.set(key, v.join(','));
          } else if (v && typeof v === 'object') {
            if (v[priceMinKey] != null) params.set(key + '_min', v[priceMinKey]);
            if (v[priceMaxKey] != null) params.set(key + '_max', v[priceMaxKey]);
          }
        });
        if (sort) params.set('sort', sort);
        var qs = params.toString();
        history.replaceState(history.state, '', window.location.pathname + (qs ? '?' + qs : ''));
      }

      return { filtersFromURL: filtersFromURL, sortFromURL: sortFromURL, syncURL: syncURL };
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tagalys"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    // Shared with collection-tagalys-facets.liquid, collection-tagalys-card.liquid,
    // and mini-bag-recommendations-script.liquid via assets/tagalys-recommendations.js
    // (window.TagalysProductFormat) — was a byte-for-byte duplicate here before
    // this dedupe (TASK-47920).
    var escHtml = window.TagalysProductFormat.escHtml;

    /* ── Tagalys integration ── */

    var _handle    = '';
    var _id        = '';
    var _pp        = 24;
    var _token     = '';
    var _domain    = '';
    var _i18n      = {
      emptyTitle:         'No products found',
      emptyDesc:          'Browse our other collections.',
      emptyDescFiltered:  'Try adjusting your filters or browse our other collections.',
      viewedOf:       'Viewed __VIEWED__ of __TOTAL__ results.',
      loadMore:       'Load __COUNT__ more',
      quickView:      'Quick view',
      notify:         'Notify',
      outOfStock:     'Out of stock',
      fromPrice:      'From __PRICE__',
      rating:         'Rated __RATING__ out of 5',
      priceMin:       'Min price',
      priceMax:       'Max price',
      /* No hardcoded literal — overwritten from data-currency (gridEl,
         itself sourced from cart.currency.iso_code | default: shop.currency
         in Liquid) below before first use; money() degrades to a plain
         number if this is ever still empty when called. */
      currency:       '',
      loadError:      'Something went wrong loading results. Please try again.',
      rootUrl:        ''
    };
    var _state     = { sort: null, filters: {}, page: 1, total: 0 };
    var _instance  = null;
    var _appending = false;

    /* Zero results reads differently depending on cause: a genuinely empty
       collection (no filters applied) vs. the visitor's own filter selection
       matching nothing — the latter should point back at the filters they
       just set, not just suggest browsing elsewhere. */
    function _emptyDesc() {
      return Object.keys(_state.filters).length ? _i18n.emptyDescFiltered : _i18n.emptyDesc;
    }
    /* Facet-rendering (accordion/checkbox/tile/boolean/price-slider/sort list)
       is shared with search-tagalys.liquid via this factory — see
       collection-tagalys-facets.liquid for what it renders and why. Collection's
       price filter uses the {min,max} shape (this connector's own setParams
       API), unlike search's SearchResults-connector {selected_min,selected_max}
       — priceMinKey/priceMaxKey tell the shared renderer which fields to read.

       facetPriority/maxFacetLinks (sections/collection.liquid's "Filter"
       blocks and "Max filters shown" setting, via product-grid.liquid's
       data-facet-priority/data-max-filters-shown) must be read here, before
       the factory call, not down in the onTagalysReady bootstrap below —
       that block runs after TagalysFacets's options object is already built
       and closed over. #tagalys-product-grid already exists in the DOM by the
       time this deferred script runs, so reading it this early is safe. */
    var _facetPriorityGridEl = document.getElementById('tagalys-product-grid');
    var _facetPriority = ((_facetPriorityGridEl && _facetPriorityGridEl.getAttribute('data-facet-priority')) || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var _maxFacetLinks = parseInt((_facetPriorityGridEl && _facetPriorityGridEl.getAttribute('data-max-filters-shown')) || '0', 10) || 0;

    var _facets = window.TagalysFacets({
      i18n:          _i18n,
      state:         _state,
      priceMinKey:   'min',
      priceMaxKey:   'max',
      facetPriority: _facetPriority,
      maxFacetLinks: _maxFacetLinks
    });
    // Also shared with search-tagalys.liquid (see collection-tagalys-price-events.liquid).
    window.TagalysPriceEvents({
      state:          _state,
      priceMinKey:    'min',
      priceMaxKey:    'max',
      syncPriceRange: _facets.syncPriceRange
    }).bind(function () { _load({ page: 1 }); });

    function onTagalysReady(cb) {
      if (window.Tagalys) return cb();
      var n = 0, t = setInterval(function () {
        if (window.Tagalys) { clearInterval(t); cb(); }
        else if (++n >= 100) {
          clearInterval(t);
          var g = document.getElementById('tagalys-product-grid');
          if (g && !g.hasAttribute('data-tagalys-ready')) {
            if (!g.querySelector('[data-product-grid], [data-empty-state]')) {
              g.innerHTML = '<div class="py-104 text-center px-24 sm:px-0" data-empty-state>' +
                '<p class="text-d3 text-primary mb-16">' + escHtml(_i18n.emptyTitle) + '</p>' +
                '<p class="text-b2 text-secondary">' + escHtml(_emptyDesc()) + '</p>' +
                '</div>';
            }
            g.style.opacity = '1';
          }
        }
      }, 50);
    }

    function _initTagalys() {
      Tagalys.setConfiguration({
        api: { serverUrl: 'https://api-r4.tagalys.com' },
        currency: {
          fractionalDigits: 2,
          forceFractionalDigits: true
        },
        analyticsStorageConsentProvided: function () {
          return window.Shopify && window.Shopify.customerPrivacy
            ? window.Shopify.customerPrivacy.analyticsProcessingAllowed() : false;
        },
        track: true
      });
      /* countryCode is the customer's ACTIVE market — read from
         data-market-country (layout/theme.liquid, sourced from
         localization.country.iso_code, the theme's own authoritative
         server-resolved market signal), not window.Shopify.country. This
         theme never sets that global itself and it isn't part of Shopify's
         documented storefront JS API, so relying on it left every request
         pinned to whatever it happened to resolve to rather than the
         shopper's actual selected market (TASK-47920). */
      var _marketCountry = (document.body && document.body.getAttribute('data-market-country')) || 'GB';
      Tagalys.setPlatformConfiguration({
        storefrontAPI: {
          accessToken:     _token,
          myShopifyDomain: _domain
        },
        countryCode:     _marketCountry,
        baseCountryCode: 'GB',
        metafields: { products: [
          { namespace: 'custom', key: 'product_type' },
          { namespace: 'custom', key: 'product_types' },
          { namespace: 'custom', key: 'taste_notes' },
          { namespace: 'custom', key: 'format' },
          { namespace: 'custom', key: 'flavour' },
          { namespace: 'custom', key: 'organic' },
          { namespace: 'custom', key: 'caffeine_free' },
          { namespace: 'custom', key: 'format_label' },
          { namespace: 'custom', key: 'origin' },
          { namespace: 'custom', key: 'gift_type' },
          { namespace: 'custom', key: 'good_for' },
          { namespace: 'custom', key: 'category' },
          { namespace: 'custom', key: 'limited_edition' },
          { namespace: 'custom', key: 'collection_campaign' }
        ]}
      });
    }

    /* Set before the initial (always-unfiltered) bootstrap call when the URL
       has filters/sort to restore — the first response's only job is then to
       seed the facet caches with the full, unfiltered option set (exactly
       like a fresh visit) before the real filtered request replaces it, so
       nothing is ever missing from the cache to fall back to. */
    var _pendingURLRestore = null;

    function _onTagalysSuccess(r) {
      _state.page  = r.page || 1;
      _state.total = r.total_count || 0;
      _renderGrid(r, _appending);
      _appending = false;
      /* renderFacets() returns the MERGED facet list (via the facet-level
         cache built earlier so a facet stays visible/greyed even when a
         response temporarily omits it) — use that, not the raw r.filters
         response, for anything summing across all facets. Confirmed live on
         the search connector that Tagalys can send a partial filters array
         (just the one facet that changed) rather than the full set on every
         response; using the merged list is the robust choice here too. */
      var merged = _facets.renderFacets(r.filters || []);
      _facets.renderSort(r.sort_options || []);
      /* Sum of active selections per facet (the same computation driving each
         accordion's own "(1)" counter badge), not Object.keys(_state.filters)
         .length — that only counted distinct facets with a selection, so two
         selected values inside one facet undercounted as 1. */
      var totalActive = merged.reduce(function (sum, f) { return sum + _facets.facetActiveCount(f); }, 0);
      if (window.PlpFilters) window.PlpFilters.update(totalActive, _state.total, merged.length > 0);
      if (window.TagalysBundleAvailability) window.TagalysBundleAvailability.correct(r.products || []);

      if (_pendingURLRestore) {
        var restore = _pendingURLRestore;
        _pendingURLRestore = null;
        _state.filters = restore.filters;
        _state.sort    = restore.sort;
        _load({ page: 1 });
        return; // real filtered response is on its way — don't reveal this intermediate one
      }

      var g = document.getElementById('tagalys-product-grid');
      if (g) { g.setAttribute('data-tagalys-ready', ''); g.style.opacity = '1'; }
      var status = document.querySelector('[data-grid-status]');
      if (status) {
        var fmt = g && g.getAttribute('data-i18n-result-count') || '__COUNT__ results';
        status.textContent = _state.total > 0 ? fmt.replace('__COUNT__', _state.total) : _i18n.emptyTitle;
      }
    }

    /* Filters/sort URL round-trip — shared with search-tagalys.liquid via
       collection-tagalys-url-state.liquid (see that file's doc header). */
    var _urlState = window.TagalysUrlState({ priceMinKey: 'min', priceMaxKey: 'max' });

    function _load(opts) {
      if (!_instance) return;
      opts = opts || {};
      if (opts.append) {
        _appending = true;
        _instance.helpers.goToNextPage();
        return;
      }
      _instance.helpers.setParams({
        collectionId: _id,
        perPage:      _pp,
        page:         1,
        sort:         _state.sort || '',
        filters:      _state.filters
      });
      _instance.helpers.call();
      _urlState.syncURL(_state.filters, _state.sort);
    }

    function _renderGrid(r, append) {
      var wrap = document.getElementById('tagalys-product-grid');
      if (!wrap) return;

      var promoSlots = Array.from(document.querySelectorAll('[data-promo-card-tpl]')).map(function (tpl) {
        var raw = parseInt(tpl.getAttribute('data-insert-after'), 10);
        return { tpl: tpl, at: isNaN(raw) ? 0 : raw };
      }).sort(function (a, b) { return a.at - b.at; });

      var prods = r.products || [];
      if (!append) wrap.innerHTML = '';

      if (!prods.length && !append) {
        wrap.innerHTML = '<div class="py-104 text-center px-24 sm:px-0" data-empty-state>' +
          '<p class="text-d3 text-primary mb-16">' + escHtml(_i18n.emptyTitle) + '</p>' +
          '<p class="text-b2 text-secondary">' + escHtml(_emptyDesc()) + '</p>' +
          '</div>';
        return;
      }

      var grid = append ? wrap.querySelector('[data-product-grid]') : null;
      if (!grid) {
        grid = document.createElement('div');
        /* Mirrors product-grid.liquid's quiz_enabled column count, since this
           rebuild replaces the server-rendered grid. */
        var isQuizPlp = !!document.querySelector('[data-quiz-nav]');
        grid.className = 'grid grid-cols-2 ' + (isQuizPlp ? 'md:grid-cols-3' : 'md:grid-cols-4') + ' gap-4';
        grid.setAttribute('data-product-grid', '');
        wrap.appendChild(grid);
      }

      var alreadyInserted = grid.querySelectorAll('[data-promo-slot]').length;
      var nextSlot = alreadyInserted;
      var appendFrom = append ? grid.children.length : 0;
      /* grid_position/insert_after is a position across the WHOLE result set,
         but `i` below is only this page's own local index (always 0-based per
         forEach call) — on a "Load More" page it resets, so a promo slot whose
         position falls on a later page could never be reached by comparing
         against `i` alone. Offsetting by how many real products are already
         in the grid converts `i` into that same whole-result-set position. */
      var productBaseIndex = grid.querySelectorAll('[data-product-card]').length;

      prods.forEach(function (p, i) {
        var globalIndex = productBaseIndex + i;
        while (nextSlot < promoSlots.length && globalIndex === promoSlots[nextSlot].at) {
          grid.appendChild(document.importNode(promoSlots[nextSlot].tpl.content, true));
          nextSlot++;
          var allVids = grid.querySelectorAll('[data-promo-video]');
          var newVid = allVids[allVids.length - 1];
          if (newVid) newVid.play().catch(function () {});
        }
        if (typeof window.TagalysCard === 'function') {
          // 5th arg: fetchpriority on the very first card of the first page only.
          // `!append` excludes infinite-scroll pages, where the first card of the
          // batch is far below the fold and a priority hint would be actively wrong.
          grid.insertAdjacentHTML('beforeend', window.TagalysCard(p, !append && i < 4, _i18n, null, !append && i === 0));
        }
      });

      if (window.TagalysBadgeHydration) window.TagalysBadgeHydration.hydrate(prods, grid);
      if (window.TagalysRatingHydration) window.TagalysRatingHydration.hydrate(prods, grid, _i18n.rating);

      if (append) {
        for (var ci = appendFrom; ci < grid.children.length; ci++) {
          grid.children[ci].classList.add('plp-card-in');
        }
        // window.TagalysCard's root is a <div data-product-card>, not the focusable
        // <a> it used to be — focus the anchor/button inside it, not the wrapper.
        var firstNew = grid.children[appendFrom];
        var focusTarget = firstNew && (firstNew.matches('a, button') ? firstNew : firstNew.querySelector('a, button'));
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }

      /* A promo card only ever shows at its exact configured slot (grid_position
         → insert_after) — if this result set has too few products to reach it,
         it simply doesn't appear, matching product-grid.liquid's own SSR
         fallback (which never force-inserts a promo at a fallback position
         either). A promo card is `col-span-2`/`row-span-2` and h-full,
         depending entirely on pairing with a sibling row for its height — a
         lone trailing insert with nothing to pair with has no way to get a
         correct height, so showing it there was worse than not showing it. */

      var old = wrap.querySelector('[data-grid-footer]');
      if (old) old.remove();
      if (_state.total) {
        var viewed  = grid.querySelectorAll('[data-product-card]').length;
        var hasMore = (r.page || 1) < (r.total_pages || 1);
        var nextBatchCount = hasMore ? Math.max(1, Math.min(_pp, _state.total - viewed)) : 0;
        var foot    = document.createElement('div');
        foot.className = 'pt-84 md:pt-108 px-24 md:px-0 flex flex-col items-center gap-16';
        foot.setAttribute('data-grid-footer', '');
        foot.innerHTML =
          '<p class="text-b2 text-primary text-center" data-viewed-of>' + escHtml(_i18n.viewedOf.replace('__VIEWED__', viewed).replace('__TOTAL__', _state.total)) + '</p>' +
          (hasMore
            ? '<button type="button" class="inline-flex items-center justify-center w-full h-48 px-24 border border-border-secondary bg-transparent text-primary text-f2 uppercase cursor-pointer select-none transition-btn-primary hover:bg-surface-tertiary hover:border-border-primary focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2 sm:w-393" data-load-more data-page="' + ((r.page || 1) + 1) + '">' + escHtml(_i18n.loadMore.replace('__COUNT__', nextBatchCount)) + '</button>'
            : '');
        wrap.appendChild(foot);
      }
    }

    /* ── Event delegation ── */

    /* Coalesces same-tick change events (e.g. a quiz answer swap's uncheck + check) into one load. */
    var filterLoadTimer = null;

    document.addEventListener('change', function (e) {
      var el = e.target, key = el.getAttribute('data-facet-key');
      if (el.type !== 'checkbox' || !key) return;
      // A checkbox can represent several ids merged under one label
      // (groupFacetItems, TASK-54365) — toggle them all together.
      var vals = window.TagalysFacetFormat.parseFacetValues(el.getAttribute('data-facet-value'));
      var current = _state.filters[key] || [];
      if (el.checked) {
        vals.forEach(function (val) { if (current.indexOf(val) < 0) current = current.concat([val]); });
        _state.filters[key] = current;
      } else {
        var updated = current.filter(function (v) { return vals.indexOf(v) < 0; });
        if (updated.length) _state.filters[key] = updated;
        else delete _state.filters[key];
      }
      if (filterLoadTimer) window.clearTimeout(filterLoadTimer);
      filterLoadTimer = window.setTimeout(function () {
        filterLoadTimer = null;
        _load({ page: 1 });
      }, 0);
    });

    document.addEventListener('click', function (e) {
      var grid = document.getElementById('tagalys-product-grid');
      var live = grid && grid.hasAttribute('data-tagalys-ready');

      var clearBtn = e.target.closest('[data-clear-filters]');
      if (clearBtn) {
        // aria-disabled (not disabled) keeps the button focusable — its own
        // aria-disabled: classes (snippets/button.liquid) stop a mouse click,
        // but not a keyboard Enter/Space activation, which still fires a real
        // click on a focusable, non-disabled <button>. Guard here too.
        if (clearBtn.getAttribute('aria-disabled') === 'true') return;
        _state.filters = {}; _state.sort = null; _load({ page: 1 }); return;
      }

      var tile = e.target.closest('[data-image-tile]');
      if (tile) {
        var k = tile.getAttribute('data-facet-key'), v = tile.getAttribute('data-facet-value');
        var cur = _state.filters[k] || [];
        var idx = cur.indexOf(v);
        if (idx >= 0) {
          var upd = cur.filter(function (x) { return x !== v; });
          if (upd.length) _state.filters[k] = upd; else delete _state.filters[k];
          tile.setAttribute('aria-pressed', 'false');
        } else {
          _state.filters[k] = cur.concat([v]);
          tile.setAttribute('aria-pressed', 'true');
        }
        _load({ page: 1 }); return;
      }

      var sortBtn = e.target.closest('[data-sort-option]');
      if (sortBtn && live) { _state.sort = sortBtn.getAttribute('data-sort-option'); _load({ page: 1 }); return; }

      var more = e.target.closest('[data-load-more]');
      if (more && live) {
        if (_appending) return;
        e.preventDefault();
        more.setAttribute('aria-busy', 'true');
        more.setAttribute('aria-label', more.textContent.trim());
        more.innerHTML = '<span data-load-dots aria-hidden="true"><span></span><span></span><span></span></span>';
        _load({ append: true });
      }
    });

    /* ── Bootstrap — reads config from data-* attributes on the grid element ── */

    onTagalysReady(function () {
      var gridEl = document.getElementById('tagalys-product-grid');
      _handle  = (gridEl && gridEl.getAttribute('data-collection-handle')) || '';
      _id      = (gridEl && gridEl.getAttribute('data-collection'))        || '';
      _pp      = parseInt((gridEl && gridEl.getAttribute('data-per-page')) || '24', 10);
      _token   = (gridEl && gridEl.getAttribute('data-tagalys-token'))     || _token;
      _domain  = (gridEl && gridEl.getAttribute('data-tagalys-domain'))    || _domain;
      _i18n.emptyTitle     = (gridEl && gridEl.getAttribute('data-i18n-empty-title'))     || _i18n.emptyTitle;
      _i18n.emptyDesc      = (gridEl && gridEl.getAttribute('data-i18n-empty-desc'))      || _i18n.emptyDesc;
      _i18n.emptyDescFiltered = (gridEl && gridEl.getAttribute('data-i18n-empty-desc-filtered')) || _i18n.emptyDescFiltered;
      _i18n.viewedOf       = (gridEl && gridEl.getAttribute('data-i18n-viewed-of'))       || _i18n.viewedOf;
      _i18n.loadMore       = (gridEl && gridEl.getAttribute('data-i18n-load-more'))       || _i18n.loadMore;
      _i18n.quickView      = (gridEl && gridEl.getAttribute('data-i18n-quick-view'))      || _i18n.quickView;
      _i18n.notify         = (gridEl && gridEl.getAttribute('data-i18n-notify'))          || _i18n.notify;
      _i18n.outOfStock     = (gridEl && gridEl.getAttribute('data-i18n-out-of-stock'))    || _i18n.outOfStock;
      _i18n.fromPrice      = (gridEl && gridEl.getAttribute('data-i18n-from-price'))      || _i18n.fromPrice;
      _i18n.rating         = (gridEl && gridEl.getAttribute('data-i18n-rating'))          || _i18n.rating;
      _i18n.priceMin       = (gridEl && gridEl.getAttribute('data-i18n-price-min'))       || _i18n.priceMin;
      _i18n.priceMax       = (gridEl && gridEl.getAttribute('data-i18n-price-max'))       || _i18n.priceMax;
      _i18n.currency       = (gridEl && gridEl.getAttribute('data-currency'))             || _i18n.currency;
      _i18n.rootUrl        = (gridEl && gridEl.getAttribute('data-root-url'))             || _i18n.rootUrl;
      _i18n.loadError      = (gridEl && gridEl.getAttribute('data-i18n-load-error'))      || _i18n.loadError;

      var urlFilters = _urlState.filtersFromURL(), urlSort = _urlState.sortFromURL();
      if (Object.keys(urlFilters).length || urlSort) _pendingURLRestore = { filters: urlFilters, sort: urlSort };

      _initTagalys();
      if (window.TagalysConsent) window.TagalysConsent.onChange(_initTagalys);
      if (_handle) {
        _instance = Tagalys.APIConnector.Collection.new({
          params: {
            collectionId: _id,
            perPage:      _pp,
            page:         1
          },
          onSuccess: _onTagalysSuccess,
          onFailure: function (r) {
            console.error('[Tagalys] collection call failed', JSON.stringify(r));
            var g = document.getElementById('tagalys-product-grid');
            if (g) g.style.opacity = '1';
            var status = document.querySelector('[data-grid-status]');
            if (status) status.textContent = _i18n.loadError;
            // A failed Load more shares this same instance/onFailure — without
            // this, _appending stays true forever (silently ignoring every
            // further click, see the [data-load-more] handler above) and the
            // button is left showing its loading-dots spinner with no label.
            if (_appending) {
              _appending = false;
              var more = document.querySelector('[data-load-more]');
              if (more) {
                more.removeAttribute('aria-busy');
                var label = more.getAttribute('aria-label');
                if (label) more.textContent = label;
              }
            }
          }
        });
        _instance.helpers.call();
        setTimeout(function () {
          var g = document.getElementById('tagalys-product-grid');
          if (g && !g.hasAttribute('data-tagalys-ready')) g.style.opacity = '1';
        }, 3000);
      }
    });

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__drawerControllerReady) return;
    window.__drawerControllerReady = true;

    /*
     * Hoist all drawer elements to <body> so they escape any ancestor stacking
     * contexts created by opacity/transform transitions in their section markup
     * (e.g. the hero overlay). Without this, the drawer's z-index is evaluated
     * within the overlay's stacking context rather than at page root, and it
     * paints behind the fixed header regardless of its z-60 value.
     */
    function hoistDrawers() {
      document.querySelectorAll('[data-drawer]').forEach(function(el) {
        if (el.parentNode !== document.body) document.body.appendChild(el);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hoistDrawers);
    } else {
      hoistDrawers();
    }

    // Dormant drawers: kept in step with assets/drawer.js (see the comment there and
    // the [data-drawer-dormant] rule in src/css/theme.css).
    function wakeAllDrawers() {
      document.querySelectorAll('[data-drawer-dormant]').forEach(function (el) {
        el.removeAttribute('data-drawer-dormant');
      });
    }
    function wakeAllDrawersWhenIdle() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(wakeAllDrawers, { timeout: 3000 });
      } else {
        window.setTimeout(wakeAllDrawers, 1500);
      }
    }
    if (document.readyState === 'complete') {
      wakeAllDrawersWhenIdle();
    } else {
      window.addEventListener('load', wakeAllDrawersWhenIdle, { once: true });
    }
    document.addEventListener('shopify:section:load', wakeAllDrawers);

    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var openCount = 0;

    function panelOf(drawer) {
      return drawer.querySelector('[data-drawer-panel]');
    }

    function isOpen(drawer) {
      return !drawer.hasAttribute('aria-hidden');
    }

    function openDrawer(drawer, trigger) {
      if (!drawer || isOpen(drawer)) return;
      drawer.removeAttribute('data-drawer-dormant');
      drawer._trigger = trigger || document.activeElement;

      // Layered drawers: every drawer shares z-60, so with equal z-index the winner is
      // DOM order — which is not source order, because hoistDrawers appends only the
      // section-nested drawers to the end of <body>. Elevate by how many are already
      // open. Kept in step with assets/drawer.js, which is the copy that actually runs.
      if (openCount > 0) drawer.style.zIndex = String(60 + openCount);

      // Drawers are often rendered inside #main-content, which is a z-index:1
      // stacking context sitting below the fixed header — so a z-60 drawer
      // would still be trapped beneath it. Portal to <body> so it overlays
      // everything. (Harmless if already a direct child of body.)
      if (drawer.parentNode !== document.body) document.body.appendChild(drawer);

      if (trigger && trigger.hasAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', 'true');
      }

      drawer.removeAttribute('inert');
      drawer.removeAttribute('aria-hidden');
      drawer.style.opacity = '1';
      drawer.style.pointerEvents = 'auto';

      var panel = panelOf(drawer);
      if (panel) {
        panel.style.translate = '0';
        var initialFocusSelector = drawer.getAttribute('data-drawer-initial-focus');
        var initialFocusEl = initialFocusSelector ? panel.querySelector(initialFocusSelector) : null;
        var focusTarget = initialFocusEl || panel.querySelector('[data-drawer-close]');
        if (focusTarget) {
          void focusTarget.offsetHeight;
          focusTarget.focus();
        }
      }

      openCount += 1;
      document.body.style.overflow = 'hidden';

      // Symmetric with closeDrawer's drawer:close below. Kept in step with
      // assets/drawer.js's own announcement, for the same reason the rest of
      // this fallback stays in lockstep with it.
      document.dispatchEvent(new CustomEvent('drawer:open', { bubbles: true, detail: { id: drawer.id } }));
    }

    function closeDrawer(drawer) {
      if (!drawer || !isOpen(drawer)) return;

      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      drawer.style.opacity = '';
      drawer.style.pointerEvents = '';
      drawer.style.zIndex = '';

      var panel = panelOf(drawer);
      if (panel) panel.style.translate = '';

      openCount = Math.max(0, openCount - 1);
      if (openCount === 0) document.body.style.overflow = '';

      var trigger = drawer._trigger;
      if (trigger && trigger.hasAttribute('aria-expanded')) {
        trigger.setAttribute('aria-expanded', 'false');
      }
      if (trigger && typeof trigger.focus === 'function') trigger.focus();
      drawer._trigger = null;

      document.dispatchEvent(new CustomEvent('drawer:close', { bubbles: true, detail: { id: drawer.id } }));
    }

    function topOpenDrawer() {
      var open = document.querySelectorAll('[data-drawer]:not([aria-hidden])');
      return open.length ? open[open.length - 1] : null;
    }

    // Lets any script open a drawer without a literal click on a
    // [data-drawer-open] trigger — e.g. the PDP add-to-bag form opening the
    // mini bag after a successful /cart/add.js call.
    document.addEventListener('drawer:open', function (event) {
      var id = event.detail && event.detail.id;
      if (id) openDrawer(document.getElementById(id));
    });

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-drawer-open]');
      if (opener) {
        event.preventDefault();
        openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')), opener);
        return;
      }

      var closer = event.target.closest('[data-drawer-close]');
      if (closer) {
        closeDrawer(closer.closest('[data-drawer]'));
        return;
      }

      if (event.target.hasAttribute('data-drawer-backdrop')) {
        closeDrawer(event.target.closest('[data-drawer]'));
      }
    });

    document.addEventListener('keydown', function (event) {
      var drawer = topOpenDrawer();
      if (!drawer) return;

      if (event.key === 'Escape') {
        closeDrawer(drawer);
        return;
      }

      if (event.key === 'Tab') {
        var panel = panelOf(drawer);
        if (!panel) return;
        var items = Array.prototype.filter.call(
          panel.querySelectorAll(FOCUSABLE),
          function (el) { return el.offsetParent !== null; }
        );
        if (!items.length) return;

        var first = items[0];
        var last = items[items.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        } else if (!panel.contains(document.activeElement)) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-calendar-script"] && !Shopify.designMode) return;
  try {
    ;(function () {
    'use strict';

    if (window.GiftCardCalendar) return;

    function init(form) {
      var root = form.querySelector('[data-gift-card-calendar]');
      var monthLabel = form.querySelector('[data-gift-card-calendar-month]');
      var weekdaysEl = form.querySelector('[data-gift-card-calendar-weekdays]');
      var daysEl = form.querySelector('[data-gift-card-calendar-days]');
      var prevBtn = form.querySelector('[data-gift-card-calendar-prev]');
      var nextBtn = form.querySelector('[data-gift-card-calendar-next]');
      var input = form.querySelector('[data-gift-card-send-on]');
      if (!root || !monthLabel || !weekdaysEl || !daysEl || !input) return;
      if (root.__giftCardCalendarReady) return;
      root.__giftCardCalendarReady = true;

      // A malformed <html lang> makes every Intl.DateTimeFormat constructor throw a
      // RangeError, which would otherwise abort init() outright and leave the calendar
      // empty and unusable. Falling back to en-GB keeps the component working on a store whose lang
      // attribute is wrong — the same default the `locale` line itself already carries for
      // a missing attribute.
      var locale = document.documentElement.lang || 'en-GB';
      var monthFormatter;
      var weekdayFormatter;
      var dayFormatter;
      try {
        monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' });
        weekdayFormatter = new Intl.DateTimeFormat(locale, { weekday: 'short' });
        dayFormatter = new Intl.DateTimeFormat(locale, {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
      } catch (error) {
        monthFormatter = new Intl.DateTimeFormat('en-GB', { month: 'long', year: 'numeric' });
        weekdayFormatter = new Intl.DateTimeFormat('en-GB', { weekday: 'short' });
        dayFormatter = new Intl.DateTimeFormat('en-GB', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
      }

      var today = new Date();
      today.setHours(0, 0, 0, 0);

      // Should-fix, 2026-10-01: Shopify rejects a scheduled Send on more than 90 days out
      // ({"send_on":["Send on must be within 90 days from now"]}, confirmed against the
      // live store), and nothing here previously stopped a shopper picking one anyway.
      var maxDate = new Date(today);
      maxDate.setDate(maxDate.getDate() + 90);

      var selected = null;
      var viewYear = today.getFullYear();
      var viewMonth = today.getMonth();

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function isoDate(d) {
        return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
      }

      function sameDay(a, b) {
        return (
          a &&
          b &&
          a.getFullYear() === b.getFullYear() &&
          a.getMonth() === b.getMonth() &&
          a.getDate() === b.getDate()
        );
      }

      function renderWeekdays() {
        if (weekdaysEl.childElementCount) return;
        // A known Monday, so the row always starts Mon and matches the grid's own
        // Monday-first math below regardless of the visitor's own locale week start.
        var base = new Date(2024, 0, 1);
        for (var i = 0; i < 7; i++) {
          var d = new Date(base.getFullYear(), base.getMonth(), base.getDate() + i);
          var cell = document.createElement('div');
          cell.className = 'text-f2 flex items-center justify-center h-38 py-12';
          cell.textContent = weekdayFormatter.format(d);
          weekdaysEl.appendChild(cell);
        }
      }

      function selectDate(date) {
        selected = date;
        input.value = isoDate(date);
        render();

        // render() empties daysEl and rebuilds every cell, so the button the shopper just
        // activated no longer exists and focus would fall to <body>, dropping a keyboard
        // user out of the calendar on every date pick. Re-focus the freshly rendered
        // cell for the same date. A mouse click already left that button focused, so this
        // restores rather than changes where focus sits.
        var restored = daysEl.querySelector(
          '[data-gift-card-calendar-date="' + isoDate(date) + '"]'
        );
        if (restored) restored.focus();
      }

      function render() {
        monthLabel.textContent = monthFormatter.format(new Date(viewYear, viewMonth, 1));
        if (prevBtn) {
          var disablePrev = viewYear === today.getFullYear() && viewMonth === today.getMonth();
          // Stepping back INTO the current month disables the very button that was just
          // activated, which silently blurs it and drops the keyboard user to <body>. Hand
          // focus to the next-month button first. Guarded on prevBtn actually holding
          // focus, so nothing moves when render() runs for any other reason.
          if (disablePrev && !prevBtn.disabled && nextBtn && document.activeElement === prevBtn) {
            nextBtn.focus();
          }
          prevBtn.disabled = disablePrev;
        }
        if (nextBtn) {
          // Symmetric with disablePrev above: the month containing maxDate is as far
          // forward as there is anything to pick, so stepping past it would show a
          // calendar with every cell disabled. Same forgotten-focus guard as prevBtn's own.
          var disableNext = viewYear === maxDate.getFullYear() && viewMonth === maxDate.getMonth();
          if (disableNext && !nextBtn.disabled && prevBtn && document.activeElement === nextBtn) {
            prevBtn.focus();
          }
          nextBtn.disabled = disableNext;
        }
        daysEl.innerHTML = '';

        var firstOfMonth = new Date(viewYear, viewMonth, 1);
        var firstWeekday = (firstOfMonth.getDay() + 6) % 7; // Monday = 0
        var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
        var daysInPrevMonth = new Date(viewYear, viewMonth, 0).getDate();
        var totalCells = Math.ceil((firstWeekday + daysInMonth) / 7) * 7;

        for (var i = 0; i < totalCells; i++) {
          var dayNum = i - firstWeekday + 1;
          var cellDate;
          var inMonth;

          if (dayNum < 1) {
            cellDate = new Date(viewYear, viewMonth - 1, daysInPrevMonth + dayNum);
            inMonth = false;
          } else if (dayNum > daysInMonth) {
            cellDate = new Date(viewYear, viewMonth + 1, dayNum - daysInMonth);
            inMonth = false;
          } else {
            cellDate = new Date(viewYear, viewMonth, dayNum);
            inMonth = true;
          }
          cellDate.setHours(0, 0, 0, 0);

          /* isUnavailable, not isPast: three dates share the same disabled/dimmed
             treatment rather than a third visual state each. Today is picked via its own
             dedicated TODAY radio above the calendar (gift-card-details-form.liquid), not
             from inside it (client fix, 2026-10-01). Beyond maxDate is Shopify's own
             90-day Send on ceiling (should-fix, 2026-10-01) — a date the add would simply
             reject. aria-current="date" below still marks which cell is "today"
             regardless of its own availability. */
          var isUnavailable = cellDate.getTime() <= today.getTime() || cellDate.getTime() > maxDate.getTime();
          var isSelected = sameDay(cellDate, selected);

          // Adjacent cells each carrying their own 1px border would otherwise paint two
          // borders side by side wherever they touch, reading as a 2px line — only the
          // grid's own outer edge is genuinely a lone 1px border. Pulling every cell but
          // the first in its row/column back by exactly the border's own width makes it
          // overlap its neighbour's border instead of sitting beside it, so the shared
          // edge renders as a single 1px line like the rest of the grid.
          var column = i % 7;
          var row = Math.floor(i / 7);
          var cellClass = 'relative flex h-40 items-center justify-center border border-border-secondary text-f2';
          if (column > 0) cellClass += ' -ml-px';
          if (row > 0) cellClass += ' -mt-px';

          // Colour-alpha modifiers on the text colour specifically (text-primary/30,
          // text-secondary/30), never a whole-element opacity-* utility: opacity fades
          // every property including border-color, and the border must stay
          // border-border-secondary at full strength in every state — the day number's
          // own colour is the only thing that dims, at 30%.
          if (!inMonth) {
            cellClass += ' text-secondary/30';
          } else if (isUnavailable) {
            cellClass += ' text-primary/30';
          } else {
            cellClass += ' text-primary';
          }

          if (isUnavailable) {
            cellClass += ' cursor-not-allowed';
          } else {
            // hover:z-10 matters here, not just on the selected cell below: without it,
            // a hovered cell's own after: rule paints UNDER whichever neighbour comes
            // later in the DOM and overlaps it via the -ml-px/-mt-px border-collapse fix
            // above, since same-stacking-context siblings paint in DOM order regardless
            // of position:relative alone. Raising the hovered cell's stacking order
            // guarantees its own rule (and its background, see below) always shows.
            // after:h-2 (2px) is the active/selected indicator's own thickness, not the
            // cell's border-border-secondary grid line above, which stays 1px in every
            // state.
            cellClass +=
              ' cursor-pointer hover:z-10 hover:bg-surface-input hover:after:absolute' +
              ' hover:after:-bottom-px hover:after:left-0 hover:after:h-2 hover:after:w-full' +
              ' hover:after:bg-border-tertiary';
          }
          if (isSelected) {
            cellClass +=
              ' z-10 bg-surface-input after:absolute after:-bottom-px after:left-0 after:h-2' +
              ' after:w-full after:bg-border-tertiary';
          }

          var cell = document.createElement('button');
          cell.type = 'button';
          cell.className = cellClass;
          cell.textContent = String(cellDate.getDate());
          // The visible text stays the bare day number; the accessible name carries the
          // full date, so "14" is not announced without its month or year.
          cell.setAttribute('aria-label', dayFormatter.format(cellDate));
          // aria-current="date" means "today" per the ARIA spec, not the date the shopper
          // picked — the selected state is carried separately by this cell's own classes
          // (bg-surface-input plus the after: underline).
          if (sameDay(cellDate, today)) cell.setAttribute('aria-current', 'date');
          if (isUnavailable) {
            cell.disabled = true;
          } else {
            cell.setAttribute('data-gift-card-calendar-date', isoDate(cellDate));
            // Classes alone would leave a screen-reader user no way to tell which date is
            // picked. Every operable cell is a toggle (only one is ever pressed at once), the same
            // pattern the mini-bag amount tiles already use.
            cell.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          }
          daysEl.appendChild(cell);
        }
      }

      renderWeekdays();
      render();

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          viewMonth -= 1;
          if (viewMonth < 0) {
            viewMonth = 11;
            viewYear -= 1;
          }
          render();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          viewMonth += 1;
          if (viewMonth > 11) {
            viewMonth = 0;
            viewYear += 1;
          }
          render();
        });
      }

      root.addEventListener('click', function (event) {
        var cell = event.target.closest('[data-gift-card-calendar-date]');
        if (!cell) return;
        var iso = cell.getAttribute('data-gift-card-calendar-date');
        var parts = iso.split('-').map(Number);
        selectDate(new Date(parts[0], parts[1] - 1, parts[2]));
      });
    }

    window.GiftCardCalendar = { init: init };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-form-script"] && !Shopify.designMode) return;
  try {
    ;(function () {
    'use strict';

    // The snippet may render more than once; the flag makes a second execution a no-op
    // rather than a second set of listeners.
    if (window.__giftCardFormLoaded) return;
    window.__giftCardFormLoaded = true;

    var TIMEOUT_MS = 8000;

    function nodes(root, selector) {
      return Array.prototype.slice.call(root.querySelectorAll(selector));
    }

    /* aria-disabled, not the disabled property: a disabled button drops focus, which would
       throw a keyboard shopper out of the buy panel mid-add. */
    function setBusy(buttons, busy) {
      buttons.forEach(function (button) {
        if (busy) {
          button.setAttribute('aria-busy', 'true');
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-busy');
          button.removeAttribute('aria-disabled');
        }
      });
    }

    function init(root) {
      function showFormError(form, message) {
        var element = form.querySelector('[data-gift-card-error]');
        if (element) element.textContent = message || '';
      }

      function setFieldError(field, input, message) {
        var element = field.querySelector('[data-gift-card-field-error]');
        // The bordered box is the field snippet's own wrapper, one level above its input.
        var floatField = input.closest('[data-float-field]');
        var box = floatField ? floatField.parentElement : null;

        if (element) {
          element.textContent = message || '';
          // Associated programmatically as well as visually, so the message is read as the
          // field's description when focus lands there.
          if (!element.id && input.id) element.id = input.id + '-error';
          if (message && element.id) {
            input.setAttribute('aria-describedby', element.id);
          } else {
            input.removeAttribute('aria-describedby');
          }
        }

        if (message) {
          input.setAttribute('aria-invalid', 'true');
        } else {
          input.removeAttribute('aria-invalid');
        }

        if (box) {
          box.classList.toggle('border-semantic-red', !!message);
          box.classList.toggle('border-border-secondary', !message);
        }
      }

      /* type="email" alone accepts a dotless domain ("name@domain"), which Shopify's add
         rejects, so a dotted domain is required as well. */
      function isEmail(input) {
        return !input.validity.typeMismatch && /@[^@\s]+\.[^@\s]+$/.test(input.value.trim());
      }

      function validate(form) {
        var firstInvalid = null;

        nodes(form, '[data-gift-card-field]').forEach(function (field) {
          var input = field.querySelector('input');
          if (!input) return;

          /* Snag fix, 2026-10-08: a malformed email is caught here, before the add request,
             rather than only from Shopify's 422. This runs inside the shopper's tap, so the
             focus below opens the mobile keyboard; iOS ignores a focus() made after the
             request resolves, which is why the field only became active on desktop. The 422
             path in submitForm stays as the fallback for anything this check lets through. */
          if (input.value.trim() && input.type === 'email' && !isEmail(input)) {
            setFieldError(field, input, field.getAttribute('data-gift-card-i18n-invalid') || '');
            if (!firstInvalid) firstInvalid = input;
            return;
          }

          if (input.value.trim()) {
            setFieldError(field, input, '');
            return;
          }

          setFieldError(field, input, field.getAttribute('data-gift-card-i18n-required') || '');
          if (!firstInvalid) firstInvalid = input;
        });

        return firstInvalid;
      }

      function submitButtons(form) {
        var list = nodes(form, '[data-gift-card-submit]');
        nodes(root, '[data-sticky-atb-submit]').forEach(function (button) {
          if (button.getAttribute('form') === form.id) list.push(button);
        });
        // A natively disabled button (an unavailable variant) is left exactly as rendered.
        return list.filter(function (button) {
          return !button.disabled;
        });
      }

      /* Client fix, 2026-10-01: Shopify's own description for a rejected recipient email
         is not always a plain string — a structured validation failure returns it as a
         nested object/array of per-field messages instead, which rendered as the literal
         text "[object Object]" once textContent coerced it. This walks either shape and
         returns the first string it finds, so a future field-keyed error reports its real
         copy instead of degrading into the generic fallback OR a raw stringified object. */
      function firstString(value) {
        if (typeof value === 'string') return value;
        if (Array.isArray(value)) {
          for (var i = 0; i < value.length; i++) {
            var found = firstString(value[i]);
            if (found) return found;
          }
          return '';
        }
        if (value && typeof value === 'object') {
          for (var key in value) {
            if (!Object.prototype.hasOwnProperty.call(value, key)) continue;
            var nested = firstString(value[key]);
            if (nested) return nested;
          }
        }
        return '';
      }

      function errorMessage(form, error) {
        if (error && error.name === 'AbortError') {
          return form.getAttribute('data-i18n-timeout') || '';
        }
        // Shopify returns its own copy for a rejected recipient email; surfacing it is the
        // point of reading the body rather than retrying blind.
        var body = error && error.body;
        var fromBody = body ? firstString(body.description) || firstString(body.message) : '';
        if (fromBody) return fromBody;
        return form.getAttribute('data-i18n-error') || '';
      }

      /* Review fix, 2026-10-01: a 422 body's description is keyed by the Shopify property
         that actually failed — { email: [...] }, { message: [...] }, { send_on: [...] } —
         confirmed against the live store's real responses for all three. The earlier pass
         here routed on "the body has a description at all", which put a message-length or
         send-date rejection on the recipient email field along with the genuine email one.
         This reads the key itself, so only email ever lands there. */
      function parseFieldError(error) {
        var description = error && error.body && error.body.description;
        if (!description || typeof description !== 'object') return null;

        for (var key in description) {
          if (!Object.prototype.hasOwnProperty.call(description, key)) continue;
          var message = firstString(description[key]);
          if (message) return { field: key, message: message };
        }
        return null;
      }

      /* Should-fix, 2026-10-01: Shopify's own fragment ("is invalid", "is too long
         (maximum is 200 characters)") has no subject and is never translated. Each
         per-field wrapper carries its own locale string (data-gift-card-i18n-invalid,
         set from gift-card-details-form.liquid), preferred over the raw fragment —
         which still stands in as a defensive fallback if that attribute is ever blank. */
      function reportFieldFailure(form, fieldName, fallbackMessage) {
        var field = form.querySelector('[data-gift-card-field="' + fieldName + '"]');
        var control = field ? field.querySelector('input, textarea') : null;
        if (!field || !control) return false;

        var localeMessage = field.getAttribute('data-gift-card-i18n-invalid');
        setFieldError(field, control, localeMessage || fallbackMessage);

        // preventScroll, then an explicit scroll: see the submit handler's own identical
        // pairing below for why a bare .focus() races the sticky ATB bar's scroll-driven
        // visibility check.
        control.focus({ preventScroll: true });
        control.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }

      function submitForm(form) {
        if (form.__giftCardBusy) return;
        form.__giftCardBusy = true;

        var buttons = submitButtons(form);
        setBusy(buttons, true);

        var payload = new FormData(form);
        // Guarded lookup, and inside a handler rather than at top level: the mini bag's own
        // helper is defined by another snippet's script (FAILS section 3).
        payload.append(
          'sections',
          window.MiniBag && typeof window.MiniBag.getSectionId === 'function'
            ? window.MiniBag.getSectionId()
            : 'mini-bag'
        );

        var controller = window.AbortController ? new AbortController() : null;
        var timer = window.setTimeout(function () {
          if (controller) controller.abort();
        }, TIMEOUT_MS);

        var addedSections = null;
        var addedProductId = null;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: payload,
          signal: controller ? controller.signal : undefined
        })
          .then(function (response) {
            if (response.ok) return response.json();

            // A body that will not parse still has to reject, not resolve.
            return response.json().catch(function () { return null; }).then(function (body) {
              var error = new Error('cart_add_failed');
              error.body = body;
              throw error;
            });
          })
          .then(function (added) {
            addedSections = added && added.sections;
            addedProductId = added && added.product_id;
            // The add route returns the added line, not the cart, and only a mutation renders
            // `sections`, so the two responses are merged.
            return fetch('/cart.js');
          })
          .then(function (response) {
            if (!response.ok) throw new Error('cart_fetch_failed');
            return response.json();
          })
          .then(function (cart) {
            cart.sections = addedSections;
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { cart: cart, addedProductId: addedProductId }
              })
            );
            // The drawer controller claims its ready flag before drawer.liquid registers a
            // fallback listener, so the event path never opens the bag. Call it directly.
            if (typeof window.__drawerOpen === 'function') window.__drawerOpen('mini-bag');
          })
          .catch(function (error) {
            /* Client fix, 2026-10-01, corrected on review: only an email- or message-keyed
               rejection belongs on its own field — email and message (the digital message,
               capped server-side at 200) both have a field slot; a send-date rejection goes
               to the generic banner down by Add to bag instead, same as a genuine non-field
               failure (a timeout, or a response with no body at all), but still with its
               own locale copy rather than Shopify's raw, subject-less fragment. */
            var parsed = parseFieldError(error);
            var FIELD_NAMES = { email: 'recipient_email', message: 'message' };

            if (parsed && FIELD_NAMES[parsed.field]) {
              if (reportFieldFailure(form, FIELD_NAMES[parsed.field], parsed.message)) return;
            }

            var fallback = errorMessage(form, error);
            if (parsed && parsed.field === 'send_on') {
              fallback = form.getAttribute('data-i18n-send-on-error') || parsed.message || fallback;
            } else if (parsed) {
              fallback = parsed.message || fallback;
            }

            showFormError(form, fallback);
          })
          .finally(function () {
            window.clearTimeout(timer);
            form.__giftCardBusy = false;
            setBusy(buttons, false);
          });
      }

      root.addEventListener('submit', function (event) {
        var form = event.target.closest('[data-gift-card-scope]');
        if (!form) return;

        event.preventDefault();
        showFormError(form, '');

        var invalid = validate(form);
        if (invalid) {
          /* Focus moves BEFORE the scroll, and with preventScroll, specifically so it
             leaves the sticky bar's own submit button — the element that dispatched this
             submit — before any scrollIntoView runs. Doing it the other way round (a bare
             .focus(), which scrolls by itself) can leave the submit button still focused
             while the scroll it triggers passes the header-end landmark, racing
             assets/product-sticky-atb.js's own scroll-driven visibility check: that check
             would then try to aria-hidden the bar while a descendant still holds focus,
             which the browser correctly refuses, leaving the bar visually hidden but not
             actually inert. The sticky bar's trigger is the path on which a required field
             can sit off-screen below it; the in-page button is not. */
          invalid.focus({ preventScroll: true });
          invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        submitForm(form);
      });
    }

    // The section root is the only thing queried from the document.
    document.querySelectorAll('[data-gift-card-section]').forEach(function (root) {
      if (root.__giftCardFormReady) return;
      root.__giftCardFormReady = true;
      init(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-script"] && !Shopify.designMode) return;
  try {
    ;(function () {
    'use strict';

    // The snippet may render more than once; the flag makes a second execution a no-op
    // rather than a second set of listeners.
    if (window.__giftCardPanelLoaded) return;
    window.__giftCardPanelLoaded = true;

    var MIN_QUANTITY = 1;

    function nodes(root, selector) {
      return Array.prototype.slice.call(root.querySelectorAll(selector));
    }

    // Scope names reach attribute selectors here, so they go through CSS.escape.
    function selectorValue(value) {
      return window.CSS && typeof window.CSS.escape === 'function'
        ? window.CSS.escape(value)
        : value;
    }

    /* Concealed with the `hidden` CLASS the markup ships with, never the bare attribute:
       these elements each carry a display utility of their own, which the attribute's
       UA-origin rule loses to (FAILS section 4). The accessibility pair moves with it, since
       aria-hidden alone leaves focusable children in the tab order. */
    function conceal(element, hidden) {
      element.classList.toggle('hidden', hidden);
      if (hidden) {
        element.setAttribute('aria-hidden', 'true');
        element.setAttribute('inert', '');
      } else {
        element.removeAttribute('aria-hidden');
        element.removeAttribute('inert');
      }
    }

    function init(root) {
      var forms = nodes(root, '[data-gift-card-scope]');
      if (!forms.length) return;

      // The panel the server rendered exposed is the one open on load; every other panel
      // carries the concealment pair.
      var openPanel = root.querySelector('[data-gift-card-tab-panel]:not([aria-hidden])');
      var current = openPanel
        ? openPanel.getAttribute('data-gift-card-tab-panel')
        : forms[0].getAttribute('data-gift-card-scope');

      function formFor(scope) {
        for (var i = 0; i < forms.length; i++) {
          if (forms[i].getAttribute('data-gift-card-scope') === scope) return forms[i];
        }
        return null;
      }

      function activeForm() {
        return formFor(current);
      }

      /* ─── Loyalty banner ───────────────────────────────────────────────────────
         The shared collapse snippet swaps Antavo's raw variant table for the single points
         line off a bubbling variant:changed carrying the variant object, exactly as the
         classic PDP dispatches it. The object comes from this section's own
         [data-variant-data] island, which lists only the URL product's variants — so a
         counterpart-tab amount finds no entry, nothing is dispatched, and the banner stays
         on the product the app block is actually bound to rather than being faked
         client-side (orch PD-4). */
      var variantData = [];
      var variantDataEl = root.querySelector('[data-variant-data]');

      if (variantDataEl) {
        try {
          var parsedVariants = JSON.parse(variantDataEl.textContent);
          if (Array.isArray(parsedVariants)) variantData = parsedVariants;
        } catch (error) {
          variantData = [];
        }
      }

      function announceVariant(variantId) {
        for (var i = 0; i < variantData.length; i++) {
          if (String(variantData[i].id) !== String(variantId)) continue;

          root.dispatchEvent(
            new CustomEvent('variant:changed', {
              bubbles: true,
              detail: { variant: variantData[i] }
            })
          );
          return;
        }
      }

      /* ─── Quantity ─────────────────────────────────────────────────────────────
         The stepper snippet is display-only by contract: the count, the disabled floor and
         the canonical hidden quantity input all belong to the consumer. The sticky bar's own
         stepper mirrors the active panel, as product-quantity.liquid mirrors it on the
         classic PDP, since it posts that same form and a count of its own would contradict it. */
      function stepperNodes(form, part) {
        var scope = form.getAttribute('data-gift-card-scope') || '';
        var list = nodes(form, '[data-gift-card-qty-' + selectorValue(scope) + '-' + part + ']');
        if (form === activeForm()) {
          list = list.concat(nodes(root, '[data-sticky-qty-' + part + ']'));
        }
        return list;
      }

      function refreshQuantity(form) {
        var input = form.querySelector('[data-gift-card-qty-input]');
        if (!input) return;

        var value = parseInt(input.value, 10) || MIN_QUANTITY;
        var atFloor = value <= MIN_QUANTITY;

        stepperNodes(form, 'count').forEach(function (count) {
          count.textContent = value;
        });
        stepperNodes(form, 'minus').forEach(function (minus) {
          minus.disabled = atFloor;
          if (atFloor) minus.setAttribute('aria-disabled', 'true');
          else minus.removeAttribute('aria-disabled');
        });
      }

      function adjustQuantity(form, delta) {
        if (!form) return;
        var input = form.querySelector('[data-gift-card-qty-input]');
        if (!input) return;

        var next = (parseInt(input.value, 10) || MIN_QUANTITY) + delta;
        input.value = next < MIN_QUANTITY ? MIN_QUANTITY : next;
        refreshQuantity(form);
      }

      /* ─── Amount ───────────────────────────────────────────────────────────────
         An amount is a variant, so selecting one writes the variant id the form posts and
         mirrors the money-formatted label the grid carries into the summary readout. */
      function applyAmount(input) {
        var form = input.form;
        if (!form) return;

        var variantInput = form.querySelector('[data-gift-card-variant-id]');
        if (variantInput) variantInput.value = input.value;

        var display = form.querySelector('[data-gift-card-amount-display]');
        var price = input.getAttribute('data-gift-card-amount-price');
        if (display && price) display.textContent = price;

        syncStickyAmount(price);
        announceVariant(input.value);
      }

      /* Writes a newly picked amount into the sticky bar's own "Amount" jump button —
         separate from selectTab()'s own sync below because an amount change (this
         function) and a tab switch (selectTab) are two different triggers for the same
         target, not one calling the other. */
      function syncStickyAmount(price) {
        if (!price) return;
        var stickyOptionValue = root.querySelector('[data-sticky-option-value]');
        if (!stickyOptionValue) return;

        stickyOptionValue.textContent = price;

        var jumpButton = stickyOptionValue.closest('[data-sticky-option-jump]');
        if (!jumpButton) return;
        var labelEl = jumpButton.querySelector('[data-sticky-option-label]');
        var labelText = labelEl ? labelEl.textContent.trim() : '';
        jumpButton.setAttribute('aria-label', labelText + ': ' + price);
      }

      /* ─── Sticky bar mirror on tab switch ─────────────────────────────────────────
         The sticky bar is rendered once, server-side, against whichever product the URL
         resolved to (see sections/product-gift-card.liquid's own render call) — switching
         tabs client-side does not re-render it. Mirrors the newly active panel's own
         already-rendered title/price/image into the sticky bar's matching elements,
         the same "copy from what's already rendered" approach sections/product.liquid's
         classic-PDP sticky sync uses (syncStickySummary/syncStickyImage there), and syncs
         the Amount value to whichever variant the target panel's own grid has checked. */
      function syncStickyFromPanel(scope) {
        var header = root.querySelector('[data-gift-card-panel-header="' + selectorValue(scope) + '"]');
        if (header) {
          var stickyTitle = root.querySelector('[data-sticky-atb-title]');
          var titleEl = header.querySelector('[data-gift-card-panel-title]');
          if (stickyTitle && titleEl) stickyTitle.textContent = titleEl.textContent;

          var stickyPrice = root.querySelector('[data-sticky-atb-price-current]');
          var priceEl = header.querySelector('[data-gift-card-panel-price]');
          if (stickyPrice && priceEl) stickyPrice.textContent = priceEl.textContent;

          var stickyImage = root.querySelector('[data-sticky-atb-image]');
          var imageSrc = header.getAttribute('data-gift-card-panel-image');
          if (stickyImage && imageSrc) {
            stickyImage.querySelectorAll('source').forEach(function (source) {
              source.removeAttribute('srcset');
              source.removeAttribute('data-srcset');
            });
            stickyImage.querySelectorAll('img').forEach(function (image) {
              image.src = imageSrc;
              image.srcset = imageSrc;
              image.removeAttribute('data-src');
              image.removeAttribute('data-srcset');
            });
          }
        }

        var panel = root.querySelector('[data-gift-card-tab-panel="' + selectorValue(scope) + '"]');
        var checkedAmount = panel ? panel.querySelector('[data-gift-card-amount]:checked') : null;
        if (checkedAmount) {
          syncStickyAmount(checkedAmount.getAttribute('data-gift-card-amount-price'));
        }
      }

      /* ─── Send date ────────────────────────────────────────────────────────────
         Disabled while concealed, so an unscheduled card posts no send-date value at all.
         The hidden Send on input is written by the calendar below, not typed by the
         shopper — there is no native date control: a custom calendar, a slide reveal and
         a rotating chevron stand in for one.

         The slide itself reuses the theme's existing accordion-panel utility and
         grid-template-rows transition (src/css/theme.css) — the same mechanism
         snippets/accordion.liquid drives — rather than a second bespoke one. Driven here
         directly instead of through accordion.liquid's own click-listener wiring: that
         module toggles on a click on ITS OWN trigger and closes accordion siblings on
         open, neither of which fits a reveal driven by which radio option is checked. */
      function setScheduled(form, isScheduled) {
        var wrap = form.querySelector('[data-gift-card-date-field]');
        var panel = form.querySelector('[data-gift-card-date-panel]');
        var input = form.querySelector('[data-gift-card-send-on]');
        var chevron = form.querySelector('[data-gift-card-send-chevron]');

        // aria-hidden/inert only here, deliberately NOT the `hidden` class conceal() also
        // toggles: the accordion-panel grid-rows transition on the panel above is what
        // actually shows/hides this content now, and instantly display:none-ing it would
        // fight that animation (nothing left to grow into on open, an instant cut on
        // close instead of a slide). The a11y pair still matters while collapsed, since
        // overflow-hidden clipping alone leaves focusable children reachable by keyboard.
        if (wrap) {
          if (isScheduled) {
            wrap.removeAttribute('aria-hidden');
            wrap.removeAttribute('inert');
          } else {
            wrap.setAttribute('aria-hidden', 'true');
            wrap.setAttribute('inert', '');
          }
        }
        if (input) input.disabled = !isScheduled;
        if (panel) panel.style.gridTemplateRows = isScheduled ? '1fr' : '';
        if (chevron) chevron.style.transform = isScheduled ? 'rotate(180deg)' : '';
      }

      /* ─── Tabs ─────────────────────────────────────────────────────────────────
         Standard ARIA tabs: one tab stop for the row, arrow keys move and activate. The
         title, price and description block is per-product too, so it moves with its panel. */
      function selectTab(scope) {
        var form = formFor(scope);
        if (!form) return;
        current = scope;

        nodes(root, '[data-gift-card-tab]').forEach(function (tab) {
          var active = tab.getAttribute('data-gift-card-tab') === scope;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          tab.classList.toggle('bg-surface-input', active);

          // The active-state bottom rule is an ::after pseudo-element on the tab button
          // itself — there is no separate label/span to toggle. Every class in the
          // Liquid markup's conditional block must be
          // toggled together here, or a client-side tab switch leaves the rule stuck on
          // whichever tab the server originally rendered as active. The matching
          // hover:after:* classes are NOT toggled here — they are static on both tabs
          // regardless of active state, so :hover alone drives them via CSS.
          tab.classList.toggle('after:absolute', active);
          tab.classList.toggle('after:-bottom-px', active);
          tab.classList.toggle('after:left-0', active);
          tab.classList.toggle('after:w-full', active);
          tab.classList.toggle('after:h-2', active);
          tab.classList.toggle('after:bg-border-tertiary', active);
        });

        nodes(root, '[data-gift-card-panel-header]').forEach(function (header) {
          conceal(header, header.getAttribute('data-gift-card-panel-header') !== scope);
        });

        nodes(root, '[data-gift-card-tab-panel]').forEach(function (panel) {
          conceal(panel, panel.getAttribute('data-gift-card-tab-panel') !== scope);
        });

        // The sticky bar's button sits outside both forms and reaches its form by id, so the
        // binding is re-pointed here or the bar adds the counterpart product.
        if (form.id) {
          nodes(root, '[data-sticky-atb-submit]').forEach(function (button) {
            button.setAttribute('form', form.id);
          });
        }

        // Same reasoning for the sticky bar's "Amount" jump button: its scroll target
        // (product-sticky-atb.liquid's option_scroll_target_id) is a per-panel id
        // (gift-card-amount-block-<scope>), since only the active panel's amount block is
        // ever visible — scrolling to the hidden one would land on nothing.
        nodes(root, '[data-sticky-option-jump][data-gift-card-more-info-scroll]').forEach(function (button) {
          button.setAttribute('data-gift-card-more-info-scroll', 'gift-card-amount-block-' + scope);
        });

        syncStickyFromPanel(scope);

        refreshQuantity(form);

        // Switching tabs changes both which panel is visible (so the sticky bar's
        // reveal-timing measurement target changes) and the buy panel's own content
        // height. Neither is a scroll or resize, so neither shared module would
        // otherwise recompute until the next one fires — refresh both immediately
        // rather than leave a stale state visible until the shopper scrolls.
        if (window.StickyAtb) window.StickyAtb.refresh(root);
        if (window.BuyPanelSticky) window.BuyPanelSticky.refresh(root);
      }

      nodes(root, '[data-gift-card-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          selectTab(tab.getAttribute('data-gift-card-tab'));
        });
      });

      nodes(root, '[data-gift-card-tablist]').forEach(function (tablist) {
        var tabs = nodes(tablist, '[data-gift-card-tab]');

        tablist.addEventListener('keydown', function (event) {
          var index = tabs.indexOf(document.activeElement);
          if (index === -1) return;

          var next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;

          event.preventDefault();
          tabs[next].focus();
          selectTab(tabs[next].getAttribute('data-gift-card-tab'));
        });
      });

      /* ─── Delegated panel behaviour ────────────────────────────────────────────
         Bound to the section root, so the copies of these same hooks inside the mini bag's
         editor panel are never touched from here. */
      root.addEventListener('change', function (event) {
        var amount = event.target.closest('[data-gift-card-amount]');
        if (amount) {
          applyAmount(amount);
          return;
        }

        var sendOption = event.target.closest('[data-gift-card-send-option]');
        if (sendOption && sendOption.form) {
          setScheduled(
            sendOption.form,
            sendOption.getAttribute('data-gift-card-send-option') === 'scheduled'
          );
        }
      });

      root.addEventListener('input', function (event) {
        var message = event.target.closest('[data-gift-card-message]');
        if (!message || !message.form) return;

        // The textarea snippet renders the counter and its live wiring but leaves the value
        // to the consumer, and reads the total off maxlength.
        var count = message.form.querySelector('[data-gift-card-message-count]');
        if (count) {
          count.textContent = message.value.length + ' / ' + (message.getAttribute('maxlength') || '');
        }
      });

      root.addEventListener('click', function (event) {
        /* Resolved and submitted here rather than left to the button's own form="…"
           attribute: selectTab() below keeps that attribute pointed at the active
           panel's form for correctness/inspection, but dynamically re-pointing an
           existing button's form attribute is not reliably honoured by every browser's
           actual submission routing (the attribute reads back correctly; the submit it
           triggers can still target whichever form owned it at parse time), which on this
           page would add the URL-scope product rather than the counterpart the shopper
           switched to. requestSubmit() targets a form object directly, sidestepping that
           lookup entirely, and still fires a real `submit` event — gift-card-form-script.
           liquid's own listener needs no change to pick it up. */
        var stickySubmit = event.target.closest('[data-sticky-atb-submit]');
        if (stickySubmit) {
          var stickyForm = activeForm();
          if (stickyForm) {
            event.preventDefault();
            if (typeof stickyForm.requestSubmit === 'function') {
              stickyForm.requestSubmit();
            } else {
              // Pre-2020 browsers with no requestSubmit(): form.submit() would skip the
              // submit event (and this feature's own validation/AJAX add) entirely.
              stickyForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
          }
          return;
        }

        if (event.target.closest('[data-sticky-qty-minus]')) {
          adjustQuantity(activeForm(), -1);
          return;
        }

        if (event.target.closest('[data-sticky-qty-plus]')) {
          adjustQuantity(activeForm(), 1);
          return;
        }

        // "+ more info" opens no note of its own (the custom.gift_card_amount_note
        // metafield does not exist in Admin) — it scrolls to the accordions instead.
        // data-gift-card-more-info-scroll carries the
        // target id rather than hardcoding it, so the markup stays the source of truth.
        var moreInfo = event.target.closest('[data-gift-card-more-info-scroll]');
        if (moreInfo) {
          var targetId = moreInfo.getAttribute('data-gift-card-more-info-scroll');
          var target = targetId ? document.getElementById(targetId) : null;
          if (target && target.scrollIntoView) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });

      forms.forEach(function (form) {
        var scope = selectorValue(form.getAttribute('data-gift-card-scope') || '');

        nodes(form, '[data-gift-card-qty-' + scope + '-minus]').forEach(function (minus) {
          minus.addEventListener('click', function () {
            adjustQuantity(form, -1);
          });
        });

        nodes(form, '[data-gift-card-qty-' + scope + '-plus]').forEach(function (plus) {
          plus.addEventListener('click', function () {
            adjustQuantity(form, 1);
          });
        });

        // Shopify resolves a scheduled send against the purchaser's own clock, so the offset
        // is stamped on load rather than left blank.
        nodes(form, '[data-gift-card-offset]').forEach(function (offset) {
          offset.value = String(new Date().getTimezoneOffset());
        });

        // Defined in snippets/gift-card-calendar-script.liquid, which renders before
        // this snippet (sections/product-gift-card.liquid) so the global exists by the
        // time this line runs — Shopify concatenates every snippet's javascript block
        // into one file in render order, not in module-import order.
        if (window.GiftCardCalendar) window.GiftCardCalendar.init(form);
        refreshQuantity(form);
      });
    }

    // The section root is the only thing queried from the document.
    document.querySelectorAll('[data-gift-card-section]').forEach(function (root) {
      if (root.__giftCardPanelReady) return;
      root.__giftCardPanelReady = true;
      init(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gorgias-chat-launcher"] && !Shopify.designMode) return;
  try {
    /*
   * State machine: idle -> loading -> ready, or loading -> stalled when a
   * click waited LOAD_TIMEOUT without Gorgias becoming ready (typically an
   * ad blocker stopping Gorgias's follow-on scripts). Gorgias's loader
   * refuses to run twice ("Another chat was detected"), so a stalled load
   * cannot be retried; a late arrival still hands over normally. A loader
   * that fails outright (error event) never ran, so it resets to idle and
   * the next click tries again; hover, focus and pointerdown no longer
   * preload after that, so an ad blocker can't trigger a fresh request on
   * every pass over the button. Once ready, LOAD_TIMEOUT no longer applies:
   * the window can still take seconds to fill, and the dots stay until the
   * hand-over.
   *
   * openRequested is set by a click and cleared only once the chat opens or
   * the click gives up, so a hover-only preload never opens the chat, and a
   * hand-over that lands before GorgiasChat.init() resolves does not swallow
   * the click.
   *
   * assets/gorgias-chat.js styles Gorgias's iframes and dispatches
   * gorgias-chat:frame-styled for each; this controller dispatches
   * gorgias-chat:load so that script only starts watching for Gorgias once
   * Gorgias has actually been asked for.
   */
  (function () {
    var launcher = document.querySelector('[data-chat-launcher]');
    // The app embed still loads Gorgias itself: leave everything to it.
    if (!launcher || document.querySelector('script[data-gorgias-loader-chat]')) return;

    var status = document.querySelector('[data-chat-launcher-status]');
    var LOAD_TIMEOUT = 20000;
    // Gorgias's loader comes from config.gorgias.chat, but the window's own
    // scripts come from this host (fetched without CORS, so the preconnect
    // carries no crossorigin). Opening it while the loader downloads saves
    // its DNS + TLS round trips later.
    var CHUNK_ORIGIN = 'https://assets.gorgias.chat';
    var BUTTON = '#gorgias-chat-messenger-button';
    // What each iframe has rendered once it is really usable. Both mount
    // empty; the window fills only when its own scripts arrive (about 8 s
    // after GorgiasChat.isOpen() turns true on a slow 4G profile), so the
    // stand-in and its dots stay until then.
    var READY = { 'chat-button': BUTTON, 'chat-window': '#self-service-portal-container' };

    var state = 'idle';
    var openRequested = false;
    var loaderFailed = false;
    var preconnected = false;
    var loadTimer = null;
    var announceTimer = null;

    function announce(key) {
      if (!status) return;
      // Cleared first so a repeated message is spoken again; a pending message
      // is cancelled so it can't land after a newer one (or after retire()).
      clearTimeout(announceTimer);
      status.textContent = '';
      if (!key) return;
      var text = status.getAttribute(key);
      announceTimer = setTimeout(function () { status.textContent = text; }, 100);
    }

    function setBusy(busy) {
      if (busy) {
        launcher.setAttribute('aria-busy', 'true');
      } else {
        launcher.removeAttribute('aria-busy');
      }
    }

    // Every script src comes from a data-* attribute, so it is checked
    // against Gorgias's own hosts first: an element further up the page
    // carrying data-chat-launcher (merchant HTML, an app widget) can never
    // point the theme at another script.
    var ORIGINS = ['https://config.gorgias.chat', 'https://content.9gtb.com', 'https://config.gorgias.help'];

    function scriptSrc(name) {
      var value = launcher.getAttribute(name);
      try {
        if (ORIGINS.indexOf(new URL(value).origin) !== -1) return value;
      } catch (e) {}
      return null;
    }

    function addScript(src) {
      if (!src) return null;
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.head.appendChild(script);
      return script;
    }

    function stopWaiting() {
      clearTimeout(loadTimer);
      setBusy(false);
    }

    function fail() {
      openRequested = false;
      stopWaiting();
      announce('data-error-text');
    }

    function onReady() {
      if (state === 'ready') return;
      state = 'ready';
      if (!openRequested) return;
      openRequested = false;
      if (!window.GorgiasChat.isOpen()) window.GorgiasChat.open();
    }

    function loadChat() {
      if (state !== 'idle') return;
      state = 'loading';
      if (!preconnected) {
        preconnected = true;
        var link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = CHUNK_ORIGIN;
        document.head.appendChild(link);
        document.dispatchEvent(new CustomEvent('gorgias-chat:load'));
      }

      var script = addScript(scriptSrc('data-chat-loader-src'));
      if (!script) {
        state = 'stalled';
        if (openRequested) fail();
        return;
      }
      script.addEventListener('load', function () {
        // The loader defines GorgiasChat as it runs; if it did not, it threw.
        if (!window.GorgiasChat) {
          state = 'stalled';
          if (openRequested) fail();
          return;
        }
        // init() only ever resolves (it never rejects); a Gorgias that never
        // gets ready is caught by the click's LOAD_TIMEOUT instead.
        window.GorgiasChat.init().then(onReady);
      });
      // Blocked or offline: the loader never ran, so the next click retries.
      script.addEventListener('error', function () {
        script.remove();
        state = 'idle';
        loaderFailed = true;
        if (openRequested) fail();
      });
    }

    // Hover, focus and pointerdown preload; after a failed loader only a click
    // retries.
    function preload() {
      if (!loaderFailed) loadChat();
    }

    function requestOpen() {
      if (state === 'ready') {
        window.GorgiasChat.open();
        return;
      }
      if (state === 'stalled') {
        announce('data-error-text');
        return;
      }
      openRequested = true;
      setBusy(true);
      announce('data-loading-text');
      clearTimeout(loadTimer);
      loadTimer = setTimeout(function () {
        if (state === 'ready') return;
        if (state === 'loading') state = 'stalled';
        fail();
      }, LOAD_TIMEOUT);
      loadChat();
    }

    // Hides the stand-in for good. If it had keyboard focus, focus follows
    // into Gorgias: the window when that is what took over, otherwise
    // Gorgias's own launcher button, never falling back to <body>.
    function retire(iframe) {
      if (launcher.hidden) return;
      var hadFocus = document.activeElement === launcher;
      stopWaiting();
      announce('');
      launcher.hidden = true;
      if (!hadFocus) return;
      if (iframe.id === 'chat-window') {
        iframe.focus();
        return;
      }
      var doc = iframe.contentDocument;
      var button = doc && doc.querySelector(BUTTON);
      if (button) button.focus();
    }

    // A childList + subtree observer on the iframe's document waits for its
    // content, one querySelector per batch, and disconnects once it lands
    // or the other iframe has already taken over.
    function handOver(event) {
      var iframe = event.detail.iframe;
      var ready = READY[iframe.id];
      var doc = iframe.contentDocument;
      if (launcher.hidden || !ready || !doc) return;
      if (doc.querySelector(ready)) {
        retire(iframe);
        return;
      }
      var observer = new MutationObserver(function () {
        if (launcher.hidden) {
          observer.disconnect();
        } else if (doc.querySelector(ready)) {
          observer.disconnect();
          retire(iframe);
        }
      });
      observer.observe(doc.documentElement, { childList: true, subtree: true });
    }

    // Convert and the mailto: replacement are not needed while the page is
    // still loading: they wait for the load event, then an idle moment
    // (Safari has no requestIdleCallback, so a short timeout stands in).
    function loadExtras() {
      function run() {
        addScript(scriptSrc('data-chat-convert-src'));
        addScript(scriptSrc('data-chat-mailto-src'));
      }
      if (window.requestIdleCallback) {
        window.requestIdleCallback(run, { timeout: 2000 });
      } else {
        setTimeout(run, 1);
      }
    }

    if (document.readyState === 'complete') {
      loadExtras();
    } else {
      window.addEventListener('load', loadExtras, { once: true });
    }

    document.addEventListener('gorgias-chat:frame-styled', handOver);
    launcher.addEventListener('pointerenter', preload);
    launcher.addEventListener('pointerdown', preload);
    launcher.addEventListener('focus', preload);
    launcher.addEventListener('click', requestOpen);
    launcher.hidden = false;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    /* ═══════════════════════════════════════════════
     Search Ticker
     Delay: 3 s  ·  Transition: 0.6 s via CSS class
  ═══════════════════════════════════════════════ */
  function initSearchTicker(tickerEl) {
    var items = Array.from(tickerEl.querySelectorAll('[data-ticker-item]'));
    if (items.length < 2) return;

    /* Snap all items to their start positions without triggering transitions.
       Items 2+ already have translate:0 100% from the inline style set in the
       template, but we suppress transitions here as a safety net in case any
       browser recomputes them before JS runs. */
    items.forEach(function(item, i) {
      item.style.transition = 'none';
      if (i !== 0) item.style.translate = '0 100%';
    });

    var current = 0;

    function advance() {
      var outgoing = items[current];
      current = (current + 1) % items.length;
      var incoming = items[current];

      incoming.style.transition = 'none';
      incoming.style.translate = '0 100%';

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          incoming.style.transition = '';
          outgoing.style.translate = '0 -100%';
          incoming.style.translate = '0 0';
          setTimeout(advance, 3600);
        });
      });
    }

    /* Re-enable transitions after two frames (ensures the snap paint
       has committed), then start the advance cycle after the initial delay. */
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        items.forEach(function(item) { item.style.transition = ''; });
        setTimeout(advance, 3000);
      });
    });
  }

  document.querySelectorAll('[data-search-ticker]').forEach(initSearchTicker);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input"] && !Shopify.designMode) return;
  try {
    /*
   * Toggle .is-floated on [data-float-field] based on focus and value state.
   * Shopify deduplicates snippet JS, so querySelectorAll finds all instances.
   */
  (function () {
    window.initFloatingFields = window.initFloatingFields || function (root) {
      (root || document).querySelectorAll('[data-float-field]').forEach(function(field) {
        if (field.__floatFieldReady) return;

        var input = field.querySelector('[data-float-input]');
        if (!input) return;

        field.__floatFieldReady = true;

        function sync() {
          field.classList.toggle('is-floated', document.activeElement === input || input.value.length > 0);
        }

        input.addEventListener('focus', sync);
        input.addEventListener('blur', sync);
        input.addEventListener('input', sync);
        sync(); // reflect pre-filled values on page load
      });
    }
    window.initFloatingFields();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-carousel-script"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      if (!window.ProductCarouselEngine) return;
      document.querySelectorAll('[data-carousel-section]').forEach(function (el) {
        if (el.__carouselReady) return;
        el.__carouselReady = true;
        window.ProductCarouselEngine(el, {
          prefix: 'data-carousel',
          multiValueBlocks: true,
          allBlockId: 'all',
          desktopClonePeriods: 2
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    /* ═══════════════════════════════════════════════
     Desktop mega-menu controller (D1/D2 hover + disclosure-on-keyboard).
     drawer.js owns open/close plumbing elsewhere; this owns mega-panel behavior.
     Shares the [data-header][data-mega-open] attribute contract with
     menu-drawer.liquid's controller — both toggle it independently via their
     own document.querySelector('[data-header]'); rename it in both files together.
  ═══════════════════════════════════════════════ */
  document.querySelectorAll('[data-header]').forEach(function (header) {
    if (header.dataset.megaMenuControllerReady === 'true') return;
    header.dataset.megaMenuControllerReady = 'true';

    var container = header.querySelector('[data-mega-menu]');
    var nav = header.querySelector('[data-mega-nav]');
    if (!container || !nav) return;

    var closeTimer = null;
    var activeKey = null;
    var searchWrap = header.querySelector('.header-search-wrapper');
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    function panelFor(key) {
      return container.querySelector('[data-mega-panel="' + CSS.escape(key) + '"]');
    }
    function triggerFor(key) {
      return nav.querySelector('[data-mega-trigger="' + CSS.escape(key) + '"]');
    }
    function setSearchChromeHidden(on) {
      if (!searchWrap) return;
      if (on) searchWrap.setAttribute('inert', '');
      else searchWrap.removeAttribute('inert');
    }

    function openKey(key) {
      if (activeKey === key) return;
      if (activeKey) {
        var prevP = panelFor(activeKey);
        var prevT = triggerFor(activeKey);
        if (prevP) {
          prevP.classList.remove('opacity-100', 'pointer-events-auto');
          prevP.classList.add('opacity-0', 'pointer-events-none');
          prevP.setAttribute('aria-hidden', 'true');
          prevP.setAttribute('inert', '');
        }
        if (prevT) {
          prevT.removeAttribute('data-mega-active');
          prevT.setAttribute('aria-expanded', 'false');
        }
      }
      var p = panelFor(key);
      var t = triggerFor(key);
      if (!p || !t) return;
      container.style.gridTemplateRows = '1fr';
      header.setAttribute('data-mega-open', '');
      setSearchChromeHidden(true);
      p.classList.remove('opacity-0', 'pointer-events-none');
      p.classList.add('opacity-100', 'pointer-events-auto');
      p.removeAttribute('aria-hidden');
      p.removeAttribute('inert');
      t.setAttribute('data-mega-active', '');
      t.setAttribute('aria-expanded', 'true');
      activeKey = key;
    }

    function closeAll() {
      if (activeKey) {
        var p = panelFor(activeKey);
        var t = triggerFor(activeKey);
        if (p) {
          p.classList.remove('opacity-100', 'pointer-events-auto');
          p.classList.add('opacity-0', 'pointer-events-none');
          p.setAttribute('aria-hidden', 'true');
          p.setAttribute('inert', '');
        }
        if (t) {
          t.removeAttribute('data-mega-active');
          t.setAttribute('aria-expanded', 'false');
        }
      }
      container.style.gridTemplateRows = '';
      header.removeAttribute('data-mega-open');
      setSearchChromeHidden(false);
      activeKey = null;
    }

    nav.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
      var key = trigger.getAttribute('data-mega-trigger');

      trigger.addEventListener('mouseenter', function () {
        /* Gated: iOS can synthesise mouseenter on a tap, racing the click handler below. */
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        openKey(key);
      });
      /* justFocused: Android Chrome (unlike iOS Safari) fires focus then a
         synthetic click from a single tap. Ungated, that focus opens the
         panel and the click right behind it reads activeKey === key and
         closes it again. The flag distinguishes that same-gesture pair from
         a genuine keyboard Tab or VoiceOver/TalkBack focus, which must still
         open the panel here — canHover can't make that distinction, since
         touch + an external keyboard, or a screen reader on touch, is also
         !canHover. */
      var justFocused = false;
      trigger.addEventListener('focus', function () {
        clearTimeout(closeTimer);
        openKey(key);
        justFocused = true;
        setTimeout(function () { justFocused = false; }, 350);
      });
      trigger.addEventListener('click', function (e) {
        if (canHover.matches) return;
        e.preventDefault();
        if (activeKey === key && !justFocused) {
          closeAll();
        } else {
          openKey(key);
        }
        justFocused = false;
      });

      /* Keyboard reachability fix (code review, TASK-50795): the panel for `key`
         sits in the DOM after every trigger, so a plain Tab from this trigger
         would skip straight past it to the next trigger — the panel was never
         reachable by keyboard. While this trigger's own panel is open, redirect
         a forward Tab into the panel's first focusable element instead. */
      trigger.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || e.shiftKey) return;
        if (activeKey !== key) return;
        var p = panelFor(key);
        var first = p && p.querySelector('a[href], button:not([disabled])');
        if (first) {
          e.preventDefault();
          first.focus();
        }
      });
    });

    /* Once focus is inside an open panel, leaving the trigger+panel widget
       entirely (Tab off the last link, Shift+Tab off the first, or a click
       elsewhere) closes it — the disclosure pattern's "close on focusout".
       requestAnimationFrame lets the new element actually receive focus
       first, so document.activeElement reflects where focus landed (more
       robust across browsers than reading focusout's relatedTarget). */
    container.addEventListener('focusout', function () {
      requestAnimationFrame(function () {
        var active = document.activeElement;
        if (!container.contains(active) && !nav.contains(active)) {
          closeAll();
        }
      });
    });

    [nav, container].forEach(function (el) {
      el.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(closeAll, 150);
      });
      el.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });
    });

    /* Touch has no mouseleave to close an open panel on — a tap outside the
       nav/panel closes it instead. */
    document.addEventListener('click', function (e) {
      if (canHover.matches || !activeKey) return;
      if (nav.contains(e.target) || container.contains(e.target)) return;
      closeAll();
    });
    header.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeKey) {
        var t = triggerFor(activeKey);
        closeAll();
        if (t) t.focus();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-drawer"] && !Shopify.designMode) return;
  try {
    /* ═══════════════════════════════════════════════
     Mobile drawer drill controller (M2 — grow-down + drill-down horizontal slide).
     drawer.js owns open/close/backdrop/Tab-trap/portal; this owns the
     Main ⇄ sub-panel drill behavior within the drawer body.
     Shares the [data-header][data-mega-open] attribute contract with
     mega-menu.liquid's controller — both toggle it independently via their
     own document.querySelector('[data-header]'); rename it in both files together.
  ═══════════════════════════════════════════════ */
  document.querySelectorAll('[data-menu-drawer]').forEach(function (drawer) {
    if (drawer.dataset.menuMotionReady === 'true') return;
    drawer.dataset.menuMotionReady = 'true';

    var header = document.querySelector('[data-header]');
    var panel = drawer.querySelector('[data-drawer-panel]');
    var main = drawer.querySelector('[data-menu-main]');
    var back = drawer.querySelector('[data-menu-back]');
    var chrome = drawer.querySelector('[data-menu-chrome]');
    if (!panel || !main || !back) return;
    var currentSub = null;

    function subFor(key) { return panel.querySelector('[data-menu-sub="' + CSS.escape(key) + '"]'); }
    function drillFor(key) { return main.querySelector('[data-menu-drill="' + CSS.escape(key) + '"]'); }
    function hideEl(el) { el.setAttribute('aria-hidden', 'true'); el.setAttribute('inert', ''); }
    function showEl(el) { el.removeAttribute('aria-hidden'); el.removeAttribute('inert'); }
    function setDrilled(on) {
      if (!chrome) return;
      if (on) chrome.setAttribute('data-menu-drilled', '');
      else chrome.removeAttribute('data-menu-drilled');
    }
    /* Panels animate `translate` and BACK animates `opacity`, so the property to
       wait on is per-caller (mirrors drawer.js's own onMotionEnd signature). */
    function onMotionEnd(el, propertyName, fn) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        el.removeEventListener('transitionend', h);
        fn();
      }
      function h(e) {
        if (e.target !== el || e.propertyName !== propertyName) return;
        finish();
      }
      el.addEventListener('transitionend', h);
      setTimeout(finish, 450);
    }
    /* Freeze/commit before an un-hide-and-reposition: the target may be
       display:none from a prior hide, so removing `hidden` while a class change
       also lands in the same tick would let the transition already on the
       element animate the display:none → visible jump itself (the CSS `used`
       value while hidden reads as unset, not the resting translate class), then
       the very next rAF reverses it — read as a bounce. Freezing the transition,
       forcing a layout flush, then handing the transition back guarantees the
       un-hide/reposition itself is instant and only the rAF-driven change animates. */
    function commitStart(el) {
      void el.offsetWidth;
      el.style.transition = '';
    }
    /* Sub-panels are display:none until the drill, so every thumbnail inside them
       is a pending lazy load that would otherwise start in the same task that
       starts the 0.4s slide — landing mid-animation as paint invalidations on a
       translating layer. Warm them on the drawer's own open signal (data-menu-open),
       not after M1's transitionend — waiting for M1 to finish races a fast drill
       that can outrun it, letting the cutout categories snap instead of slide. */
    var warmState = 0; /* 0 idle · 1 scheduled · 2 done */
    function warmCutouts() {
      if (warmState === 2) return;
      warmState = 2;
      panel.querySelectorAll('[data-menu-sub] [data-menu-cutout] img').forEach(function (img) {
        if (img.getAttribute('loading') !== 'lazy') return;
        img.loading = 'eager';
        if (typeof img.decode === 'function') img.decode().catch(function () {});
      });
    }
    function scheduleWarm() {
      if (warmState !== 0) return;
      warmState = 1;
      warmCutouts();
    }
    function resetSubPanel(sub) {
      /* Re-opening the drawer must always land at the top of the panel (QA snag
         pass 2026-08-14) — these panels are the scroll containers, not the drawer.
         scrollTop must be reset BEFORE the `hidden` class (display:none) lands —
         browsers silently no-op a scrollTop write on an already-hidden element,
         so setting it after would leave the stale scrolled position in place for
         the next time this panel is shown. */
      sub.scrollTop = 0;
      sub.classList.add('hidden', 'translate-x-full');
      sub.classList.remove('flex');
      hideEl(sub);
    }
    function resetAllSubs() {
      panel.querySelectorAll('[data-menu-sub]').forEach(resetSubPanel);
    }
    function fadeInBack() {
      back.classList.remove('hidden');
      back.classList.add('flex', 'opacity-0');
      void back.offsetWidth;
      requestAnimationFrame(function () {
        back.classList.remove('opacity-0');
      });
    }
    function fadeOutBack() {
      back.classList.add('opacity-0');
      onMotionEnd(back, 'opacity', function () {
        back.classList.add('hidden');
        back.classList.remove('flex');
      });
    }
    function hideBackInstant() {
      back.classList.add('hidden', 'opacity-0');
      back.classList.remove('flex');
    }
    function syncHeaderFill() {
      if (!header) return;
      /* Mobile drawer covers the header (same inset, z-60). Stamping D1's
         data-mega-open cream fill onto a transparent homepage header is the
         flash through the frost while M1 is still scaleY(0). Desktop mega
         still owns this attribute via mega-menu.liquid. */
      if (!drawer.hasAttribute('data-menu-open') || drawer.hasAttribute('data-menu-closing')) {
        header.removeAttribute('data-mega-open');
      }
    }
    function resetToMain() {
      if (currentSub) {
        var drill = drillFor(currentSub);
        if (drill) drill.setAttribute('aria-expanded', 'false');
        currentSub = null;
      }
      resetAllSubs();
      main.classList.remove('hidden', '-translate-x-full');
      main.scrollTop = 0;
      showEl(main);
      hideBackInstant();
      setDrilled(false);
    }
    function onDrawerStateChange() {
      syncHeaderFill();
      if (drawer.hasAttribute('aria-hidden') && !drawer.hasAttribute('data-menu-closing')) {
        resetToMain();
      } else if (drawer.hasAttribute('data-menu-open') && !drawer.hasAttribute('data-menu-closing')) {
        scheduleWarm();
      }
    }
    new MutationObserver(onDrawerStateChange).observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'data-menu-closing', 'data-menu-open']
    });

    function showSub(key) {
      var sub = subFor(key);
      if (!sub || currentSub) return;
      resetAllSubs();
      /* Forward drill: Main slides out to the left, sub slides in from the right.
         sub's own transition is frozen while it's un-hidden and repositioned at
         translate-x-full (see commitStart above) — only the rAF-driven change
         below animates. */
      sub.style.transition = 'none';
      sub.classList.remove('hidden');
      sub.classList.add('flex', 'translate-x-full');
      showEl(sub);
      commitStart(sub);
      requestAnimationFrame(function () {
        main.classList.add('-translate-x-full');
        sub.classList.remove('translate-x-full');
      });
      hideEl(main);
      onMotionEnd(main, 'translate', function () {
        main.classList.add('hidden');
      });
      fadeInBack();
      setDrilled(true);
      var drill = drillFor(key);
      if (drill) drill.setAttribute('aria-expanded', 'true');
      currentSub = key;
      var first = sub.querySelector('a[href], button:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }

    function showMain() {
      if (!currentSub) return;
      var sub = subFor(currentSub);
      var drill = drillFor(currentSub);
      /* Back: reversed — Main slides back in from the left, sub slides out right.
         Same freeze/commit as showSub(): main is un-hidden and repositioned at
         -translate-x-full with its transition frozen first. */
      main.style.transition = 'none';
      main.classList.remove('hidden');
      main.classList.add('-translate-x-full');
      showEl(main);
      commitStart(main);
      requestAnimationFrame(function () {
        main.classList.remove('-translate-x-full');
        if (sub) sub.classList.add('translate-x-full');
      });
      if (sub) hideEl(sub);
      if (sub) onMotionEnd(sub, 'translate', function () { resetSubPanel(sub); });
      fadeOutBack();
      setDrilled(false);
      if (drill) {
        drill.setAttribute('aria-expanded', 'false');
        drill.focus({ preventScroll: true });
      }
      currentSub = null;
    }

    panel.addEventListener('click', function (e) {
      var drill = e.target.closest('[data-menu-drill]');
      if (drill && panel.contains(drill)) {
        e.preventDefault();
        showSub(drill.getAttribute('data-menu-drill'));
        return;
      }
      if (e.target.closest('[data-menu-back]')) {
        e.preventDefault();
        showMain();
      }
    });

    var desktopMq = window.matchMedia('(min-width: 1024px)');
    function closeMenuOnDesktop() {
      if (!desktopMq.matches) return;
      if (drawer.hasAttribute('aria-hidden')) return;
      var closer = drawer.querySelector('[data-drawer-close]');
      if (closer) closer.click();
    }
    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', closeMenuOnDesktop);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(closeMenuOnDesktop);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-bundle-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /* Delegated at document level, bound once. sections/mini-bag.liquid re-renders
       [data-mini-bag-lines] wholesale via the Section Rendering API on every cart
       mutation (mini-bag-cart-script.liquid's applySection), so a per-element listener
       bound at render time would be lost on the first quantity change. Shopify bundles
       this file's javascript block once regardless of how many bundle lines render, so
       there is no double-registration to guard against. */
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-bundle-contents-trigger]');
      if (!trigger) return;

      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;

      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

      if (isOpen) {
        panel.style.gridTemplateRows = '';
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
      } else {
        panel.style.gridTemplateRows = '1fr';
        /* Cleared with removeAttribute, never set to an explicit false value
           (_SHARED_INVARIANTS.md §1 rule 6), and always unset together with inert. */
        panel.removeAttribute('aria-hidden');
        panel.removeAttribute('inert');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-cart-script"] && !Shopify.designMode) return;
  try {
    (function () {
    window.MiniBag = window.MiniBag || {};

    if (window.MiniBag.cartScriptLoaded) return;
    window.MiniBag.cartScriptLoaded = true;

    var MiniBag = window.MiniBag;
    var FALLBACK_SECTION_ID = 'mini-bag';
    var pendingRemovals = {};

    /* The mini bag is rendered inside header-group.json, so Shopify gives its live section
       instance a dynamic ID (for example sections--1234__mini-bag). Requesting the section
       type name `mini-bag` instead renders schema defaults with no merchant blocks, which is
       why the promo disappeared after every cart mutation. The marker travels with the
       hoisted drawer and keeps the real instance ID available after drawer.js moves it to
       <body>. */
    function getSectionId() {
      var marker = document.querySelector('[data-mini-bag-section-id]');
      var sectionId = marker && marker.getAttribute('data-mini-bag-section-id');
      return sectionId || FALLBACK_SECTION_ID;
    }

    /* Figma "UNDO STATE - DESKTOP & MOBILE" (12384:135293): "the undo state appears for
       3.5s. After that, the product is removed from the bag." */
    var UNDO_WINDOW_MS = 3500;

    MiniBag.SECTION_ID = getSectionId();
    MiniBag.getSectionId = getSectionId;
    MiniBag.pendingRemovals = pendingRemovals;

    function itemRoot(key) {
      return document.querySelector('[data-mini-bag-item="' + key + '"]');
    }

    // Focus a control inside a given line, used either side of the undo swap so the
    // control that replaces the one just activated inherits focus instead of losing it.
    function moveFocusWithin(key, selector) {
      var root = itemRoot(key);
      var control = root ? root.querySelector(selector) : null;
      if (control) control.focus();
    }

    /* The line keys the bag will still hold once every open undo window has expired.
       A removed line stays in the DOM, dimmed, for the whole 3.5s — so a raw count of
       [data-mini-bag-item] answers "how many rows are drawn", not "how many items the
       shopper still has", and the two diverge the moment a second line is removed while
       the first is still pending. Everything that reacts to the bag emptying has to ask
       this, not the DOM. */
    function liveItemKeys() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-mini-bag-item]'))
        .map(function (el) { return el.getAttribute('data-mini-bag-item'); })
        .filter(function (itemKey) { return itemKey && !pendingRemovals[itemKey]; });
    }

    MiniBag.liveItemKeys = liveItemKeys;

    /* replaceDrawerRegion and restoreFocusAfterRemoval live in
       mini-bag-dom-helpers-script.liquid, exposed as MiniBag.* — kept out of this file
       so a small shared helper doesn't grow one already well past the 500-line ceiling. */
    var restoreFocusAfterRemoval = function () {
      if (MiniBag.restoreFocusAfterRemoval) MiniBag.restoreFocusAfterRemoval();
    };

    function applySection(html) {
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var liveItems = document.querySelector('[data-mini-bag-items]');
      var panel = liveItems ? liveItems.closest('[data-drawer-panel]') : null;
      var newPanel = tmp.querySelector('[data-drawer-panel]');
      if (!panel || !newPanel) return;
      function replaceInner(selector) {
        var live = panel.querySelector(selector);
        var fresh = newPanel.querySelector(selector);
        if (!live || !fresh) return;
        live.innerHTML = fresh.innerHTML;
      }

      /* Keep the content after the line list anchored while its server-rendered markup is
         swapped. In particular, an open subscription row otherwise briefly returns with its
         default max-height before initMiniBagSubscriptionRows measures it, producing an
         up/down bounce below the list. The minimum height lasts for one render only: genuine
         growth (an added line) is never constrained, and genuine shrinkage (a removed line)
         settles on the following frame without exposing an intermediate height. */
      function replaceLines() {
        var live = panel.querySelector('[data-mini-bag-lines]');
        var fresh = newPanel.querySelector('[data-mini-bag-lines]');
        if (!live || !fresh) return;

        if (live.__miniBagHeightRelease) {
          window.cancelAnimationFrame(live.__miniBagHeightRelease);
        }

        var previousHeight = live.getBoundingClientRect().height;
        if (previousHeight > 0) live.style.minHeight = previousHeight + 'px';
        live.setAttribute('data-section-refreshing', 'true');
        live.innerHTML = fresh.innerHTML;
        initMiniBagSubscriptionRows(live);

        live.__miniBagHeightRelease = window.requestAnimationFrame(function () {
          live.__miniBagHeightRelease = window.requestAnimationFrame(function () {
            live.style.minHeight = '';
            live.removeAttribute('data-section-refreshing');
            live.__miniBagHeightRelease = null;
          });
        });
      }

      /* The section response is authoritative for the promo slot. The ticker keeps a stable,
         hidden root while configured but no message is currently live, so applying an empty
         slot is now reserved for a genuine configuration change (disabled/removed), not a
         cart threshold transition. A ticker-specific "must contain a ticker" guard would
         leave stale copy behind in that genuine empty state. */
      replaceInner('[data-mini-bag-promo-slot]');

      /* Loyalty gift picker: only the confirm-button wrapper, not its footer as a whole —
         the error live region beside it must never be destroyed and recreated
         mid-message (_SHARED_INVARIANTS.md §1 rule 12), and the card grid's selection
         state is re-synced from the cart by mini-bag-loyalty-gift-script.liquid, so
         patching either from here would wipe a message or flash stale state. */
      if (MiniBag.replaceDrawerRegion) {
        MiniBag.replaceDrawerRegion(tmp, '#gift-drawer [data-drawer-footer]');
        MiniBag.replaceDrawerRegion(tmp, '#loyalty-gift-drawer [data-loyalty-gift-confirm-wrap]');
      }
      replaceLines();
      replaceInner('[data-drawer-footer]');
      replaceInner('[data-drawer-title]');
    }

    function refreshMiniBagModules() {
      if (MiniBag.initPromoTickers) {
        MiniBag.initPromoTickers(document);
      }
      if (MiniBag.initSampleSelectors) {
        MiniBag.initSampleSelectors(document);
      }
      if (MiniBag.initSampleSliders) {
        MiniBag.initSampleSliders(document);
      }
      initMiniBagSubscriptionRows(document);
      if (MiniBag.syncRecommendationsPanel) {
        MiniBag.syncRecommendationsPanel();
      }
    }

    /* An empty bag shows NO recommendations, on any breakpoint. Three surfaces have to be
       shut off together, which is why the previous fix (desktop aside only) was not
       enough: the aside's populated channel, the aside's empty-bag channel, and the
       mobile row rendered inside the empty block. The empty-bag channel is now never
       surfaced — it stays in the markup so reinstating it is a one-line change. */
    function setRecommendationsPanelEmptyState(isEmpty) {
      var panelPopulated = document.querySelector('[data-mini-bag-panel-populated]');
      var panelEmpty = document.querySelector('[data-mini-bag-panel-empty]');
      if (panelPopulated) panelPopulated.classList.toggle('hidden', isEmpty);
      if (panelEmpty) panelEmpty.classList.add('hidden');
      document
        .querySelectorAll('[data-mini-bag-empty] [data-mini-bag-upsells-mobile]')
        .forEach(function (row) {
          row.classList.add('hidden');
        });
      /* Re-evaluate the aside's slide immediately. Without this it only recomputed on
         cart:updated, which for a removal is 4s away (the undo window), and not at all on
         Undo. syncRecommendationsPanel is idempotent, so the duplicate call via
         refreshMiniBagModules on cart:updated is harmless. */
      if (MiniBag.syncRecommendationsPanel) MiniBag.syncRecommendationsPanel();
    }

    function setEmptyState(isEmpty) {
      var items = document.querySelector('[data-mini-bag-items]');
      var empty = document.querySelector('[data-mini-bag-empty]');
      var checkout = document.querySelector('[data-mini-bag-checkout]');
      if (items) items.classList.toggle('hidden', isEmpty);
      if (empty) empty.classList.toggle('hidden', !isEmpty);
      if (checkout) checkout.classList.toggle('hidden', isEmpty);
      setRecommendationsPanelEmptyState(isEmpty);
    }

    function setQtyControlsDisabled(key, disabled) {
      var root = itemRoot(key);
      if (!root) return;
      root.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (button) {
        button.disabled = disabled;
        if (disabled) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }
      });
    }

    // The rendered count is the quantity the server holds, so it doubles as the line's ceiling after a refusal.
    function currentQuantity(key) {
      var root = itemRoot(key);
      var countEl = root ? root.querySelector('[data-qty-count]') : null;
      var quantity = countEl ? parseInt(countEl.textContent, 10) : NaN;
      return Number.isFinite(quantity) ? quantity : null;
    }

    function restoreQtyControlsAfterFailure(key, atMax) {
      var root = itemRoot(key);
      if (!root) return;
      var minusBtn = root.querySelector('[data-qty-minus]');
      var plusBtn = root.querySelector('[data-qty-plus]');
      var quantity = currentQuantity(key);
      if (plusBtn) {
        // Re-enabling + at the ceiling is what let a shopper reload the same refusal indefinitely.
        plusBtn.disabled = Boolean(atMax);
        if (atMax) {
          plusBtn.setAttribute('aria-disabled', 'true');
        } else {
          plusBtn.removeAttribute('aria-disabled');
        }
      }
      if (minusBtn) {
        var minusDisabled = quantity === 1;
        minusBtn.disabled = minusDisabled;
        if (minusDisabled) {
          minusBtn.setAttribute('aria-disabled', 'true');
        } else {
          minusBtn.removeAttribute('aria-disabled');
        }
      }
    }

    function reapplyPendingRemovedStates() {
      Object.keys(pendingRemovals).forEach(function (pendingKey) {
        setRemovedState(pendingKey, true);
      });
    }

    /* Single door for every cart mutation in the mini bag: identical headers, the section
       request, and an 8s abort — all three required by _SHARED_INVARIANTS.md §1 rule 12,
       and previously missing (each call site hand-rolled its own fetch with no timeout).
       Rejects with the original error so reportCartError can tell an abort from a server
       failure and pick the right message. */
    function cartRequest(url, body) {
      var ac = window.AbortController ? new AbortController() : null;
      var timer = window.setTimeout(function () {
        if (ac) ac.abort();
      }, 8000);

      body.sections = getSectionId();

      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
        signal: ac ? ac.signal : undefined,
      })
        .then(function (r) {
          // Carry the status: a 422 is Shopify refusing a quantity above the line's maximum, not a failure.
          if (!r.ok) {
            var httpError = new Error('cart_request_failed');
            httpError.status = r.status;
            throw httpError;
          }
          return r.json();
        })
        .finally(function () {
          window.clearTimeout(timer);
        });
    }

    function reportCartError(error, maxQuantity) {
      document.dispatchEvent(
        new CustomEvent('cart:error', {
          bubbles: true,
          detail: {
            timedOut: Boolean(error && error.name === 'AbortError'),
            maxQuantity: Number.isFinite(maxQuantity) ? maxQuantity : null,
          },
        })
      );
    }

    function getBuyAgainBundleProperties(properties) {
      if (
        !properties ||
        typeof properties !== 'object' ||
        Array.isArray(properties)
      ) {
        return null;
      }

      var role = properties._bundle_role;
      var priceMode = properties._price_mode;
      var discount = Number(properties._bundle_discount);

      if (
        !properties._bundle_id ||
        !properties._box_variant ||
        (role !== 'component' && role !== 'marker') ||
        (priceMode !== 'sum' && priceMode !== 'sum_discounted') ||
        !Number.isFinite(discount)
      ) {
        return null;
      }

      return {
        _bundle_id: String(properties._bundle_id),
        _box_variant: String(properties._box_variant),
        _bundle_role: role,
        _price_mode: priceMode,
        _bundle_discount: String(
          Math.max(0, Math.min(100, discount))
        ),
      };
    }

    function handleBuyAgainRedirect() {
      var url = new URL(window.location.href);
      var encodedPayload = url.searchParams.get('buy_again');

      if (!encodedPayload) return;

      var payload;

      try {
        payload = JSON.parse(encodedPayload);
      } catch (error) {
        console.warn('Buy Again: invalid payload.', error);
        url.searchParams.delete('buy_again');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        return;
      }

      if (!payload || !Array.isArray(payload.items) || !payload.items.length) {
        url.searchParams.delete('buy_again');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        return;
      }

      var items = payload.items.map(function (item) {
        var cartItem = {
          id: Number(item.id),
          quantity: Math.max(1, Number(item.quantity) || 1),
        };
        if (item.properties != null) {
          var properties = getBuyAgainBundleProperties(item.properties);
          if (!properties) {
            return null;
          }
          cartItem.properties = properties;
        }
        return cartItem;
      })
      .filter(function (item) {
        return (item &&  Number.isFinite(item.id) && item.id > 0);
      });

      if (!items.length) {
        url.searchParams.delete('buy_again');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        return;
      }

      /*
      * Consume the URL before starting the cart request.
      *
      * If the shopper refreshes while the request is running, the same Buy Again
      * payload must not be submitted a second time.
      */
      url.searchParams.delete('buy_again');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);

      var flushPending =
        MiniBag.flushPendingRemovalsForMutation
          ? MiniBag.flushPendingRemovalsForMutation()
          : Promise.resolve();

      flushPending
        .then(function () {
          return cartRequest('/cart/add.js', {
            items: items,
          });
        })
        .then(function (response) {
          return fetch('/cart.js', {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          }).then(function (cartResponse) {
            if (!cartResponse.ok) {
              throw new Error('cart_fetch_failed');
            }

            return cartResponse.json().then(function (cart) {
              cart.sections = response.sections || {};

              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  bubbles: true,
                  detail: {
                    cart: cart,
                    fromBuyAgain: true,
                  },
                })
              );

              if (typeof window.__drawerOpen === 'function') {
                window.__drawerOpen('mini-bag');
              }
            });
          });
        })
        .catch(function (error) {
          console.error('Buy Again: could not add order items.', error);
          reportCartError(error);
        });
    }

    /* How long the recommendation card's "Added" confirmation stays up. Matched to the
       undo window's 3.5s (Figma "UNDO STATE - DESKTOP & MOBILE", 12384:135293) — the only
       timed transient state the bag already has — so the two do not read as two different
       conventions when both are on screen. */
    var ADDED_STATE_MS = 3500;

    /* The add control on a recommendation card is a transparent full-bleed overlay with no
       text of its own, so the aria-disabled/aria-busy set on it below produced no visible
       change at all: the shopper got no signal the add had worked, and the line it created
       lands in a list they are not looking at (desktop puts the recommendations in a
       separate side panel; mobile puts them below the lines). The state lives on the CTA
       bar rather than the button because the bar owns both the price and the label/glyph
       slot that has to swap — see [data-mini-bag-cta] in product-card.liquid and in
       mini-bag-recommendations-card-script.liquid's injected twin.

       Safe against a re-render: the upsells row is a sibling of [data-mini-bag-lines], not
       a child, so applySection never replaces the node holding this state or its timer. */
    function setAddState(bar, state) {
      if (!bar) return;

      /* Cleared unconditionally, so a second add on the same card restarts the window
         instead of inheriting the first one's pending revert and snapping back early. */
      if (bar.__miniBagAddStateTimer) {
        window.clearTimeout(bar.__miniBagAddStateTimer);
        bar.__miniBagAddStateTimer = null;
      }

      if (state) {
        bar.setAttribute('data-add-state', state);
      } else {
        bar.removeAttribute('data-add-state');
      }

      if (state !== 'added') return;

      bar.__miniBagAddStateTimer = window.setTimeout(function () {
        bar.__miniBagAddStateTimer = null;
        bar.removeAttribute('data-add-state');
      }, ADDED_STATE_MS);
    }

    /* A custom-bundle line carries data-cart-line because two bundles under the same
       parent product share one item.key and so cannot be addressed by it. /cart/change.js
       takes a 1-based `line` index as an alternative target, which is unambiguous.
       Everything else keeps addressing by key. */
    function changeTarget(key) {
      var root = itemRoot(key);
      if (!root || !root.hasAttribute('data-cart-line')) return { id: key };

      /* Position is resolved live, not read back off the rendered attribute: a removal is
         deferred by the 4s undo window, and an earlier removal landing in the meantime
         shifts every later line up by one. DOM order matches cart.items order because the
         section renders the lines straight from that loop. */
      var container = document.querySelector('[data-mini-bag-lines]');
      var lines = container
        ? Array.prototype.slice.call(container.querySelectorAll('[data-mini-bag-item]'))
        : [];
      var index = lines.indexOf(root);
      return index >= 0 ? { line: index + 1 } : { id: key };
    }

    function mutateCart(key, quantity, focusHint, isRemoval) {
      setQtyControlsDisabled(key, true);
      var changePayload = changeTarget(key);
      changePayload.quantity = quantity;
      return cartRequest('/cart/change.js', changePayload)
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cart },
            })
          );
          /* cart:updated is dispatched synchronously, so applySection has already run by
             this line and the Undo button that held focus is gone. */
          if (isRemoval) restoreFocusAfterRemoval();
          if (focusHint) {
            var root = itemRoot(key);
            var target = root ? root.querySelector('[data-qty-' + focusHint + ']') : null;
            if (target && !target.disabled) {
              target.focus();
            } else if (root) {
              var fallback =
                root.querySelector('[data-qty-minus]:not([disabled])') ||
                root.querySelector('[data-qty-plus]:not([disabled])') ||
                root.querySelector('[data-remove-item]');
              if (fallback) fallback.focus();
            }
          }
        })
        .catch(function (error) {
          // Shopify caps a line at min(inventory, 50) while Liquid reports raw stock, so "+" outlives the real ceiling: a 422 on an increase IS that ceiling, and the quantity still on the line is the maximum. TASK-54344.
          var held = currentQuantity(key);
          var atMax = Boolean(
            error && error.status === 422 && held !== null && quantity > held
          );
          restoreQtyControlsAfterFailure(key, atMax);
          if (isRemoval) {
            setRemovedState(key, false);
          }
          reportCartError(error, atMax ? held : null);
        });
    }

    /* A removal is deferred by the 4s undo window (see the click handler below), but
       nothing stopped a second cart mutation — e.g. a custom bundle add — from firing
       while one was still pending. Both hit /cart/change.js and /cart/add.js independently
       with no shared lock, so Shopify could process them out of order against a stale
       cart view: the deferred removal's line index was resolved before the new add landed,
       so it could end up zeroing the wrong line, orphaning the rest of the old bundle's
       group (Cart Transform can no longer re-merge an incomplete group, so the leftovers
       surface as raw, unmerged lines — including the £0 marker on its own). Call this
       before starting any other cart mutation so pending removals resolve first. */
    function flushPendingRemovalsForMutation() {
      var keys = Object.keys(pendingRemovals);
      if (!keys.length) return Promise.resolve();
      return Promise.all(
        keys.map(function (key) {
          window.clearTimeout(pendingRemovals[key]);
          delete pendingRemovals[key];
          return mutateCart(key, 0, null, true);
        })
      );
    }

    MiniBag.flushPendingRemovalsForMutation = flushPendingRemovalsForMutation;

    function setRemovedState(key, isRemoved) {
      var root = itemRoot(key);
      if (!root) return;
      var banner = root.querySelector('[data-removed-banner]');
      var badges = root.querySelector('[data-mini-bag-line-item-badges]');
      var removeActions = root.querySelectorAll('[data-item-remove-action]');
      var titleRow = root.querySelector('[data-item-title-row]');
      var subtitle = root.querySelector('[data-item-subtitle]');
      var qtyRow = root.querySelector('[data-item-qty-row]');
      var subscriptionRow = root.querySelector('[data-item-subscription-row]');
      // Custom-bundle lines only (mini-bag-bundle-line-item.liquid) — dims the read-only
      // CONTENTS accordion alongside the rest of the card during the 4s undo window.
      var bundleContents = root.querySelector('[data-bundle-contents]');
      var image = root.querySelector('[data-item-image]');
      if (banner) {
        banner.classList.toggle('hidden', !isRemoved);
        banner.classList.toggle('flex', isRemoved);
      }
      if (badges) {
        badges.classList.toggle('hidden', isRemoved);
      }
      removeActions.forEach(function (button) {
        button.classList.toggle('hidden', isRemoved);
        button.disabled = isRemoved;
        if (isRemoved) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }
      });
      if (titleRow) {
        titleRow.classList.toggle('hidden', isRemoved);
      }
      /* Figma "UNDO STATE - DESKTOP & MOBILE" (12384:135293) splits the fade in two: the
         IMAGE goes to 60%, and the rest of the product detail goes to 20%. Both were
         previously 60%, which left the removed card reading as merely dimmed rather than
         as struck-out. */
      if (subtitle) {
        subtitle.classList.toggle('opacity-20', isRemoved);
      }
      if (qtyRow) {
        qtyRow.classList.toggle('opacity-20', isRemoved);
        qtyRow.classList.toggle('pointer-events-none', isRemoved);
      }
      if (subscriptionRow) {
        subscriptionRow.classList.toggle('opacity-20', isRemoved);
        subscriptionRow.classList.toggle('pointer-events-none', isRemoved);
      }
      if (bundleContents) {
        bundleContents.classList.toggle('opacity-20', isRemoved);
        bundleContents.classList.toggle('pointer-events-none', isRemoved);
      }
      if (image) {
        image.classList.toggle('opacity-75', isRemoved);
      }
    }

    // Mirrors product-custom-bundle.js's syncFilterLabel — the real <select> stays
    // invisible (opacity-0, absolute) for functionality/accessibility, so the
    // custom-styled span visitors actually see has to be kept in sync by hand.
    function syncMiniBagSubscriptionPlanLabel(select) {
      var wrap = select.closest('[data-mini-bag-subscription-plan-wrap]');
      var label = wrap ? wrap.querySelector('[data-mini-bag-subscription-plan-label]') : null;
      if (!label) return;
      var option = select.options[select.selectedIndex];
      label.textContent = option ? option.textContent.trim() : '';
    }

    function setMiniBagSubscriptionState(row, isActive) {
      var details = row.querySelector('[data-mini-bag-subscription-details]');
      var select = row.querySelector('[data-mini-bag-subscription-plan-select]');
      row.setAttribute('data-subscription-open', isActive ? 'true' : 'false');
      if (select) {
        select.disabled = !isActive;
        if (isActive) {
          select.removeAttribute('aria-disabled');
        } else {
          select.setAttribute('aria-disabled', 'true');
        }
      }
      if (details) {
        if (isActive) {
          details.removeAttribute('aria-hidden');
          details.removeAttribute('inert');
        } else {
          details.setAttribute('aria-hidden', 'true');
          details.setAttribute('inert', '');
        }
        details.style.setProperty('--mini-bag-subscription-details-height', details.scrollHeight + 'px');
      }
    }

    function initMiniBagSubscriptionRows(root) {
      (root || document).querySelectorAll('[data-mini-bag-subscription-row]').forEach(function (row) {
        var checkbox = row.querySelector('[data-mini-bag-subscription-checkbox]');
        var details = row.querySelector('[data-mini-bag-subscription-details]');
        var isActive = checkbox ? checkbox.checked : row.getAttribute('data-subscription-open') === 'true';
        if (details) {
          details.style.setProperty('--mini-bag-subscription-details-height', details.scrollHeight + 'px');
        }
        setMiniBagSubscriptionState(row, isActive);
      });
    }

    function changeLineSellingPlan(lineKey, sellingPlanId, isActive, control) {
      var row = control ? control.closest('[data-mini-bag-subscription-row]') : null;
      var checkbox = row ? row.querySelector('[data-mini-bag-subscription-checkbox]') : null;
      var select = row ? row.querySelector('[data-mini-bag-subscription-plan-select]') : null;
      var previousPlanId = row ? row.getAttribute('data-current-selling-plan-id') || '' : '';

      if (row) {
        row.setAttribute('data-subscription-loading', 'true');
      }

      cartRequest('/cart/change.js', {
        id: lineKey,
        selling_plan: isActive ? Number(sellingPlanId) : null,
      })
        .then(function (cart) {
          if (row) {
            row.setAttribute('data-current-selling-plan-id', isActive ? String(sellingPlanId) : '');
          }
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: { cart: cart },
            })
          );
        })
        .catch(function (error) {
          if (checkbox) {
            checkbox.checked = Boolean(previousPlanId);
          }
          if (select && previousPlanId) {
            select.value = previousPlanId;
          }
          if (row) {
            setMiniBagSubscriptionState(row, Boolean(previousPlanId));
            row.removeAttribute('data-subscription-loading');
          }
          reportCartError(error);
        });
    }

    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart) return;
      setEmptyState(cart.item_count === 0);
      var sectionId = getSectionId();
      var sectionHtml = cart.sections && cart.sections[sectionId];
      if (!sectionHtml && cart.sections) {
        sectionHtml = cart.sections[FALLBACK_SECTION_ID];
      }
      applySection(sectionHtml);
      reapplyPendingRemovedStates();
      refreshMiniBagModules();
    });

    /* cart:error was dispatched from three places and listened for by nothing, so every
       failed quantity change, upsell add and subscription toggle failed in total silence.
       This is the surface that was missing. It lives in the sticky footer, so it is in
       view wherever in the bag the failure came from, and applySection replaces the
       footer on the next success, which clears it. */
    document.addEventListener('cart:error', function (event) {
      var el = document.querySelector('[data-mini-bag-error]');
      if (!el) return;
      var detail = event.detail || {};
      // A reached ceiling is information, not a failure, so it gets its own copy rather than "try again".
      var limitTemplate =
        typeof detail.maxQuantity === 'number'
          ? el.getAttribute('data-i18n-quantity-limit')
          : null;
      el.textContent = limitTemplate
        ? limitTemplate.replace('__COUNT__', detail.maxQuantity)
        : el.getAttribute(detail.timedOut ? 'data-i18n-timeout' : 'data-i18n-error') || '';
    });

    document.addEventListener('click', function (event) {
      var addProduct = event.target.closest('[data-mini-bag-add-product]');
      if (addProduct) {
        event.preventDefault();
        if (addProduct.getAttribute('data-mini-bag-adding') === 'true') return;
        var variantId = addProduct.getAttribute('data-variant-id');
        if (!variantId) return;
        var addedFromUpsell = Boolean(addProduct.closest('[data-mini-bag-upsells]'));
        // Empty-bag add: the populated channel still needs its own first fetch.
        var addedFromEmptyUpsells = Boolean(addProduct.closest('[data-mini-bag-upsells-empty]'));
        var addCta = addProduct.closest('[data-mini-bag-cta]');
        addProduct.setAttribute('data-mini-bag-adding', 'true');
        addProduct.setAttribute('aria-disabled', 'true');
        addProduct.setAttribute('aria-busy', 'true');
        setAddState(addCta, 'adding');
        cartRequest('/cart/add.js', { id: Number(variantId), quantity: 1 })
          .then(function (response) {
            return fetch('/cart.js', {
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
              },
            })
              .then(function (r) {
                if (!r.ok) throw new Error('cart_fetch_failed');
                return r.json();
              })
              .then(function (cart) {
                cart.sections = response.sections || {};
                document.dispatchEvent(
                  new CustomEvent('cart:updated', {
                    bubbles: true,
                    detail: { cart: cart, fromUpsellAdd: addedFromUpsell, fromEmptyUpsells: addedFromEmptyUpsells, addedProductId: response.product_id },
                  })
                );
                /* Set only here — after the live cart has been re-read and the section
                   swap has been dispatched — so the confirmation cannot claim an add that
                   the server has not actually acknowledged. */
                setAddState(addCta, 'added');
                /* window.__drawerOpen, never a drawer:open event — assets/drawer.js
                   claims __drawerControllerReady first, so drawer.liquid's fallback
                   block returns before registering the only listener that event ever
                   had. Harmless here (this add happens with the bag already open) but
                   kept consistent so no future caller inherits a dead path. */
                if (typeof window.__drawerOpen === 'function') {
                  window.__drawerOpen('mini-bag', addProduct);
                }
              });
          })
          .catch(function (error) {
            /* Drops straight back to the resting CTA — the failure itself is reported on
               the footer's [data-mini-bag-error] surface, so leaving the bar dimmed would
               strand the card in a state with no exit. */
            setAddState(addCta, null);
            reportCartError(error);
          })
          .finally(function () {
            addProduct.removeAttribute('data-mini-bag-adding');
            addProduct.removeAttribute('aria-disabled');
            addProduct.removeAttribute('aria-busy');
          });

        return;
      }

      var minus = event.target.closest('[data-qty-minus]');

      if (minus) {
        event.preventDefault();
        var minusKey = minus.dataset.qtyMinus;
        var minusRoot = itemRoot(minusKey);
        var minusCountEl = minusRoot ? minusRoot.querySelector('[data-qty-count]') : null;
        var minusQty = minusCountEl ? Math.max(0, parseInt(minusCountEl.textContent, 10) - 1) : 0;
        mutateCart(minusKey, minusQty, 'minus');
        return;
      }

      var plus = event.target.closest('[data-qty-plus]');

      if (plus) {
        event.preventDefault();
        var plusKey = plus.dataset.qtyPlus;
        var plusRoot = itemRoot(plusKey);
        var plusCountEl = plusRoot ? plusRoot.querySelector('[data-qty-count]') : null;
        var plusQty = plusCountEl ? parseInt(plusCountEl.textContent, 10) + 1 : 1;
        mutateCart(plusKey, plusQty, 'plus');
        return;
      }

      var remove = event.target.closest('[data-remove-item]');

      if (remove) {
        event.preventDefault();
        var key = remove.dataset.removeItem;
        setRemovedState(key, true);
        /* Registered BEFORE the recommendation/panel updates below, not after: both of
           them ask liveItemKeys() (directly, or via nextAnchorProductIds in
           mini-bag-recommendations-script.liquid) what the bag will hold once the undo
           windows expire, and this line only counts as pending once it is in here. */
        pendingRemovals[key] = window.setTimeout(function () {
          delete pendingRemovals[key];
          mutateCart(key, 0, null, true);
        }, UNDO_WINDOW_MS);
        /* The control that was just activated is now hidden AND disabled, so focus would
           otherwise fall to <body> — outside the drawer, and outside its focus trap. Hand
           it to Undo, which is the only thing left to do to this line and is what a screen
           reader needs to hear. Done here rather than inside setRemovedState, which also
           runs from reapplyPendingRemovedStates on every re-render, where moving focus
           would yank it away from whatever the shopper was actually doing. */
        moveFocusWithin(key, '[data-undo-remove]');
        if (MiniBag.refreshUpsellsNow) MiniBag.refreshUpsellsNow(key);
        /* Was `querySelectorAll('[data-mini-bag-item]').length === 1`, which read the
           number of rows DRAWN rather than the number of items left. Remove a second line
           while the first is still inside its undo window and the count is 2, so the
           desktop recommendations panel stayed open over a bag that was about to be
           empty — and never closed until both mutations landed 3.5s later. */
        if (!liveItemKeys().length) {
          setRecommendationsPanelEmptyState(true);
        }
        return;
      }

      var undo = event.target.closest('[data-undo-remove]');

      if (undo) {
        event.preventDefault();
        var undoKey = undo.dataset.undoRemove;
        if (pendingRemovals[undoKey]) {
          window.clearTimeout(pendingRemovals[undoKey]);
          delete pendingRemovals[undoKey];
        }
        setRemovedState(undoKey, false);
        // Mirror of the remove path: Undo has just hidden itself, so focus goes back to
        // the remove control it was standing in for.
        moveFocusWithin(undoKey, '[data-remove-item]');
        setRecommendationsPanelEmptyState(false);
        if (MiniBag.refreshUpsellsNow) MiniBag.refreshUpsellsNow();
      }
    });

    document.addEventListener('change', function (event) {
      var checkbox = event.target.closest('[data-mini-bag-subscription-checkbox]');
      if (checkbox) {
        var checkboxRow = checkbox.closest('[data-mini-bag-subscription-row]');
        if (!checkboxRow) return;
        var checkboxSelect = checkboxRow.querySelector('[data-mini-bag-subscription-plan-select]');
        var checkboxLineKey = checkbox.getAttribute('data-line-key');
        var checkboxSellingPlanId = checkboxSelect ? checkboxSelect.value : '';
        var checkboxIsActive = checkbox.checked;
        if (!checkboxLineKey || (checkboxIsActive && !checkboxSellingPlanId)) return;
        setMiniBagSubscriptionState(checkboxRow, checkboxIsActive);
        changeLineSellingPlan(checkboxLineKey, checkboxSellingPlanId, checkboxIsActive, checkbox);
        return;
      }

      var select = event.target.closest('[data-mini-bag-subscription-plan-select]');
      if (select) {
        var selectRow = select.closest('[data-mini-bag-subscription-row]');
        if (!selectRow) return;
        var selectCheckbox = selectRow.querySelector('[data-mini-bag-subscription-checkbox]');
        var selectLineKey = select.getAttribute('data-line-key');
        var selectSellingPlanId = select.value;
        if (!selectLineKey || !selectSellingPlanId) return;
        syncMiniBagSubscriptionPlanLabel(select);
        if (selectCheckbox && !selectCheckbox.checked) {
          selectCheckbox.checked = true;
          setMiniBagSubscriptionState(selectRow, true);
        }
        changeLineSellingPlan(selectLineKey, selectSellingPlanId, true, select);
      }
    });

    /* A removal is deferred behind the undo window, so leaving the page inside it dropped
       the mutation entirely: the shopper watched the line say "Item removed!", navigated
       away, and found it still in the bag. Flush whatever is still pending on the way out.

       `pagehide` rather than `beforeunload` — it is the event mobile Safari actually fires
       on a bfcache navigation — and `keepalive` so the request outlives the document.

       Flushes even on a bfcache hide, not just a true unload: checkout outlasts the 3.5s
       undo window, so a timer left running instead fires the instant the shopper hits back,
       completing a removal they never confirmed. The pageshow handler below re-syncs the bag
       so a restored page doesn't keep showing that line as still-removable once it's gone.

       One /cart/update.js keyed by line key, not N /cart/change.js calls: `updates` is
       index-independent and atomic, whereas parallel index-addressed changes would each
       be computed against a cart the others are already shifting.

       Bundle lines are deliberately excluded. Two bundles built from the same parent
       product share one item.key (see mini-bag-bundle-line-item.liquid), so keying by key
       would zero BOTH — including one the shopper never touched. They keep the existing
       timer behaviour; losing a bundle removal on a mid-window exit is the status quo,
       whereas removing an untouched bundle would be a new and much worse bug. */
    function flushPendingRemovals() {
      var updates = {};
      var hasUpdates = false;

      Object.keys(pendingRemovals).forEach(function (key) {
        var root = itemRoot(key);
        if (root && root.hasAttribute('data-cart-line')) return;
        window.clearTimeout(pendingRemovals[key]);
        delete pendingRemovals[key];
        updates[key] = 0;
        hasUpdates = true;
      });

      if (!hasUpdates) return;

      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ updates: updates }),
          keepalive: true,
        });
      } catch (e) {
        /* Nothing useful to do on the way out of the document, and the pending timer may
           still land if the page turns out not to be going anywhere. */
      }
    }

    window.addEventListener('pagehide', flushPendingRemovals);

    /* Companion to the pagehide flush above: a bfcache-restored page's DOM can be stale in
       ways beyond that one path (a second tab, the cart page, checkout itself), so this
       re-syncs both the panel markup and, via cart:updated, every other module that keys
       off the cart (samples, gift drawer, subscriptions) rather than patching one symptom. */
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      Promise.all([
        fetch('/?section_id=' + encodeURIComponent(getSectionId()), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        }).then(function (r) { return r.ok ? r.text() : null; }),
        fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) {
          return r.ok ? r.json() : null;
        }),
      ])
        .then(function (results) {
          var html = results[0];
          var cart = results[1];
          if (html) {
            applySection(html);
            refreshMiniBagModules();
          }
          if (cart) {
            document.dispatchEvent(
              new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
            );
          }
        })
        .catch(function () {});
    });

    handleBuyAgainRedirect();
    MiniBag.itemRoot = itemRoot;
    MiniBag.applySection = applySection;
    MiniBag.setEmptyState = setEmptyState;
    MiniBag.setRemovedState = setRemovedState;
    MiniBag.initSubscriptionRows = initMiniBagSubscriptionRows;
    MiniBag.refreshModules = refreshMiniBagModules;

    initMiniBagSubscriptionRows(document);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-dom-helpers-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniBag = window.MiniBag || {};
    if (window.MiniBag.domHelpersLoaded) return;
    window.MiniBag.domHelpersLoaded = true;

    var MiniBag = window.MiniBag;

    /* Patches one region of a rendered section HTML string into its live counterpart.
       Used by both gift-family drawers, each its own [data-drawer-panel] outside
       applySection's `panel` scope — `selector` carries the drawer-id scope itself
       (e.g. '#gift-drawer [data-drawer-footer]'), so one function serves both. */
    function replaceDrawerRegion(tmp, selector) {
      var live = document.querySelector(selector);
      var fresh = tmp.querySelector(selector);
      if (!live || !fresh) return;
      live.innerHTML = fresh.innerHTML;
    }

    /* Completes the handover started when the bin was clicked: the removal's own Undo
       button had focus, applySection then destroys it replacing the line list, dropping
       a keyboard user to <body>. Put them back on the drawer's close button, which
       always exists while the bag is open. Guarded to only fire when focus is actually
       lost to <body> and the mini bag is genuinely open. Reused by
       mini-bag-loyalty-gift-redemption-script.liquid's confirm flow, which strands
       focus the same way when closing its own drawer hands focus to a trigger the
       following re-render then removes or hides. */
    function restoreFocusAfterRemoval() {
      var active = document.activeElement;
      if (active && active !== document.body) return;

      var drawer = document.getElementById('mini-bag');
      if (!drawer || drawer.hasAttribute('inert')) return;

      var closeButton = drawer.querySelector('[data-drawer-panel] [data-drawer-close]');
      if (closeButton) closeButton.focus();
    }

    MiniBag.replaceDrawerRegion = replaceDrawerRegion;
    MiniBag.restoreFocusAfterRemoval = restoreFocusAfterRemoval;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-free-samples-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniBag = window.MiniBag || {};
    if (window.MiniBag.freeSamplesLoaded) return;
    window.MiniBag.freeSamplesLoaded = true;

    var MiniBag = window.MiniBag;
    var TIMEOUT_MS = 8000;

    function cardsIn(wrap) {
      return Array.prototype.slice.call(wrap.querySelectorAll('[data-mini-bag-sample-card]'));
    }

    function selectedCards(wrap) {
      return cardsIn(wrap).filter(function (card) {
        return card.getAttribute('data-selected') === 'true';
      });
    }

    function selectedCount(wrap) {
      return selectedCards(wrap).length;
    }

    /* Whether a click on an unselected card at the limit replaces the held sample. Read off
       the wrapper rather than re-derived from data-max-samples so the rule lives in exactly
       one place — mini-bag-free-samples.liquid, which also uses it for the server-rendered
       disabled state. */
    function allowsSwap(wrap) {
      return wrap.getAttribute('data-allow-swap') === 'true';
    }

    /* Repaints aria-pressed, the dim-others flag, and the at-limit disabled state purely
       from the cards' own data-selected attributes, so there is one place that decides
       what the UI looks like for a given selection — the click handler only has to flip
       data-selected and call this. Exported as initSampleSelectors because
       mini-bag-cart-script.liquid's refreshMiniBagModules already calls that name after
       every cart mutation. */
    function syncSamples(wrap) {
      var max = parseInt(wrap.getAttribute('data-max-samples') || '1', 10) || 1;
      var canSwap = allowsSwap(wrap);
      var count = selectedCount(wrap);

      wrap.setAttribute('data-at-max', count >= max ? 'true' : 'false');

      cardsIn(wrap).forEach(function (card) {
        var isSelected = card.getAttribute('data-selected') === 'true';
        var button = card.querySelector('[data-mini-bag-sample-button]');
        if (!button) return;

        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

        /* Being at the limit only blocks a card when a swap cannot resolve the click.
           Where it can, the card stays enabled and merely dims, so the shopper can change
           their mind in one click instead of deselecting first (UAT, Sprint 3). Mirrors
           mini-bag-free-sample-card.liquid's own server-rendered gate, off the same
           data-allow-swap. */
        var blocked = !isSelected && count >= max && !canSwap;
        button.disabled = blocked;
        card.setAttribute('data-disabled', blocked ? 'true' : 'false');
        if (blocked) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }
      });
    }

    function initSampleSelectors(root) {
      (root || document).querySelectorAll('[data-mini-bag-free-samples]').forEach(syncSamples);
    }

    function showError(wrap, message) {
      var el = wrap.querySelector('[data-mini-bag-samples-error]');
      if (el) el.textContent = message || '';
    }

    function postJson(url, body) {
      var ac = window.AbortController ? new AbortController() : null;
      var timer = window.setTimeout(function () {
        if (ac) ac.abort();
      }, TIMEOUT_MS);

      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
        signal: ac ? ac.signal : undefined,
      })
        .then(function (r) {
          if (!r.ok) throw new Error('sample_request_failed');
          return r.json();
        })
        .finally(function () {
          window.clearTimeout(timer);
        });
    }

    /* Mirrors mini-bag-cart-script.liquid's own add flow: the mutation endpoints render
       `sections`, plain GET /cart.js does not, so the fresh cart is fetched separately and
       the rendered section is stapled on before cart:updated fires. */
    function announceCart(sections) {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('cart_fetch_failed');
          return r.json();
        })
        .then(function (cart) {
          cart.sections = sections || {};
          document.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
          );
        });
    }

    // Fallback for a card whose line key never made it into the DOM (e.g. the sample was
    // added in another tab): find the sample line for this variant in the live cart.
    function findSampleLineKey(variantId) {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('cart_fetch_failed');
          return r.json();
        })
        .then(function (cart) {
          var match = (cart.items || []).filter(function (line) {
            return String(line.variant_id) === String(variantId) &&
              line.properties && line.properties._free_sample;
          })[0];
          return match ? match.key : null;
        });
    }

    function addSample(card, variantId) {
      return postJson('/cart/add.js', {
        items: [{ id: Number(variantId), quantity: 1, properties: { _free_sample: 'true' } }],
        sections: MiniBag.getSectionId ? MiniBag.getSectionId() : 'mini-bag',
      }).then(function (response) {
        var line = response && response.items && response.items[0];
        if (line && line.key) card.setAttribute('data-sample-line-key', line.key);
        card.setAttribute('data-selected', 'true');
        return response.sections;
      });
    }

    function removeSample(card, variantId) {
      var known = card.getAttribute('data-sample-line-key');
      var lookup = known ? Promise.resolve(known) : findSampleLineKey(variantId);

      return lookup.then(function (lineKey) {
        // Nothing to remove — the line is already gone, so just settle the UI.
        if (!lineKey) {
          card.removeAttribute('data-sample-line-key');
          card.setAttribute('data-selected', 'false');
          return null;
        }
        return postJson('/cart/change.js', {
          id: lineKey,
          quantity: 0,
          sections: MiniBag.getSectionId ? MiniBag.getSectionId() : 'mini-bag',
        }).then(function (cart) {
          card.removeAttribute('data-sample-line-key');
          card.setAttribute('data-selected', 'false');
          return cart.sections;
        });
      });
    }

    /* Replaces the held sample with the clicked one, so the shopper does not have to
       deselect before choosing again (UAT, Sprint 3).

       Two mutations, deliberately sequential: both touch the same cart, and the wrapper's
       data-busy guard only serialises CLICKS, not the calls inside one of them.

       Remove first, then add. The reverse order would sit over the configured limit for the
       width of one request, and a failure there would leave the shopper holding two free
       samples all the way to checkout — real stock the merchant did not agree to give away.
       This order's own failure case costs nothing but a second click.

       `progress` carries the remove's section render back out, because a swap is the only
       path here where the first half can land and the second half fail: every other path is
       a single mutation, so a rejection means the cart never changed and whatever the bag
       has already rendered is still true. */
    function swapSample(incoming, incomingVariantId, outgoing, progress) {
      return removeSample(outgoing, outgoing.getAttribute('data-variant-id')).then(function (sections) {
        progress.sections = sections;
        return addSample(incoming, incomingVariantId);
      });
    }

    document.addEventListener('click', function (event) {
      var card = event.target.closest('[data-mini-bag-sample-card]');
      if (!card) return;

      var wrap = card.closest('[data-mini-bag-free-samples]');
      if (!wrap) return;

      var button = card.querySelector('[data-mini-bag-sample-button]');
      if (!button || button.disabled) return;

      /* One sample mutation at a time — two in flight would race on the shared cart. The
         busy state locks card clicks but deliberately does not dim the track: remaining
         samples must stay at full opacity until the configured maximum is reached. The
         clicked card's pending-selected indicator provides the in-progress feedback. */
      if (wrap.getAttribute('data-busy') === 'true') return;

      var variantId = card.getAttribute('data-variant-id');
      if (!variantId) return;

      var willSelect = card.getAttribute('data-selected') !== 'true';

      /* Selecting while every slot is already used, and the limit is one that a swap can
         resolve: give up the held sample for this one. Only ever one card here, because
         swapping is enabled at a limit of 1 — see allowsSwap. */
      var max = parseInt(wrap.getAttribute('data-max-samples') || '1', 10) || 1;
      var outgoing = null;
      if (willSelect && allowsSwap(wrap) && selectedCount(wrap) >= max) {
        outgoing = selectedCards(wrap)[0] || null;
      }

      showError(wrap, '');
      wrap.setAttribute('data-busy', 'true');
      button.setAttribute('aria-busy', 'true');
      if (willSelect) card.setAttribute('data-pending-selected', 'true');

      var progress = { sections: null };
      var work;

      if (!willSelect) {
        work = removeSample(card, variantId);
      } else if (outgoing) {
        work = swapSample(card, variantId, outgoing, progress);
      } else {
        work = addSample(card, variantId);
      }

      work
        .then(function (sections) {
          syncSamples(wrap);
          return announceCart(sections);
        })
        .catch(function (error) {
          var timedOut = error && error.name === 'AbortError';
          showError(
            wrap,
            timedOut
              ? wrap.getAttribute('data-i18n-timeout')
              : wrap.getAttribute('data-i18n-error')
          );
          // Nothing changed server-side, so repaint from the untouched attributes.
          syncSamples(wrap);

          /* Unless a swap got half-way: the remove landed and the add did not, so the cart
             really did change and the bag is still rendering a sample line that no longer
             exists. Settle it against the remove's own section render, which is a truthful
             picture of the cart as it now stands. Null on every other path, and on a swap
             whose remove was itself what failed. */
          if (progress.sections) {
            announceCart(progress.sections).catch(function () {});
          }
        })
        .finally(function () {
          card.removeAttribute('data-pending-selected');
          wrap.removeAttribute('data-busy');
          button.removeAttribute('aria-busy');
        });
    });

    /* A selected sample is a real cart line, so it also appears in the mini bag's line
       list with its own remove control — and it can be changed from another tab or the
       cart page. Re-deriving every card from the cart payload on each cart:updated keeps
       the cards and the cart from drifting apart: remove the sample line anywhere and its
       card deselects itself, freeing a slot against the limit. */
    function syncFromCart(cart) {
      var lines = (cart && cart.items) || [];
      document.querySelectorAll('[data-mini-bag-free-samples]').forEach(function (wrap) {
        cardsIn(wrap).forEach(function (card) {
          var variantId = card.getAttribute('data-variant-id');
          var match = lines.filter(function (line) {
            return String(line.variant_id) === String(variantId) &&
              line.properties && line.properties._free_sample;
          })[0];

          if (match) {
            card.setAttribute('data-selected', 'true');
            if (match.key) card.setAttribute('data-sample-line-key', match.key);
          } else {
            card.setAttribute('data-selected', 'false');
            card.removeAttribute('data-sample-line-key');
          }
        });
        syncSamples(wrap);
      });
    }

    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart) return;
      syncFromCart(cart);
    });

    MiniBag.initSampleSelectors = initSampleSelectors;
    MiniBag.syncSamples = syncSamples;

    initSampleSelectors(document);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-gift-card-amount-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniBag = window.MiniBag || {};
    var MiniBag = window.MiniBag;
    var giftCardAmount = (MiniBag.giftCardAmount = MiniBag.giftCardAmount || {});
    if (giftCardAmount.loaded) return;
    giftCardAmount.loaded = true;

    // Toggled on an amount tile when it becomes the selected one — pulled out to a
    // constant so buildAmountGrid (initial render) and selectAmountTile (a click) apply
    // and remove the exact same tokens rather than two copies of the same string.
    var AMOUNT_TILE_SELECTED_CLASS =
      'bg-surface-input after:absolute after:-bottom-px after:left-0 after:h-2' +
      ' after:w-full after:bg-border-tertiary';
    var AMOUNT_TILE_SELECTED_TOKENS = AMOUNT_TILE_SELECTED_CLASS.split(' ');

    /* Mirrors gift-card-script.liquid's own setScheduled exactly — the same markup, the
       same reveal. The accordion-panel grid-rows transition on [data-gift-card-date-panel]
       is what actually shows the calendar; toggling `hidden` on the field wrapper alone
       would leave the panel's own grid-template-rows at its collapsed 0fr default, so the
       calendar would stay invisible even once the field wrapper's aria-hidden/inert were
       lifted. aria-hidden/inert stay on the field wrapper
       for the same reason as there: overflow-hidden clipping alone leaves focusable
       children reachable by keyboard while collapsed. A disabled input is not read back
       on save, so an unscheduled card sends no send-date value at all rather than an
       empty one. */
    function setScheduled(root, isScheduled) {
      var wrap = root.querySelector('[data-gift-card-date-field]');
      var panel = root.querySelector('[data-gift-card-date-panel]');
      var input = root.querySelector('[data-gift-card-send-on]');
      var chevron = root.querySelector('[data-gift-card-send-chevron]');

      if (wrap) {
        if (isScheduled) {
          wrap.removeAttribute('aria-hidden');
          wrap.removeAttribute('inert');
        } else {
          wrap.setAttribute('aria-hidden', 'true');
          wrap.setAttribute('inert', '');
        }
      }
      if (input) input.disabled = !isScheduled;
      if (panel) panel.style.gridTemplateRows = isScheduled ? '1fr' : '';
      if (chevron) chevron.style.transform = isScheduled ? 'rotate(180deg)' : '';
    }

    function selectSendOption(root, value) {
      root.querySelectorAll('[data-gift-card-send-option]').forEach(function (option) {
        option.checked = option.getAttribute('data-gift-card-send-option') === value;
      });
      setScheduled(root, value === 'scheduled');
    }

    // The shared field snippet is rendered once for this drawer with include_recipient
    // and include_send_date both hardcoded true (mini-bag-gift-card-drawer.liquid), since
    // one panel serves every line and its shape can't be re-rendered per line server-side
    // — so a physical line's edit has to hide the recipient row and the whole send-date
    // block by JS instead, using the data hooks gift-card-details-form.liquid carries for
    // exactly this. Only visual: the submit handler is what actually skips validating and
    // sending those fields for a physical line (see the submit listener in
    // mini-bag-gift-card-script.liquid).
    function setPhysicalMode(root, isPhysical) {
      var recipientRow = root.querySelector('[data-gift-card-recipient-row]');
      var sendDateBlock = root.querySelector('[data-gift-card-send-date-block]');
      if (recipientRow) recipientRow.classList.toggle('hidden', isPhysical);
      if (sendDateBlock) sendDateBlock.classList.toggle('hidden', isPhysical);

      /* Review fix, 2026-10-01: digital's Message is Shopify's own native property, capped
         server-side at 200 — physical's is the theme-owned _gift_message, which Shopify
         never validates, so 500 (this drawer's own markup default) stays correct there.
         This is the one point in the shared, single-instance drawer that already knows
         which kind of card is open, so the swap happens here rather than duplicating the
         drawer markup per scope the way the PDP's two separate panels can. */
      var messageField = root.querySelector('[data-gift-card-message]');
      var messageCount = root.querySelector('[data-gift-card-message-count]');
      if (messageField) {
        messageField.setAttribute('maxlength', isPhysical ? 500 : 200);
        if (messageCount) {
          messageCount.textContent = messageField.value.length + ' / ' + messageField.getAttribute('maxlength');
        }
      }
    }

    // Marks (or unmarks) one tile as the picked amount — pulled out so buildAmountGrid's
    // initial render and a shopper's click apply the exact same selected-state classes.
    function setTileSelected(tile, isSelected) {
      AMOUNT_TILE_SELECTED_TOKENS.forEach(function (token) {
        tile.classList.toggle(token, isSelected);
      });
      tile.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    }

    // Builds the amount grid (snippets/mini-bag-gift-card-drawer.liquid) from the line's
    // own product.variants, JSON-encoded as {id, label} entries onto the trigger by
    // snippets/mini-bag-line-item.liquid — there is no hardcoded amount list to search.
    // A real picker, not a decorative grid: each tile is a button carrying the variant id
    // the submit handler needs to add if the shopper picks a different one. The tile
    // matching the line's own variant is
    // selected on open by variant id, never by label — two variants can share a
    // currency-converted display label on some markets, but never an id.
    function buildAmountGrid(root, variantsJson, currentVariantId, currentAmount) {
      var grid = root.querySelector('[data-gcd-amount-grid]');
      var display = root.querySelector('[data-gcd-amount-display]');
      if (!grid) return;

      grid.innerHTML = '';

      var variants = [];
      try {
        variants = JSON.parse(variantsJson || '[]');
      } catch (error) {
        variants = [];
      }

      variants.forEach(function (variant, index) {
        var tile = document.createElement('button');
        tile.type = 'button';
        // 65px tall without a fixed height or a new token:
        // py-26 (26px, an existing --spacing-26 token) top and bottom + a single !leading-none
        // text line (line-height forced to exactly 1, i.e. the f2 font-size itself, 12px) +
        // the 1px border-b add up to 26+26+12+1 = 65 exactly. text-f2's own line-height
        // (1.2 → 14.4px) can't reach 65 through whole-pixel padding tokens at all, hence
        // overriding it here — !leading-none forces the win regardless of which of the two
        // same-layer utilities (text-f2 vs leading-none) the build happens to emit last.
        tile.className =
          'relative flex flex-col items-center justify-center py-26 text-f2 !leading-none' +
          ' text-center uppercase text-primary whitespace-nowrap border-b border-border-secondary' +
          ' cursor-pointer hover:bg-surface-input hover:after:absolute' +
          ' hover:after:-bottom-px hover:after:left-0 hover:after:h-2 hover:after:w-full' +
          ' hover:after:bg-border-tertiary' +
          (index % 4 !== 3 ? ' border-r' : '');
        tile.textContent = variant.label;
        tile.setAttribute('data-gcd-amount-tile', '');
        tile.setAttribute('data-gcd-variant-id', variant.id);
        tile.setAttribute('data-gcd-variant-label', variant.label);
        setTileSelected(tile, String(variant.id) === String(currentVariantId));
        grid.appendChild(tile);
      });

      if (display) display.textContent = currentAmount || '';
    }

    function selectAmountTile(root, tile) {
      var grid = tile.closest('[data-gcd-amount-grid]');
      if (!grid) return;

      grid.querySelectorAll('[data-gcd-amount-tile]').forEach(function (node) {
        setTileSelected(node, node === tile);
      });

      var display = root.querySelector('[data-gcd-amount-display]');
      if (display) display.textContent = tile.getAttribute('data-gcd-variant-label') || '';
    }

    giftCardAmount.setScheduled = setScheduled;
    giftCardAmount.selectSendOption = selectSendOption;
    giftCardAmount.setPhysicalMode = setPhysicalMode;
    giftCardAmount.buildAmountGrid = buildAmountGrid;
    giftCardAmount.selectAmountTile = selectAmountTile;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-gift-card-details-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniBag = window.MiniBag || {};
    if (window.MiniBag.giftCardDetailsScriptLoaded) return;
    window.MiniBag.giftCardDetailsScriptLoaded = true;

    /* The panel carries its own display utility once open, so concealment is a class swap
       (`hidden` off, `flex` on) rather than the native attribute, which a UA-origin
       display rule would lose with — the same pattern the removed-state banner on this
       card already uses.

       Concealment is aria-hidden plus inert together, and exposure REMOVES both rather
       than writing a falsy value, which some assistive technologies read as truthy
       regardless. aria-hidden on its own would also leave the panel's controls in the tab
       order. pointer-events-none rides along because inert's hit-test pass-through is not
       reliable on WebKit. */
    function setDetailsState(toggle, panel, isOpen) {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      // The chevron flips from down to up on expand, the same transform
      // snippets/accordion.liquid's own chevron already uses.
      var chevron = toggle.querySelector('[data-gcd-details-chevron]');
      if (chevron) chevron.style.transform = isOpen ? 'rotate(180deg)' : '';

      // Space below the toggle while collapsed only — open, the toggle sits flush
      // against the panel it reveals.
      toggle.classList.toggle('mb-4', !isOpen);

      panel.classList.toggle('hidden', !isOpen);
      panel.classList.toggle('flex', isOpen);
      panel.classList.toggle('pointer-events-none', !isOpen);

      if (isOpen) {
        panel.removeAttribute('aria-hidden');
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
      }
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-gcd-details-toggle]');
      if (!toggle) return;

      // Scoped to the line the chevron belongs to: several gift-card lines can be in the
      // bag at once, and each carries its own panel.
      var line = toggle.closest('[data-mini-bag-item]');
      var panel = line ? line.querySelector('[data-gcd-details]') : null;
      if (!panel) return;

      setDetailsState(toggle, panel, toggle.getAttribute('aria-expanded') !== 'true');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-gift-card-save-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniBag = window.MiniBag || {};
    var giftCardSave = (MiniBag.giftCardSave = MiniBag.giftCardSave || {});

    // Duplicated from mini-bag-gift-card-script.liquid rather than threaded through the
    // shared object: a plain constant literal carries no load-order dependency, so an
    // alias would buy nothing here.
    var JSON_HEADERS = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };

    // A thrown Error carries the parsed body when there is one, same shape on every
    // rejection this file (and mini-bag-gift-card-script.liquid's own saveProperties)
    // produces, so errorMessage can read error.body regardless of which step in a save
    // actually failed.
    giftCardSave.httpError = function (name, response) {
      return response
        .json()
        .catch(function () {
          return null;
        })
        .then(function (body) {
          var error = new Error(name);
          error.body = body;
          throw error;
        });
    };

    /* Review fix, 2026-10-01: moved here from mini-bag-gift-card-script.liquid to keep that
       file under the 500-line hard ceiling (giftCardSave is already the shared home for
       this feature's error/save plumbing). Same helpers as gift-card-form-script.liquid's
       PDP fix — see that file for the fuller "[object Object]" and field-routing story.

       firstString walks a 422 body's description/message, a plain string or a nested
       object/array of per-field messages, and returns the first string found. */
    giftCardSave.firstString = function firstString(value) {
      if (typeof value === 'string') return value;
      if (Array.isArray(value)) {
        for (var i = 0; i < value.length; i++) {
          var found = firstString(value[i]);
          if (found) return found;
        }
        return '';
      }
      if (value && typeof value === 'object') {
        for (var key in value) {
          if (!Object.prototype.hasOwnProperty.call(value, key)) continue;
          var nested = firstString(value[key]);
          if (nested) return nested;
        }
      }
      return '';
    };

    giftCardSave.errorMessage = function (form, error) {
      if (error && error.name === 'AbortError') {
        return form.getAttribute('data-i18n-timeout') || '';
      }
      var body = error && error.body;
      var fromBody = body
        ? giftCardSave.firstString(body.description) || giftCardSave.firstString(body.message)
        : '';
      if (fromBody) return fromBody;
      return form.getAttribute('data-i18n-error') || '';
    };

    // A 422 body's description is keyed by the Shopify property that actually failed —
    // { email: [...] }, { message: [...] }, { send_on: [...] }.
    giftCardSave.parseFieldError = function (error) {
      var description = error && error.body && error.body.description;
      if (!description || typeof description !== 'object') return null;

      for (var key in description) {
        if (!Object.prototype.hasOwnProperty.call(description, key)) continue;
        var message = giftCardSave.firstString(description[key]);
        if (message) return { field: key, message: message };
      }
      return null;
    };

    // Finds the old line to remove by its own key first — the fast, exact path that
    // matches whenever the cart has not reshuffled anything else since the panel opened.
    // This store's cart carries loyalty/free-gift logic that can restructure OTHER lines
    // in reaction to any mutation (mini-bag-cart-script.liquid's own comments document
    // exactly this fragility for bundle lines), so a key captured when the panel opened
    // is not trusted blindly here: if it no longer matches anything post-add, this falls
    // back to the old variant id plus the recipient email the line ORIGINALLY carried
    // (captured at populate() time, distinct from whatever the shopper may have retyped
    // into the email field for this same save) — a pairing at least as unique as the key
    // in practice, since a shopper rarely holds two gift cards of the same denomination
    // addressed to the same recipient at once.
    //
    // A physical line has no recipient email at all, so this fallback is effectively
    // digital-only: if the exact key ever fails to match for a physical amount swap
    // (the same rare cart-reshuffle scenario), findLineIndex returns -1 and the save
    // surfaces an error rather than guessing which physical line was meant — accepted as
    // the same best-effort limit the digital fallback already carries.
    function findLineIndex(cart, lineKey, oldVariantId, oldRecipientEmail) {
      var items = (cart && cart.items) || [];

      var byKey = -1;
      for (var i = 0; i < items.length; i++) {
        if (items[i].key === lineKey) {
          byKey = i;
          break;
        }
      }
      if (byKey !== -1) return byKey;

      for (var j = 0; j < items.length; j++) {
        var item = items[j];
        if (
          String(item.variant_id) === String(oldVariantId) &&
          item.properties &&
          item.properties['Recipient email'] === oldRecipientEmail
        ) {
          return j;
        }
      }
      return -1;
    }

    // The changed-amount path: add the new variant first, remove the old line only once
    // that succeeds (see mini-bag-gift-card-script.liquid's own doc comment for why this
    // order and never the reverse). The old line is removed by a freshly resolved 1-based
    // `line` index rather than the key captured when the panel opened — findLineIndex
    // above explains why that key cannot be trusted blindly. /cart.js is fetched fresh
    // rather than trusting the add's own response, which reflects the cart BEFORE the old
    // line is gone — rendering from it would show both lines for one card until some
    // later, unrelated refresh caught up.
    giftCardSave.saveVariantChange = function (
      lineKey,
      newVariantId,
      properties,
      sectionId,
      signal,
      oldVariantId,
      oldRecipientEmail
    ) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ id: newVariantId, quantity: 1, properties: properties }),
        signal: signal,
      })
        .then(function (r) {
          return r.ok ? r.json() : giftCardSave.httpError('gift_card_add_failed', r);
        })
        .then(function () {
          return fetch('/cart.js', { signal: signal });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('gift_card_cart_fetch_failed');
          return r.json();
        })
        .then(function (cart) {
          var index = findLineIndex(cart, lineKey, oldVariantId, oldRecipientEmail);
          if (index === -1) throw new Error('gift_card_remove_not_found');

          return fetch('/cart/change.js', {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify({ line: index + 1, quantity: 0, sections: sectionId }),
            signal: signal,
          });
        })
        .then(function (r) {
          return r.ok ? r.json() : giftCardSave.httpError('gift_card_remove_failed', r);
        });
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-gift-card-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniBag = window.MiniBag || {};
    if (window.MiniBag.giftCardScriptLoaded) return;
    window.MiniBag.giftCardScriptLoaded = true;

    var MiniBag = window.MiniBag;
    var TIMEOUT_MS = 8000;
    var DRAWER_ID = 'gift-card-details-drawer';
    var JSON_HEADERS = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };

    /* Shopify's own line-item property keys. The capitalisation is theirs and is not
       negotiable — properties[Recipient Email] is silently ignored. */
    var PROP_NAME = 'Recipient name';
    var PROP_EMAIL = 'Recipient email';
    var PROP_MESSAGE = 'Message';
    var PROP_SEND_ON = 'Send on';
    var PROP_TO_RECIPIENT = '__shopify_send_gift_card_to_recipient';
    var PROP_OFFSET = '__shopify_offset';
    // Physical's own message key — theme-owned, not Shopify's, matching the name
    // gift-card-details-form.liquid's physical panel already submits under (its
    // message_name assign, gated on include_recipient being false).
    var PROP_PHYSICAL_MESSAGE = '_gift_message';

    var FIELD_NAMES = {};
    FIELD_NAMES[PROP_NAME] = 'properties[' + PROP_NAME + ']';
    FIELD_NAMES[PROP_EMAIL] = 'properties[' + PROP_EMAIL + ']';
    FIELD_NAMES[PROP_MESSAGE] = 'properties[' + PROP_MESSAGE + ']';
    FIELD_NAMES[PROP_SEND_ON] = 'properties[' + PROP_SEND_ON + ']';

    /* The amount grid, the physical-line hiding and the send-date reveal live in
       snippets/mini-bag-gift-card-amount-script.liquid; the changed-amount save contract
       (findLineIndex/saveVariantChange/httpError) lives in
       snippets/mini-bag-gift-card-save-script.liquid — both split out to keep this file
       under the 500-line hard ceiling and D21's 6 KB per-file gzip budget.
       Both shared OBJECTs are aliased here, never the individual functions, so it does not
       matter which of the concatenated IIFEs runs first. */
    var giftCardAmount = (MiniBag.giftCardAmount = MiniBag.giftCardAmount || {});
    var giftCardSave = (MiniBag.giftCardSave = MiniBag.giftCardSave || {});

    // The line the open panel is editing: its key and variant id (the latter compared
    // against the amount grid's own selection on save to tell whether the amount actually
    // changed), the offset it was added with, its original recipient email — kept
    // alongside the key as a second way to relocate the line if a variant-change save
    // needs to remove it (see saveVariantChange for why the key alone is not trusted) —
    // and whether it's a physical card, which carries no recipient/send-date fields at
    // all.
    var editing = { key: '', offset: '', variantId: '', recipientEmail: '', isPhysical: false };

    function drawerRoot() {
      return document.getElementById(DRAWER_ID);
    }

    function panelForm(root) {
      return root ? root.querySelector('[data-gcd-form]') : null;
    }

    function field(form, property) {
      return form ? form.elements[FIELD_NAMES[property]] || null : null;
    }

    /* Assigning .value fires nothing, so the floating label would stay parked over a
       filled field and the character count would keep the previous line's number. */
    function writeField(form, property, value) {
      var input = field(form, property);
      if (!input) return;
      input.value = value || '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function showError(root, message) {
      var el = root ? root.querySelector('[data-gcd-error]') : null;
      if (el) el.textContent = message || '';
    }

    // Required-field messages are authored in Liquid and read off the field's own wrapper,
    // never hardcoded here. Review fix, 2026-10-01: brought in line with the PDP's own
    // setFieldError (gift-card-form-script.liquid) — aria-invalid, aria-describedby and the
    // border-semantic-red toggle, not just the text.
    function showFieldError(root, name, message) {
      var fieldWrap = root.querySelector('[data-gift-card-field="' + name + '"]');
      var el = fieldWrap ? fieldWrap.querySelector('[data-gift-card-field-error]') : null;
      var control = fieldWrap ? fieldWrap.querySelector('input, textarea') : null;

      if (el) {
        el.textContent = message || '';
        if (!el.id && control && control.id) el.id = control.id + '-error';
        if (message && control && el.id) {
          control.setAttribute('aria-describedby', el.id);
        } else if (control) {
          control.removeAttribute('aria-describedby');
        }
      }

      if (control) {
        if (message) {
          control.setAttribute('aria-invalid', 'true');
        } else {
          control.removeAttribute('aria-invalid');
        }
      }

      var floatField = control ? control.closest('[data-float-field]') : null;
      var box = floatField ? floatField.parentElement : null;
      if (box) {
        box.classList.toggle('border-semantic-red', !!message);
        box.classList.toggle('border-border-secondary', !message);
      }
    }

    function clearFieldErrors(root) {
      root.querySelectorAll('[data-gift-card-field]').forEach(function (fieldWrap) {
        var name = fieldWrap.getAttribute('data-gift-card-field');
        if (name) showFieldError(root, name, '');
      });
    }

    function syncCount(root) {
      var input = root.querySelector('[data-gift-card-message]');
      var count = root.querySelector('[data-gift-card-message-count]');
      if (!input || !count) return;
      count.textContent = input.value.length + ' / ' + (input.getAttribute('maxlength') || '');
    }

    function populate(root, trigger) {
      var form = panelForm(root);
      if (!form) return;

      // Guarded internally (root.__giftCardCalendarReady) so calling this on every open
      // costs nothing after the first: the shared field snippet renders the calendar's
      // markup, but only gift-card-calendar-script.liquid knows how to drive it, and its
      // own forms.forEach loop (gift-card-script.liquid) only ever sees the PDP's forms.
      if (window.GiftCardCalendar) window.GiftCardCalendar.init(form);

      editing.key = trigger.getAttribute('data-gcd-line-key') || '';
      editing.offset = trigger.getAttribute('data-gcd-offset') || '';
      editing.variantId = trigger.getAttribute('data-gcd-variant-id') || '';
      editing.recipientEmail = trigger.getAttribute('data-gcd-recipient-email') || '';
      editing.isPhysical = trigger.getAttribute('data-gcd-is-physical') === 'true';

      giftCardAmount.setPhysicalMode(root, editing.isPhysical);

      var amount = trigger.getAttribute('data-gcd-amount') || '';
      giftCardAmount.buildAmountGrid(root, trigger.getAttribute('data-gcd-variants'), editing.variantId, amount);

      var sendOn = trigger.getAttribute('data-gcd-send-on') || '';

      writeField(form, PROP_NAME, trigger.getAttribute('data-gcd-recipient-name'));
      writeField(form, PROP_EMAIL, trigger.getAttribute('data-gcd-recipient-email'));
      writeField(form, PROP_MESSAGE, trigger.getAttribute('data-gcd-message'));

      giftCardAmount.selectSendOption(root, sendOn ? 'scheduled' : 'today');
      writeField(form, PROP_SEND_ON, sendOn);

      clearFieldErrors(root);
      showError(root, '');
      syncCount(root);
    }

    function resetPanel(root) {
      var form = panelForm(root);
      if (!form) return;

      editing.key = '';
      editing.offset = '';
      editing.variantId = '';
      editing.recipientEmail = '';
      editing.isPhysical = false;

      giftCardAmount.setPhysicalMode(root, false);
      giftCardAmount.buildAmountGrid(root, '[]', '', '');

      // Not form.reset(): that restores what the server rendered, which for a shared panel
      // is whatever the last shopper left in it.
      writeField(form, PROP_NAME, '');
      writeField(form, PROP_EMAIL, '');
      writeField(form, PROP_MESSAGE, '');
      writeField(form, PROP_SEND_ON, '');

      giftCardAmount.selectSendOption(root, 'today');
      clearFieldErrors(root);
      showError(root, '');
      syncCount(root);
    }

    /* The panel closes four ways — its own close control, the backdrop, Escape, and a
       programmatic close after a save — and all four end with the drawer's root regaining
       aria-hidden. Watching the attribute covers every path with one listener. */
    function watchForClose(root) {
      if (root.__giftCardCloseWatch || !window.MutationObserver) return;
      root.__giftCardCloseWatch = true;

      new MutationObserver(function () {
        if (root.hasAttribute('aria-hidden')) resetPanel(root);
      }).observe(root, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    function setBusy(button, busy) {
      if (!button) return;
      // aria-disabled, not the disabled property: a disabled button loses focus, which
      // would drop a keyboard user out of the panel mid-save.
      if (busy) {
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-busy');
        button.removeAttribute('aria-disabled');
      }
    }

    function escapeKey(key) {
      return window.CSS && window.CSS.escape ? window.CSS.escape(key) : key;
    }

    // errorMessage/parseFieldError: moved to mini-bag-gift-card-save-script.liquid's own
    // giftCardSave object to keep this file under the 500-line hard ceiling (same reason
    // that file's own save contract lives there instead of here) — exposed as
    // giftCardSave.errorMessage / giftCardSave.parseFieldError, called below.

    // The unchanged-amount path: replaces the line's properties in place. Resolves to the
    // full cart object, the same shape /cart/change.js always returns.
    function saveProperties(lineKey, properties, sectionId, signal) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ id: lineKey, properties: properties, sections: sectionId }),
        signal: signal,
      }).then(function (r) {
        return r.ok ? r.json() : giftCardSave.httpError('gift_card_change_failed', r);
      });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-gcd-line-key]');
      if (!trigger) return;

      var root = drawerRoot();
      if (!root) return;

      watchForClose(root);
      populate(root, trigger);
    });

    document.addEventListener('click', function (event) {
      var tile = event.target.closest('[data-gcd-amount-tile]');
      if (!tile) return;

      var root = drawerRoot();
      if (!root || !root.contains(tile)) return;

      giftCardAmount.selectAmountTile(root, tile);
    });

    document.addEventListener('change', function (event) {
      var option = event.target.closest('[data-gift-card-send-option]');
      if (!option) return;

      // The same field snippet renders on the gift-card product page, so the panel only
      // answers for the copy inside itself.
      var root = drawerRoot();
      if (!root || !root.contains(option)) return;

      giftCardAmount.setScheduled(root, option.getAttribute('data-gift-card-send-option') === 'scheduled');
    });

    document.addEventListener('input', function (event) {
      var message = event.target.closest('[data-gift-card-message]');
      if (!message) return;

      var root = drawerRoot();
      if (!root || !root.contains(message)) return;

      syncCount(root);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-gcd-form]');
      if (!form) return;

      event.preventDefault();

      var root = drawerRoot();
      if (!root || !editing.key) return;

      var button = root.querySelector('[data-gcd-submit]');
      if (button && button.getAttribute('aria-disabled') === 'true') return;

      var nameField = field(form, PROP_NAME);
      var emailField = field(form, PROP_EMAIL);
      var messageField = field(form, PROP_MESSAGE);
      var sendOnField = field(form, PROP_SEND_ON);

      var recipientName = nameField ? nameField.value.trim() : '';
      var recipientEmail = emailField ? emailField.value.trim() : '';
      var message = messageField ? messageField.value.trim() : '';
      // A disabled date field is the shopper choosing "today", so its value is not read.
      var sendOn = sendOnField && !sendOnField.disabled ? sendOnField.value.trim() : '';

      clearFieldErrors(root);

      // A physical card has no recipient at all — see the doc comment above and
      // setPhysicalMode — so there is nothing to require here beyond the message itself,
      // and the message textarea has no maxlength-only validation of its own.
      var invalid = null;
      if (!editing.isPhysical) {
        if (!recipientEmail) invalid = { name: 'recipient_email', input: emailField };
        if (!recipientName) invalid = { name: 'recipient_name', input: nameField };
      }

      if (invalid) {
        var wrap = root.querySelector('[data-gift-card-field="' + invalid.name + '"]');
        var requiredMessage = wrap ? wrap.getAttribute('data-gift-card-i18n-required') : '';
        showFieldError(root, invalid.name, requiredMessage);
        if (invalid.input) invalid.input.focus();
        return;
      }

      showError(root, '');
      setBusy(button, true);

      /* The complete property set, every time. /cart/change.js replaces the whole
         properties object, so a payload carrying only the edited fields would erase the
         control property below and quietly unmake the gift card. Carried into
         /cart/add.js unchanged too, on the variant-change path below, for the same
         reason.

         Physical is a genuinely different property set, not a partial one: it has no
         recipient, no send date and no send-to-recipient control property at all
         (gift-card-details-form.liquid's own physical panel never renders them either),
         only the theme-owned _gift_message key the PDP's physical form already submits
         under. Sending the digital keys instead would silently attach a "Recipient
         email": "" property to a physical line that never had one. */
      var properties = {};
      if (editing.isPhysical) {
        properties[PROP_PHYSICAL_MESSAGE] = message;
      } else {
        properties[PROP_NAME] = recipientName;
        properties[PROP_EMAIL] = recipientEmail;
        properties[PROP_MESSAGE] = message;
        properties[PROP_SEND_ON] = sendOn;
        properties[PROP_TO_RECIPIENT] = 'true';
        properties[PROP_OFFSET] = editing.offset || String(new Date().getTimezoneOffset());
      }

      var lineKey = editing.key;
      var sectionId = MiniBag.getSectionId ? MiniBag.getSectionId() : 'mini-bag';

      // The selected tile, not editing.variantId, is read here — editing.variantId stays
      // the line's ORIGINAL variant for the whole time the panel is open, precisely so
      // this comparison can tell whether the shopper actually changed it.
      var selectedTile = root.querySelector('[data-gcd-amount-tile][aria-pressed="true"]');
      var selectedVariantId = selectedTile ? selectedTile.getAttribute('data-gcd-variant-id') : '';
      var variantChanged = Boolean(selectedVariantId) && selectedVariantId !== editing.variantId;

      var ac = window.AbortController ? new AbortController() : null;
      var timer = window.setTimeout(function () {
        if (ac) ac.abort();
      }, TIMEOUT_MS);
      var signal = ac ? ac.signal : undefined;

      var save = variantChanged
        ? giftCardSave.saveVariantChange(
            lineKey,
            selectedVariantId,
            properties,
            sectionId,
            signal,
            editing.variantId,
            editing.recipientEmail
          )
        : saveProperties(lineKey, properties, sectionId, signal);

      save
        .then(function (cart) {
          /* Close BEFORE announcing the update: cart:updated re-renders the bag's lines,
             which is where the control that opened this panel lives, so closing afterwards
             would hand focus to a node that had just been detached. */
          var closeButton = root.querySelector('[data-drawer-panel] [data-drawer-close]');
          if (closeButton) closeButton.click();

          document.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
          );

          /* Focus the freshly rendered edit control for the same line. A cart line key
             contains a colon, which is a syntax error in an unescaped attribute selector.
             A variant change gives the line a genuinely new key (a Shopify line key is
             derived from the variant id and its properties together), so this silently
             finds nothing and leaves focus wherever the drawer's own close left it —
             correct behaviour on the properties-only path, a known gap on this one. */
          window.requestAnimationFrame(function () {
            var restored = document.querySelector(
              '[data-gcd-line-key="' + escapeKey(lineKey) + '"]'
            );
            if (restored) restored.focus();
          });
        })
        .catch(function (error) {
          // Email/message route to their own field; send_on and anything else go to the
          // generic banner with its own locale copy, never Shopify's raw fragment — same
          // split as gift-card-form-script.liquid's PDP catch. Neither field branch is
          // reachable on the physical path (no recipient email; _gift_message is
          // theme-owned, never validated by Shopify).
          var parsed = giftCardSave.parseFieldError(error);
          var fieldControls = { email: PROP_EMAIL, message: PROP_MESSAGE };
          var fieldNames = { email: 'recipient_email', message: 'message' };
          var control = parsed && !editing.isPhysical && fieldControls[parsed.field]
            ? field(form, fieldControls[parsed.field])
            : null;

          if (control) {
            var fieldWrap = root.querySelector('[data-gift-card-field="' + fieldNames[parsed.field] + '"]');
            var localeMessage = fieldWrap ? fieldWrap.getAttribute('data-gift-card-i18n-invalid') : '';
            showFieldError(root, fieldNames[parsed.field], localeMessage || parsed.message);
            control.focus();
            return;
          }

          var fallback = giftCardSave.errorMessage(form, error);
          if (parsed && parsed.field === 'send_on') {
            fallback = form.getAttribute('data-i18n-send-on-error') || parsed.message || fallback;
          } else if (parsed) {
            fallback = parsed.message || fallback;
          }

          showError(root, fallback);
        })
        .finally(function () {
          window.clearTimeout(timer);
          setBusy(button, false);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-gift-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniBag = window.MiniBag || {};
    if (window.MiniBag.giftScriptLoaded) return;
    window.MiniBag.giftScriptLoaded = true;

    var MiniBag = window.MiniBag;
    var TIMEOUT_MS = 8000;

    // The one visible attribute: what staff read on the order and what the warehouse maps.
    var ATTR_MESSAGE = 'Gift message';

    // Underscored keys stay out of the admin order view and the customer notifications;
    // they exist only so mini-bag-gift-drawer.liquid can repopulate the three fields,
    // which the composed string above cannot be split back into reliably.
    var ATTR_RAW_TO = '_gift_message_to';
    var ATTR_RAW_BODY = '_gift_message_body';
    var ATTR_RAW_FROM = '_gift_message_from';

    // Cleared on every write so a cart built against the old three-attribute contract
    // cannot reach the warehouse carrying both shapes at once.
    var LEGACY_ATTRS = ['Gift message to', 'Gift message from'];

    // Line-per-part, labelled, with any empty part omitted along with its label.
    function composeMessage(to, message, from) {
      var lines = [];
      if (to) lines.push('To: ' + to);
      lines.push(message);
      if (from) lines.push('From: ' + from);
      return lines.join('\n');
    }

    // Every attribute this feature owns, so a save and a remove write the same key set.
    function giftAttributes(to, message, from) {
      var attributes = {};
      attributes[ATTR_MESSAGE] = message ? composeMessage(to, message, from) : '';
      attributes[ATTR_RAW_TO] = to;
      attributes[ATTR_RAW_BODY] = message;
      attributes[ATTR_RAW_FROM] = from;
      LEGACY_ATTRS.forEach(function (key) {
        attributes[key] = '';
      });
      return attributes;
    }

    /* Live character count. textarea.liquid renders the count element and its aria-live
       wiring but leaves the value to the consumer (same contract product-reviews.liquid
       uses for the review body). The initial text is rendered server-side from the saved
       message, so this only has to keep it in step with typing — and it reads the total
       off maxlength rather than repeating the number here. */
    document.addEventListener('input', function (event) {
      var field = event.target.closest('[data-gift-message]');
      if (!field) return;

      var count = document.querySelector('[data-gift-count]');
      if (!count) return;

      count.textContent = field.value.length + ' / ' + (field.getAttribute('maxlength') || '');
    });

    function showError(form, message) {
      var el = form.querySelector('[data-gift-error]');
      if (el) el.textContent = message || '';
    }

    function fieldValue(form, name) {
      var field = form.elements[name];
      return field ? field.value.trim() : '';
    }

    function setBusy(button, busy) {
      if (!button) return;
      if (busy) {
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-busy');
        button.removeAttribute('aria-disabled');
      }
    }

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-gift-form]');
      if (!form) return;

      event.preventDefault();

      var button = document.querySelector('[data-gift-submit]');
      // Guard re-entry with aria-disabled rather than the disabled property: a disabled
      // button loses focus, which would drop a keyboard user out of the drawer mid-save.
      if (button && button.getAttribute('aria-disabled') === 'true') return;

      var to = fieldValue(form, 'gift_to');
      var message = fieldValue(form, 'gift_message');
      var from = fieldValue(form, 'gift_from');

      // Message alone is required: To and From are optional, so an unaddressed or unsigned
      // message is a valid save. Report against the message field and move focus there.
      if (!message) {
        var field = form.elements.gift_message;
        showError(form, form.getAttribute('data-i18n-required') || '');
        if (field) field.focus();
        return;
      }

      showError(form, '');
      setBusy(button, true);

      var attributes = giftAttributes(to, message, from);

      var ac = window.AbortController ? new AbortController() : null;
      var timer = window.setTimeout(function () {
        if (ac) ac.abort();
      }, TIMEOUT_MS);

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          attributes: attributes,
          sections: MiniBag.getSectionId ? MiniBag.getSectionId() : 'mini-bag',
        }),
        signal: ac ? ac.signal : undefined,
      })
        .then(function (r) {
          if (!r.ok) throw new Error('gift_update_failed');
          return r.json();
        })
        .then(function (cart) {
          /* /cart/update.js returns the cart itself, sections included — no follow-up
             /cart.js needed here, unlike the add/change flows which return a line item. */
          /* Close BEFORE announcing the update. cart:updated re-renders the mini bag
             footer, which is where the trigger that opened this drawer lives — closing
             afterwards would hand focus to a node that had just been detached, dropping
             the shopper to <body>. */
          var closeButton = document.querySelector('#gift-drawer [data-drawer-close]');
          if (closeButton) closeButton.click();

          document.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
          );

          /* The re-render also replaced the trigger the drawer just restored focus to, so
             put focus on its freshly rendered replacement — which now reads "Edit gift
             message", confirming the save to a screen reader as well as visually. */
          window.requestAnimationFrame(function () {
            var trigger = document.querySelector('[data-drawer-open="gift-drawer"]');
            if (trigger) trigger.focus();
          });
        })
        .catch(function (error) {
          var timedOut = error && error.name === 'AbortError';
          showError(
            form,
            timedOut
              ? form.getAttribute('data-i18n-timeout')
              : form.getAttribute('data-i18n-error')
          );
        })
        .finally(function () {
          window.clearTimeout(timer);
          setBusy(button, false);
        });
    });

    // Mirrors the submit handler above, but clears the attributes instead of saving them.
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-gift-remove]');
      if (!button) return;

      if (button.getAttribute('aria-disabled') === 'true') return;

      var form = document.getElementById('gift-message-form');
      var errorEl = document.querySelector('[data-gift-error]');
      if (errorEl) errorEl.textContent = '';

      setBusy(button, true);

      var attributes = giftAttributes('', '', '');

      var ac = window.AbortController ? new AbortController() : null;
      var timer = window.setTimeout(function () {
        if (ac) ac.abort();
      }, TIMEOUT_MS);

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          attributes: attributes,
          sections: MiniBag.getSectionId ? MiniBag.getSectionId() : 'mini-bag',
        }),
        signal: ac ? ac.signal : undefined,
      })
        .then(function (r) {
          if (!r.ok) throw new Error('gift_remove_failed');
          return r.json();
        })
        .then(function (cart) {
          if (form) {
            // Not form.reset(): that restores the server-rendered value, not blank.
            ['gift_to', 'gift_message', 'gift_from'].forEach(function (name) {
              var input = form.elements[name];
              if (!input) return;
              input.value = '';
              input.dispatchEvent(new Event('input', { bubbles: true }));
            });
          }

          var closeButton = document.querySelector('#gift-drawer [data-drawer-close]');
          if (closeButton) closeButton.click();

          document.dispatchEvent(
            new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
          );

          window.requestAnimationFrame(function () {
            var trigger = document.querySelector('[data-drawer-open="gift-drawer"]');
            if (trigger) trigger.focus();
          });
        })
        .catch(function (error) {
          var timedOut = error && error.name === 'AbortError';
          if (errorEl) {
            errorEl.textContent = timedOut
              ? (form ? form.getAttribute('data-i18n-timeout') : '')
              : (form ? form.getAttribute('data-i18n-error') : '');
          }
        })
        .finally(function () {
          window.clearTimeout(timer);
          setBusy(button, false);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-loyalty-gift-redemption-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniBag = window.MiniBag || {};
    if (window.MiniBag.loyaltyGiftRedemptionLoaded) return;
    window.MiniBag.loyaltyGiftRedemptionLoaded = true;

    var MiniBag = window.MiniBag;
    MiniBag.loyaltyGift = MiniBag.loyaltyGift || {};
    var shared = MiniBag.loyaltyGift;

    var clearingDiscount = false;

    /* Deliberately scoped to the code we ourselves applied. A shopper may have entered
       their own promotion code, and clearing that because a gift line went away would be
       a far worse bug than leaving a stale loyalty code behind. With no cached code we
       do nothing. */
    function hasLoyaltyDiscount(cart) {
      var code = shared.couponCode;
      if (!code) return false;
      var needle = code.toLowerCase();
      return ((cart && cart.cart_level_discount_applications) || []).some(function (application) {
        return application &&
          typeof application.title === 'string' &&
          application.title.toLowerCase() === needle;
      });
    }

    /* Defensive fallback for a gift whose card is not on the grid at all: the merchant
       may have taken that product out of the collection since the shopper picked it.
       Same shape as mini-bag-free-samples-script's findSampleLineKey. */
    function resolveOutgoing() {
      var card = shared.heldCard();
      if (card) {
        return Promise.resolve({
          key: card.getAttribute('data-loyalty-gift-line-key'),
          variantId: card.getAttribute('data-variant-id'),
        });
      }
      return shared.fetchCart().then(function (cart) {
        var line = shared.loyaltyGiftLine(cart);
        return line ? { key: line.key, variantId: String(line.variant_id) } : null;
      });
    }

    function addGift(variantId) {
      return shared.cartRequest('/cart/add.js', {
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: { _loyalty_gift: 'true', _antavo_coupon: shared.couponCode },
          },
        ],
      });
    }

    function applyDiscount() {
      return shared.cartRequest('/cart/update.js', { discount: shared.couponCode });
    }

    /* Two mutations, deliberately sequential — the same reasoning
       mini-bag-free-samples-script's swapSample records. Both touch the same cart, and
       remove-then-add is the safe order: the reverse would hold two loyalty gifts for the
       width of one request, and a failure there would carry both all the way to checkout
       against a coupon that grants one. This order's own failure costs a second click.

       `progress` carries the remove's section render back out, because a swap is the only
       path here where the first half can land and the second fail. */
    function confirmGift() {
      if (shared.isBusy()) return;

      var button = shared.confirmButton();
      if (button && button.getAttribute('aria-disabled') === 'true') return;

      var card = shared.selectedCard();
      if (!card) return;

      var variantId = card.getAttribute('data-variant-id');
      if (!variantId || !shared.couponCode) {
        shared.showError('error');
        return;
      }

      shared.showError(null);
      shared.setBusy(true);

      var progress = { sections: null };

      resolveOutgoing()
        .then(function (outgoing) {
          // Already holding exactly this product: nothing to mutate, just close.
          if (outgoing && String(outgoing.variantId) === String(variantId)) return 'unchanged';
          if (!outgoing) return null;
          return shared.cartRequest('/cart/change.js', { id: outgoing.key, quantity: 0 })
            .then(function (cart) {
              progress.sections = cart.sections;
              return null;
            });
        })
        .then(function (state) {
          if (state === 'unchanged') return 'unchanged';
          return addGift(variantId).then(applyDiscount);
        })
        .then(function (result) {
          if (result === 'unchanged') {
            shared.closeDrawer();
            return;
          }

          var line = shared.loyaltyGiftLine(result);

          /* The add landed but the discount did not zero the line: an expired code, a
             wrongly scoped one, or a discount-combination conflict. Client fix, 2026-10-01
             — the line used to stay in the cart, still labelled "Free" (mini-bag-line-
             item.liquid keys that purely off _loyalty_gift, never final_line_price), with
             the total genuinely unchanged and the shopper told to remove it themselves.
             Roll it back instead: remove the line we just added, clear the coupon if it
             still landed with nothing to discount, then announce that truthful cart. */
          if (!line || line.final_line_price !== 0) {
            var rollback = line
              ? shared.cartRequest('/cart/change.js', { id: line.key, quantity: 0 })
              : Promise.resolve(result);

            return rollback
              .then(function (cartAfterRemoval) {
                return hasLoyaltyDiscount(cartAfterRemoval)
                  ? shared.cartRequest('/cart/update.js', { discount: '' })
                  : cartAfterRemoval;
              })
              .then(function (finalCart) {
                shared.announce(finalCart);
                shared.showError('discount-error');
              });
          }

          /* Close BEFORE announcing: closing hands focus to whichever trigger opened the
             drawer, and announce()'s own re-render can then remove or hide that same
             trigger (syncBanner hides the banner the moment a gift line exists). Reuses
             mini-bag-cart-script.liquid's own guard for exactly that — focus stranded on
             <body> while the mini bag is still open — rather than re-implementing it. */
          shared.closeDrawer();
          shared.announce(result);
          if (MiniBag.restoreFocusAfterRemoval) MiniBag.restoreFocusAfterRemoval();
        })
        .catch(function (error) {
          shared.showError(error && error.name === 'AbortError' ? 'timeout' : 'error');

          /* Unless a swap got half-way: the remove landed and the add did not, so the cart
             really did change and the bag is still drawing a gift line that no longer
             exists. Settle it against the remove's own section render, which is a truthful
             picture of the cart as it now stands. */
          if (progress.sections) {
            shared.announceSections(progress.sections).catch(function () {});
          }
        })
        .finally(function () {
          shared.setBusy(false);
        });
    }

    /* The bin icon on a gift line removes it through the ordinary mini-bag removal path,
       which knows nothing about discounts — leaving the cart in a "code applied, nothing
       left to discount" state. POST /cart/update.js with an empty discount is Shopify's
       documented way to clear a cart-level code, so this closes that state the moment the
       line goes. Guarded so it can only ever clear OUR code (see hasLoyaltyDiscount) and
       cannot re-enter: once cleared the condition is false, and the flag covers the window
       before the response lands. */
    function clearOrphanedDiscount(cart) {
      if (clearingDiscount || !shared.couponCode) return;
      if (shared.loyaltyGiftLine(cart)) return;
      if (!hasLoyaltyDiscount(cart)) return;

      clearingDiscount = true;
      shared.cartRequest('/cart/update.js', { discount: '' })
        .then(function (fresh) {
          shared.announce(fresh);
        })
        .catch(function () {
          /* Nothing the shopper can act on: the gift is already gone, and a dangling code
             with no qualifying item discounts nothing at checkout either. */
        })
        .finally(function () {
          clearingDiscount = false;
        });
    }

    /* A signed-out visitor must never be left holding a gift line or its discount: the
       coupon is tied to one specific Antavo customer, so it cannot honestly belong to a
       guest either. Sign-out happens through Shopify's own /account/logout, a full page
       navigation, so there is no cart:updated to react to — mini-bag-loyalty-gift-
       script.liquid's own init() calls this directly, once, off the cart it already
       fetched. The code to clear is read off the gift line's own _antavo_coupon property
       rather than shared.couponCode: fetchEligibility short-circuits before asking Antavo
       anything once window.loyaltyCustomerEmail is gone, so couponCode is never populated
       for a guest. Reading it from the line keeps the clear scoped to a code this line can
       prove it applied, never a promotion the shopper entered themselves — same reasoning
       as hasLoyaltyDiscount, just sourced from the line instead of memory. Shares
       clearingDiscount with clearOrphanedDiscount so the two can never race; by the time
       this one's own announce() reaches that listener the line and the discount are
       already gone, so it no-ops. */
    function cleanupSignedOutGift(cart) {
      if (window.loyaltyCustomerEmail) return;
      if (clearingDiscount) return;

      var line = shared.loyaltyGiftLine(cart);
      if (!line) return;

      var code = line.properties && line.properties._antavo_coupon;

      clearingDiscount = true;
      shared.cartRequest('/cart/change.js', { id: line.key, quantity: 0 })
        .then(function (cartAfterRemove) {
          if (!code) return cartAfterRemove;
          return shared.cartRequest('/cart/update.js', { discount: '' });
        })
        .then(function (fresh) {
          shared.announce(fresh);
        })
        .catch(function () {
          /* Loyalty must never block or break the cart: leaving the line for one more
             page view is safer than surfacing an error a signed-out visitor has no
             control over. */
        })
        .finally(function () {
          clearingDiscount = false;
        });
    }

    document.addEventListener('click', function (event) {
      var confirm = event.target.closest('[data-loyalty-gift-confirm]');
      if (!confirm) return;
      event.preventDefault();
      confirmGift();
    });

    /* Registered after mini-bag-cart-script.liquid's own listener (render order in
       sections/mini-bag.liquid), so applySection — and with it the footer swap this
       relies on — has already run by the time these run. */
    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart) return;
      clearOrphanedDiscount(cart);
    });

    shared.cleanupSignedOutGift = cleanupSignedOutGift;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-loyalty-gift-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniBag = window.MiniBag || {};
    if (window.MiniBag.loyaltyGiftLoaded) return;
    window.MiniBag.loyaltyGiftLoaded = true;

    var MiniBag = window.MiniBag;
    MiniBag.loyaltyGift = MiniBag.loyaltyGift || {};
    var shared = MiniBag.loyaltyGift;

    var ENDPOINT = '/apps/whittard-loyalty/gift-eligibility';
    var TIMEOUT_MS = 8000;

    /* Antavo's answer to "does this customer hold a claimed, unexpired free-gift
       coupon". Resolved once per page and cached: the endpoint is GET-only and its
       answer depends solely on the Antavo customer record, never on cart contents, so
       re-asking after every cart mutation would spend a request per click on a value
       that cannot have moved. Whether the BANNER is on screen is a different question
       entirely, re-derived from the cart each time — see syncBanner. Exposed as
       shared.couponCode (plain property, not a getter) since the redemption script
       reads and never writes it. */
    var eligible = false;
    shared.couponCode = null;

    var busy = false;

    function bannerRoot() {
      return document.querySelector('[data-mini-bag-loyalty-gift]');
    }

    function grid() {
      return document.querySelector('[data-loyalty-gift-grid]');
    }

    /* Re-queried on every use rather than held: both of these live in the drawer footer,
       which mini-bag-cart-script.liquid's replaceLoyaltyGiftDrawerFooter swaps wholesale
       after each cart mutation, so a cached node goes stale without warning. */
    function confirmButton() {
      return document.querySelector('[data-loyalty-gift-confirm]');
    }

    function errorElement() {
      return document.querySelector('[data-loyalty-gift-error]');
    }

    /* kind is the suffix of the data-i18n-* attribute carrying the copy ('error',
       'timeout', 'discount-error'); null clears the surface. Never silently absorbed
       (_SHARED_INVARIANTS.md §1 rule 12). */
    function showError(kind) {
      var el = errorElement();
      if (!el) return;
      el.textContent = kind ? el.getAttribute('data-i18n-' + kind) || '' : '';
    }

    function cards() {
      var root = grid();
      return root
        ? Array.prototype.slice.call(root.querySelectorAll('[data-loyalty-gift-card]'))
        : [];
    }

    function selectedCard() {
      return cards().filter(function (card) {
        return card.getAttribute('data-selected') === 'true';
      })[0] || null;
    }

    /* The card holding the gift the shopper currently has in the bag. It keeps its line
       key after a different card is picked, which is exactly what makes it findable as
       the OUTGOING line when the swap runs. */
    function heldCard() {
      var root = grid();
      return root ? root.querySelector('[data-loyalty-gift-card][data-loyalty-gift-line-key]') : null;
    }

    function loyaltyGiftLine(cart) {
      return ((cart && cart.items) || []).filter(function (line) {
        return line.properties && line.properties._loyalty_gift === 'true';
      })[0] || null;
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('cart_fetch_failed');
          return r.json();
        });
    }

    /* Same single-door shape as mini-bag-cart-script.liquid's own cartRequest: shared
       headers, the section render stapled on, and an 8s abort so a hung request cannot
       leave the confirm control disabled forever. */
    function cartRequest(url, body) {
      var ac = window.AbortController ? new AbortController() : null;
      var timer = window.setTimeout(function () {
        if (ac) ac.abort();
      }, TIMEOUT_MS);

      body.sections = MiniBag.getSectionId ? MiniBag.getSectionId() : 'mini-bag';

      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
        signal: ac ? ac.signal : undefined,
      })
        .then(function (r) {
          if (!r.ok) throw new Error('loyalty_gift_request_failed');
          return r.json();
        })
        .finally(function () {
          window.clearTimeout(timer);
        });
    }

    function announce(cart) {
      document.dispatchEvent(
        new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
      );
    }

    /* For the one path whose section render arrives without a cart attached: a swap whose
       remove landed and whose add then failed. Mirrors mini-bag-free-samples-script's
       announceCart for the same half-way case. */
    function announceSections(sections) {
      return fetchCart().then(function (cart) {
        cart.sections = sections || {};
        announce(cart);
      });
    }

    function syncConfirmState() {
      var button = confirmButton();
      if (!button || busy) return;
      if (selectedCard()) {
        button.removeAttribute('aria-disabled');
      } else {
        button.setAttribute('aria-disabled', 'true');
      }
    }

    function setBusy(state) {
      busy = state;

      /* Blocks card clicks for the width of the mutation, closing the window where a
         second pick is accepted by the browser and then silently swallowed by the guard
         below. Sits on the grid so the drawer can still be scrolled and closed. */
      var root = grid();
      if (root) {
        if (state) {
          root.setAttribute('data-busy', 'true');
        } else {
          root.removeAttribute('data-busy');
        }
      }

      var button = confirmButton();
      if (!button) return;

      if (state) {
        button.setAttribute('aria-busy', 'true');
        /* aria-disabled, not the disabled property: a disabled button loses focus, which
           would drop a keyboard user out of the drawer mid-redemption. */
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-busy');
        syncConfirmState();
      }
    }

    /* Radio, not toggle: there is always exactly one gift, and "no gift" is reached by
       removing the line from the bag rather than by unpicking a card here. */
    function selectCard(card) {
      cards().forEach(function (other) {
        var isTarget = other === card;
        other.setAttribute('data-selected', isTarget ? 'true' : 'false');
        var button = other.querySelector('[data-loyalty-gift-button]');
        if (button) button.setAttribute('aria-pressed', isTarget ? 'true' : 'false');
      });
      syncConfirmState();
    }

    /* Re-derives every card from the cart payload, so the picker and the bag can never
       drift: remove the gift line from the line list, another tab or the cart page and
       its card deselects itself. This reads the CART, never the server section render —
       the grid is deliberately left out of applySection's swaps so a re-render cannot
       flash stale selection over a live one. */
    function syncCardsFromCart(cart) {
      var line = loyaltyGiftLine(cart);
      cards().forEach(function (card) {
        var isHeld = Boolean(line) && String(line.variant_id) === card.getAttribute('data-variant-id');
        card.setAttribute('data-selected', isHeld ? 'true' : 'false');
        if (isHeld && line.key) {
          card.setAttribute('data-loyalty-gift-line-key', line.key);
        } else {
          card.removeAttribute('data-loyalty-gift-line-key');
        }
        var button = card.querySelector('[data-loyalty-gift-button]');
        if (button) button.setAttribute('aria-pressed', isHeld ? 'true' : 'false');
      });
      syncConfirmState();
    }

    /* Entry point for a FIRST pick only — it disappears the moment a gift line exists,
       because changing the pick is done from that line's own Change gift control. */
    function syncBanner(cart) {
      var root = bannerRoot();
      if (!root) return;
      root.classList.toggle('hidden', !(eligible && !loyaltyGiftLine(cart)));
    }

    function closeDrawer() {
      var closeButton = document.querySelector('#loyalty-gift-drawer [data-drawer-close]');
      /* Close only this drawer. The mini bag is still open underneath — the global
         controller stacks drawers rather than replacing them. */
      if (closeButton) closeButton.click();
    }

    function fetchEligibility() {
      // A coupon is tied to a real Antavo customer, so a guest has nothing to ask about.
      if (!window.loyaltyCustomerEmail) return Promise.resolve(false);

      var ac = window.AbortController ? new AbortController() : null;
      var timer = window.setTimeout(function () {
        if (ac) ac.abort();
      }, TIMEOUT_MS);

      var url = ENDPOINT + '?customer_email=' + encodeURIComponent(window.loyaltyCustomerEmail);

      return fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: ac ? ac.signal : undefined,
      })
        .then(function (r) {
          if (!r.ok) throw new Error('loyalty_gift_eligibility_failed');
          return r.json();
        })
        .then(function (data) {
          eligible = Boolean(data && data.ok && data.eligible && data.coupon && data.coupon.code);
          shared.couponCode = eligible ? String(data.coupon.code) : null;
          return eligible;
        })
        .catch(function (error) {
          /* Loyalty must never block or break the cart: an unreachable proxy simply means
             no banner, exactly as mini-bag-loyalty-script.liquid treats its own failure. */
          console.warn('Mini Bag loyalty gift eligibility failed:', error);
          eligible = false;
          shared.couponCode = null;
          return false;
        })
        .finally(function () {
          window.clearTimeout(timer);
        });
    }

    document.addEventListener('click', function (event) {
      var card = event.target.closest('[data-loyalty-gift-card]');
      if (!card) return;
      if (busy) return;
      showError(null);
      selectCard(card);
    });

    /* Registered after mini-bag-cart-script.liquid's own listener (render order in
       sections/mini-bag.liquid), so applySection — and with it the footer swap the
       redemption script's confirm button relies on — has already run by the time this
       fires. */
    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail && event.detail.cart;
      if (!cart) return;
      syncBanner(cart);
      syncCardsFromCart(cart);
    });

    function init() {
      // Neither surface rendered: the feature is switched off for this store.
      if (!bannerRoot() && !grid()) return;

      Promise.all([
        fetchEligibility(),
        fetchCart().catch(function () {
          return null;
        }),
      ]).then(function (results) {
        var cart = results[1];
        if (!cart) return;
        syncBanner(cart);
        syncCardsFromCart(cart);
        /* Owned by mini-bag-loyalty-gift-redemption-script.liquid — guarded in case that
           file is ever missing, mirroring this codebase's own MiniBag.init* checks
           elsewhere (e.g. refreshMiniBagModules). */
        if (shared.cleanupSignedOutGift) shared.cleanupSignedOutGift(cart);
      });
    }

    /* Exposed for mini-bag-loyalty-gift-redemption-script.liquid's confirm sequence and
       clean-up functions. Grouped here rather than scattered inline so the boundary
       between the two files is one place to read, not one per function. */
    shared.cartRequest = cartRequest;
    shared.fetchCart = fetchCart;
    shared.announce = announce;
    shared.announceSections = announceSections;
    shared.loyaltyGiftLine = loyaltyGiftLine;
    shared.selectedCard = selectedCard;
    shared.heldCard = heldCard;
    shared.confirmButton = confirmButton;
    shared.errorElement = errorElement;
    shared.showError = showError;
    shared.setBusy = setBusy;
    shared.isBusy = function () {
      return busy;
    };
    shared.closeDrawer = closeDrawer;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-loyalty-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniBag = window.MiniBag || {};

    if (window.MiniBag.loyaltyScriptLoaded) return;
    window.MiniBag.loyaltyScriptLoaded = true;

    var MiniBag = window.MiniBag;

    var ENDPOINT = '/apps/whittard-loyalty/cart-summary';

    /*
     * Antavo's Primary ID is email, not the Shopify customer id - the backend
     * now 400s a signed-in request with no customer_email (see
     * loyalty-customer-context.liquid, rendered once globally). Guests never
     * have window.loyaltyCustomerEmail set, so this leaves their request
     * untouched and they still fall into the existing guest-estimate path.
     */
    function withCustomerEmail(url) {
      if (!window.loyaltyCustomerEmail) return url;

      return url + '?customer_email=' + encodeURIComponent(window.loyaltyCustomerEmail);
    }

    var activeController = null;
    var requestVersion = 0;

    function getRoot() {
      return document.querySelector('[data-mini-bag-loyalty]');
    }

    function setVisible(root, visible) {
      if (!root) return;

      root.classList.toggle('hidden', !visible);
    }

    function setLoading(root, loading) {
      if (!root) return;

      root.setAttribute('aria-busy', loading ? 'true' : 'false');
    }

    function formatPoints(value) {
      var number = Number(value);

      if (!Number.isFinite(number)) {
        number = 0;
      }

      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        maximumFractionDigits: 0,
      }).format(number);
    }

    function formatMoney(value, currency) {
      var amount = Number(value);

      if (!Number.isFinite(amount)) {
        amount = 0;
      }

      var isoCode = String(currency || 'GBP').toUpperCase();

      var formattedAmount;

      try {
        formattedAmount = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(amount);
      } catch (error) {
        formattedAmount = amount.toFixed(2);
      }

      switch (isoCode) {
        case 'USD':
        case 'CAD':
        case 'AUD':
        case 'HKD':
          return '$' + formattedAmount + ' ' + isoCode;

        case 'GBP':
          return '£' + formattedAmount;

        case 'EUR':
          return '€' + formattedAmount;

        case 'JPY':
          return '¥' + formattedAmount;

        case 'KRW':
          return '₩' + formattedAmount;

        default:
          return formattedAmount + ' ' + isoCode;
      }
    }

    function updateText(root, selector, value) {
      var element = root.querySelector(selector);

      if (element) {
        element.textContent = value;
      }
    }

    function renderLoyalty(root, data, currency) {
      /*
       * Two sources of a reliable figure, matching the two states this
       * markup actually renders (see mini-bag-loyalty.liquid): a genuine
       * member response, or a guest estimate from the ghost/guest Antavo
       * customer. Whichever fields the response provides tells this
       * function which DOM block is present - it never checks `customer`
       * itself. updateText no-ops safely against the block that isn't.
       */
      var isMemberResponse = !!(data && data.authenticated && data.member && data.balance && data.earn);
      var isGuestEstimate = !!(data && data.guestEstimate && data.earn);

      if (!isMemberResponse && !isGuestEstimate) {
        setVisible(root, false);
        return;
      }

      if (isMemberResponse) {
        updateText(root, '[data-mini-bag-loyalty-balance-points]', formatPoints(data.balance.points));
        updateText(root, '[data-mini-bag-loyalty-balance-value]', formatMoney(data.balance.value, currency));
        updateText(root, '[data-mini-bag-loyalty-earn-points]', formatPoints(data.earn.points));
        updateText(root, '[data-mini-bag-loyalty-earn-value]', formatMoney(data.earn.value, currency));
      } else {
        updateText(root, '[data-mini-bag-loyalty-guest-points]', formatPoints(data.earn.points));
      }

      setVisible(root, true);
    }

    function requestSummary(cart) {
      var root = getRoot();

      /*
       * Guests do not have this server-rendered root,
       * so there is nothing to hydrate and no reason
       * to call the loyalty backend.
       */
      if (!root) {
        return Promise.resolve();
      }

      if (!cart || !Array.isArray(cart.items) || cart.item_count <= 0) {
        setVisible(root, false);
        return Promise.resolve();
      }

      /*
       * Every cart mutation may start another loyalty
       * calculation before the previous one finishes.
       *
       * Abort the previous request so an older response
       * can never overwrite newer cart data.
       */
      if (activeController) {
        activeController.abort();
      }

      activeController = window.AbortController ? new AbortController() : null;

      requestVersion += 1;

      var currentVersion = requestVersion;

      setLoading(root, true);

      return fetch(withCustomerEmail(ENDPOINT), {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },

        body: JSON.stringify(cart),

        signal: activeController ? activeController.signal : undefined,
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('loyalty_summary_request_failed');
          }

          return response.json();
        })
        .then(function (data) {
          /*
           * AbortController isn't available everywhere.
           * The version guard gives us the same stale
           * response protection in that case.
           */
          if (currentVersion !== requestVersion) {
            return;
          }

          renderLoyalty(root, data, cart.currency);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') {
            return;
          }

          console.warn('Mini Bag loyalty summary failed:', error);

          /*
           * Loyalty must never block or break the cart.
           * If Antavo/the proxy fails, simply remove the
           * optional loyalty surface.
           */
          if (currentVersion === requestVersion) {
            setVisible(root, false);
          }
        })
        .finally(function () {
          if (currentVersion === requestVersion) {
            setLoading(root, false);
            activeController = null;
          }
        });
    }

    function fetchCurrentCart() {
      return fetch('/cart.js', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('cart_fetch_failed');
        }

        return response.json();
      });
    }

    function refresh(cart) {
      if (cart) {
        return requestSummary(cart);
      }

      return fetchCurrentCart()
        .then(function (currentCart) {
          return requestSummary(currentCart);
        })
        .catch(function (error) {
          console.warn('Mini Bag loyalty cart fetch failed:', error);

          var root = getRoot();

          if (root) {
            setVisible(root, false);
            setLoading(root, false);
          }
        });
    }

    /*
     * mini-bag-cart-script.liquid already emits
     * this after successful Shopify cart mutations.
     *
     * Use its authoritative cart response rather
     * than making a second /cart.js request.
     */
    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail && event.detail.cart;

      if (!cart) return;

      refresh(cart);
    });

    MiniBag.refreshLoyalty = refresh;

    /*
     * Initial page/cart state.
     */
    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          refresh();
        },
        {
          once: true,
        }
      );
    } else {
      refresh();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-recommendations-card-script"] && !Shopify.designMode) return;
  try {
    (function () {
    window.MiniBag = window.MiniBag || {};

    if (window.MiniBag.recommendationsCardScriptLoaded) return;

    window.MiniBag.recommendationsCardScriptLoaded = true;
    // Shared with collection-tagalys-card.liquid via assets/tagalys-recommendations.js
    // (window.TagalysProductFormat) — was a byte-for-byte duplicate of escHtml/money/
    // readMetaValue in both files before this extraction (TASK-47920).
    //
    // Read defensively. That asset is a separate deferred <script> in layout/theme.liquid,
    // and dereferencing it at parse time meant a single failed request (network, CSP, an
    // extension) threw a TypeError right here — which is not a local failure, because
    // Shopify concatenates EVERY section/snippet javascript block into one bundle, so an
    // uncaught throw takes down every block ordered after this one. That is the same
    // hazard the drawer is insulated from by living in its own asset (layout/theme.liquid).
    //
    // Nothing below can actually run without the asset anyway: every render path is
    // reached only through fetchAndRenderUpsells / fetchAndRenderEmptyUpsells, and both
    // already bail on a missing window.TagalysRecommendations. So the only job here is to
    // not explode on the way in, leaving the mini bag fully functional minus its
    // recommendations rather than half-initialised.
    var TagalysFormat = window.TagalysProductFormat || {};
    var escHtml = TagalysFormat.escHtml;
    var money = TagalysFormat.money;

    // No silent cap: bundle-price-cache.liquid sets this when the configured
    // collection held more custom-bundle products than it reads (shared flag
    // with collection-tagalys-card.liquid's identical check, so it only logs once).
    if (window.WhittardBundlePriceCacheTruncated && window.console && !window.__whittardBundleCacheWarned) {
      window.__whittardBundleCacheWarned = true;
      console.warn('[bundle-price-cache]', 'window.WhittardBundlePriceCache is truncated — some bundle cards may show their placeholder Shopify price.');
    }

    function shopifySrcset(src) {
      return TagalysFormat.shopifySrcset ? TagalysFormat.shopifySrcset(src, [390, 480, 640]) : '';
    }

    // Mirrors product-card.liquid's current markup for quick_action: 'add_to_cart', picker_mode: false.
    function upsellCardHtml(p, addedLabel, fromPriceFmt, cardClass, currency, rootUrl) {
      var imgs = p.images || [], img0 = imgs[0] || {}, img1 = imgs[1] || {};
      var avail = p.available !== false;
      var variantId = (p.variants && p.variants[0] && p.variants[0].id) || '';
      var title = escHtml(p.name || p.title || '');
      var rawHref = (p.url && /^(\/|https?:\/\/)/.test(String(p.url))) ? p.url : ('/products/' + (p.handle || ''));
      /* Same market-root fix as collection-tagalys-card.liquid: a bare
         root-relative product URL resolves to the domain root on this store's
         path-based Markets setup (/en-int/, /en-eu/), dropping the shopper
         back into the default market/currency on click. */
      var href = rawHref;
      if (rootUrl && rootUrl !== '/' && /^\//.test(rawHref) && rawHref.indexOf(rootUrl) !== 0) {
        href = rootUrl.replace(/\/$/, '') + rawHref;
      }
      var sizes = '(min-width:1024px) 25vw,50vw';
      var ss0 = shopifySrcset(img0.src), ss1 = shopifySrcset(img1.src);

      var hImg = img1.src
        ? '<div class="absolute inset-0 isolate bg-surface-tertiary"><img src="' + escHtml(img1.src) + '"' + (ss1 ? ' srcset="' + ss1 + '"' : '') + ' sizes="' + sizes + '" alt="' + escHtml(img1.alt || '') + '" loading="lazy" class="absolute inset-0 w-full h-full object-contain mix-blend-multiply" aria-hidden="true"></div>'
        : '';
      var fImg = img0.src
        ? '<div class="absolute inset-0 isolate bg-surface-tertiary' + (img1.src ? ' transition-fade group-hover:opacity-0' : '') + '"><img src="' + escHtml(img0.src) + '"' + (ss0 ? ' srcset="' + ss0 + '"' : '') + ' sizes="' + sizes + '" alt="' + escHtml(img0.alt || '') + '" loading="lazy" class="absolute inset-0 w-full h-full object-contain mix-blend-multiply"></div>'
        : '';

      // Custom-bundle entry is [from_total, from_sum] pence (discounted,
      // undiscounted) from window.WhittardBundlePriceCache (bundle-price-cache.liquid)
      // — same lookup as collection-tagalys-card.liquid's TagalysCard, since Tagalys's
      // own recommendation index only ever carries the bundle's placeholder Shopify
      // price/compare-at, never its real computed "From" total.
      var bundleEntry = (window.WhittardBundlePriceCache || {})[p.handle || ''];
      var cmp, minP, isBundleFrom = false;
      if (bundleEntry) {
        minP = bundleEntry[0] / 100;
        cmp = bundleEntry[1] > bundleEntry[0] ? bundleEntry[1] / 100 : 0;
        isBundleFrom = true;
      } else {
        cmp = p.compare_at_price_min || 0;
        minP = p.price_min || 0;
      }
      var priceHtml = cmp > minP
        ? '<span class="line-through">' + money(cmp, currency) + '</span><span>' + money(minP, currency) + '</span>'
        : (p.price_varies || isBundleFrom) ? '<span>' + escHtml(fromPriceFmt.replace('__PRICE__', money(minP, currency))) + '</span>' : '<span>' + money(minP, currency) + '</span>';

      // Tagalys's own index carries no rating field and no product metafields
      // (FAILS_INDEX.md §12), so this can never be filled synchronously here.
      // Always rendered, hidden until snippets/tagalys-rating-hydration.liquid
      // resolves a live Yotpo rating for this card's data-product-id and
      // reveals it — byte-identical to collection-tagalys-card.liquid's own
      // rating slot.
      var ratHtml = '<div class="hidden items-center gap-4 shrink-0 order-2 md:order-2 md:ml-auto pointer-events-none" data-product-rating aria-live="polite">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="size-16 text-brand-primary-blue" aria-hidden="true" focusable="false">' +
        '<path d="M20.5463 10.7802L16.9281 13.8368L18.0305 18.4078C18.0913 18.656 18.0756 18.9162 17.9854 19.1556C17.8953 19.3951 17.7347 19.6029 17.5239 19.7531C17.3131 19.9032 17.0616 19.9887 16.8011 19.999C16.5407 20.0092 16.283 19.9436 16.0606 19.8106L12.0002 17.364L7.93735 19.8106C7.71498 19.9429 7.45759 20.0078 7.19759 19.9972C6.93759 19.9866 6.68661 19.9009 6.47625 19.7509C6.2659 19.6009 6.10557 19.3934 6.01546 19.1544C5.92535 18.9154 5.90949 18.6556 5.96987 18.4078L7.07623 13.8368L3.45805 10.7802C3.2613 10.6137 3.11901 10.3942 3.04894 10.149C2.97888 9.90385 2.98414 9.64389 3.06408 9.40163C3.14403 9.15936 3.2951 8.94553 3.49844 8.78682C3.70178 8.62811 3.94837 8.53157 4.20742 8.50925L8.95125 8.13456L10.7812 3.79886C10.8803 3.56257 11.0489 3.36045 11.2656 3.2182C11.4823 3.07595 11.7373 3 11.9982 3C12.259 3 12.514 3.07595 12.7307 3.2182C12.9474 3.36045 13.116 3.56257 13.2151 3.79886L15.0443 8.13456L19.7881 8.50925C20.0476 8.53074 20.295 8.62674 20.499 8.78523C20.7031 8.94372 20.8549 9.15764 20.9353 9.4002C21.0158 9.64276 21.0213 9.90316 20.9512 10.1488C20.8812 10.3944 20.7386 10.6143 20.5415 10.781L20.5463 10.7802Z" fill="currentColor"/></svg>' +
        '<span class="text-b3 uppercase leading-none text-primary" data-rating-value></span></div>';

      /* Custom Events Tracking impression payload — same contract as
         product-card.liquid and TagalysCard; see the note in
         collection-tagalys-card.liquid for the SKU fallback and why Tagalys
         prices are formatted rather than divided. */
      var tVariant = (p.variants && p.variants[0]) || {};
      var trackAttr = ' data-track-item="' + escHtml(JSON.stringify({
        id: String(tVariant.sku || p.sku || p.id || ''),
        name: p.name || p.title || '',
        brand: p.vendor || '',
        category: p.product_type || '',
        variant: tVariant.title || '',
        price: parseFloat(minP || 0).toFixed(2),
        product_id: String(p.id || ''),
        variant_id: String(variantId || ''),
        compare_at_price: parseFloat(cmp || 0).toFixed(2),
        image: img0.src || ''
      })) + '"';

      return '<div class="' + cardClass + '" data-mini-bag-upsell-card data-product-id="' + escHtml(p.id) + '" data-variant-id="' + escHtml(variantId) + '" role="listitem">' +
        '<div class="product-card group relative flex flex-col bg-surface-tertiary no-underline h-full w-full" data-product-card' + trackAttr + ' data-product-id="' + escHtml(p.id) + '" data-product-url="' + escHtml(href) + '" data-product-handle="' + escHtml(p.handle) + '">' +
        '<a href="' + escHtml(href) + '" class="absolute inset-0 z-0" aria-label="' + title + '"></a>' +
        '<div class="relative z-10 pointer-events-none aspect-square overflow-hidden shrink-0 border-b border-border-secondary">' + hImg + fImg + '</div>' +
        '<div class="relative z-10 pointer-events-none flex flex-col gap-8 pl-12 pr-16 pt-16 flex-1 md:flex-row md:flex-wrap md:items-center md:gap-x-12 md:gap-y-8">' +
        '<p class="text-b2 text-primary line-clamp-2 order-1 md:order-1 md:flex-1 md:min-w-0">' + title + '</p>' +
        ratHtml +
        '</div>' +
        '<div class="group/cta relative z-10 isolate flex items-center gap-24 mt-24 border-t border-border-secondary px-12 py-16 transition-colours data-[add-state=adding]:opacity-75 md:mt-32 md:hover:bg-surface-secondary-blue" data-mini-bag-cta>' +
        '<button type="button" class="absolute inset-0 z-0 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-not-allowed" data-mini-bag-add-product data-variant-id="' + escHtml(variantId) + '" aria-label="' + title + '"' + (avail ? '' : ' disabled aria-disabled="true"') + '></button>' +
        '<div class="relative z-10 flex items-center gap-4 flex-1 min-w-0 text-b3 uppercase text-secondary md:group-hover/cta:text-invert pointer-events-none">' + priceHtml + '</div>' +
        '<div class="relative z-10 flex items-center gap-4 shrink-0 text-primary pointer-events-none opacity-100 transition-fade group-data-[add-state=added]/cta:hidden md:opacity-0 md:group-hover:opacity-100 md:group-hover/cta:text-invert" aria-hidden="true">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="relative bottom-px" aria-hidden="true" focusable="false"><path d="M12.001 2.90039C14.0699 2.90039 15.7606 4.4273 15.7607 6.33398V7.21289H16.5713C17.4373 7.21289 18.1912 7.79452 18.3232 8.5918L20.0791 19.1924C20.2465 20.2006 19.3812 21.0996 18.291 21.0996H5.70801C4.61789 21.0994 3.75436 20.2003 3.9209 19.1924L5.67773 8.5918C5.80972 7.79477 6.56155 7.21311 7.42676 7.21289H8.2373V6.33398C8.23746 4.42715 9.93233 2.9005 12.001 2.90039ZM9.05469 9.67578L9.04785 9.75293C9.03176 9.82821 8.9908 9.89629 8.93359 9.94922V9.9502C8.85635 10.0206 8.75316 10.0585 8.64746 10.0586C8.54247 10.0586 8.43906 10.0218 8.36133 9.95117C8.28445 9.88106 8.23614 9.78276 8.2373 9.67578V7.97559H7.42676C6.97589 7.97577 6.60349 8.25381 6.50195 8.63184L6.48535 8.70898L4.72754 19.3096C4.63962 19.8454 5.08566 20.3377 5.70801 20.3379H18.292C18.9147 20.3379 19.3621 19.8453 19.2734 19.3096L17.5176 8.70898C17.448 8.2922 17.0537 7.97461 16.5732 7.97461H15.7627V9.67676C15.7626 9.78158 15.7159 9.87843 15.6387 9.94922L15.6396 9.9502C15.5815 10.0039 15.5079 10.038 15.4307 10.0518L15.3525 10.0586C15.136 10.0576 14.9442 9.89512 14.9453 9.67578V7.97461H9.05469V9.67578ZM12.001 3.66309C10.3555 3.66319 9.05476 4.85764 9.05469 6.33398V7.21289H14.9443V6.33398C14.9443 4.85749 13.6473 3.66309 12.001 3.66309Z" fill="currentColor" stroke="currentColor" stroke-width="0.2"/></svg>' +
        '</div>' +
        /* Confirmation twin — byte-for-byte the same contract as product-card.liquid's
           own [data-mini-bag-added-label] block (icon-check-bolder at 16px, label at
           every breakpoint, no md:opacity-0 hover pair, role="status" and no
           aria-hidden). Both card paths have to carry it: this Tagalys-injected clone
           is the production path whenever a recommendation id is set, and the Liquid
           card is the upsells_collection fallback. */
        '<div class="relative z-10 hidden items-center gap-4 shrink-0 text-primary pointer-events-none group-data-[add-state=added]/cta:flex md:group-hover/cta:text-invert" data-mini-bag-added-label role="status">' +
        '<span class="text-b3 uppercase leading-none whitespace-nowrap">' + escHtml(addedLabel) + '</span>' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12" fill="none" class="relative bottom-px shrink-0" aria-hidden="true" focusable="false"><path d="M9.82417 3.61414C9.92235 3.51851 10.0806 3.51935 10.1777 3.61607C10.2747 3.71283 10.2739 3.86881 10.1757 3.96446L4.6103 9.38486C4.51294 9.47965 4.35661 9.47963 4.25923 9.38486L1.82417 7.01344C1.72603 6.91778 1.72518 6.7618 1.82222 6.66504C1.91928 6.56832 2.07755 6.56749 2.17573 6.66311L4.43452 8.86322L9.82417 3.61414Z" fill="currentColor" stroke="currentColor" stroke-width="0.65" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';
    }

    // Shared by both the populated (cart-anchored) and empty-bag fetch paths —
    // fills every given container's own track with the same product list.
    function renderUpsellCardsInto(containers, products) {
      containers.forEach(function (container) {
        var track = container.querySelector('[data-mini-bag-upsells-track]');
        if (!track) return;
        var cardClass = track.getAttribute('data-mini-bag-upsell-card-class') || '';
        var addedLabel = container.getAttribute('data-i18n-added') || 'Added';
        var fromPriceFmt = container.getAttribute('data-i18n-from-price') || 'From __PRICE__';
        var ratingLabel = container.getAttribute('data-i18n-rating') || 'Rated __RATING__ out of 5';
        var currency = container.getAttribute('data-currency') || '';
        var rootUrl = container.getAttribute('data-root-url') || '';
        track.innerHTML = products.slice(0, 12).map(function (p) {
          return upsellCardHtml(p, addedLabel, fromPriceFmt, cardClass, currency, rootUrl);
        }).join('');
        // container is the stable [data-mini-bag-upsells] mount — only
        // track's innerHTML above gets replaced on each re-render, matching
        // the stable-ancestor/volatile-children shape
        // window.TagalysRatingHydration expects.
        if (window.TagalysRatingHydration) window.TagalysRatingHydration.hydrate(products, container, ratingLabel);
      });
    }

    window.MiniBag.renderUpsellCardsInto = renderUpsellCardsInto;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-recommendations-script"] && !Shopify.designMode) return;
  try {
    (function () {
    window.MiniBag = window.MiniBag || {};

    if (window.MiniBag.recommendationsScriptLoaded) return;

    window.MiniBag.recommendationsScriptLoaded = true;

    var MiniBag = window.MiniBag;

    // An empty bag shows NO recommendations, on any breakpoint — the desktop aside stays
    // shut and both mobile rows stay hidden. `[data-mini-bag-items]` carrying `hidden` is
    // the same empty-bag signal setEmptyState uses, so this needs no cart fetch and is
    // correct the instant the class flips, with no page refresh.
    function isBagEmpty() {
      var itemsEl = document.querySelector('[data-mini-bag-items]');
      return Boolean(itemsEl && itemsEl.classList.contains('hidden'));
    }
    MiniBag.isBagEmpty = isBagEmpty;

    function recommendationsPanelHasContent(recommendationsPanel) {
      if (isBagEmpty()) return false;
      var relevant = recommendationsPanel.querySelector('[data-mini-bag-panel-populated]');
      if (!relevant || !relevant.querySelector('[data-mini-bag-upsells]')) return false;
      // Two different switches hide this element and BOTH have to be read.
      // setUpsellsVisibility (below) hides a channel with an inline display, but
      // setRecommendationsPanelEmptyState (mini-bag-cart-script.liquid) hides it with the
      // `hidden` class. Reading only the inline style meant a channel the class had
      // already hidden still reported as content.
      if (relevant.classList.contains('hidden')) return false;
      return relevant.style.display !== 'none';
    }

    function syncRecommendationsPanel() {
      var drawer = document.getElementById('mini-bag');

      if (!drawer) return;

      var drawerPanel = drawer.querySelector('[data-drawer-panel]');
      var recommendationsPanel = drawer.querySelector('[data-mini-bag-recommendations-panel]');

      if (!drawerPanel || !recommendationsPanel) return;

      recommendationsPanel.style.setProperty(
        '--mini-bag-drawer-width',
        drawerPanel.getBoundingClientRect().width + 'px'
      );

      var isDesktop = window.innerWidth >= 1024;
      var isOpen = drawer.getAttribute('aria-hidden') !== 'true' && !drawer.hasAttribute('inert');
      // recommendationsPanelHasContent supersedes main's simpler empty-cart guard (merge conflict).
      var shouldOpen = Boolean(isDesktop && isOpen && recommendationsPanelHasContent(recommendationsPanel));

      recommendationsPanel.setAttribute('data-open', shouldOpen ? 'true' : 'false');

      if (shouldOpen) {
        recommendationsPanel.removeAttribute('aria-hidden');
        recommendationsPanel.removeAttribute('inert');
      } else {
        recommendationsPanel.setAttribute('aria-hidden', 'true');
        recommendationsPanel.setAttribute('inert', '');
      }
    }

    function observeDrawerForRecommendations() {
      var drawer = document.getElementById('mini-bag');

      if (!drawer || drawer.__miniBagRecommendationsObserved || !window.MutationObserver) return;

      drawer.__miniBagRecommendationsObserved = true;

      new MutationObserver(syncRecommendationsPanel).observe(drawer, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'inert', 'class'],
      });
    }

    document.addEventListener('drawer:close', function (event) {
      if (!event.detail || event.detail.id !== 'mini-bag') return;

      syncRecommendationsPanel();
    });

    window.addEventListener('resize', syncRecommendationsPanel, { passive: true });

    MiniBag.syncRecommendationsPanel = syncRecommendationsPanel;
    MiniBag.observeDrawerForRecommendations = observeDrawerForRecommendations;

    observeDrawerForRecommendations();
    syncRecommendationsPanel();

    /* ── Tagalys-driven upsells ──────────────────────────────────────────────
       mini-bag-upsells.liquid renders an EMPTY [data-mini-bag-upsells-track]
       (no upsells_collection products) whenever a merchant sets a Tagalys
       recommendation ID, exactly like product-carousel.liquid's own
       Tagalys-fallback tabs — this fills it in, cart-anchored, via the shared
       window.TagalysRecommendations.fetch (assets/tagalys-recommendations.js),
       reusing product-card.liquid's current `quick_action: 'add_to_cart'`
       markup (data-mini-bag-add-product is already a document-level delegated
       handler in mini-bag-cart-script.liquid, so it needs no wiring here). ── */

    // Card markup (upsellCardHtml, the Tagalys format helpers and the bundle-price
    // lookup) lives in snippets/mini-bag-recommendations-card-script.liquid. Resolved at
    // call time, not parse time: it is only needed inside Tagalys's async onProducts
    // callback, by which point both blocks of the compiled bundle have run. If it is
    // somehow missing, the channel stays hidden rather than throwing.
    function renderUpsellCardsInto(containers, products) {
      if (typeof MiniBag.renderUpsellCardsInto !== 'function') return false;
      MiniBag.renderUpsellCardsInto(containers, products);
      return true;
    }

    var upsellsLastAnchorKey = null;
    var upsellsFetchInFlight = false;
    var upsellsPendingProductIds = null;

    // If an add-to-cart (or any cart change) asks for a new anchor while the
    // previous fetch is still in flight (e.g. the page-load fetch is still
    // waiting on the Tagalys SDK/network round-trip when the shopper clicks
    // Add to bag), the superseding request would otherwise be silently
    // dropped — upsellsLastAnchorKey only gets set by the in-flight request's
    // OWN anchor, so the product that was actually just added would never
    // get fetched at all. Remember it and run it once the current one settles.
    function runPendingUpsellsFetch() {
      if (upsellsPendingProductIds === null) return;
      var next = upsellsPendingProductIds;
      upsellsPendingProductIds = null;
      fetchAndRenderUpsells(next);
    }

    // Anchor recommendations on the MAX_ANCHOR_PRODUCTS most recently added distinct
    // products, not the whole cart — Shopify appends new line items to the end of
    // cart.items, so the tail of the array is the most recent adds (a quantity-only
    // change on an existing line doesn't move it). Used only as a fallback when no
    // explicit add event fired (initial page load, quantity/subscription changes,
    // bundle adds with no single "the product").
    var MAX_ANCHOR_PRODUCTS = 3; // Tagalys's Recommendations connector supports up to 3 anchor products.

    function latestProductIds(cart, max) {
      var items = (cart && cart.items) || [];
      var ids = [];
      for (var i = items.length - 1; i >= 0 && ids.length < max; i--) {
        var id = String(items[i].product_id);
        if (ids.indexOf(id) === -1) ids.push(id);
      }
      return ids;
    }

    // cart.items order is an observed convention, not a documented Shopify
    // contract, and it only exists in memory for the page load that actually
    // ran the add — navigate to a new page and it's gone, leaving only the
    // order-based fallback (which can genuinely diverge from what was really
    // last added). Persist the real adds, most-recent-first, across page loads
    // in sessionStorage so every subsequent load prefers them over the
    // order-based guess, as long as each product is still actually in the cart.
    var LAST_ADDED_KEY = 'mini_bag_last_added_product_ids';

    function readLastAddedProductIds() {
      try {
        var raw = window.sessionStorage.getItem(LAST_ADDED_KEY);
        var parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed.map(String) : [];
      } catch (e) { return []; }
    }

    function pushLastAddedProductId(id) {
      var ids = readLastAddedProductIds().filter(function (existing) { return existing !== String(id); });
      ids.unshift(String(id));
      try { window.sessionStorage.setItem(LAST_ADDED_KEY, JSON.stringify(ids.slice(0, MAX_ANCHOR_PRODUCTS))); } catch (e) {}
    }

    function preferredAnchorProductIds(cart, freshProductId) {
      var items = (cart && cart.items) || [];
      var ids = [];
      if (freshProductId) ids.push(String(freshProductId));
      readLastAddedProductIds().forEach(function (id) {
        if (ids.indexOf(id) !== -1) return;
        if (items.some(function (item) { return String(item.product_id) === id; })) ids.push(id);
      });
      latestProductIds(cart, MAX_ANCHOR_PRODUCTS).forEach(function (id) {
        if (ids.indexOf(id) === -1) ids.push(id);
      });
      return ids.slice(0, MAX_ANCHOR_PRODUCTS);
    }

    function upsellWrapperOf(container) {
      return container.closest('[data-mini-bag-panel-populated], [data-mini-bag-panel-empty]') ||
        container.closest('[data-mini-bag-recommendations-panel]') ||
        container.closest('[data-mini-bag-upsells-mobile]') ||
        container;
    }

    // Hides the whole channel instance (not just its inner track) whenever it has
    // no in-stock recommendations, instead of showing an empty "You Might Also
    // Like" shell. Takes an explicit container list so the populated and
    // empty-bag channels (fetchAndRenderUpsells / fetchAndRenderEmptyUpsells)
    // only ever touch their own containers, never each other's. The desktop
    // panel's own open/close slide is a separate concern, fully owned by
    // syncRecommendationsPanel (data-open + the CSS transform transition,
    // recomputed via recommendationsPanelHasContent) — this just needs a plain
    // display toggle on each channel's own wrapper.
    function setUpsellsVisibility(containers, visible) {
      containers.forEach(function (container) {
        upsellWrapperOf(container).style.display = visible ? '' : 'none';
      });
    }

    function fetchAndRenderUpsells(productIds) {
      var containers = Array.prototype.slice.call(document.querySelectorAll('[data-mini-bag-upsells][data-tagalys-recommendation-id]:not([data-mini-bag-upsells-empty])'));
      if (!containers.length || !window.TagalysRecommendations) return;

      var first = containers[0];
      var recId = first.getAttribute('data-tagalys-recommendation-id');
      if (!recId) return;

      // Nothing to anchor to (empty cart) — stays hidden, avoiding a guaranteed
      // 400 on a cold anchor-required id; the empty-bag channel covers this state.
      if (!productIds.length) { setUpsellsVisibility(containers, false); return; }

      // Skip a refetch when the cart's distinct product set hasn't actually
      // changed (e.g. a quantity-only +/- on an item already in the anchor set).
      var anchorKey = recId + '|' + productIds.slice().sort().join(',');
      var firstTrack = first.querySelector('[data-mini-bag-upsells-track]');
      if (anchorKey === upsellsLastAnchorKey && firstTrack && firstTrack.children.length) {
        // Same anchor as the last SUCCESSFUL fetch — but upsellsLastAnchorKey
        // is never updated on empty/error, so if this same product was removed
        // and a different (or empty) anchor failed/emptied out in between, the
        // panel would still be hidden from that even though this key matches.
        // The rendered track content for this key is still valid (nothing but
        // a successful fetch ever overwrites it), so just re-show it rather
        // than silently doing nothing. Guarded on the track's own children
        // count too — this assumes applySection (mini-bag-cart-script.liquid)
        // never replaces the track's container out from under it; if that
        // selector list ever widens, an empty track falls through to a real
        // refetch below instead of re-showing an empty shell.
        setUpsellsVisibility(containers, true);
        window.requestAnimationFrame(function () {
          MiniBag.syncRecommendationsPanel && MiniBag.syncRecommendationsPanel();
        });
        return;
      }
      if (upsellsFetchInFlight) { upsellsPendingProductIds = productIds; return; }
      upsellsFetchInFlight = true;

      window.TagalysRecommendations.fetch({
        recommendationId: recId,
        productIds: productIds,
        count: 12,
        token: first.getAttribute('data-tagalys-token') || '',
        domain: first.getAttribute('data-tagalys-domain') || '',
        sdkUrl: first.getAttribute('data-tagalys-sdk-url') || '',
        onProducts: function (products) {
          // Stays "in flight" through the bundle correction too — otherwise a
          // new request landing mid-correction would skip the queue (since
          // this one already looks finished) and could race it, letting a
          // stale render win over a fresher one.
          window.TagalysRecommendations.correctAvailability(products, first, function (corrected) {
            upsellsFetchInFlight = false;
            var inStock = corrected.filter(function (p) { return p.available !== false; });
            if (!inStock.length) { setUpsellsVisibility(containers, false); runPendingUpsellsFetch(); return; }
            if (!renderUpsellCardsInto(containers, inStock)) { setUpsellsVisibility(containers, false); runPendingUpsellsFetch(); return; }
            upsellsLastAnchorKey = anchorKey;
            setUpsellsVisibility(containers, true);
            // Deferred, not called synchronously: gives the browser a paint tick
            // between the track's content landing and syncRecommendationsPanel
            // recomputing data-open (recommendationsPanelHasContent reads the
            // display style just set above) — calling it synchronously risks the
            // CSS transform transition collapsing to a pop instead of a slide.
            window.requestAnimationFrame(function () {
              MiniBag.syncRecommendationsPanel && MiniBag.syncRecommendationsPanel();
            });
            runPendingUpsellsFetch();
          });
        },
        onEmpty: function () { upsellsFetchInFlight = false; setUpsellsVisibility(containers, false); runPendingUpsellsFetch(); },
        onError: function () { upsellsFetchInFlight = false; setUpsellsVisibility(containers, false); runPendingUpsellsFetch(); }
      });
    }

    // ── Empty-bag channel — a second, independent recommendation source ──────
    // Always the merchant's dedicated "empty bag" Tagalys ID, never the
    // populated-bag collection/ID above and never cart-anchored (there's
    // nothing in the bag to anchor to). Fetched once — its content doesn't
    // depend on cart state, only WHETHER it's the currently-relevant channel
    // does, and that's handled entirely by the data-mini-bag-panel-empty /
    // empty-instance data-mini-bag-upsells-mobile hidden-class toggling, driven
    // by cart.item_count (sections/mini-bag.liquid + setEmptyState). No anchor
    // key, in-flight queue, or refetch-on-cart-change needed, unlike the
    // populated channel above — a store-wide feed has nothing to re-anchor to.
    var emptyUpsellsFetchStarted = false;

    function fetchAndRenderEmptyUpsells() {
      if (emptyUpsellsFetchStarted) return;
      var containers = Array.prototype.slice.call(document.querySelectorAll('[data-mini-bag-upsells][data-tagalys-recommendation-id][data-mini-bag-upsells-empty]'));
      if (!containers.length || !window.TagalysRecommendations) return;

      var first = containers[0];
      var recId = first.getAttribute('data-tagalys-recommendation-id');
      if (!recId) return;
      // Set only once every guard above has passed — set any earlier and a
      // missing recId would permanently block every future call (the guard
      // at the top of this function), even though this call never actually
      // fetched anything.
      emptyUpsellsFetchStarted = true;

      window.TagalysRecommendations.fetch({
        recommendationId: recId,
        productIds: [],
        count: 12,
        token: first.getAttribute('data-tagalys-token') || '',
        domain: first.getAttribute('data-tagalys-domain') || '',
        sdkUrl: first.getAttribute('data-tagalys-sdk-url') || '',
        onProducts: function (products) {
          window.TagalysRecommendations.correctAvailability(products, first, function (corrected) {
            var inStock = corrected.filter(function (p) { return p.available !== false; });
            if (!inStock.length) { setUpsellsVisibility(containers, false); return; }
            if (!renderUpsellCardsInto(containers, inStock)) { setUpsellsVisibility(containers, false); return; }
            setUpsellsVisibility(containers, true);
            window.requestAnimationFrame(function () {
              MiniBag.syncRecommendationsPanel && MiniBag.syncRecommendationsPanel();
            });
          });
        },
        onEmpty: function () { setUpsellsVisibility(containers, false); },
        onError: function () { setUpsellsVisibility(containers, false); }
      });
    }

    // Re-asserts empty-channel visibility without re-fetching. Currently UNUSED: an empty
    // bag shows no recommendations, so mini-bag-cart-script.liquid no longer calls this
    // and fetchAndRenderEmptyUpsells is never invoked. Retained, with its export, so
    // reinstating the empty-bag panel is a one-line change.
    function showEmptyUpsellsIfReady() {
      var containers = Array.prototype.slice.call(document.querySelectorAll('[data-mini-bag-upsells][data-tagalys-recommendation-id][data-mini-bag-upsells-empty]'));
      var withContent = containers.filter(function (c) {
        var track = c.querySelector('[data-mini-bag-upsells-track]');
        return track && track.children.length;
      });
      if (withContent.length) setUpsellsVisibility(withContent, true);
    }
    MiniBag.showEmptyUpsellsIfReady = showEmptyUpsellsIfReady;

    function refreshUpsellsFromCart(cart) {
      if (!document.querySelector('[data-mini-bag-upsells][data-tagalys-recommendation-id]:not([data-mini-bag-upsells-empty])')) return;
      fetchAndRenderUpsells(preferredAnchorProductIds(cart));
    }

    // Line-item removal is deferred (a 4s undo window before the real
    // /cart/change.js call), so waiting on cart:updated would leave the
    // recommendation stale for that whole window. Recompute the anchor
    // instantly from the DOM instead — excludeKey lets a remove click ignore
    // the item mid-removal; call with no argument (e.g. on undo) to recompute
    // from the current DOM as-is.
    function nextAnchorProductIds(excludeKey) {
      var items = Array.prototype.slice.call(document.querySelectorAll('[data-mini-bag-item]'));
      if (excludeKey) {
        items = items.filter(function (el) { return el.getAttribute('data-mini-bag-item') !== excludeKey; });
      }
      /* Every OTHER line inside an open undo window has to go too, not just the one this
         call is about. A removed line stays in the DOM for the full 3.5s, so with two
         removals in flight the second call would filter out its own key and then happily
         anchor on the first one — surfacing "You Might Also Like" for a product the
         shopper deleted seconds earlier, in a bag that is about to be empty. Reads the
         cart script's own pending map so there is a single source of truth for what is
         mid-removal. */
      var pending = (window.MiniBag && window.MiniBag.pendingRemovals) || {};
      items = items.filter(function (el) {
        var itemKey = el.getAttribute('data-mini-bag-item');
        return !(itemKey && pending[itemKey]);
      });
      if (!items.length) return [];

      var presentIds = items.map(function (el) { return el.getAttribute('data-product-id'); }).filter(Boolean);

      // DOM order is only a same-page proxy for "newest added" — prefer the
      // tracked genuinely-last-added products (same source of truth the add
      // flow uses), for any still among the current items, so e.g. Undo
      // restores recs for the real newest adds rather than whichever items
      // happen to render last.
      var ids = readLastAddedProductIds().filter(function (id) { return presentIds.indexOf(id) !== -1; });

      for (var i = items.length - 1; i >= 0 && ids.length < MAX_ANCHOR_PRODUCTS; i--) {
        var pid = items[i].getAttribute('data-product-id');
        if (pid && ids.indexOf(pid) === -1) ids.push(pid);
      }
      return ids.slice(0, MAX_ANCHOR_PRODUCTS);
    }

    MiniBag.refreshUpsellsNow = function (excludeKey) {
      // Deliberately does not touch the persisted "last added" tracking — a
      // remove click here is still just a reversible preview (the real
      // /cart/change.js call is 4s away, or never happens if Undo is
      // clicked), so this must never overwrite what the confirmed cart
      // actually thinks is newest. Undo relies on that value being left
      // exactly as it was to correctly restore it.
      if (!document.querySelector('[data-mini-bag-upsells][data-tagalys-recommendation-id]:not([data-mini-bag-upsells-empty])')) return;
      fetchAndRenderUpsells(nextAnchorProductIds(excludeKey));
    };

    document.addEventListener('cart:updated', function (event) {
      // An add-to-bag click from within this same (populated) upsells UI
      // shouldn't cause its own recommendation list to refetch and replace
      // itself out from under the shopper — only cart changes from elsewhere
      // (line-item qty, PDP add, etc.) should refresh the anchor. An add from
      // the EMPTY-bag channel is exempt from this guard: it's the bag's first
      // item, so the populated channel (still on its stale/empty page-load
      // fetch) needs to actually anchor and render for the first time, not be
      // skipped as if it were refreshing itself.
      if (event.detail && event.detail.fromUpsellAdd && !event.detail.fromEmptyUpsells) return;
      var cart = event.detail && event.detail.cart;
      if (!cart) return;
      if (!document.querySelector('[data-mini-bag-upsells][data-tagalys-recommendation-id]:not([data-mini-bag-upsells-empty])')) return;
      // Prefer the product id the add-to-cart call itself just added — cart.items
      // order isn't a documented Shopify contract, only an observed convention, so
      // an explicit id from the mutation response is more reliable when the
      // caller has one (PDP add, mini-bag's own add-to-bag). Persisted (most-recent-
      // first, capped at MAX_ANCHOR_PRODUCTS) so it survives a page navigation, not
      // just this one in-memory event, and so the up-to-3-product anchor stays
      // ordered newest-add-first rather than falling back to cart.items order alone.
      // Falls back to the LIVE cart's own most recent items for callers that don't
      // have an explicit id (quantity/subscription changes, bundle adds) — NOT
      // preferredAnchorProductIds' persisted-across-page-loads guess: that's stale by
      // definition next to a cart:updated event that just told us the current cart
      // state directly, and preferring it here let an old add (mini-bag or empty-bag)
      // silently outrank an actual newer add whose dispatcher doesn't send
      // addedProductId (a PDP add, e.g.), leaving recs anchored on the wrong, older
      // product.
      var addedProductId = event.detail && event.detail.addedProductId;
      if (addedProductId) {
        pushLastAddedProductId(addedProductId);
        fetchAndRenderUpsells(preferredAnchorProductIds(cart, addedProductId));
      } else {
        fetchAndRenderUpsells(latestProductIds(cart, MAX_ANCHOR_PRODUCTS));
      }
    });

    // Hidden until each channel's first fetch resolves, so neither ever flashes
    // empty before we know whether it actually has recommendations.
    setUpsellsVisibility(Array.prototype.slice.call(document.querySelectorAll('[data-mini-bag-upsells][data-tagalys-recommendation-id]:not([data-mini-bag-upsells-empty])')), false);
    setUpsellsVisibility(Array.prototype.slice.call(document.querySelectorAll('[data-mini-bag-upsells][data-tagalys-recommendation-id][data-mini-bag-upsells-empty]')), false);

    // Initial recommendations fetch (populated channel) — needs the current
    // cart contents once, so they're ready by the time the shopper opens the
    // drawer. Guard hoisted above the fetch (refreshUpsellsFromCart's own
    // check runs too late to skip the request) so a page with no populated-
    // channel container/Tagalys ID configured never fires the /cart.js call
    // at all.
    if (document.querySelector('[data-mini-bag-upsells][data-tagalys-recommendation-id]:not([data-mini-bag-upsells-empty])')) {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) refreshUpsellsFromCart(cart); })
        .catch(function () {});
    }

    // The empty-bag channel is deliberately NOT fetched: an empty bag now shows no
    // recommendations at all, so the request could only ever render into hidden markup.
    // fetchAndRenderEmptyUpsells is left in place, unreferenced, because reinstating the
    // empty-bag panel is a one-line change if that decision is reversed.
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-bag-ui-script"] && !Shopify.designMode) return;
  try {
    (function () {
    window.MiniBag = window.MiniBag || {};

    if (window.MiniBag.uiScriptLoaded) return;

    window.MiniBag.uiScriptLoaded = true;

    var MiniBag = window.MiniBag;

    function clearPromoTickers() {
      (MiniBag.promoIntervalIds || []).forEach(function (intervalId) {
        window.clearInterval(intervalId);
      });
      MiniBag.promoIntervalIds = [];
    }

    /* Long enough to outlast the CSS slide (--duration-a4, 0.3s) before the outgoing
       message is parked back below the box, ready for its next turn. A timeout rather than
       transitionend because transitionend never fires under prefers-reduced-motion, where
       the transition is 0ms — the park has to happen either way. */
    var PROMO_SLIDE_MS = 450;

    function initPromoTickers(root) {
      clearPromoTickers();
      (root || document).querySelectorAll('[data-mini-bag-promo-ticker]').forEach(function (ticker) {
        var messages = Array.prototype.slice.call(ticker.querySelectorAll('[data-mini-bag-promo-message]'));
        var interval = parseInt(ticker.getAttribute('data-mini-bag-promo-interval') || '3000', 10);
        var index = 0;

        if (messages.length <= 1) return;

        function advance() {
          var current = messages[index];

          index = (index + 1) % messages.length;

          var next = messages[index];

          /* 'outgoing' lifts the current message up and out; the incoming one goes
             straight from 'hidden' (parked below, no transition) to 'current', so the
             browser animates it up into the box. Together that is Figma's "pushed
             upwards" effect. */
          if (current) {
            current.setAttribute('data-promo-state', 'outgoing');
            window.setTimeout(function () {
              if (current.getAttribute('data-promo-state') === 'outgoing') {
                current.setAttribute('data-promo-state', 'hidden');
              }
            }, PROMO_SLIDE_MS);
          }

          if (next) {
            next.setAttribute('data-promo-state', 'current');
          }
        }

        function start() {
          stop();
          var intervalId = window.setInterval(advance, interval);
          ticker.__miniBagPromoIntervalId = intervalId;
          MiniBag.promoIntervalIds.push(intervalId);
        }

        function stop() {
          if (!ticker.__miniBagPromoIntervalId) return;
          window.clearInterval(ticker.__miniBagPromoIntervalId);
          ticker.__miniBagPromoIntervalId = null;
        }

        /* WCAG 2.2.2 (Pause, Stop, Hide) — auto-updating content needs a way to stop it.
           Bound once per element: initPromoTickers re-runs after every cart mutation, and
           only the interval should be rebuilt, not the listeners. */
        if (!ticker.__miniBagPromoBound) {
          ticker.__miniBagPromoBound = true;
          ticker.addEventListener('mouseenter', stop);
          ticker.addEventListener('mouseleave', start);
          ticker.addEventListener('focusin', stop);
          ticker.addEventListener('focusout', start);
        }

        start();
      });
    }

    /* Sample SELECTION (and the cart add/remove behind it) now lives in
       mini-bag-free-samples.liquid, next to the markup it drives, and still exports
       MiniBag.initSampleSelectors — so mini-bag-cart-script.liquid's refreshMiniBagModules
       call site is unchanged. Only the slider stays here. The old handler here was
       display-only single-select: it toggled data-selected/aria-pressed and never put
       anything in the cart, so a "selected" sample never reached checkout. */

    function initSampleSliders(root) {
      (root || document).querySelectorAll('[data-mini-bag-free-samples]').forEach(function (wrap) {
        if (wrap.__miniBagSampleSliderReady) return;

        wrap.__miniBagSampleSliderReady = true;

        var track = wrap.querySelector('[data-mini-bag-samples-track]');
        var prev = wrap.querySelector('[data-mini-bag-samples-prev]');
        var next = wrap.querySelector('[data-mini-bag-samples-next]');

        if (!track) return;

        function getScrollAmount() {
          var card = track.querySelector('[data-mini-bag-sample-card]');

          if (!card) return track.clientWidth;

          var cardRect = card.getBoundingClientRect();
          var styles = window.getComputedStyle(track);
          var gap = parseFloat(styles.columnGap || styles.gap) || 0;

          return cardRect.width + gap;
        }

        function setArrowDisabled(button, disabled) {
          if (!button) return;
          button.disabled = disabled;
          if (disabled) {
            button.setAttribute('aria-disabled', 'true');
          } else {
            button.removeAttribute('aria-disabled');
          }
        }

        function syncArrows() {
          var maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
          setArrowDisabled(prev, track.scrollLeft <= 1);
          setArrowDisabled(next, track.scrollLeft >= maxScrollLeft - 1);
        }

        if (prev) {
          prev.addEventListener('click', function () {
            track.scrollBy({
              left: getScrollAmount() * -1,
              behavior: 'smooth',
            });
          });
        }

        if (next) {
          next.addEventListener('click', function () {
            track.scrollBy({
              left: getScrollAmount(),
              behavior: 'smooth',
            });
          });
        }

        track.addEventListener('scroll', syncArrows, { passive: true });
        if (window.ResizeObserver) {
          wrap.__miniBagSampleResizeObserver = new ResizeObserver(syncArrows);
          wrap.__miniBagSampleResizeObserver.observe(track);
        } else {
          window.addEventListener('resize', syncArrows);
        }
        window.requestAnimationFrame(syncArrows);
      });
    }

    MiniBag.initPromoTickers = initPromoTickers;
    MiniBag.clearPromoTickers = clearPromoTickers;
    MiniBag.initSampleSliders = initSampleSliders;

    initPromoTickers(document);
    initSampleSliders(document);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-search-mobile-open"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    var MOBILE_MAX_WIDTH = 1023;
    var drawer       = document.getElementById('mini-search-drawer');
    var headerWrapper = document.querySelector('[data-header-primary-wrapper]');
    if (!drawer || !headerWrapper) return;

    function isMobile() {
      return window.innerWidth <= MOBILE_MAX_WIDTH;
    }

    function reset() {
      headerWrapper.style.gridTemplateRows = '';
      drawer.removeAttribute('data-mobile-step');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-open="mini-search-drawer"]') && isMobile()) {
        headerWrapper.style.gridTemplateRows = '0fr';
        setTimeout(function () {
          drawer.setAttribute('data-mobile-step', '2');
          setTimeout(function () { drawer.setAttribute('data-mobile-step', '3'); }, 200);
        }, 300);
        return;
      }
      var closer   = e.target.closest('[data-drawer-close]');
      var backdrop = e.target.hasAttribute('data-drawer-backdrop') ? e.target.closest('[data-drawer]') : null;
      if ((closer && closer.closest('[data-drawer]')) === drawer || backdrop === drawer) reset();
    });

    /* Capture — drawer.liquid's own Escape handler runs first and would otherwise close it before this check ran. */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hasAttribute('aria-hidden')) reset();
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-search-render"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function escHtml(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    /* AJAX-derived href/src values are HTML-escaped but that alone doesn't
       block a javascript: scheme — only allow a relative path or an https
       URL through, matching search-tagalys.liquid's own _imageTiles check. */
    function safeUrl(url) {
      url = String(url || '');
      return (/^https:\/\//.test(url) || /^\/(?!\/)/.test(url)) ? url : '';
    }

    var drawer = document.getElementById('mini-search-drawer');
    if (!drawer) return;
    var productsGrid  = drawer.querySelector('[data-mini-search-products-grid]');
    var suggestedWrap = drawer.querySelector('[data-mini-search-suggested]');
    var suggestedList = drawer.querySelector('[data-mini-search-suggested-list]');
    var panels = {
      categories: drawer.querySelector('[data-mini-search-panel="categories"]'),
      articles:   drawer.querySelector('[data-mini-search-panel="articles"]')
    };
    var tabButtons = Array.prototype.slice.call(drawer.querySelectorAll('[data-mini-search-tab]'));

    /* Lock each tab's minWidth to Math.max(regular, italic) so the hover:italic
       state can no longer resize the box (the hover twitch/flicker) — the same
       measure-then-lock as assets/product-carousel-engine.js's
       lockDesktopTabWidths(). Re-measured per search rather than once at init,
       because setTabCount() rewrites the count into the label: a width locked for
       "Products (3)" is wrong for "Products (12)". minWidth is cleared first so
       offsetWidth reads the natural width and not the previous lock, and fontStyle
       is forced both ways rather than trusting the class, since the active tab
       already carries `italic`. A tab still hidden measures 0 and is skipped; it
       locks on the next search that reveals it. Called from maybeFinish() in
       mini-search-tagalys.liquid, which owns the tabs' label/visibility state. */
    function lockTabWidths() {
      tabButtons.forEach(function (btn) {
        btn.style.minWidth = '';
        if (!btn.offsetWidth) return;
        btn.style.fontStyle = 'normal';
        var normal = btn.offsetWidth;
        btn.style.fontStyle = 'italic';
        var italic = btn.offsetWidth;
        btn.style.fontStyle = '';
        btn.style.minWidth = Math.max(normal, italic) + 'px';
      });
    }

    /* Single-sourced from mini-search-drawer.liquid's data-chip-class (button.liquid's 'chip' variant) — mini-search-tagalys.liquid's loadPopularSearches reads the same attribute, since static JS can't render that Liquid snippet at runtime. */
    var CHIP_CLASS = (suggestedList && suggestedList.getAttribute('data-chip-class')) ||
      'bg-surface-tertiary flex items-center justify-center px-8 py-4 rounded-xs shrink-0 text-b2 text-primary cursor-pointer border border-transparent transition-btn-primary hover:bg-surface-tile-hover hover:border-border-primary';

    /* Typed-match Suggested chips — dropping anything that's just the typed
       word itself (e.g. typing "tea" shouldn't offer a "tea" chip back), and
       highlighting the matched substring per Figma node 8948:110276: always
       15px/Regular(400) via text-b1 font-normal, vs the base 14px/light(300)
       via text-b2 font-light — both font-weight utilities compile after
       text-b1/text-b2 in theme.css, so they win the cascade without needing
       !important. */
    function renderSuggested(terms, queries, fallbackHTML) {
      if (!suggestedWrap || !suggestedList) return;
      var termLower = (terms || '').trim().toLowerCase();
      var filtered = (queries || []).filter(function (q) {
        var text = (q.text || '').trim();
        return text && text.toLowerCase() !== termLower;
      });
      /* No typed matches for this term: fall back to the default/generic chips
         (mini-search-tagalys.liquid's defaultSuggestedHTML, passed in) rather
         than hiding the section or leaving the PREVIOUS term's chips in place —
         Suggested stays visible for as long as a term is active, in both the
         populated and the no-results state. Hidden only when there are no
         default chips either, matching the blank-query branch. */
      if (!filtered.length) {
        suggestedList.innerHTML = fallbackHTML || '';
        suggestedWrap.classList.toggle('hidden', !fallbackHTML);
        return;
      }
      suggestedWrap.classList.remove('hidden');
      suggestedList.innerHTML = filtered.slice(0, 6).map(function (q) {
        var text = q.text || '';
        var html = escHtml(text);
        if (terms) {
          var idx = text.toLowerCase().indexOf(terms.toLowerCase());
          if (idx !== -1) {
            html = escHtml(text.slice(0, idx)) + '<span class="text-b1 font-normal">' + escHtml(text.slice(idx, idx + terms.length)) + '</span>' + escHtml(text.slice(idx + terms.length));
          }
        }
        /* The button is display:flex; mixed text+span children directly
           inside it each become their own anonymous flex item and lose the
           whitespace between them, so the whole label is wrapped in one
           inner span to keep it a single flex item with normal text flow. */
        return '<button type="button" class="' + CHIP_CLASS.replace('text-b2', 'text-b2 font-light') + '" data-mini-search-suggestion="' + escHtml(text) + '"><span>' + html + '</span></button>';
      }).join('');
    }

    /* Column count scales with how many categories match: ~7 items per column,
       up to 4 columns on desktop. Mobile caps at 2 regardless — the drawer is
       full-width there, but still too narrow for 3-4 short text columns. */
    var CATEGORY_ITEMS_PER_COLUMN     = 7;
    var CATEGORY_MAX_COLUMNS_DESKTOP  = 4;
    var CATEGORY_MAX_COLUMNS_MOBILE   = 2;
    /* Literal class names (not built via string concatenation) so Tailwind's
       build-time scanner picks them all up. */
    var GRID_COLS_MOBILE  = { 1: 'grid-cols-1', 2: 'grid-cols-2' };
    var GRID_COLS_DESKTOP = { 1: 'md:grid-cols-1', 2: 'md:grid-cols-2', 3: 'md:grid-cols-3', 4: 'md:grid-cols-4' };

    function renderCategories(collections) {
      var links = collections.map(function (c) {
        /* The caller (mini-search-tagalys.liquid) already maps the Tagalys
           collections section to a title/url pair, so c.url is always present
           today. The handle fallback stays as defensive belt-and-braces, not
           because another caller exists; safeUrl gates the scheme on either
           path. */
        var url = safeUrl(c.url || ('/collections/' + c.handle));
        return '<a href="' + escHtml(url) + '" class="text-b2 text-primary no-underline block cursor-pointer hover:opacity-75 transition-fade">' + escHtml(c.title) + '</a>';
      });

      if (links.length <= CATEGORY_ITEMS_PER_COLUMN) {
        panels.categories.innerHTML = '<div class="flex flex-col gap-16">' + links.join('') + '</div>';
        return;
      }

      /* Split top-to-bottom per column (first N items in column one, next N
         in column two, etc.) rather than interleaved — matches Figma's
         Categories (14) layout. Desktop column count drives the split;
         mobile just displays fewer of those same column groups per row. */
      var desktopCols = Math.min(CATEGORY_MAX_COLUMNS_DESKTOP, Math.ceil(links.length / CATEGORY_ITEMS_PER_COLUMN));
      var mobileCols  = Math.min(CATEGORY_MAX_COLUMNS_MOBILE, desktopCols);
      var perColumn   = Math.ceil(links.length / desktopCols);

      var columns = [];
      for (var i = 0; i < desktopCols; i++) {
        columns.push('<div class="flex flex-col gap-16">' + links.slice(i * perColumn, (i + 1) * perColumn).join('') + '</div>');
      }

      panels.categories.innerHTML =
        '<div class="grid ' + GRID_COLS_MOBILE[mobileCols] + ' ' + GRID_COLS_DESKTOP[desktopCols] + ' gap-x-4 gap-y-16 w-full">' +
          columns.join('') +
        '</div>';
    }

    var readMoreLabel = (panels.articles && panels.articles.getAttribute('data-i18n-read-more')) || 'Read more';
    var logoUrl = (panels.articles && panels.articles.getAttribute('data-logo-url')) || '';

    /* Same width-param pattern as collection-tagalys-card.liquid's
       _shopifySrcset — only appends the Shopify CDN transform to a real
       cdn.shopify.com URL, and uses & instead of ? if the URL already has a
       query string, so an existing ?v=... version param doesn't break. */
    function articleSrcset(src) {
      if (!src || !/cdn\.shopify\.com/.test(src)) return '';
      var sep = src.indexOf('?') >= 0 ? '&' : '?';
      return [103, 206].map(function (w) { return escHtml(src + sep + 'width=' + w) + ' ' + w + 'w'; }).join(', ');
    }

    function renderArticles(articles) {
      panels.articles.innerHTML = articles.map(function (a) {
        /* Thumbnail is a landscape 103x80 crop in Figma at 1024+, 93x72 below
           that — and the row's own vertical rhythm is py-20 at 1024+, py-16
           below. "Read more" only appears on hover (Figma's Default state has
           no such label). An article with no image gets the same-size tile
           with the Whittard brand mark centred inside it instead of the
           photo — Figma's Image=False variant (node 8948:xxxxxx). Explicit
           width/height + srcset reserve the right space (no CLS) and stop the
           request over-fetching full-res into a ~100px tile. */
        var imageUrl = safeUrl(a.image);
        var srcset = articleSrcset(imageUrl);
        var img = imageUrl
          ? '<img src="' + escHtml(imageUrl) + '" ' + (srcset ? 'srcset="' + srcset + '" sizes="103px" ' : '') + 'alt="" loading="lazy" width="103" height="80" class="w-93 h-72 md:w-103 md:h-80 object-cover shrink-0">'
          : '<span class="bg-surface-tertiary flex items-center justify-center w-93 h-72 md:w-103 md:h-80 shrink-0">' + (logoUrl ? '<img src="' + escHtml(logoUrl) + '" alt="" loading="lazy" class="w-50 h-auto">' : '') + '</span>';
        return '<a href="' + escHtml(safeUrl(a.url)) + '" class="group flex items-center gap-16 py-16 md:py-20 px-24 md:px-32 border-b border-dashed border-border-secondary no-underline text-primary w-full transition-colours hover:bg-surface-secondary-blue/3">' +
          '<span class="relative flex-1 min-w-0 transition-reveal-eb group-hover:-translate-y-11">' +
            '<span class="block text-b2">' + escHtml(a.title) + '</span>' +
            '<span class="absolute left-0 top-full mt-8 block text-f2 uppercase whitespace-nowrap opacity-0 translate-y-4 transition-reveal-eb group-hover:opacity-75 group-hover:translate-y-0">' + escHtml(readMoreLabel) + '</span>' +
          '</span>' + img + '</a>';
      }).join('');
    }

    var MAX_PRODUCTS = 12;
    var cardI18n = {
      fromPrice:  (productsGrid && productsGrid.getAttribute('data-i18n-from-price'))  || 'From __PRICE__',
      rating:     (productsGrid && productsGrid.getAttribute('data-i18n-rating'))      || 'Rated __RATING__ out of 5',
      quickView:  (productsGrid && productsGrid.getAttribute('data-i18n-quick-view'))  || 'Quick view',
      notify:     (productsGrid && productsGrid.getAttribute('data-i18n-notify'))      || 'Notify',
      currency:   (productsGrid && productsGrid.getAttribute('data-currency'))         || '',
      rootUrl:    (productsGrid && productsGrid.getAttribute('data-root-url'))         || ''
    };

    /* target defaults to the Products-tab grid so every existing caller is
       unchanged; the mini-search Trending slot passes its own container
       (TASK-47920, SP2). cardI18n stays module-scope and is deliberately still
       read from the Products grid — both grids show the same card strings, so
       there is nothing to duplicate. */
    function renderProducts(products, target) {
      var grid = target || productsGrid;
      if (!grid) return;
      grid.innerHTML = '';
      var shown = products.slice(0, MAX_PRODUCTS);
      shown.forEach(function (p, i) {
        if (typeof window.TagalysCard === 'function') {
          grid.insertAdjacentHTML('beforeend', window.TagalysCard(p, i < 4, cardI18n));
        }
      });
      if (window.TagalysBadgeHydration) window.TagalysBadgeHydration.hydrate(shown, productsGrid);
      if (window.TagalysRatingHydration) window.TagalysRatingHydration.hydrate(shown, productsGrid, cardI18n.rating);
      if (window.TagalysBundleAvailability) window.TagalysBundleAvailability.correct(shown, 'mini-search-products-grid');
    }

    window.MiniSearchRender = {
      renderCategories: renderCategories,
      renderArticles: renderArticles,
      renderProducts: renderProducts,
      renderSuggested: renderSuggested,
      lockTabWidths: lockTabWidths
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-search-tagalys-connectors"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.MiniSearchTagalysConnectors = function (options) {
      options = options || {};

      /* Delegates to the shared window.ensureTagalysSdk loader (assets/tagalys-sdk-loader.js,
         global in layout/theme.liquid) — same mechanism the search-results PLP uses, so the
         SDK is never loaded twice regardless of which surface triggers it first. */
      function ensureSdk(cb) {
        window.ensureTagalysSdk(options.sdkUrl, cb);
      }

      var configured = false;

      function applyConfiguration() {
        Tagalys.setConfiguration({
          api: { serverUrl: 'https://api-r4.tagalys.com' },
          currency: { fractionalDigits: 2, forceFractionalDigits: true },
          analyticsStorageConsentProvided: function () {
            return window.Shopify && window.Shopify.customerPrivacy
              ? window.Shopify.customerPrivacy.analyticsProcessingAllowed() : false;
          },
          track: true
        });
        /* countryCode is the customer's ACTIVE market — read from
           data-market-country (layout/theme.liquid, sourced from
           localization.country.iso_code), not window.Shopify.country: this
           theme never sets that global and it isn't part of Shopify's
           documented storefront JS API (TASK-47920). */
        var marketCountry = (document.body && document.body.getAttribute('data-market-country')) || 'GB';
        Tagalys.setPlatformConfiguration({
          storefrontAPI: { accessToken: options.token, myShopifyDomain: options.domain },
          countryCode: marketCountry,
          baseCountryCode: 'GB'
        });
      }

      function configure() {
        if (configured || !window.Tagalys) return;
        configured = true;
        applyConfiguration();
        if (window.TagalysConsent) window.TagalysConsent.onChange(applyConfiguration);
      }

      function fetchPopularSearches(count, onQueries) {
        ensureSdk(function () {
          configure();
          try {
            /* .PopularSearches isn't on the public SDK — SearchSuggestions' own getPopularSearches() reaches the same data. */
            var instance = Tagalys.APIConnector.SearchSuggestions.new({
              params: {},
              onSuccess: function () {},
              onFailure: function () {}
            });
            /* No AbortSignal support (same SDK limitation as Products search) — just flagged if it never resolves. */
            var timedOut = false;
            var timeoutId = setTimeout(function () {
              timedOut = true;
              console.error('[Mini Search] Tagalys getPopularSearches timed out');
            }, 8000);
            instance.helpers.getPopularSearches(count).then(function (queries) {
              clearTimeout(timeoutId);
              if (timedOut) return;
              onQueries(queries);
            }).catch(function (err) {
              clearTimeout(timeoutId);
              if (!timedOut) console.error('[Mini Search] Tagalys getPopularSearches failed', err);
            });
          } catch (err) {
            console.error('[Mini Search] Tagalys.APIConnector.SearchSuggestions.new() threw', err);
          }
        });
      }

      function searchProducts(opts) {
        configure();
        try {
          /* Tagalys client feedback, TASK-47920 SP3: typed product suggestions now
             come from the search-suggestions endpoint rather than the search-results
             one. sections names only the PREDEFINED products id — never an
             account-specific one — and MUST keep the include list, because the SDK
             shallow-merges this object over its own default and the caller reads the
             product total off the response section (this connector exposes no
             getTotalProductsCount helper). Constructed fresh per keystroke and driven
             by helpers.call(), NOT by the connector's own query-updating helper: that
             helper is wrapped in a debounce whose duration cannot be overridden (it
             reads arguments[1] with a falsy fallback to 500ms), which would stack on
             top of this drawer's own 300ms debounce. */
          /* Categories ride this same call (TASK-47920): the collections
             section id is predefined like products, and was confirmed live
             for this account. Its items pass through the SDK formatter
             untouched — only the products items are reformatted — so adding
             it changes nothing about the products half of the response. The
             FAILOVER construction below deliberately stays products-only:
             the Shopify-backed sibling builds its collection items from a
             mis-cased field and emits no handle, so requesting them there
             would render dead links. Do not add a section to it. */
          var params = {
            query: opts.term,
            sections: {
              products:    { include: ['total_count', 'items'], count: opts.perPage },
              collections: { count: opts.categoryCount }
            }
          };
          var instance = Tagalys.APIConnector.SearchSuggestions.new({
            params: params,
            failover: function () {
              return Tagalys.APIConnector.ShopifySearchSuggestions.new({
                params: { query: opts.term, sections: { products: { count: opts.perPage } } },
                onSuccess: opts.onSuccess,
                onFailure: opts.onFailure
              });
            },
            onSuccess: opts.onSuccess,
            onFailure: opts.onFailure
          });
          instance.helpers.call();
        } catch (err) {
          opts.onError(err);
        }
      }

      /* Smart Widget feed for the drawer's Trending slot (TASK-47920, SP2).
         Delegates to the shared hardened wrapper in assets/tagalys-recommendations.js
         — the same caller product-carousel-script.liquid and
         mini-bag-recommendations-script.liquid already use — so the 8s timeout, the
         anchor auto-detect and the console prefix all come for free. A Smart Widget
         requires no anchor product, so productIds is deliberately omitted: the
         wrapper learns anchored=false on the first attempt. Empty and error are
         both no-ops here; the caller simply leaves its container concealed. */
      function fetchRecommendations(recId, count, onProducts) {
        if (!recId || !window.TagalysRecommendations) return;
        window.TagalysRecommendations.fetch({
          recommendationId: recId,
          count: count,
          token:  options.token,
          domain: options.domain,
          sdkUrl: options.sdkUrl,
          onProducts: onProducts,
          onEmpty: function () {},
          onError: function () {}
        });
      }

      return {
        ensureSdk:            ensureSdk,
        configure:            configure,
        applyConfiguration:   applyConfiguration,
        fetchPopularSearches: fetchPopularSearches,
        searchProducts:       searchProducts,
        fetchRecommendations: fetchRecommendations
      };
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mini-search-tagalys"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function escHtml(s) {
      return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    var drawer        = document.getElementById('mini-search-drawer');
    if (!drawer) return;
    var input         = document.getElementById('mini-search-input');
    var clearBtn      = drawer.querySelector('[data-mini-search-clear]');
    var suggestedWrap = drawer.querySelector('[data-mini-search-suggested]');
    var suggestedList = drawer.querySelector('[data-mini-search-suggested-list]');
    var focusedBody    = drawer.querySelector('[data-mini-search-focused]');
    var resultsBody     = drawer.querySelector('[data-mini-search-results]');
    var tabsRow          = drawer.querySelector('[data-mini-search-tabs]');
    var productsGrid   = drawer.querySelector('[data-mini-search-products-grid]');
    var emptyState     = drawer.querySelector('[data-mini-search-empty]');
    var emptyText      = drawer.querySelector('[data-mini-search-empty-text]');
    var errorAnnouncer = drawer.querySelector('[data-mini-search-error]');
    var viewAllWrap    = drawer.querySelector('[data-mini-search-view-all]');
    var viewAllLink    = drawer.querySelector('[data-mini-search-view-all-link]');
    var viewAllText    = drawer.querySelector('[data-mini-search-view-all-text]');
    var drawerContent  = drawer.querySelector('[data-drawer-content]');
    var tabButtons     = Array.prototype.slice.call(drawer.querySelectorAll('[data-mini-search-tab]'));
    var panels         = {
      products:   drawer.querySelector('[data-mini-search-panel="products"]'),
      categories: drawer.querySelector('[data-mini-search-panel="categories"]'),
      articles:   drawer.querySelector('[data-mini-search-panel="articles"]')
    };
    /* Cache server-rendered chips so clearing restores them; loadPopularSearches() replaces this if unset. */
    var defaultSuggestedHTML  = suggestedList ? suggestedList.innerHTML : '';
    var hasSuggestedOverride  = !!(suggestedWrap && suggestedWrap.getAttribute('data-mini-search-suggested-override') === 'true');
    var popularSearchesLoaded = false;

    var MAX_PRODUCTS = 12;
    /* Categories ride the typed-suggestions request (see runSearch). 24 carries
       the previous client-side ceiling forward verbatim so the panel's maximum
       density is unchanged; the vendor default is 10 and the API may cap this,
       in which case fewer categories render identically (criterion L2). */
    var MAX_CATEGORIES = 24;
    /* Sources runSearch waits on before deciding the empty state: the typed
       suggestions call (products AND categories, one response) and the native
       predictive-search call (articles + suggested). Named so the two
       comparison sites inside maybeFinish cannot drift apart (L-CAT-1). */
    var RESULT_PATHS = 2;
    /* Single-sourced from mini-search-drawer.liquid's data-chip-class (button.liquid's 'chip' variant) — mini-search-render.liquid's renderSuggested reads the same attribute, since static JS can't render that snippet. */
    var CHIP_CLASS = (suggestedList && suggestedList.getAttribute('data-chip-class')) || 'bg-surface-tertiary flex items-center justify-center px-8 py-4 rounded-xs shrink-0 text-b2 text-primary cursor-pointer border border-transparent transition-btn-primary hover:bg-surface-tile-hover hover:border-border-primary';
    var i18n = {
      tabProducts:   (tabsRow && tabsRow.getAttribute('data-i18n-products'))     || 'Products (__COUNT__)',
      tabCategories: (tabsRow && tabsRow.getAttribute('data-i18n-categories'))   || 'Categories (__COUNT__)',
      tabArticles:   (tabsRow && tabsRow.getAttribute('data-i18n-articles'))     || 'Articles (__COUNT__)',
      viewAll:       (viewAllLink && viewAllLink.getAttribute('data-i18n-view-all')) || 'View all results (__COUNT__)',
      noResults:     (emptyState && emptyState.getAttribute('data-i18n-empty')) || 'No results found for __TERM__',
      searchError:   (errorAnnouncer && errorAnnouncer.getAttribute('data-i18n-error')) || 'Something went wrong loading search results. Please try again.'
    };
    var searchUrl = (viewAllLink && viewAllLink.getAttribute('data-search-url')) || '/search';

    /* Rendered by this file's own render call above, so the connectors bundle
       is always concatenated first — the same guarantee collection-tagalys.liquid
       relies on for window.TagalysUrlState. */
    var connectors = window.MiniSearchTagalysConnectors({
      sdkUrl: productsGrid && productsGrid.getAttribute('data-tagalys-sdk-url'),
      token:  productsGrid && productsGrid.getAttribute('data-tagalys-token'),
      domain: productsGrid && productsGrid.getAttribute('data-tagalys-domain')
    });

    /* View all is Products-only — track active tab + last count/term. */
    var activeTab         = 'products';
    var lastProductTotal  = 0;
    var lastTerm          = '';

    function updateViewAll() {
      if (activeTab === 'products' && lastProductTotal > 0) {
        viewAllWrap.classList.remove('hidden');
        viewAllLink.href = searchUrl + '?q=' + encodeURIComponent(lastTerm);
        viewAllText.textContent = i18n.viewAll.replace('__COUNT__', lastProductTotal);
      } else {
        viewAllWrap.classList.add('hidden');
      }
    }

    /* Reset the query + the body scroll position (so it reopens at the top) on close (button/backdrop/Escape), delayed 400ms (--duration-a7) so it happens once fully hidden. Scroll reset is deliberately local — drawer.liquid/assets/drawer.js are shared by ~18 consumers. */
    function resetQuery() {
      if (drawerContent) drawerContent.scrollTop = 0;
      if (!input || !input.value) return;
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var resetQueryTimer = null;
    function resetQueryAfterClose() { clearTimeout(resetQueryTimer); resetQueryTimer = setTimeout(resetQuery, 400); }

    function warmMiniSearch() {
      connectors.ensureSdk(function () {});
      loadPopularSearches();
      loadTrendingRecommendations();
    }
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('[data-drawer-open="mini-search-drawer"]')) warmMiniSearch();
    });
    document.addEventListener('focusin', function (e) {
      if (e.target.closest('[data-drawer-open="mini-search-drawer"]')) warmMiniSearch();
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-open="mini-search-drawer"]')) {
        clearTimeout(resetQueryTimer); /* cancel a pending reset from a quick close+reopen */
        warmMiniSearch();
        /* Focus is handled by drawer.liquid's own data-drawer-initial-focus mechanism
           (mini-search-drawer.liquid passes initial_focus_selector: '#mini-search-input'),
           synchronously on open — not here. A deferred setTimeout-based focus() used to
           live in this handler; on iOS Safari a focus() call outside the synchronous
           gesture that triggered it never raises the keyboard, which is exactly what a
           setTimeout callback is (TASK-52632). */
      }
    });

    var drawerCloseBtn = drawer.querySelector('[data-drawer-close]');
    if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', resetQueryAfterClose);
    var drawerBackdrop = drawer.querySelector('[data-drawer-backdrop]');
    if (drawerBackdrop) drawerBackdrop.addEventListener('click', resetQueryAfterClose);
    /* Capture, not bubble — drawer.liquid's own Escape handler runs first and would otherwise close it first. */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hasAttribute('aria-hidden')) resetQueryAfterClose();
    }, true);


    var TRENDING_COUNT_MD   = 6;
    var TRENDING_COUNT_BASE = 4;
    var trendingMq       = window.matchMedia('(min-width: 1024px)');
    var trendingBlock    = drawer.querySelector('[data-mini-search-trending-block]');
    var trendingGrid     = drawer.querySelector('[data-mini-search-trending-grid]');
    var trendingLoaded   = false;
    var trendingProducts = null;

    function renderTrending() {
      if (!trendingProducts || !trendingProducts.length) return;
      var count = trendingMq.matches ? TRENDING_COUNT_MD : TRENDING_COUNT_BASE;
      window.MiniSearchRender.renderProducts(trendingProducts.slice(0, count), trendingGrid);
      trendingBlock.classList.remove('hidden');
    }

    function loadTrendingRecommendations() {
      if (trendingLoaded || !trendingBlock || !trendingGrid) return;
      trendingLoaded = true;
      connectors.fetchRecommendations(
        trendingGrid.getAttribute('data-tagalys-recommendation-id'),
        TRENDING_COUNT_MD,
        function (products) {
          trendingProducts = products;
          renderTrending();
        }
      );
    }

    if (trendingBlock && trendingGrid) {
      if (typeof trendingMq.addEventListener === 'function') {
        trendingMq.addEventListener('change', renderTrending);
      } else if (typeof trendingMq.addListener === 'function') {
        trendingMq.addListener(renderTrending);
      }
    }

    /* Suggested chips before any query — real Tagalys analytics terms, skipped when the merchant's override blocks exist. */
    function loadPopularSearches() {
      if (popularSearchesLoaded || hasSuggestedOverride || !suggestedList || !suggestedWrap) return;
      popularSearchesLoaded = true;
      connectors.fetchPopularSearches(6, function (queries) {
        if (!queries || !queries.length) {
          /* Not a failure — no search-analytics history yet; configure "Search suggestion" blocks as a manual override meanwhile. */
          console.info('[Mini Search] Tagalys getPopularSearches resolved with 0 terms.');
          return;
        }
        defaultSuggestedHTML = queries.map(function (q) {
          var text = typeof q === 'string' ? q : (q.query || q.text || '');
          if (!text) return '';
          return '<button type="button" class="' + CHIP_CLASS + '" data-mini-search-suggestion="' + escHtml(text) + '">' + escHtml(text) + '</button>';
        }).join('');
        if (input && !input.value.trim()) { /* only apply if not typing yet */
          suggestedList.innerHTML = defaultSuggestedHTML;
          suggestedWrap.classList.remove('hidden');
        }
      });
    }

    /* renderSuggested() (typed-match chips) lives in mini-search-render.liquid too, called via window.MiniSearchRender. */
    function setTabCount(key, count) {
      var btn = tabButtons.filter(function (b) { return b.getAttribute('data-mini-search-tab') === key; })[0];
      if (!btn) return;
      var fmt = i18n['tab' + key.charAt(0).toUpperCase() + key.slice(1)];
      btn.textContent = fmt.replace('__COUNT__', count);
    }

    function showTab(key) {
      activeTab = key;
      tabButtons.forEach(function (b) {
        var active = b.getAttribute('data-mini-search-tab') === key;
        b.setAttribute('aria-selected', active ? 'true' : 'false');
        b.classList.toggle('italic', active);
        b.classList.toggle('opacity-100', active);
        b.classList.toggle('not-italic', !active);
        b.classList.toggle('opacity-75', !active);
        /* Products loads active:true server-side, skipping these hover classes — add them once inactive. */
        b.classList.toggle('hover:italic', !active);
        b.classList.toggle('hover:opacity-100', !active);
      });
      Object.keys(panels).forEach(function (k) {
        panels[k].classList.toggle('hidden', k !== key);
        panels[k].classList.toggle('flex', k === key);
      });
      var shown = panels[key];
      if (shown) {
        /* Remove+reflow+re-add replays the fade-in even on a repeat click of the already-active tab. */
        shown.classList.remove('mini-search-panel-in');
        void shown.offsetWidth;
        shown.classList.add('mini-search-panel-in');
      }
      updateViewAll();
    }

    tabsRow.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mini-search-tab]');
      if (btn) showTab(btn.getAttribute('data-mini-search-tab'));
    });

    /* Arrow-key roving (APG tabs pattern), only among currently visible tabs. */
    tabsRow.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var current = e.target.closest('[data-mini-search-tab]');
      if (!current) return;
      var visible = tabButtons.filter(function (b) { return !b.hasAttribute('hidden'); });
      var i = visible.indexOf(current);
      if (i === -1) return;
      var next = visible[(i + (e.key === 'ArrowRight' ? 1 : visible.length - 1)) % visible.length];
      e.preventDefault();
      next.focus();
      showTab(next.getAttribute('data-mini-search-tab'));
    });

    if (suggestedList) {
      suggestedList.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-mini-search-suggestion]');
        if (!chip || !input) return;
        input.value = chip.getAttribute('data-mini-search-suggestion');
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (!input) return;
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
    }

    var miniSearchForm = drawer.querySelector('[data-mini-search-form]');
    if (miniSearchForm) {
      /* Blank Enter would otherwise submit natively to /search?q= — not useful to land on from here. */
      miniSearchForm.addEventListener('submit', function (e) {
        if (!input || !input.value.trim()) e.preventDefault();
      });

      /* Bare search links (no query) have no design of their own — open the drawer in place instead of navigating there. */
      var searchUrlPath = miniSearchForm.getAttribute('action');
      document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href]');
        if (!link || link.pathname !== searchUrlPath || link.search) return;
        e.preventDefault();
        var trigger = document.querySelector('[data-drawer-open="mini-search-drawer"]');
        if (trigger) trigger.click();
      });
    }

    /* ── Search orchestration ── */

    var requestSeq   = 0;
    var debounceTimer;
    var activeController = null;

    function runSearch(term) {
      var seq = ++requestSeq;

      /* Cancel the previous keystroke's still-in-flight requests, not just their results. */
      if (activeController) activeController.abort();
      var controller = new AbortController();
      activeController = controller;
      var timedOut = false;
      var timeoutId = setTimeout(function () { timedOut = true; controller.abort(); }, 8000);
      if (errorAnnouncer) errorAnnouncer.textContent = '';

      var hasCategories = false, hasArticles = false, productTotal = 0;
      /* Gates the empty-state decision on both sources reporting, avoiding a "no results" flash while one is still in flight. */
      var pathsResolved = 0;

      /* seq mismatch or a non-timeout AbortError = superseded, silent; anything else is a genuine failure. */
      function handleFetchError(err, label) {
        if (seq !== requestSeq) return;
        if (err && err.name === 'AbortError' && !timedOut) return;
        console.error('[Mini Search] ' + label + ' failed', err);
        if (errorAnnouncer) errorAnnouncer.textContent = i18n.searchError;
      }

      function maybeFinish() {
        pathsResolved += 1;

        var hasProducts = productTotal > 0;
        tabButtons.forEach(function (b) {
          var key = b.getAttribute('data-mini-search-tab');
          var hasResults = key === 'products' ? hasProducts : (key === 'categories' ? hasCategories : hasArticles);
          b.toggleAttribute('hidden', !hasResults);
        });
        /* Decide the active tab only once every source has answered, so a faster tab can't win purely by resolving first; DOM order is already Products > Categories > Articles. */
        if (pathsResolved >= RESULT_PATHS) {
          /* Kills the hover:italic tab twitch (lockTabWidths() lives in
             mini-search-render.liquid). Called here: labels and hidden states are
             final, results body still visible, so each tab measures its true width. */
          window.MiniSearchRender.lockTabWidths();
          var firstVisible = tabButtons.filter(function (b) { return !b.hasAttribute('hidden'); })[0];
          if (firstVisible) showTab(firstVisible.getAttribute('data-mini-search-tab'));
        }
        lastProductTotal = productTotal;
        lastTerm = term;
        updateViewAll();

        if (pathsResolved < RESULT_PATHS) return;
        clearTimeout(timeoutId);

        /* Zero everything (Figma 8948:117573): hide tabs/panels, show "Sorry, no results...", re-show the Focused body as a fallback. */
        var totalEmpty = productTotal === 0 && !hasCategories && !hasArticles;
        resultsBody.classList.toggle('hidden', totalEmpty);
        focusedBody.classList.toggle('hidden', !totalEmpty);
        emptyState.classList.toggle('hidden', !totalEmpty);
        /* Suggested needs no handling here — renderSuggested() now owns its visibility for every term-active state, falling back to the default chips when a term has no typed matches (Figma 8948:117590 orders it message > Suggested > Popular/Help > Trending). */
        if (totalEmpty) emptyText.textContent = i18n.noResults.replace('__TERM__', term);
      }

      /* Products, capped at 12. The SDK has no AbortSignal support; the seq guard still stops a stale response from rendering. */
      connectors.ensureSdk(function () {
        if (seq !== requestSeq) return;
        connectors.searchProducts({
          term: term,
          perPage: MAX_PRODUCTS,
          categoryCount: MAX_CATEGORIES,
          onSuccess: function (response, helpers) {
            if (seq !== requestSeq) return;
            var products = helpers.getProducts() || [];
            var productsSection = (response && response.sections && response.sections.products) || {};
            productTotal = productsSection.total_count || products.length;
            window.MiniSearchRender.renderProducts(products);
            setTabCount('products', productTotal);
            try {
              var catSection = (response && response.sections && response.sections.collections) || {};
              var categories = (Array.isArray(catSection.items) ? catSection.items : []).map(function (c) {
                var url = c.handle ? '/collections/' + encodeURIComponent(c.handle) : '';
                return (url && c.title) ? { title: c.title, url: url } : null;
              }).filter(Boolean);
              hasCategories = categories.length > 0;
              window.MiniSearchRender.renderCategories(categories);
              setTabCount('categories', categories.length);
            } catch (err) { console.error('[Mini Search] renderCategories threw', err); }
            maybeFinish();
          },
          onFailure: function (r) {
            handleFetchError(new Error(JSON.stringify(r)), 'Tagalys search suggestions');
            maybeFinish();
          },
          onError: function (err) {
            handleFetchError(err, 'Tagalys search suggestions');
            maybeFinish();
          }
        });
      });

      /* Native predictive search — articles+pages (one Articles tab, Figma has no separate Pages tab) and suggested queries. Each render call has its own try/catch, since an unexpected shape thrown inside renderArticles previously aborted the whole .then() silently. */
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=article,page,query&resources[limit]=10', { signal: controller.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (seq !== requestSeq) return;
          var results = (data.resources && data.resources.results) || {};
          var articles = (results.articles || []).concat(results.pages || []);
          var queries  = results.queries || [];
          hasArticles  = articles.length > 0;
          try { window.MiniSearchRender.renderArticles(articles); } catch (err) { console.error('[Mini Search] renderArticles threw', err); }
          try { window.MiniSearchRender.renderSuggested(term, queries, defaultSuggestedHTML); } catch (err) { console.error('[Mini Search] renderSuggested threw', err); }
          setTabCount('articles', articles.length);
          maybeFinish();
        })
        .catch(function (err) {
          handleFetchError(err, 'Predictive search');
          maybeFinish();
        });
    }

    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearBtn.classList.toggle('hidden', !term);

        /* Unconditional, and BEFORE the blank-value branch: every keystroke cancels the previously scheduled search. Blank-branch returns used to skip this, so clearing the field mid-debounce still let the old term's results land afterwards. It is also what makes fast backspacing render no intermediate terms (each keystroke lands inside the 300ms window and supersedes the last) while slow, deliberate deletion still renders each step. */
        clearTimeout(debounceTimer);
        if (!term) {
          focusedBody.classList.remove('hidden');
          resultsBody.classList.add('hidden');
          if (suggestedWrap) suggestedWrap.classList.toggle('hidden', !defaultSuggestedHTML);
          if (suggestedList) suggestedList.innerHTML = defaultSuggestedHTML;
          lastProductTotal = 0;
          updateViewAll();
          emptyState.classList.add('hidden');
          requestSeq++;
          return;
        }

        focusedBody.classList.add('hidden');
        resultsBody.classList.remove('hidden');
        debounceTimer = setTimeout(function () { runSearch(term); }, 300);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plp-option-tooltips"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var _inited = false;
    var _canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    function _closeAll(except) {
      document.querySelectorAll('[data-option-tooltip-trigger][aria-expanded="true"]').forEach(function (t) {
        if (t !== except) t.setAttribute('aria-expanded', 'false');
      });
    }

    // Hover-capable pointers reveal the popover via pure CSS (:focus-within),
    // so aria-expanded never applies there and _closeAll() is a no-op on
    // desktop. Escape still needs to dismiss a focus-triggered popover (WCAG
    // 1.4.13) without also stripping keyboard focus from the trigger itself
    // (WCAG 2.4.3) — data-tooltip-dismissed suppresses the CSS reveal while
    // focus remains, and clears itself once the trigger blurs so the next
    // focus-in shows the popover again.
    function _dismissFocused() {
      var active = document.activeElement;
      var trig = active && active.closest && active.closest('[data-option-tooltip-trigger]');
      if (trig) trig.setAttribute('data-tooltip-dismissed', '');
    }

    document.addEventListener('focusout', function (e) {
      var trig = e.target.closest && e.target.closest('[data-option-tooltip-trigger]');
      if (trig) trig.removeAttribute('data-tooltip-dismissed');
    }, true);

    function _positionPopover(e) {
      var trig = e.target.closest && e.target.closest('[data-option-tooltip-trigger]');
      var popover = trig && trig.querySelector('[data-option-tooltip-popover]');
      var container = trig && trig.closest('[data-facets-container]');
      if (!popover || !container) return;

      var defaultLeft = trig.getBoundingClientRect().left + (trig.offsetWidth / 2) - (popover.offsetWidth / 2);
      var shift = (container.getBoundingClientRect().left + 8) - defaultLeft;
      var arrow = popover.querySelector('[data-option-tooltip-arrow]');

      popover.style.translate = shift > 0 ? 'calc(-50% + ' + shift + 'px) 0' : '';
      if (arrow) arrow.style.translate = shift > 0 ? (-shift) + 'px 0' : '';
    }

    document.addEventListener('mouseenter', _positionPopover, true);
    document.addEventListener('focusin', _positionPopover, true);

    function init() {
      if (_inited) return;
      _inited = true;

      /* The trigger sits inside the option's own <label> (for the checkbox
         it documents) — hover already shows it on desktop, so the click is
         always swallowed there (preventDefault + stopPropagation, so it
         still can't fall through and toggle the checkbox) but left inert:
         only a real hover-capable pointer is denied the aria-expanded toggle.
         Touch has no hover state, so this is what makes it tap-to-toggle
         there instead. */
      document.addEventListener('click', function (e) {
        var trig = e.target.closest('[data-option-tooltip-trigger]');
        if (trig) {
          e.preventDefault();
          e.stopPropagation();
          if (_canHover.matches) return;
          var wasOpen = trig.getAttribute('aria-expanded') === 'true';
          _closeAll(trig);
          trig.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
          return;
        }
        _closeAll();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        _closeAll();
        _dismissFocused();
      });
    }

    window.PlpOptionTooltips = { init: init };

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plp-scroll-helpers"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var _reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Animates container.scrollTop by hand (requestAnimationFrame + easing)
       rather than scrollIntoView/scrollTo's smooth behaviour — nested
       overflow-y:auto containers (the facets list inside the drawer's own
       scrollable body) are a known spot where WebKit silently drops a
       programmatic smooth scroll instead of painting it, so this guarantees
       the animation actually plays instead of trading correctness for
       polish. Skips straight to the end position under reduced motion. */
    function animateScrollTop(container, target) {
      var start = container.scrollTop;
      var change = target - start;
      if (!change) return;
      if (_reducedMotion.matches) { container.scrollTop = target; return; }

      // Reads --duration-a3 (0.3s) rather than hardcoding 300 so this stays in
      // sync with the token. No --ease-* token is used for the curve itself —
      // they're all cubic-bezier() for CSS transitions, and this symmetric
      // quad in/out doesn't map onto any of them; hand-rolling it here is
      // simpler than shipping a bezier evaluator to reuse one.
      var duration = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--duration-a3')) * 1000 || 300;
      var startTime = null;
      function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
      function step(now) {
        if (startTime === null) startTime = now;
        var progress = Math.min((now - startTime) / duration, 1);
        container.scrollTop = start + change * ease(progress);
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    /* Manually computes the scroll needed to bring `item` fully into view
       within its scrolling ancestor (mirrors scrollIntoView's block:'nearest'). */
    function scrollIntoViewIfNeeded(item) {
      var container = item.closest('[data-facets-container]');
      if (!container) return;
      var containerRect = container.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var itemTop = (itemRect.top - containerRect.top) + container.scrollTop;
      var itemBottom = itemTop + itemRect.height;
      var viewTop = container.scrollTop;
      var viewBottom = viewTop + container.clientHeight;

      var target = null;
      if (itemBottom > viewBottom) {
        target = itemBottom - container.clientHeight;
      } else if (itemTop < viewTop) {
        target = itemTop;
      }
      if (target === null) return;

      animateScrollTop(container, Math.max(0, Math.min(target, container.scrollHeight - container.clientHeight)));
    }

    window.PlpScrollHelpers = {
      animateScrollTop: animateScrollTop,
      scrollIntoViewIfNeeded: scrollIntoViewIfNeeded
    };

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["plp-ui"] && !Shopify.designMode) return;
  try {
    (function () {

    var BP_MD = 1024;
    var _MD   = window.matchMedia('(min-width: ' + BP_MD + 'px)');
    var _sortInited      = false;
    var _accordionInited = false;

    /* ── Sort popup (desktop) / drawer trigger (mobile) ─────────────────────── */

    function _anchorSort(trigger, panel) {
      var rect = trigger.getBoundingClientRect();
      panel.style.top   = (rect.bottom + 19) + 'px';
      panel.style.right = (window.innerWidth - rect.right - 12) + 'px';
      panel.style.left  = 'auto';
    }

    function _openSort(trigger, panel) {
      _anchorSort(trigger, panel);
      var bar = document.querySelector('[data-filter-bar]');
      var sticky = bar && bar.classList.contains('is-sticky');
      panel.style.backgroundColor = sticky
        ? 'var(--color-surface-tertiary)'
        : 'var(--color-surface-primary)';
      if (sticky) {
        panel.setAttribute('data-sort-sticky', '');
      } else {
        panel.removeAttribute('data-sort-sticky');
      }
      panel.classList.remove('opacity-0', 'pointer-events-none');
      panel.removeAttribute('inert');
      panel.removeAttribute('aria-hidden');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function _closeSort(trigger, panel) {
      panel.classList.add('opacity-0', 'pointer-events-none');
      panel.setAttribute('inert', '');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.backgroundColor = '';
      panel.removeAttribute('data-sort-sticky');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function _syncSortSticky(sticky) {
      var panel = document.querySelector('[data-sort-dropdown-desktop]');
      if (!panel || panel.classList.contains('opacity-0')) return;
      var trigger = document.querySelector('[data-sort-trigger]');
      panel.style.backgroundColor = sticky ? 'var(--color-surface-tertiary)' : 'var(--color-surface-primary)';
      if (sticky) {
        panel.setAttribute('data-sort-sticky', '');
      } else {
        panel.removeAttribute('data-sort-sticky');
      }
      if (trigger) _anchorSort(trigger, panel);
    }

    function _initSort() {
      if (_sortInited) return;
      _sortInited = true;
      var trigger = document.querySelector('[data-sort-trigger]');
      var panel   = document.querySelector('[data-sort-dropdown-desktop]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        if (trigger.getAttribute('aria-expanded') === 'true') {
          _closeSort(trigger, panel); return;
        }
        if (_MD.matches) {
          _openSort(trigger, panel);
        } else if (window.__drawerOpen) {
          window.__drawerOpen('sort-drawer', trigger);
        }
      });

      document.addEventListener('click', function (e) {
        if (trigger.getAttribute('aria-expanded') !== 'true') return;
        if (e.target.closest('[data-sort-option]')) { _closeSort(trigger, panel); return; }
        if (!panel.contains(e.target) && !trigger.contains(e.target)) _closeSort(trigger, panel);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
          _closeSort(trigger, panel);
          trigger.focus();
        }
      });

      var _anchorRaf = null;
      window.addEventListener('scroll', function () {
        if (trigger.getAttribute('aria-expanded') !== 'true') return;
        var bar = document.querySelector('[data-filter-bar]');
        if (bar && bar.classList.contains('is-sticky')) return;
        if (_anchorRaf) return;
        _anchorRaf = requestAnimationFrame(function () { _anchorRaf = null; _anchorSort(trigger, panel); });
      }, { passive: true });

      window.addEventListener('resize', function () {
        if (trigger.getAttribute('aria-expanded') === 'true') _anchorSort(trigger, panel);
      }, { passive: true });
    }

    /* ── Filter accordion ───────────────────────────────────────────────────── */

    function _openAccordion(item) {
      var wrapper = item.querySelector('[data-accordion-wrapper]');
      var trigger = item.querySelector('[data-accordion-trigger]');
      if (!wrapper || !trigger) return;
      wrapper.style.gridTemplateRows = '1fr';
      wrapper.removeAttribute('inert');
      trigger.setAttribute('aria-expanded', 'true');

      /* Scroll once the grid-rows expand (transition-grid-rows-eb) has actually
         finished, so the scroll target accounts for the panel's final height,
         not its mid-transition one. transitionend is the real signal; the
         timeout is a fallback for reduced-motion (no transition fires) or if
         the event is otherwise missed. */
      var scrolled = false;
      function scrollNow() {
        if (scrolled) return;
        scrolled = true;
        wrapper.removeEventListener('transitionend', onTransitionEnd);
        /* Only needed for the collapse animation (clips content while the
           grid row is mid-transition between 0fr and 1fr) — once fully open,
           it has to come off or anything that pops outside the panel's own
           box (e.g. a facet-option tooltip) gets clipped at that boundary. */
        var clip = item.querySelector('[data-accordion-clip]');
        if (clip) clip.style.overflow = 'visible';
        window.PlpScrollHelpers.scrollIntoViewIfNeeded(item);
      }
      function onTransitionEnd(e) {
        if (e.target === wrapper && e.propertyName === 'grid-template-rows') scrollNow();
      }
      wrapper.addEventListener('transitionend', onTransitionEnd);
      setTimeout(scrollNow, 350);
    }

    function _closeAccordion(item) {
      var wrapper = item.querySelector('[data-accordion-wrapper]');
      var trigger = item.querySelector('[data-accordion-trigger]');
      if (!wrapper || !trigger) return;
      /* Reinstate the clip before collapsing so the close animation doesn't
         let content spill out while the grid row shrinks back to 0fr. */
      var clip = item.querySelector('[data-accordion-clip]');
      if (clip) clip.style.overflow = '';
      wrapper.style.gridTemplateRows = '';
      wrapper.setAttribute('inert', '');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function _initAccordion() {
      if (_accordionInited) return;
      _accordionInited = true;
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-accordion-trigger]');
        var drawer = t && t.closest('#filters-drawer');
        if (!t || !drawer) return;
        var item = t.closest('[data-accordion-item]');
        if (!item) return;
        if (t.getAttribute('aria-expanded') === 'true') { _closeAccordion(item); return; }
        drawer.querySelectorAll('[data-accordion-item]').forEach(function (other) {
          if (other !== item) _closeAccordion(other);
        });
        _openAccordion(item);
      });

      var drawer = document.getElementById('filters-drawer');
      if (!drawer || !window.MutationObserver) return;
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'aria-hidden' && drawer.getAttribute('aria-hidden') === 'true') {
            drawer.querySelectorAll('[data-accordion-item]').forEach(_closeAccordion);
          }
        });
      }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    /* ── Sticky filter-bar shadow ───────────────────────────────────────────── */

    function _initStickyBar() {
      var bar = document.querySelector('[data-filter-bar]');
      if (!bar || bar.hasAttribute('data-filter-bar-static') || !window.IntersectionObserver) return;

      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none';
      bar.parentNode.insertBefore(sentinel, bar);

      var placeholder = document.createElement('div');
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.style.cssText = 'display:none;pointer-events:none';
      bar.parentNode.insertBefore(placeholder, bar);

      function _computeTop() {
        var header = document.getElementById('site-header');
        var offset = window.innerWidth >= BP_MD ? 12 : 8;
        if (!header || header.style.transform) return offset + 'px';
        return (offset + header.offsetHeight - 1) + 'px';
      }

      var _topRaf = null;
      var _trackEnd = 0;
      var _trackRaf = null;

      function _trackSort() {
        _syncSortSticky(bar.classList.contains('is-sticky'));
        if (performance.now() < _trackEnd) {
          _trackRaf = requestAnimationFrame(_trackSort);
        } else {
          _trackRaf = null;
        }
      }

      function _scheduleTrack() {
        _trackEnd = performance.now() + 350;
        if (!_trackRaf) _trackRaf = requestAnimationFrame(_trackSort);
      }

      function _syncHeaderShadow() {
        var header = document.getElementById('site-header');
        if (!header) return;
        var filterSticky = bar.classList.contains('is-sticky');
        var headerVisible = filterSticky && !header.style.transform;
        if (headerVisible) {
          header.setAttribute('data-filter-below', '');
        } else {
          header.removeAttribute('data-filter-below');
        }
      }

      window.addEventListener('scroll', function () {
        if (!bar.classList.contains('is-sticky')) return;
        if (_topRaf) return;
        _topRaf = requestAnimationFrame(function () {
          _topRaf = null;
          var newTop = _computeTop();
          var changed = bar.style.top !== newTop;
          bar.style.top = newTop;
          _syncSortSticky(true);
          _syncHeaderShadow();
          if (changed) _scheduleTrack();
        });
      }, { passive: true });

      new IntersectionObserver(function (entries) {
        var stuck = !entries[0].isIntersecting;
        if (stuck) {
          placeholder.style.height = bar.offsetHeight + 'px';
          placeholder.style.display = '';
          bar.style.top = _computeTop();
          bar.classList.add('is-sticky', 'filter-bar--stuck');
        } else {
          bar.classList.remove('is-sticky', 'filter-bar--stuck');
          bar.style.top = '';
          placeholder.style.display = 'none';
        }
        requestAnimationFrame(function () {
          _syncSortSticky(stuck);
          _syncHeaderShadow();
          if (stuck) _scheduleTrack();
        });
      }, { threshold: 1 }).observe(sentinel);

      window.addEventListener('resize', function () {
        if (bar.classList.contains('is-sticky')) {
          bar.style.top = _computeTop();
          placeholder.style.height = bar.offsetHeight + 'px';
        }
      }, { passive: true });
    }

    /* ── Quick-filter link → scroll + open accordion ───────────────────────── */

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter-trigger]');
      if (!btn) return;
      var key = btn.getAttribute('data-filter-trigger');
      if (!key || key === 'all') return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var item = document.querySelector('[data-accordion-item][data-filter-key="' + key + '"]');
          if (!item) return;
          var t = item.querySelector('[data-accordion-trigger]');
          if (t && t.getAttribute('aria-expanded') !== 'true') {
            t.click();
          } else {
            window.PlpScrollHelpers.scrollIntoViewIfNeeded(item);
          }
        });
      });
    });

    /* ── Scroll-position preservation ──────────────────────────────────────── */

    function _initScrollPreservation() {
      var KEY = 'plp-scroll-' + window.location.pathname;
      var saved = sessionStorage.getItem(KEY);
      if (saved) {
        sessionStorage.removeItem(KEY);
        requestAnimationFrame(function () { window.scrollTo(0, parseInt(saved, 10)); });
      }
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-product-grid] a')) {
          sessionStorage.setItem(KEY, String(window.scrollY || window.pageYOffset));
        }
      });
    }

    /* ── Promo-card background pin ──────────────────────────────────────────── */

    function _initPromoPin() {
      function _measure() {
        document.querySelectorAll('[data-promo-card]').forEach(function (card) {
          var media = card.querySelector('[data-promo-media]');
          if (!media) return;
          media.classList.remove('is-pinned');
          var rect = card.getBoundingClientRect();
          media.style.setProperty('--pin-left',   rect.left   + 'px');
          media.style.setProperty('--pin-width',  rect.width  + 'px');
          media.style.setProperty('--pin-height', rect.height + 'px');
        });
      }

      function _update() {
        document.querySelectorAll('[data-promo-card]').forEach(function (card) {
          var media = card.querySelector('[data-promo-media]');
          if (!media) return;
          var rect = card.getBoundingClientRect();
          media.classList.toggle('is-pinned', rect.top <= 0 && rect.bottom > 0);
        });
      }

      _measure();
      _update();

      var _rafId = null;
      window.addEventListener('scroll', function () {
        if (_rafId) return;
        _rafId = requestAnimationFrame(function () { _rafId = null; _update(); });
      }, { passive: true });

      window.addEventListener('resize', function () { _measure(); _update(); }, { passive: true });

      // drawer.liquid locks body scroll (removes the scrollbar) for the whole
      // time the filters drawer is open — checking a filter while it's open
      // re-renders the grid and re-measures while that lock is still active,
      // caching a --pin-left based on a wider, scrollbar-less viewport. Once
      // the drawer closes and the scrollbar returns, that cached value is off
      // by the scrollbar's width — re-measure on its close event to correct it.
      document.addEventListener('drawer:close', function () { _measure(); _update(); });

      var _grid = document.querySelector('.tagalys-grid-init');
      if (_grid && window.MutationObserver) {
        // Debounced, not immediate: a filter/sort change clears the grid and
        // re-inserts results as separate mutations, not one atomic swap —
        // measuring on the first (e.g. the clear, or a partial insert) cached
        // a transient mid-render rect, which then played out as the promo
        // background jumping on the next scroll. Waiting for mutations to
        // settle measures the final, real layout instead.
        var _mutationTimer = null;
        new MutationObserver(function () {
          clearTimeout(_mutationTimer);
          _mutationTimer = setTimeout(function () { _measure(); _update(); }, 100);
        }).observe(_grid, { childList: true });
      }
    }

    /* ── Load-more fallback (before Tagalys sets data-tagalys-ready) ─────────── */

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-load-more]');
      if (!btn || btn.dataset.loading) return;
      var wrap = document.querySelector('.tagalys-grid-init');
      if (wrap && wrap.hasAttribute('data-tagalys-ready')) return;
      var grid = document.querySelector('[data-product-grid]');
      if (!grid) return;
      var url = btn.getAttribute('data-next-url');
      if (!url) return;
      e.preventDefault();
      var _label = btn.textContent.trim();
      btn.dataset.loading = 'true';
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('aria-label', _label);
      btn.innerHTML = '<span data-load-dots aria-hidden="true"><span></span><span></span><span></span></span>';
      btn.style.pointerEvents = 'none';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-product-grid]');
          if (newGrid) {
            Array.prototype.forEach.call(newGrid.children, function (child) {
              if (!child.hasAttribute('data-promo-slot')) grid.appendChild(child);
            });
          }
          var counter = document.querySelector('[data-viewed-of]');
          if (counter) {
            var fmt = counter.getAttribute('data-format') || '';
            counter.textContent = fmt.replace('__VIEWED__', grid.querySelectorAll('[data-product-card]').length);
          }
          var next = doc.querySelector('[data-load-more]');
          if (next) {
            btn.setAttribute('data-next-url', next.getAttribute('data-next-url') || '');
            btn.textContent = next.textContent.trim();
            delete btn.dataset.loading;
            btn.removeAttribute('aria-busy');
            btn.removeAttribute('aria-label');
            btn.style.pointerEvents = '';
          } else {
            btn.remove();
          }
        })
        .catch(function () {
          delete btn.dataset.loading;
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('aria-label');
          btn.textContent = _label;
          btn.style.pointerEvents = '';
        });
    });

    /* ── Subcategory pill drag-scroll (mouse + touch) ───────────────────────── */

    function _initSubcatDrag() {
      var el = document.querySelector('[data-plp-subcats-mobile]');
      if (!el) return;
      var startX = 0, scrollLeft = 0, active = false;
      el.addEventListener('scroll', function () {
        el.toggleAttribute('data-scrolled', el.scrollLeft > 0);
      }, { passive: true });
      el.addEventListener('pointerdown', function (e) {
        /* Mouse only. setPointerCapture on a touch pointer makes this element
           the exclusive target for the whole gesture, which suppresses iOS
           Safari's native horizontal scroll (and its momentum) entirely — the
           pills became unswipeable on iOS. Touch/pen fall through untouched so
           overflow-x-auto handles them natively. */
        if (e.pointerType !== 'mouse') return;
        active = true;
        startX = e.clientX;
        scrollLeft = el.scrollLeft;
        el.setPointerCapture(e.pointerId);
        el.style.cursor = 'grabbing';
      });
      el.addEventListener('pointermove', function (e) {
        if (!active) return;
        el.scrollLeft = scrollLeft - (e.clientX - startX);
      }, { passive: true });
      function _end() { active = false; el.style.cursor = ''; }
      el.addEventListener('pointerup', _end);
      el.addEventListener('pointercancel', _end);
    }

    /* PlpFilters now lives in collection-tagalys-api.liquid, rendered after this
       file in both sections/collection.liquid and sections/search.liquid — a
       second window.PlpFilters definition here would silently win (later script
       wins the plain assignment) and shadow that file's handling with a stale
       copy, exactly the bug this comment replaces. */

    /* ── Bootstrap ──────────────────────────────────────────────────────────── */

    function _main() {
      _initSort();
      _initAccordion();
      window.PlpOptionTooltips.init();
      _initStickyBar();
      _initScrollPreservation();
      _initPromoPin();
      _initSubcatDrag();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', _main);
    } else {
      _main();
    }

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-antavo-points-collapse"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function normaliseText(value) {
      return String(value || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function getVariantData(wrap) {
      var section = wrap.closest('section');

      if (!section) return [];

      var dataEl = section.querySelector('[data-variant-data]');

      if (!dataEl) return [];

      try {
        var variants = JSON.parse(dataEl.textContent);

        return Array.isArray(variants) ? variants : [];
      } catch (error) {
        return [];
      }
    }

    function getInitialVariant(wrap) {
      var section = wrap.closest('section');

      if (!section) return null;

      var variants = getVariantData(wrap);

      if (!variants.length) return null;

      /*
       * Prefer the current product form variant.
       *
       * This is server-rendered using Shopify's
       * selected_or_first_available_variant, so it
       * is more reliable than assuming variants[0].
       */
      var variantInput = section.querySelector('[data-product-form] [data-variant-id]');

      /*
       * The gift-card PDP presents two product
       * forms on one page and deliberately carries
       * no [data-product-form] wrapper: that
       * attribute is what admits a section into
       * sections/product.liquid's single-form
       * controller, which must never run against
       * the tab layout.
       *
       * Fall back to the panel the server rendered
       * exposed, which is the product the URL
       * resolved to and therefore the one Antavo's
       * app block is bound to.
       */
      if (!variantInput) {
        variantInput = section.querySelector(
          '[data-gift-card-tab-panel]:not([aria-hidden]) [data-gift-card-variant-id]'
        );
      }

      var variantId = variantInput ? variantInput.value || variantInput.getAttribute('value') : '';

      /*
       * A ?variant= URL should win where present.
       */
      var requestedVariantId = new URLSearchParams(window.location.search).get('variant');

      if (requestedVariantId) {
        variantId = requestedVariantId;
      }

      if (variantId) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) {
            return variants[i];
          }
        }
      }

      return variants[0];
    }

    function extractPoints(text) {
      var value = String(text || '');

      /*
       * Prefer a number immediately associated
       * with "point/points".
       */
      var pointsMatch = value.match(/([\d,]+)\s*points?/i);

      if (pointsMatch) {
        return pointsMatch[1].replace(/,/g, '');
      }

      /*
       * Antavo's table cell can contain only
       * the numeric points value.
       */
      var numberMatch = value.match(/[\d,]+/);

      return numberMatch ? numberMatch[0].replace(/,/g, '') : null;
    }

    function renderLine(wrap, points) {
      var line = wrap.querySelector('[data-antavo-single-line]');

      var template = wrap.getAttribute('data-single-line-template');

      if (!line || !template || points == null) {
        return false;
      }

      line.textContent = template.replace('__POINTS__', points);

      line.style.removeProperty('display');

      return true;
    }

    function rewriteSingleVariant(wrap, singleVariant) {
      if (!singleVariant) return;
      var points = extractPoints(singleVariant.textContent);
      if (points == null) return;
      var template = wrap.getAttribute('data-single-line-template');
      if (!template) return;
      var nextText = template.replace('__POINTS__', points);
      /*
       * Important:
       * This element is observed for text mutations.
       * Writing the same text back would trigger our own
       * MutationObserver again and can create a loop.
       */
      if (singleVariant.textContent.trim() === nextText.trim()) {
        return;
      }
      singleVariant.textContent = nextText;
    }

    function findVariantRow(rows, variant) {
      if (!variant) return null;

      var expectedTitle = normaliseText(variant.option_summary);

      var expectedPrice = normaliseText(variant.price);

      var rowData = Array.prototype.map.call(rows, function (row) {
        var cells = row.querySelectorAll('td');

        return {
          row: row,

          title: cells[0] ? normaliseText(cells[0].textContent) : '',

          price: cells[1] ? normaliseText(cells[1].textContent) : '',

          points: cells[2] ? extractPoints(cells[2].textContent) : null,
        };
      });

      /*
       * Best match:
       *
       * Shopify option_summary + formatted price.
       *
       * Example:
       *
       * 125g / 4.4oz / Beans
       * £6.50
       */
      var exactMatches = rowData.filter(function (item) {
        return item.title === expectedTitle && item.price === expectedPrice;
      });

      if (exactMatches.length === 1) {
        return exactMatches[0];
      }

      /*
       * Price formatting may occasionally differ
       * between Antavo and the theme.
       *
       * The variant option summary is therefore
       * our second match.
       */
      var titleMatches = rowData.filter(function (item) {
        return item.title === expectedTitle;
      });

      if (titleMatches.length === 1) {
        return titleMatches[0];
      }

      /*
       * Fallback for widgets whose variant title
       * differs from Shopify's title.
       *
       * Only use price when exactly one Antavo row
       * has that price.
       */
      var priceMatches = rowData.filter(function (item) {
        return item.price === expectedPrice;
      });

      if (priceMatches.length === 1) {
        return priceMatches[0];
      }

      return null;
    }

    function collapseTable(wrap, tableWrap, variant) {
      if (!tableWrap || !variant) {
        return;
      }

      var table = tableWrap.querySelector('.product_points_table');

      if (!table) return;

      var rows = table.querySelectorAll('tbody tr');

      if (!rows.length) return;

      var match = findVariantRow(rows, variant);

      /*
       * Fail safely.
       *
       * If Antavo's markup changes and we cannot
       * identify the selected variant, keep their
       * native table rather than showing the wrong
       * points.
       */
      if (!match || match.points == null) {
        var line = wrap.querySelector('[data-antavo-single-line]');
        if (line) {
          line.style.display = 'none';
        }
        tableWrap.style.removeProperty('display');
        return;
      }

      if (!renderLine(wrap, match.points)) {
        return;
      }

      /*
       * Antavo's CSS is unlayered and can beat
       * theme utilities, so use inline !important.
       */
      tableWrap.style.setProperty('display', 'none', 'important');
    }

    function watchSingleVariant(wrap, singleVariant) {
      if (!singleVariant) return;

      rewriteSingleVariant(wrap, singleVariant);

      if (!window.MutationObserver) {
        return;
      }

      new MutationObserver(function () {
        rewriteSingleVariant(wrap, singleVariant);
      }).observe(singleVariant, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    function watchTable(wrap, tableWrap) {
      if (!tableWrap) return;

      wrap.__antavoSelectedVariant = getInitialVariant(wrap);

      collapseTable(wrap, tableWrap, wrap.__antavoSelectedVariant);

      if (!window.MutationObserver) {
        return;
      }

      /*
       * Antavo can insert/update table content
       * asynchronously without changing the
       * wrapper's class.
       *
       * Watch the actual subtree as well as
       * Antavo's reveal class.
       */
      new MutationObserver(function () {
        collapseTable(wrap, tableWrap, wrap.__antavoSelectedVariant);
      }).observe(tableWrap, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    function initialise(wrap) {
      if (wrap.__antavoPointsCollapseInitialised) {
        return;
      }
      wrap.__antavoPointsCollapseInitialised = true;
      var singleVariant = wrap.querySelector('.single-variant');
      var tableWrap = wrap.querySelector('.product-points-table-wrapper');
      if (singleVariant) {
        watchSingleVariant(wrap, singleVariant);
      }
      if (tableWrap) {
        watchTable(wrap, tableWrap);
      }
    }

    document.querySelectorAll('[data-antavo-points-wrap]').forEach(initialise);

    /*
     * sections/product.liquid already dispatches
     * this event every time the PDP variant
     * selection changes.
     *
     * Use the actual selected variant object rather
     * than trying to infer it again from price.
     */
    document.addEventListener('variant:changed', function (event) {
      var section = event.target;

      if (!section || !section.querySelectorAll) {
        return;
      }

      var variant = event.detail && event.detail.variant;

      /*
       * An incomplete option selection can
       * temporarily produce variant === null.
       *
       * Keep the last valid loyalty value until
       * Shopify resolves a real variant rather
       * than showing an incorrect table/value.
       */
      if (!variant) return;

      section.querySelectorAll('[data-antavo-points-wrap]').forEach(function (wrap) {
        var tableWrap = wrap.querySelector('.product-points-table-wrapper');

        if (!tableWrap) {
          return;
        }

        wrap.__antavoSelectedVariant = variant;

        collapseTable(wrap, tableWrap, variant);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-antavo-points-guest"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var ENDPOINT = '/apps/whittard-loyalty/cart-summary';

    /*
     * The engine/variant picker can fire several selection changes in quick
     * succession (e.g. arrow-key stepping through options). Matches the
     * custom-bundle points debounce against the same endpoint.
     */
    var DEBOUNCE_MS = 500;

    function getVariantData(wrap) {
      var section = wrap.closest('section');

      if (!section) return [];

      var dataEl = section.querySelector('[data-variant-data]');

      if (!dataEl) return [];

      try {
        var variants = JSON.parse(dataEl.textContent);

        return Array.isArray(variants) ? variants : [];
      } catch (error) {
        return [];
      }
    }

    function getInitialVariant(wrap) {
      var section = wrap.closest('section');

      if (!section) return null;

      var variants = getVariantData(wrap);

      if (!variants.length) return null;

      var variantInput = section.querySelector('[data-product-form] [data-variant-id]');

      /*
       * The gift-card PDP presents two product forms on one page with no
       * [data-product-form] wrapper - see product-antavo-points-collapse.liquid's
       * own copy of this fallback.
       */
      if (!variantInput) {
        variantInput = section.querySelector(
          '[data-gift-card-tab-panel]:not([aria-hidden]) [data-gift-card-variant-id]'
        );
      }

      var variantId = variantInput ? (variantInput.value || variantInput.getAttribute('value')) : '';

      var requestedVariantId = new URLSearchParams(window.location.search).get('variant');

      if (requestedVariantId) {
        variantId = requestedVariantId;
      }

      if (variantId) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) {
            return variants[i];
          }
        }
      }

      return variants[0];
    }

    function hide(wrap) {
      var line = wrap.querySelector('[data-antavo-single-line]');

      /*
       * !important for the same reason as everywhere else in this file's
       * sibling scripts: antavo.css's unlayered `.hidden` beats layered
       * Tailwind utilities on any product page.
       */
      wrap.style.setProperty('display', 'none', 'important');

      if (line) line.style.setProperty('display', 'none');
    }

    function show(wrap, points) {
      var line = wrap.querySelector('[data-antavo-single-line]');

      var template = wrap.getAttribute('data-single-line-template');

      if (!line || !template) return;

      line.textContent = template.replace('__POINTS__', points);

      line.style.removeProperty('display');

      wrap.style.removeProperty('display');
    }

    function requestEstimate(wrap, variant) {
      var productId = wrap.getAttribute('data-product-id');

      var priceMinor = variant ? Number(variant.price_minor) : NaN;

      if (!variant || !productId || !Number.isFinite(priceMinor) || priceMinor <= 0) {
        hide(wrap);
        return;
      }

      if (wrap.__antavoGuestController) {
        wrap.__antavoGuestController.abort();
      }

      wrap.__antavoGuestController = window.AbortController ? new AbortController() : null;

      wrap.__antavoGuestRequestVersion = (wrap.__antavoGuestRequestVersion || 0) + 1;

      var currentVersion = wrap.__antavoGuestRequestVersion;

      var cart = {
        currency: (window.storeContext && window.storeContext.currency) || 'GBP',
        item_count: 1,
        items_subtotal_price: priceMinor,
        total_price: priceMinor,
        items: [
          {
            product_id: productId,
            variant_id: variant.id,
            quantity: 1,
            final_line_price: priceMinor,
            line_level_total_discount: 0
          }
        ]
      };

      fetch(ENDPOINT, {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },

        body: JSON.stringify(cart),

        signal: wrap.__antavoGuestController ? wrap.__antavoGuestController.signal : undefined
      })
        .then(function (response) {
          if (!response.ok) throw new Error('loyalty_guest_points_request_failed');

          return response.json();
        })
        .then(function (data) {
          if (currentVersion !== wrap.__antavoGuestRequestVersion) return;

          var points = data && data.earn ? Math.round(Number(data.earn.points)) : null;

          /*
           * guestEstimate, not authenticated/member: this is always a ghost
           * account response, never a real customer's. See cart-summary.mjs.
           */
          if (!data || !data.guestEstimate || !Number.isFinite(points)) {
            hide(wrap);
            return;
          }

          show(wrap, points);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;

          console.warn('Guest PDP loyalty points failed:', error);

          /*
           * Loyalty is an optional surface and must never break the PDP. On any
           * failure the line simply isn't shown, rather than showing a figure we
           * cannot stand behind.
           */
          if (currentVersion === wrap.__antavoGuestRequestVersion) {
            hide(wrap);
          }
        });
    }

    function schedule(wrap, variant) {
      if (wrap.__antavoGuestDebounce) {
        clearTimeout(wrap.__antavoGuestDebounce);
      }

      wrap.__antavoGuestDebounce = setTimeout(function () {
        wrap.__antavoGuestDebounce = null;
        requestEstimate(wrap, variant);
      }, DEBOUNCE_MS);
    }

    document.querySelectorAll('[data-antavo-points-wrap]').forEach(function (wrap) {
      requestEstimate(wrap, getInitialVariant(wrap));
    });

    /*
     * sections/product.liquid already dispatches this event every time the PDP
     * variant selection changes - see product-antavo-points-collapse.liquid,
     * which listens for the same event for the signed-in path.
     */
    document.addEventListener('variant:changed', function (event) {
      var section = event.target;

      if (!section || !section.querySelectorAll) return;

      var variant = event.detail && event.detail.variant;

      if (!variant) return;

      section.querySelectorAll('[data-antavo-points-wrap]').forEach(function (wrap) {
        schedule(wrap, variant);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-brewing-guide-scripts"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-brewing-guide]').forEach(function (root) {
    if (root.__brewingGuideReady) return;
    root.__brewingGuideReady = true;

    var scope = root.getAttribute('data-brewing-guide-scope');
    if (!scope) return;

    function scoped(selector) {
      return document.querySelectorAll('[data-brewing-guide-scope="' + scope + '"] ' + selector);
    }

    function setTriggerState(button, active) {
      var kind = button.getAttribute('data-trigger-kind');

      if (kind === 'tab') {
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.setAttribute('tabindex', active ? '0' : '-1');
        button.classList.toggle('italic', active);
        button.classList.toggle('not-italic', !active);
        button.classList.toggle('opacity-75', !active);
        return;
      }

      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('italic', active);
      button.classList.toggle('not-italic', !active);
      button.classList.toggle('opacity-75', !active);
    }

    function setVisibility(nodes, index) {
      nodes.forEach(function (node) {
        var nodeIndex = parseInt(node.getAttribute('data-recipe-index'), 10);
        var isActive = nodeIndex === index;
        node.classList.toggle('hidden', !isActive);
        node.hidden = !isActive;
        if (isActive) {
          node.removeAttribute('aria-hidden');
          node.removeAttribute('inert');
        } else {
          node.setAttribute('aria-hidden', 'true');
          node.setAttribute('inert', '');
        }
      });
    }

    function selectRecipe(index) {
      var triggers = scoped('[data-recipe-trigger]');
      var panels = scoped('[data-recipe-panel]');
      var media = scoped('[data-recipe-media]');
      var supporting = scoped('[data-recipe-supporting]');

      triggers.forEach(function (trigger) {
        var triggerIndex = parseInt(trigger.getAttribute('data-recipe-index'), 10);
        setTriggerState(trigger, triggerIndex === index);
      });

      setVisibility(panels, index);
      setVisibility(media, index);
      setVisibility(supporting, index);
    }

    scoped('[data-recipe-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = parseInt(trigger.getAttribute('data-recipe-index'), 10) || 0;
        selectRecipe(index);
      });
    });

    root.querySelectorAll('[data-recipe-tablist]').forEach(function (tabList) {
      var tabs = Array.from(tabList.querySelectorAll('[data-trigger-kind="tab"]'));
      tabList.addEventListener('keydown', function (event) {
        var currentIndex = tabs.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        var nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;

        event.preventDefault();
        tabs[nextIndex].focus();
        selectRecipe(parseInt(tabs[nextIndex].getAttribute('data-recipe-index'), 10) || 0);
      });
    });

    var initialIndex = parseInt(root.getAttribute('data-initial-index'), 10) || 0;
    selectRecipe(initialIndex);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-bundle-items"] && !Shopify.designMode) return;
  try {
    /*
   * Fixed-bundle "what's inside": fetch the parent variant's native bundle
   * components from the Storefront GraphQL API and hydrate one row per
   * component. Passive display enhancement -> fails quietly (hide + warn) on
   * empty/error. Auto-deferred + deduplicated by Shopify's snippet JS bundler.
   */
  ;(function () {
    var root = document.querySelector('[data-bundle-items]');
    if (!root) return;

    var token = root.getAttribute('data-bundle-token');
    if (!token) return;

    var version = root.getAttribute('data-bundle-api-version') || '2026-07';
    var variantId = root.getAttribute('data-bundle-variant-id');
    var itemLabelTemplate = root.getAttribute('data-bundle-item-label') || '';
    var moreInfoLabel = root.getAttribute('data-bundle-more-info') || '';
    var moreInfoAriaTemplate = root.getAttribute('data-bundle-more-info-aria') || '';

    var UNIT_MAP = { GRAMS: 'g', KILOGRAMS: 'kg', POUNDS: 'lb', OUNCES: 'oz' };

    // @inContext(country:) is required — without it this always resolves against
    // the shop's default market rather than the shopper's actual one (TASK-47920,
    // same defect found live in assets/tagalys-recommendations.js's
    // correctAvailability, which the market-mismatch actually surfaced visibly).
    var marketCountry = (document.body && document.body.getAttribute('data-market-country')) || 'GB';

    var QUERY =
      'query BundleComponents($id: ID!, $country: CountryCode!) @inContext(country: $country) {' +
      '  node(id: $id) {' +
      '    ... on ProductVariant {' +
      '      requiresComponents' +
      '      components(first: 20) {' +
      '        nodes {' +
      '          quantity' +
      '          productVariant {' +
      '            id title weight weightUnit' +
      '            selectedOptions { name value }' +
      '            price { amount currencyCode }' +
      '            image { url altText }' +
      '            product { title handle onlineStoreUrl }' +
      '          }' +
      '        }' +
      '      }' +
      '    }' +
      '  }' +
      '}';

    function hideBlock() {
      root.classList.add('hidden');
    }

    function showBlock() {
      root.classList.remove('hidden');
    }

    // Drop the current rows (kept: root's role/aria attributes) before a re-render.
    function clearRows() {
      while (root.firstChild) root.removeChild(root.firstChild);
    }

    // Absolute https URL only (component image src).
    function isHttpUrl(value) {
      try {
        var protocol = new URL(value).protocol;
        return protocol === 'https:';
      } catch (err) {
        return false;
      }
    }

    // Same-origin relative path, or an absolute https URL (component link href).
    function isSafeHref(value) {
      if (!value) return false;
      if (value.charAt(0) === '/' && value.charAt(1) !== '/') return true;
      try {
        return new URL(value, window.location.origin).protocol === 'https:';
      } catch (err) {
        return false;
      }
    }

    function formatWeight(weight, unit) {
      var suffix = UNIT_MAP[unit] || '';
      return String(weight) + suffix;
    }

    // Descriptor shown after the product name. Figma orders the grind/format
    // before the size/weight ("Beans, 250g / 8.8oz"), but Shopify's variant title
    // joins option values in the product's own option order (e.g.
    // "250g / 8.8oz / Beans"). Read the structured selectedOptions instead of the
    // joined title (the size value itself contains a "/", so the title can't be
    // split reliably) and place non-numeric values (grind) before numeric ones
    // (size/weight). Falls back to the physical weight for single-variant
    // ("Default Title") products so weight-only bundles (e.g. the hot-chocolate
    // box) still label as before.
    function variantDescriptor(pv) {
      var options = (pv && pv.selectedOptions) || [];
      var grind = [];
      var measure = [];
      options.forEach(function (opt) {
        var value = opt && opt.value;
        if (!value || value === 'Default Title') return;
        if (/\d/.test(value)) measure.push(value);
        else grind.push(value);
      });
      var ordered = grind.concat(measure);
      if (ordered.length) return ordered.join(', ');

      if (pv && typeof pv.weight === 'number' && pv.weight > 0) {
        return formatWeight(pv.weight, pv.weightUnit);
      }
      return '';
    }

    function buildRow(node, index) {
      var pv = node && node.productVariant;
      if (!pv) return null;
      var product = pv.product || {};
      var productTitle = product.title || pv.title || '';

      var row = document.createElement('div');
      row.className = 'flex items-center w-full gap-16 pr-24 border-t last:border-b border-border-secondary md:gap-24 md:pr-0';
      row.setAttribute('role', 'listitem');

      var tile = document.createElement('div');
      tile.className = 'flex items-center justify-center bg-black/3';
      if (pv.image && pv.image.url && isHttpUrl(pv.image.url)) {
        var img = document.createElement('img');
        // Bound the CDN image to ~2x the 56/64px render size instead of serving full resolution.
        var imgSrc = pv.image.url;
        try {
          var imgUrl = new URL(pv.image.url);
          imgUrl.searchParams.set('width', '128');
          imgSrc = imgUrl.href;
        } catch (err) {}
        img.setAttribute('src', imgSrc);
        img.setAttribute('alt', pv.image.altText || product.title || '');
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
        img.className = 'w-72 h-88 md:w-64 md:h-80 object-contain';
        tile.appendChild(img);
      } else {
        // No component image: keep the tinted tile footprint instead of collapsing.
        tile.className += ' size-64 md:size-56';
      }
      row.appendChild(tile);

      var content = document.createElement('div');
      content.className = 'flex flex-1 flex-col min-w-0 gap-8';

      var labelRow = document.createElement('div');
      labelRow.className = 'flex items-start justify-between w-full text-f2 uppercase';

      var label = document.createElement('span');
      label.className = 'text-secondary';
      label.textContent = itemLabelTemplate.replace('{n}', index);
      labelRow.appendChild(label);

      var href = product.onlineStoreUrl || ('/products/' + encodeURIComponent(product.handle || ''));
      if (product.handle && isSafeHref(href)) {
        var link = document.createElement('a');
        link.setAttribute('href', href);
        link.setAttribute('data-quick-view-open', '');
        link.setAttribute('data-product-url', href);
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', 'QuickViewDrawer');
        link.className = 'shrink-0 text-primary underline';
        link.textContent = moreInfoLabel;
        if (productTitle) {
          link.setAttribute('aria-label', moreInfoAriaTemplate.replace('{title}', function () { return productTitle; }));
        }
        labelRow.appendChild(link);
      }
      content.appendChild(labelRow);

      var valueRow = document.createElement('div');
      valueRow.className = 'flex flex-wrap items-start w-full gap-x-8 gap-y-4 text-b2 md:gap-y-8';

      // Bundle variants (quantity options) can include >1 of a component; prefix "N × " when so.
      var qty = node && node.quantity ? parseInt(node.quantity, 10) : 1;
      if (!(qty > 0)) qty = 1;
      var displayTitle = (qty > 1 ? qty + ' × ' : '') + productTitle;

      // Weight, or the variant's option values (e.g. "250g / Cafetière") for multi-variant products.
      var descriptor = variantDescriptor(pv);

      var title = document.createElement('span');
      title.className = 'min-w-0 text-ellipsis whitespace-nowrap text-primary overflow-hidden md:overflow-visible md:text-clip md:whitespace-normal';
      // Figma renders the title with a trailing comma before the descriptor ("Title, 350g").
      title.textContent = descriptor ? displayTitle + ',' : displayTitle;
      valueRow.appendChild(title);

      if (descriptor) {
        var size = document.createElement('span');
        size.className = 'shrink-0 text-secondary';
        size.textContent = descriptor;
        valueRow.appendChild(size);
      }
      content.appendChild(valueRow);

      row.appendChild(content);
      return row;
    }

    var endpoint = '/api/' + version + '/graphql.json';
    var requestSeq = 0; // monotonic token — a later variant selection invalidates earlier responses
    var activeAbort = null; // in-flight controller, aborted when a newer selection arrives

    function load(id) {
      if (!id) return;
      var seq = ++requestSeq;
      if (activeAbort) activeAbort.abort();
      var ac = window.AbortController ? new AbortController() : null;
      activeAbort = ac;
      var timeout = setTimeout(function () {
        if (ac) ac.abort();
      }, 8000);

      (async function () {
        try {
          var res = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Shopify-Storefront-Access-Token': token
            },
            body: JSON.stringify({
              query: QUERY,
              variables: { id: 'gid://shopify/ProductVariant/' + id, country: marketCountry }
            }),
            signal: ac ? ac.signal : undefined
          });

          if (seq !== requestSeq) return; // superseded by a newer selection — drop this response

          if (!res.ok) {
            hideBlock();
            return;
          }

          var json = await res.json();
          if (seq !== requestSeq) return;

          if (json && json.errors) {
            console.warn('[bundle-items] GraphQL errors', json.errors);
            hideBlock();
            return;
          }

          var nodeData = json && json.data && json.data.node;
          if (!nodeData || nodeData.requiresComponents === false) {
            hideBlock();
            return;
          }

          var nodes = (nodeData.components && nodeData.components.nodes) || [];
          // Exclude the zero-priced warehouse marker component; it must stay at 0 for this filter to hold.
          var filtered = nodes.filter(function (n) {
            var amount = n && n.productVariant && n.productVariant.price && n.productVariant.price.amount;
            return parseFloat(amount || '0') > 0;
          });

          var built = [];
          filtered.forEach(function (n, i) {
            var row = buildRow(n, i + 1);
            if (row) built.push(row);
          });

          // Re-fetched on every variant change → replace the prior variant's rows wholesale.
          clearRows();

          if (built.length === 0) {
            hideBlock();
            return;
          }

          built.forEach(function (row) {
            root.appendChild(row);
          });
          showBlock();
        } catch (err) {
          if (seq !== requestSeq) return; // aborted because a newer selection superseded this one
          console.warn('[bundle-items] fetch failed', err && err.name === 'AbortError' ? 'timeout' : err);
          hideBlock();
        } finally {
          clearTimeout(timeout);
        }
      })();
    }

    // First paint for the first-available variant.
    load(variantId);

    // Bundle variants (e.g. quantity options) change which components are in the box and how
    // many of each. The picker dispatches a bubbling 'variant:changed'; re-fetch for the new
    // variant so the list (and its "N ×" quantities) always matches the current selection.
    document.addEventListener('variant:changed', function (e) {
      var variant = e && e.detail && e.detail.variant;
      if (!variant || variant.id == null) return;
      var id = String(variant.id);
      if (id === String(variantId)) return; // unchanged (e.g. the picker's init dispatch)
      variantId = id;
      load(id);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-carousel-script"] && !Shopify.designMode) return;
  try {
    (function () {
    // Thin consumer of the shared carousel engine (assets/product-carousel-engine.js,
    // loaded once, defer, in layout/theme.liquid). Slides are server-rendered, so no
    // populate hook — the engine toggles per-block visibility and builds the loop.
    // The only dynamic piece is the Tagalys fallback below, for tabs with no manual
    // collection: it fetches once, replaces that block's placeholder slide, then
    // calls the engine's own rebuild() to remeasure/clone — the tab-switch/loop
    // logic itself is never re-implemented here.
    var DISPLAY_COUNT = 12;

    function fillTagalysFallbacks(root, engine) {
      var placeholders = Array.prototype.slice.call(root.querySelectorAll('[data-pc-tagalys-placeholder]'));
      // Do NOT also check window.TagalysCard here: snippet-scripts.js (which defines
      // TagalysCard in collection-tagalys-card.liquid) and this snippet's own script
      // are both deferred, in document order. TagalysCard is only referenced below
      // inside the async onProducts callback, by which time the network round-trip
      // has long since given snippet-scripts.js time to run (FAILS_INDEX.md §3).
      if (!placeholders.length || !window.TagalysRecommendations) return;

      var token     = root.getAttribute('data-tagalys-token')   || '';
      var domain    = root.getAttribute('data-tagalys-domain')  || '';
      var sdkUrl    = root.getAttribute('data-tagalys-sdk-url') || '';
      var productId = root.getAttribute('data-pc-product-id')   || '';
      var cardI18n = {
        quickView:  root.getAttribute('data-i18n-quick-view')  || 'Quick view',
        notify:     root.getAttribute('data-i18n-notify')      || 'Notify',
        fromPrice:  root.getAttribute('data-i18n-from-price')  || 'From __PRICE__',
        rating:     root.getAttribute('data-i18n-rating')      || 'Rated __RATING__ out of 5',
        currency:   root.getAttribute('data-currency')         || '',
        rootUrl:    root.getAttribute('data-root-url')         || ''
      };

      // A tab whose Tagalys fallback resolves empty/errored would otherwise stay
      // clickable with nothing behind it. Hide its tab button(s) (mobile + desktop
      // share the same data-pc-tab id) so a shopper can't land on a dead tab; if the
      // hidden tab was the active one, hand off to the next visible tab instead.
      function hideEmptyTab(blockId) {
        var tabs = root.querySelectorAll('[data-pc-tab="' + CSS.escape(blockId) + '"]');
        if (!tabs.length) return;
        var wasActive = false;
        tabs.forEach(function (tab) {
          if (tab.getAttribute('aria-selected') === 'true') wasActive = true;
          tab.hidden = true;
        });
        if (wasActive) {
          var nextTab = root.querySelector('[data-pc-tab]:not([hidden])');
          if (nextTab) engine.setTab(nextTab.getAttribute('data-pc-tab'));
        }
      }

      // Once every Tagalys placeholder has settled (filled or given up), hide the
      // whole section if nothing ended up with a real slide anywhere — a
      // collection-backed tab always has one (server-rendered), a Tagalys tab
      // only gets one on a successful in-stock result, and single-tab carousels
      // (tab_count <= 1) render no [data-pc-tab] buttons at all, so hideEmptyTab
      // alone can't catch that case — checking for slides directly covers both.
      var pending = placeholders.length;
      function settled() {
        pending -= 1;
        if (pending <= 0 && !root.querySelector('[data-pc-slide]')) root.hidden = true;
      }

      placeholders.forEach(function (placeholder) {
        var recId   = placeholder.getAttribute('data-pc-tagalys-rec-id') || '';
        var blockId = placeholder.getAttribute('data-pc-block') || '';
        if (!recId) { settled(); return; }

        // Always offer the current product as a candidate anchor — the shared wrapper
        // (assets/tagalys-recommendations.js) auto-detects whether this recommendation
        // ID actually requires one, retrying with the other mode on a 400 and caching
        // the result, so this section no longer needs to know per-block.
        var anchorIds = productId ? [productId] : [];

        window.TagalysRecommendations.fetch({
          recommendationId: recId,
          productIds: anchorIds,
          count: DISPLAY_COUNT,
          token: token,
          domain: domain,
          sdkUrl: sdkUrl,
          onProducts: function (products) {
            if (!products.length) { settled(); return; } // leave the empty placeholder as-is
            window.TagalysRecommendations.correctAvailability(products, root, function (corrected) {
              // Unlike the PLP/search grid (which shows OOS products with a Notify me
              // CTA on purpose), this is a curated recommendations rail — an OOS product
              // here shouldn't take up a slot at all. Matches
              // mini-bag-recommendations-script.liquid's own in-stock filter.
              var inStock = corrected.filter(function (p) { return p.available !== false; });
              if (!inStock.length) { hideEmptyTab(blockId); settled(); return; }

              // Read hidden state now, not before the fetch started: the placeholder is a
              // live DOM node the engine keeps toggling via setTab() while this is in
              // flight, so a value captured earlier would be stale if the shopper switched
              // tabs mid-fetch — the injected slides would land hidden on the very tab
              // they're meant to appear in.
              var isHidden = placeholder.hidden;
              var frag = document.createDocumentFragment();
              inStock.slice(0, DISPLAY_COUNT).forEach(function (p, i) {
                var slide = document.createElement('div');
                slide.className = 'flex shrink-0 snap-start';
                slide.setAttribute('data-pc-slide', '');
                slide.setAttribute('data-pc-block', blockId);
                slide.hidden = isHidden;
                slide.innerHTML = window.TagalysCard(p, i < 4, cardI18n);
                frag.appendChild(slide);
              });
              placeholder.replaceWith(frag);
              engine.rebuild();
              if (window.TagalysRatingHydration) window.TagalysRatingHydration.hydrate(inStock, root, cardI18n.rating);
              settled();
            });
          },
          onEmpty: function () { hideEmptyTab(blockId); settled(); },
          onError: function () { hideEmptyTab(blockId); settled(); }
        });
      });
    }

    function init() {
      if (!window.ProductCarouselEngine) return;
      document.querySelectorAll('[data-pc-section]').forEach(function (el) {
        var engine = window.ProductCarouselEngine(el, { prefix: 'data-pc' });
        fillTagalysFallbacks(el, engine);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-custom-bundle-points"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var wrap = document.querySelector('[data-antavo-points-wrap]');
    var configEl = document.querySelector('[data-custom-bundle-config]');

    if (!wrap || !configEl) return;

    var line = wrap.querySelector('[data-antavo-single-line]');
    var template = wrap.getAttribute('data-single-line-template');

    if (!line || !template) return;

    var cfg;

    try {
      cfg = JSON.parse(configEl.textContent);
    } catch (error) {
      return;
    }

    var PRODUCT_ID = cfg.boxProductId;
    var VARIANT_ID = cfg.boxVariantId;

    if (!PRODUCT_ID || !VARIANT_ID) return;

    var ENDPOINT = '/apps/whittard-loyalty/cart-summary';

    /*
     * Antavo's Primary ID is email, not the Shopify customer id - cart-summary.mjs
     * now 400s a signed-in request with no customer_email (see
     * loyalty-customer-context.liquid, rendered once globally). This snippet runs
     * for both a signed-in member and a guest on a custom-bundle PDP: guests never
     * have window.loyaltyCustomerEmail set, so this leaves their request untouched
     * and they still fall into the existing guest-estimate path.
     */
    function withCustomerEmail(url) {
      if (!window.loyaltyCustomerEmail) return url;

      return url + '?customer_email=' + encodeURIComponent(window.loyaltyCustomerEmail);
    }

    /*
     * The engine fires custom-bundle:changed on every slot and quantity change,
     * which is far too fast to hit Antavo on. 500ms matches the debounce the
     * checkout-points-banner extension already uses against the sibling
     * /api/loyalty/checkout-quote endpoint.
     */
    var DEBOUNCE_MS = 500;

    var debounceId = null;
    var activeController = null;
    var requestVersion = 0;

    /*
     * Hidden via inline style, deliberately not the `hidden` utility: antavo.css
     * defines its own unlayered, unscoped `.hidden` that beats every layered
     * Tailwind utility on any product page — the same collision already
     * documented for the single-line <p> in sections/product.liquid.
     */
    function hide() {
      wrap.style.setProperty('display', 'none', 'important');
      line.style.setProperty('display', 'none');
    }

    function show(points) {
      line.textContent = template.replace('__POINTS__', points);
      line.style.removeProperty('display');
      wrap.style.removeProperty('display');
    }

    function buildCart(state) {
      var quantity = Number(state.quantity) || 1;

      /*
       * state.price.total is the price for the whole box quantity, already
       * discounted, in the presentment currency's Ajax-cart subunits — the same
       * 100-based representation minorToMajor() expects server-side.
       *
       * Sending it as BOTH items_subtotal_price and total_price leaves
       * normalizeAjaxCart()'s derived cartDiscount at 0, so Antavo prices the net
       * amount the customer actually pays. The Cart Transform's discount is
       * already inside this figure; declaring it again would double-count it.
       */
      var total = Number(state.price && state.price.total) || 0;

      return {
        currency: state.currency,
        item_count: quantity,
        items_subtotal_price: total,
        total_price: total,
        items: [
          {
            product_id: PRODUCT_ID,
            variant_id: VARIANT_ID,
            quantity: quantity,
            final_line_price: total,
            line_level_total_discount: 0
          }
        ]
      };
    }

    function request(state) {
      /*
       * An unfilled box (or a running total of £0) has nothing to preview,
       * and the endpoint would return a zero earn for it anyway. Show 0
       * rather than hiding the banner, so a logged-in customer sees it from
       * the moment they land and watches it update as they build their box,
       * rather than it appearing only once their selection earns points.
       * Skip the round trip either way — there's nothing to ask for yet.
       */
      if (!state || !state.count || !state.price || state.price.total <= 0) {
        show(0);
        return;
      }

      if (activeController) {
        activeController.abort();
      }

      activeController = window.AbortController ? new AbortController() : null;

      requestVersion += 1;

      var currentVersion = requestVersion;

      fetch(withCustomerEmail(ENDPOINT), {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },

        body: JSON.stringify(buildCart(state)),

        signal: activeController ? activeController.signal : undefined
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('loyalty_points_request_failed');
          }

          return response.json();
        })
        .then(function (data) {
          /*
           * AbortController isn't available everywhere. The version guard gives
           * the same stale-response protection where it is missing.
           */
          if (currentVersion !== requestVersion) return;

          var points =
            data && data.earn ? Math.round(Number(data.earn.points)) : 0;

          /*
           * Two sources of a reliable figure: a genuine, authenticated,
           * member response, or a guest estimate (data.guestEstimate) from
           * the ghost/guest Antavo customer. Either is shown, even at 0
           * points. Hiding stays reserved for cases where neither applies:
           * a malformed response, or a request that failed outright.
           */
          var isMemberResponse = !!(data && data.authenticated && data.member);
          var isGuestEstimate = !!(data && data.guestEstimate);

          if (!(isMemberResponse || isGuestEstimate) || !Number.isFinite(points)) {
            hide();
            return;
          }

          show(points);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;

          console.warn('Custom bundle loyalty points failed:', error);

          /*
           * Loyalty is an optional surface and must never break the PDP. On any
           * failure the banner simply isn't shown, rather than showing a figure
           * we cannot stand behind.
           */
          if (currentVersion === requestVersion) {
            hide();
          }
        })
        .finally(function () {
          if (currentVersion === requestVersion) {
            activeController = null;
          }
        });
    }

    function schedule(state) {
      if (debounceId) {
        clearTimeout(debounceId);
      }

      debounceId = setTimeout(function () {
        debounceId = null;
        request(state);
      }, DEBOUNCE_MS);
    }

    document.addEventListener('custom-bundle:changed', function (event) {
      schedule(event.detail);
    });

    /*
     * The engine dispatches its first custom-bundle:changed during its own init,
     * which can land before this listener is attached (it is a deferred asset;
     * this is part of the theme bundle). Pull the current state directly instead
     * of relying on that ordering — prefilled default selections would otherwise
     * show no points until the customer touched something.
     */
    function primeFromEngine() {
      var api = window.WhittardCustomBundle;

      if (api && typeof api.getState === 'function') {
        schedule(api.getState());
        return true;
      }

      return false;
    }

    if (!primeFromEngine()) {
      document.addEventListener('DOMContentLoaded', primeFromEngine);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;

    var slides = track.querySelectorAll('[data-gallery-slide]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var isDesktop = window.matchMedia('(min-width: 1024px)');
    var syncEnabled = gallery.getAttribute('data-variant-sync') !== 'false';
    // Suppress the scroll on the initial (server-rendered) first-paint dispatch so the page
    // / carousel doesn't auto-jump on load; only user-initiated changes (after the first
    // frame) scroll. The highlight is always applied (idempotent with the server render).
    var allowScroll = false;

    // Reactive scroll-to / highlight: the section dispatches a bubbling variant:changed
    // event, so listen at document scope (this gallery root is a descendant of the
    // section). First paint is server-rendered, so an initial dispatch is idempotent.
    document.addEventListener('variant:changed', function (e) {
      if (!syncEnabled) return;
      var mid = e.detail && e.detail.variant && e.detail.variant.featured_media_id;
      if (mid == null) return;
      var target = track.querySelector('[data-gallery-slide][data-media-id="' + CSS.escape(String(mid)) + '"]');
      if (!target) return;
      slides.forEach(function (s) {
        if (s === target) {
          s.setAttribute('aria-current', 'true');
        } else {
          s.removeAttribute('aria-current');
        }
      });
      if (!allowScroll) return;
      var behavior = reduceMotion.matches ? 'auto' : 'smooth';
      if (isDesktop.matches) {
        // The desktop gallery is a page-level vertical stack. The first slide sits below
        // gallery padding, but selecting it must restore the actual page top. Later slides
        // can overlap the preceding slide (the first uses md:-mb-56), so align to the
        // preceding slide's visual bottom rather than the target's layout top. Do not
        // subtract the header measured before scrolling: it hides on downward scroll and
        // that stale clearance is what left a strip of the previous image visible.
        var destination = 0;
        if (target !== slides[0]) {
          var targetTop = target.getBoundingClientRect().top + window.scrollY;
          var previous = target.previousElementSibling;
          destination = targetTop;
          if (previous && previous.hasAttribute('data-gallery-slide')) {
            destination = Math.max(destination, previous.getBoundingClientRect().bottom + window.scrollY);
          }
          // A slide taller than the viewport cannot fit: top-aligning it leaves the subject below the visual centre and its base cut off, so split the overflow above and below instead.
          var overflow = target.getBoundingClientRect().height - window.innerHeight;
          if (overflow > 0) destination = destination + overflow / 2;
        }
        window.scrollTo({ top: destination, behavior: behavior });
      } else {
        // Mobile: scroll the horizontal carousel only — never yank the page vertically.
        track.scrollTo({ left: target.offsetLeft, behavior: behavior });
      }
    });
    window.requestAnimationFrame(function () {
      allowScroll = true;
    });

    var counter = gallery.querySelector('[data-gallery-counter]');
    var progress = gallery.querySelector('[data-gallery-progress]');
    var progressBar = gallery.querySelector('[data-gallery-progress-bar]');
    var total = slides.length;

    if (total < 2) {
      if (progress) progress.hidden = true;
      return;
    }

    var template = counter ? counter.getAttribute('data-counter-template') || counter.textContent : '';

    function update() {
      var width = track.clientWidth;
      if (!width) return;
      var current = Math.round(track.scrollLeft / width) + 1;
      if (current < 1) current = 1;
      if (current > total) current = total;

      if (counter) {
        counter.textContent = template.replace('%%CURRENT%%', current);
      }

      if (progressBar) {
        var progressPercent = (current / total) * 100;
        progressBar.style.width = progressPercent + '%';
      }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    });

    window.addEventListener('resize', update);

    if (progressBar) {
      progressBar.style.width = '0%';
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(update);
    });

    /* ═══════════════════════════════════════════════
       Warm the next two slides, AFTER load
    ═══════════════════════════════════════════════
       Slides 2+ are server-rendered loading="lazy". Native lazy-loading
       gives generous preload margins BELOW the fold but effectively none to
       the RIGHT inside a horizontal scroller, so each slide only begins
       downloading as it is swiped to — which is the pop-in Kristina reported
       from an iPad 11" (TASK-54774, reproduced: slides 2 and 3 were still
       unfetched at load and only arrived once the track was scrolled).

       Warming them, but NOT by making them eager in the markup. That was
       measured and it is the wrong fix: eager on slides 2-3 cost ~0.85s of
       LCP across 4 paired runs at 390px / 4x CPU / 1.6Mbps (median 4.22s vs
       3.37s control, all four runs above the control median), because ~114KB
       of extra image lands in the same window the LCP image is competing for.
       Slide 1 carries fetchpriority="high" precisely because it IS the LCP
       element; pulling bandwidth away from it to smooth a swipe is a bad
       trade on a template already failing the 2.5s threshold.

       Deferring to `load` instead costs nothing measurable (median 3.42s vs
       3.37s control, inside control's own 2.54-6.76 spread) and has the two
       slides ready a median of ~2.0s after load under that same throttling —
       far less on a real device over wifi. LCP has already happened by then,
       so there is nothing left to compete with.

       Bounded to two so a long gallery does not pull its whole media set.
       Setting `loading` to 'eager' on an un-loaded lazy image triggers the
       fetch immediately; no src rewrite, so the srcset/sizes choice already
       made by the browser is preserved. */
    function warmNextSlides() {
      var pending = [].slice.call(track.querySelectorAll('img[loading="lazy"]')).slice(0, 2);
      pending.forEach(function (img) {
        if (!img.complete) img.loading = 'eager';
      });
    }

    /* Shopify bundles this section's script into a deferred file, so `load`
       may already have fired by the time it runs — in which case the listener
       would never call back and the slides would never warm. */
    if (document.readyState === 'complete') {
      warmNextSlides();
    } else {
      window.addEventListener('load', warmNextSlides);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quantity"] && !Shopify.designMode) return;
  try {
    ;(function () {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;

    var form = section.querySelector('[data-product-form]');
    var canonical = form && form.querySelector('[data-product-qty-input]');
    if (!form || !canonical) return;

    var MIN = 1;
    var qtyWrap = section.querySelector('[data-product-qty]');
    var initialMax = qtyWrap ? parseInt(qtyWrap.getAttribute('data-product-qty-max'), 10) : NaN;
    var MAX = Number.isFinite(initialMax) ? initialMax : Infinity;

    // Mirrors the low-stock gate in sections/product.liquid's lowStockMessage(): a cap
    // only applies when inventory is tracked, oversell is denied, and stock remains.
    /* Warehouse-only deliverable stock (custom.warehouse_stock, carried on
       data-variant-data by sections/product.liquid) tightens the blended
       inventory_quantity cap when it is a populated POSITIVE number lower than it
       (the partial-stock case). null/undefined (not yet backfilled) or exactly
       zero both leave the pre-fix blended cap untouched - not because zero is
       purchasable (per the confirmed client decision it is not), but because the
       whole quantity/Add-to-Bag wrap is hidden once warehouseAvailable() resolves
       false, so this cap value is moot in that case; only a positive figure ever
       tightens.
       The inventory_management / inventory_policy gates are unchanged - they answer
       a different question (is inventory tracked, is oversell allowed) that this
       metafield says nothing about. */
    function maxForVariant(variant) {
      if (!variant) return Infinity;

      var raw = variant.warehouse_stock;
      var wh = (raw === null || raw === undefined || raw === '') ? null : Number(raw);
      if (wh !== null && !Number.isFinite(wh)) wh = null;

      var base = Infinity;
      if (variant.available && variant.inventory_management && variant.inventory_policy !== 'continue') {
        var quantity = Number(variant.inventory_quantity);
        if (Number.isFinite(quantity) && quantity > 0) base = quantity;
      }

      if (wh === null || wh <= 0) return base;
      return Math.min(base, wh);
    }

    function refresh() {
      var value = parseInt(canonical.value, 10) || MIN;
      var atMin = value === MIN;
      var atMax = value >= MAX;

      section.querySelectorAll('[data-product-qty-count], [data-sticky-qty-count]').forEach(function (count) {
        count.textContent = value;
      });

      section.querySelectorAll('[data-product-qty-minus], [data-sticky-qty-minus]').forEach(function (minus) {
        minus.disabled = atMin;
        if (atMin) {
          minus.setAttribute('aria-disabled', 'true');
        } else {
          minus.removeAttribute('aria-disabled');
        }
      });

      section.querySelectorAll('[data-product-qty-plus], [data-sticky-qty-plus]').forEach(function (plus) {
        plus.disabled = atMax;
        if (atMax) {
          plus.setAttribute('aria-disabled', 'true');
        } else {
          plus.removeAttribute('aria-disabled');
        }
      });
    }

    function setValue(v) {
      v = Math.min(MAX, Math.max(MIN, (v | 0) || MIN));
      canonical.value = v;
      form.dispatchEvent(new CustomEvent('product:quantity-changed', { bubbles: true, detail: { value: v } }));
    }

    section.addEventListener('click', function (event) {
      var current = parseInt(canonical.value, 10) || MIN;

      if (event.target.closest('[data-product-qty-minus], [data-sticky-qty-minus]')) {
        setValue(current - 1);
        return;
      }

      if (event.target.closest('[data-product-qty-plus], [data-sticky-qty-plus]')) {
        setValue(current + 1);
      }
    });

    form.addEventListener('product:quantity-changed', refresh);

    section.addEventListener('variant:changed', function (event) {
      MAX = maxForVariant(event.detail && event.detail.variant);
      setValue(parseInt(canonical.value, 10) || MIN);
    });

    refresh();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quick-view-script-foundation"] && !Shopify.designMode) return;
  try {
    (function () {
    window.WhittardQuickView = window.WhittardQuickView || {};

    var Q = window.WhittardQuickView;

    Q.drawerId = 'QuickViewDrawer';
    Q.sectionId = 'product-quick-view';
    Q.cache = Q.cache || {};
    Q.activeRequestId = Q.activeRequestId || 0;
    Q.prefetchDelay = 120;
    Q.prefetchTimer = null;

    // Bundle mode (custom gift box picker). The custom-bundle engine sets bundleSlot
    // when its picker opens; activeBundleSlot/bundleTrigger are set on trigger click
    // (product-quick-view-script.liquid). Null on every normal PLP/search QV.
    if (Q.bundleSlot === undefined) Q.bundleSlot = null;
    if (Q.activeBundleSlot === undefined) Q.activeBundleSlot = null;
    if (Q.bundleTrigger === undefined) Q.bundleTrigger = null;
    if (Q.allowedBundleVariantIds === undefined) { Q.allowedBundleVariantIds = []; }

    Q.parseBundleAllowedVariantIds = function (trigger) {
      if (!trigger) return [];
      var raw = trigger.getAttribute('data-cb-allowed-variants');
      if (!raw) return [];
      try {
        var ids = JSON.parse(raw);
        if (!Array.isArray(ids)) { return []; }
        return ids.map(function (id) {
          return String(id);
        });
      } catch (error) { return []; }
    };

    Q.getDrawer = function () {
      return document.getElementById(Q.drawerId);
    };

    Q.getContent = function () {
      var drawer = Q.getDrawer();
      return drawer ? drawer.querySelector('[data-quick-view-content]') : null;
    };

    Q.getFooter = function () {
      var drawer = Q.getDrawer();
      return drawer ? drawer.querySelector('[data-quick-view-footer]') : null;
    };

    Q.resetQuickViewScroll = function () {
      var drawer = Q.getDrawer();
      var content = Q.getContent();
      if (!drawer) return;

      var nodes = [
        drawer,
        content,
        drawer.querySelector('[data-drawer-body]'),
        drawer.querySelector('[data-drawer-content]'),
      ];

      var parent = content ? content.parentElement : null;

      while (parent) {
        nodes.push(parent);
        if (parent === drawer) break;
        parent = parent.parentElement;
      }

      nodes.forEach(function (node, index) {
        if (!node || nodes.indexOf(node) !== index) return;

        node.scrollTop = 0;
        node.scrollLeft = 0;
      });
    };

    Q.normaliseProductUrl = function (productUrl) {
      var url = new URL(productUrl, window.location.origin);
      url.hash = '';

      // The search string used to be dropped here, which meant the bundle picker's
      // ?variant= (the pinned weight) never survived into buildSectionUrl's fetch — Quick
      // View always resolved Shopify's own default variant instead. Kept (not blanked)
      // so this URL doubles correctly as both the fetch target and the cache key: normal,
      // non-bundle triggers never carry a query string, so their cache key is unchanged.
      return url.pathname + url.search;
    };

    Q.buildSectionUrl = function (productUrl) {
      var url = new URL(Q.normaliseProductUrl(productUrl), window.location.origin);
      url.searchParams.set('section_id', Q.sectionId);

      return url.toString();
    };

    Q.extractQuickViewHtml = function (html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;

      var product = temp.querySelector('[data-quick-view-product]');

      return product ? product.outerHTML : html;
    };

    Q.isCustomBundleResponse = function (html) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var product = temp.querySelector('[data-quick-view-product]');
      return (product && product.getAttribute('data-is-custom-bundle') === 'true');
    };

    Q.resetFooter = function () {
      var footer = Q.getFooter();
      if (!footer) return;

      footer.innerHTML = '';
      footer.hidden = true;
    };

    Q.syncFooter = function (target, selector) {
      var footer = Q.getFooter();
      if (!footer || !target) return;

      var source = target.querySelector(selector || '[data-quick-view-footer-source]');

      if (!source) {
        Q.resetFooter();
        return;
      }

      footer.innerHTML = source.innerHTML;
      footer.hidden = false;
      footer.__quickViewRoot = target.closest('[data-quick-view-product]') || target;
    };

    Q.formatTemplate = function (template, map) {
      if (!template) return '';

      return template.replace(/\[\[([a-z_]+)\]\]/gi, function (match, key) {
        return map && map[key] != null ? map[key] : match;
      });
    };

    Q.escapeHtml = function (value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    Q.setButtonDisabled = function (button, disabled) {
      if (!button) return;

      button.disabled = disabled;

      if (disabled) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
    };

    Q.setButtonLabel = function (button, label) {
      if (!button || !label) return;

      button.textContent = label;
    };

    Q.prefersReducedMotion = function () {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    };

    Q.transitionDurationMs = function () {
      var value = window.getComputedStyle(document.documentElement).getPropertyValue('--duration-a3').trim();

      if (value.endsWith('ms')) return parseFloat(value);
      if (value.endsWith('s')) return parseFloat(value) * 1000;

      return 300;
    };

    Q.fadeSwap = function (fromEl, toEl, beforeShow) {
      if (!fromEl || !toEl) return;

      if (Q.prefersReducedMotion()) {
        fromEl.classList.add('hidden');
        fromEl.classList.remove('opacity-0');

        if (typeof beforeShow === 'function') {
          beforeShow();
        }

        toEl.classList.remove('hidden', 'opacity-0');
        return;
      }

      fromEl.classList.add('opacity-0');

      window.setTimeout(function () {
        fromEl.classList.add('hidden');

        if (typeof beforeShow === 'function') {
          beforeShow();
        }

        toEl.classList.add('opacity-0');
        toEl.classList.remove('hidden');

        window.requestAnimationFrame(function () {
          if (typeof beforeShow === 'function') {
            beforeShow();
          }

          toEl.classList.remove('opacity-0');
        });
      }, Q.transitionDurationMs());
    };
  })();

  (function () {
    window.WhittardQuickView = window.WhittardQuickView || {};

    var Q = window.WhittardQuickView;

    Q.syncQuickViewRatingSummary = function (root, bottomline) {
      var productRoot = root.querySelector('[data-quick-view-product]');
      var rating = root.querySelector('[data-product-rating]');

      if (!productRoot || !rating) return;

      var score = bottomline && bottomline.average_score ? Number(bottomline.average_score) : 0;
      var total = bottomline && bottomline.total_review ? Number(bottomline.total_review) : 0;

      if (!total) {
        rating.classList.add('hidden');
        return;
      }

      var value = rating.querySelector('[data-rating-value]');
      var count = rating.querySelector('[data-rating-count]');
      var scoreText = score.toFixed(1);

      rating.classList.remove('hidden');

      if (value) {
        value.textContent = scoreText;
      }

      if (count) {
        count.textContent = Q.formatTemplate(productRoot.getAttribute('data-reviews-count-template') || '([[count]])', {
          count: total,
        });
        count.classList.remove('hidden');
      }

      rating.setAttribute(
        'aria-label',
        Q.formatTemplate(productRoot.getAttribute('data-rating-label-template') || 'Rating [[rating]]', {
          rating: scoreText,
        })
      );
    };

    Q.syncRating = function (root) {
      var productRoot = root.querySelector('[data-quick-view-product]');
      if (!productRoot) return;

      var appKey = productRoot.getAttribute('data-yotpo-app-key');
      var productId = productRoot.getAttribute('data-yotpo-product-id');

      if (!appKey || !productId) return;

      window.__yotpoReviewsCache = window.__yotpoReviewsCache || {};

      var key = 'summary|' + productId;
      var yotpoCache = window.__yotpoReviewsCache;

      if (yotpoCache[key]) {
        Q.syncQuickViewRatingSummary(root, (yotpoCache[key].response || {}).bottomline);
        return;
      }

      var url =
        'https://api-cdn.yotpo.com/v1/widget/' +
        encodeURIComponent(appKey) +
        '/products/' +
        encodeURIComponent(productId) +
        '/reviews.json?page=1&per_page=1';

      fetch(url, {
        headers: {
          Accept: 'application/json',
        },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('quick_view_rating_failed');
          return response.json();
        })
        .then(function (data) {
          yotpoCache[key] = data;
          Q.syncQuickViewRatingSummary(root, (data.response || {}).bottomline);
        })
        .catch(function () {});
    };
  })();

  (function () {
    window.WhittardQuickView = window.WhittardQuickView || {};

    var Q = window.WhittardQuickView;

    Q.parseVariants = function (root) {
      var script = root.querySelector('[data-quick-view-variant-data]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent || '[]');
      } catch (error) {
        return [];
      }
    };

    Q.getQuickViewState = function (root) {
      if (!root.__quickViewState) {
        root.__quickViewState = {
          variants: Q.parseVariants(root),
          currentVariant: null,
          currentSelection: [],
        };
      }

      return root.__quickViewState;
    };

    Q.currentSelection = function (root) {
      var selection = [];

      root.querySelectorAll('input[data-option-position]').forEach(function (input) {
        var index = parseInt(input.getAttribute('data-option-position'), 10) - 1;
        if (index < 0) return;

        if (input.checked) {
          selection[index] = input.value;
        }
      });

      return selection;
    };

    Q.hasUnselectedSize = function (root) {
      var sizeAxis = root.querySelector('[data-size-axis]');
      if (!sizeAxis) return false;

      return !sizeAxis.querySelector('input[type="radio"]:checked');
    };

    Q.matchVariantFromSelection = function (variants, selection) {
      if (!variants.length) return null;

      var hasSelection = selection.some(function (value) {
        return value != null && value !== '';
      });

      if (!hasSelection) {
        return variants[0];
      }

      return (
        variants.find(function (variant) {
          if (!variant || !variant.options) return false;

          for (var i = 0; i < variant.options.length; i++) {
            if (!selection[i]) return false;
            if (variant.options[i] !== selection[i]) return false;
          }

          return true;
        }) || null
      );
    };

    Q.findVariantById = function (variants, id) {
      if (!id) return null;

      return (
        variants.find(function (variant) {
          return String(variant.id) === String(id);
        }) || null
      );
    };

    Q.applyBundleVariantRestrictions = function (root) {
      if (!root || Q.activeBundleSlot == null ) { return; }
      var allowedIds = Q.allowedBundleVariantIds || [];
      if (!allowedIds.length) { return; }
      var allowedLookup = {};
      allowedIds.forEach(function (id) {
        allowedLookup[String(id)] = true;
      });

      var state = Q.getQuickViewState(root);
      state.variants = state.variants.filter(
        function (variant) {
          return Boolean( variant && allowedLookup[String(variant.id)] );
        }
      );

      if (!state.variants.length) { return; }

      var picker = root.querySelector('[data-variant-picker]');
      var currentVariantId = root.getAttribute('data-current-variant-id');
      var selectedVariant = Q.findVariantById(state.variants, currentVariantId) || state.variants[0];
      state.currentVariant = selectedVariant;
      state.currentSelection = selectedVariant.options ? selectedVariant.options.slice() : [];
      root.setAttribute('data-current-variant-id', selectedVariant.id);
      var idInput = root.querySelector('[data-quick-view-variant-id]');

      if (idInput) { idInput.value = selectedVariant.id; }
      if (!picker) { return; }

      // Linked products navigate away from the bundle flow,
      // so they are never available in bundle-mode Quick View.
      picker.querySelectorAll('[data-linked-product-option]')
        .forEach(function (item) {
          item.classList.add('hidden');
          item.setAttribute('aria-hidden', 'true');
          if (item.matches('a')) {
            item.setAttribute('tabindex', '-1');
          }
        });

      // Hide all native option values that cannot produce
      // one of the curated variants.
      picker.querySelectorAll('[data-bundle-option-value][data-bundle-option-position]')
        .forEach(function (item) {
          var position = parseInt(item.getAttribute('data-bundle-option-position'), 10) - 1;
          var value = item.getAttribute('data-bundle-option-value');
          var isAllowed = state.variants.some(
              function (variant) {
                return ( variant.options && variant.options[position] === value );
              }
            );
          item.classList.toggle('hidden', !isAllowed);
          item.setAttribute('aria-hidden', isAllowed ? 'false' : 'true');
          var input = item.querySelector('input[data-option-position]');
          if (input) {
            input.disabled = !isAllowed;
            if (!isAllowed) { input.checked = false; }
          }
        });

      // Select the exact curated variant that Quick View
      // was opened with, or the first allowed one.
      picker.querySelectorAll('input[data-option-position]')
        .forEach(function (input) {
          var position = parseInt(input.getAttribute('data-option-position'), 10) - 1;
          input.checked = selectedVariant.options && selectedVariant.options[position] === input.value;
        });

      if (state.variants.length === 1) {
        picker.classList.remove('hidden');
        picker.removeAttribute('aria-hidden');
        picker.querySelectorAll('[data-option-group]')
          .forEach(function (group) {
            /*  Keep the format summary row visible so the customer can see the selected grind and related product information such as Roast. */
            if (group.hasAttribute('data-size-axis')) {
              var sizeRow = group.parentElement;
              if (sizeRow) {
                sizeRow.classList.add('hidden');
                sizeRow.setAttribute('aria-hidden', 'true');
              }
              return;
            }
            group.classList.add('hidden');
            group.setAttribute('aria-hidden', 'true');
          });
      } else {
        picker.classList.remove('hidden');
        picker.removeAttribute('aria-hidden');
        picker.querySelectorAll('[data-option-group]')
          .forEach(function (group) {
            group.classList.remove('hidden');
            group.removeAttribute('aria-hidden');
            if (group.hasAttribute('data-size-axis')) {
              var sizeRow = group.parentElement;
              if (sizeRow) {
                sizeRow.classList.remove('hidden');
                sizeRow.removeAttribute('aria-hidden');
              }
            }
          });
      }
      Q.syncSelectedLabels = function (root, selection) {
        root.querySelectorAll('[data-selected-value][data-option-position]').forEach(function (label) {
          var index = parseInt(label.getAttribute('data-option-position'), 10) - 1;
          if (index < 0 || !selection[index]) return;
          var labelText = selection[index];
          /*
          * Custom Bundle Quick View only.
          * When the admin has restricted the product to one variant,
          * show its fixed weight alongside the grind.
          *
          * Example:
          * Beans → Beans, 250g / 8.8oz
          */
          if (Q.activeBundleSlot != null && label.hasAttribute('data-bundle-format-summary')) {
            var state = Q.getQuickViewState(root);
            if (state.variants.length === 1) {
              var sizeAxis = root.querySelector('[data-size-axis]');
              if (sizeAxis) {
                var sizePosition = parseInt(sizeAxis.getAttribute('data-option-position'), 10) - 1;
                var sizeLabel = selection[sizePosition];
                if (sizeLabel) {
                  labelText += ', ' + sizeLabel;
                }
              }
            }
          }
          label.textContent = labelText;
        });
      };
    };

    Q.syncQuickViewPrice = function (root, variant) {
      if (!variant) return;

      var price = root.querySelector('[data-price]');
      if (!price) return;

      var current = price.querySelector('[data-price-current]');
      var compare = price.querySelector('[data-price-compare]');

      if (current) {
        current.textContent = variant.price || '';
        current.classList.toggle('text-semantic-red', Boolean(variant.compare_at_price));
      }

      if (compare) {
        compare.textContent = variant.compare_at_price || '';
        compare.classList.toggle('hidden', !variant.compare_at_price);
      }
    };

    Q.syncSelectedLabels = function (root, selection) {
      root.querySelectorAll('[data-selected-value][data-option-position]').forEach(function (label) {
        var index = parseInt(label.getAttribute('data-option-position'), 10) - 1;
        if (index < 0 || !selection[index]) return;

        label.textContent = selection[index];
      });
    };

    Q.updateNotifySummary = function (root, variant) {
      var summary = root.querySelector('[data-quick-view-notify-variant-summary]');
      var format = root.querySelector('[data-quick-view-notify-variant-format]');
      var separator = root.querySelector('[data-quick-view-notify-variant-separator]');
      var size = root.querySelector('[data-quick-view-notify-variant-size]');
      var price = root.querySelector('[data-quick-view-notify-price]');
      var formatValue = variant ? String(variant.format || '').trim() : '';
      var sizeValue = variant ? String(variant.size || '').trim() : '';
      if (format) {
        format.textContent = formatValue;
        format.classList.toggle('hidden', !formatValue);
      }
      if (size) {
        size.textContent = sizeValue;
        size.classList.toggle('hidden', !sizeValue);
      }
      if (separator) {
        separator.classList.toggle('hidden', !(formatValue && sizeValue));
      }
      if (summary) {
        summary.classList.toggle('hidden', !(formatValue || sizeValue));
      }

      if (price && variant && variant.price) {
        price.textContent = variant.price;
      }
    };

    Q.optionSelectionFromOosButton = function (root, button) {
      var selection = Q.currentSelection(root);
      var index = parseInt(button.getAttribute('data-option-position'), 10) - 1;
      var value = button.getAttribute('data-oos-value');

      if (index >= 0 && value) {
        selection[index] = value;
      }

      return selection;
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quick-view-script-notify"] && !Shopify.designMode) return;
  try {
    (function () {
    window.WhittardQuickView = window.WhittardQuickView || {};

    var Q = window.WhittardQuickView;

    Q.swymErrorMessage = function (error, fallback) {
      if (!error) return fallback;
      if (typeof error === 'string') return error;
      if (error.message) return error.message;
      if (error.msg) return error.msg;
      if (error.error) return error.error;
      if (error.errorMessage) return error.errorMessage;

      return fallback;
    };

    // Swym drops the request with no callback if an opt-in is sent while its dashboard mailing-list check is off.
    Q.swymMailingListEnabled = function (swat) {
      return Boolean(swat && swat.retailerSettings && swat.retailerSettings.Watchlist && swat.retailerSettings.Watchlist.MailingListCheckInPopup);
    };

    Q.withSwymReady = function (onReady, onError) {
      if (
        window.__whittardSwymBisInstance &&
        typeof window.__whittardSwymBisInstance.subscribeForProductAlert === 'function'
      ) {
        onReady(window.__whittardSwymBisInstance);
        return;
      }

      if (window._swat && typeof window._swat.subscribeForProductAlert === 'function') {
        window.__whittardSwymBisInstance = window._swat;
        onReady(window.__whittardSwymBisInstance);
        return;
      }

      var resolved = false;
      var timeout = window.setTimeout(function () {
        if (resolved) return;

        resolved = true;
        onError();
      }, 5000);

      function handleReady() {
        if (resolved) return;

        resolved = true;
        window.clearTimeout(timeout);
        onReady(window.__whittardSwymBisInstance);
      }

      document.addEventListener('whittard:swym:ready', handleReady, { once: true });
    };

    Q.setNotifyError = function (root, message) {
      var error = root.querySelector('[data-quick-view-notify-error]');
      if (!error) return;

      error.textContent = message || '';
      error.classList.toggle('hidden', !message);
    };

    Q.resetQuickViewNotifyFeedback = function (root) {
      var success = root.querySelector('[data-quick-view-notify-success]');
      var notifyBody = root.querySelector('[data-quick-view-notify-body]');
      var status = root.querySelector('[data-quick-view-notify-status]');
      var footer = Q.getFooter();
      var submit = footer ? footer.querySelector('[data-quick-view-notify-submit]') : null;

      if (success) {
        success.classList.add('hidden');
        success.classList.remove('flex');
      }

      if (notifyBody) {
        notifyBody.classList.remove('hidden');
      }

      Q.setNotifyError(root, '');

      if (status) {
        status.textContent = '';
      }

      if (submit) {
        Q.setButtonLabel(submit, submit.getAttribute('data-submit-label') || 'Notify me');
      }

      Q.setButtonDisabled(submit, false);
    };

    Q.submitQuickViewNotify = function (root, event) {
      event.preventDefault();

      var state = Q.getQuickViewState(root);
      var form = root.querySelector('[data-quick-view-notify-form]');
      var email = root.querySelector('[data-quick-view-notify-email]');
      var marketing = root.querySelector('[data-quick-view-notify-marketing]');
      var success = root.querySelector('[data-quick-view-notify-success]');
      var status = root.querySelector('[data-quick-view-notify-status]');
      var footer = Q.getFooter();
      var submit = footer ? footer.querySelector('[data-quick-view-notify-submit]') : null;

      if (!form || !email || !state.currentVariant) return;

      var stillAvailable = Q.warehouseAvailable
        ? Q.warehouseAvailable(state.currentVariant)
        : state.currentVariant.available;

      if (stillAvailable) {
        var unavailableMessage = form.getAttribute('data-error-unavailable') || 'This product is available';

        Q.setNotifyError(root, unavailableMessage);
        if (status) status.textContent = unavailableMessage;
        return;
      }

      if (typeof email.reportValidity === 'function' && email.reportValidity() === false) {
        return;
      }

      Q.setNotifyError(root, '');
      if (status) status.textContent = '';
      Q.setButtonDisabled(submit, true);

      if (submit) {
        Q.setButtonLabel(submit, submit.getAttribute('data-loading-label') || 'Submitting…');
      }

      var baseUrl = form.getAttribute('data-product-url');
      var productPayload = {
        epi: state.currentVariant.id,
        empi: form.getAttribute('data-product-id'),
        du: baseUrl ? baseUrl + '?variant=' + encodeURIComponent(state.currentVariant.id) : window.location.href,
        iu: state.currentVariant.image || '',
        pr: state.currentVariant.price_value,
        dt: root.getAttribute('data-product-title') || document.title,
      };

      var emailValue = email.value.trim();
      var addToMailingList = marketing && marketing.checked ? 1 : 0;
      var genericError = form.getAttribute('data-error-generic') || 'Unable to submit';

      function handleNotifySuccess() {
        var notifyBody = root.querySelector('[data-quick-view-notify-body]');

        if (success) {
          success.classList.remove('hidden');
          success.classList.add('flex');

          if (typeof success.focus === 'function') {
            success.focus({ preventScroll: true });
          }
        }

        if (notifyBody) {
          notifyBody.classList.add('hidden');
        }

        email.value = '';
        email.dispatchEvent(new Event('input', { bubbles: true }));

        if (marketing) {
          marketing.checked = false;
        }

        if (status) {
          status.textContent = form.getAttribute('data-success-status') || '';
        }

        Q.setNotifyError(root, '');

        if (submit) {
          Q.setButtonLabel(submit, submit.getAttribute('data-submit-label') || 'Notify me');
        }

        Q.setButtonDisabled(submit, false);
      }

      function handleNotifyError(error) {
        var message = Q.swymErrorMessage(error, genericError);

        Q.setNotifyError(root, message);

        if (status) {
          status.textContent = message;
        }

        if (submit) {
          Q.setButtonLabel(submit, submit.getAttribute('data-submit-label') || 'Notify me');
        }

        Q.setButtonDisabled(submit, false);
      }

      function sendSwymNotifyRequest(swat, marketingOptIn, allowRetryWithoutMarketing) {
        var completed = false;

        var timeout = window.setTimeout(function () {
          if (completed) return;

          completed = true;

          if (allowRetryWithoutMarketing) {
            sendSwymNotifyRequest(swat, 0, false);
            return;
          }

          handleNotifyError(genericError);
        }, 8000);

        swat.subscribeForProductAlert(
          emailValue,
          'email',
          productPayload,
          function () {
            if (completed) return;

            completed = true;
            window.clearTimeout(timeout);

            handleNotifySuccess();
          },
          function (error) {
            if (completed) return;

            completed = true;
            window.clearTimeout(timeout);

            if (allowRetryWithoutMarketing) {
              sendSwymNotifyRequest(swat, 0, false);
              return;
            }

            handleNotifyError(error);
          },
          marketingOptIn,
          'backinstock'
        );
      }

      Q.withSwymReady(
        function (swat) {
          if (!swat || typeof swat.subscribeForProductAlert !== 'function') {
            handleNotifyError(genericError);
            return;
          }

          var marketingOptIn = addToMailingList && Q.swymMailingListEnabled(swat) ? 1 : 0;
          sendSwymNotifyRequest(swat, marketingOptIn, Boolean(marketingOptIn));
        },
        function () {
          handleNotifyError(genericError);
        }
      );
    };
  })();

  (function () {
    window.WhittardQuickView = window.WhittardQuickView || {};

    var Q = window.WhittardQuickView;

    Q.getDrawerTitle = function () {
      var drawer = Q.getDrawer();
      if (!drawer) return null;

      return drawer.querySelector('#' + Q.drawerId + '-title') || drawer.querySelector('[data-drawer-title]');
    };

    Q.getQuickViewBackIcon = function () {
      var drawer = Q.getDrawer();
      var template = drawer ? drawer.querySelector('[data-quick-view-header-back-icon]') : null;

      if (!template) return '';

      return template.innerHTML;
    };

    Q.setQuickViewHeader = function (mode) {
      var title = Q.getDrawerTitle();
      var content = Q.getContent();

      if (!title || !content) return;

      var quickViewTitle = content.getAttribute('data-quick-view-title') || 'Quick View';
      var notifyTitle = content.getAttribute('data-quick-view-notify-title') || 'Notify me when back in stock';

      if (mode === 'notify-static') {
        title.textContent = notifyTitle;
        return;
      }

      if (mode === 'notify') {
        title.innerHTML =
          '<button type="button" class="inline-flex w-full items-center gap-8 text-left text-f2 uppercase text-primary cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" data-quick-view-header-back aria-label="' +
          Q.escapeHtml(notifyTitle) +
          '">' +
          Q.getQuickViewBackIcon() +
          '<span>' +
          Q.escapeHtml(notifyTitle) +
          '</span>' +
          '</button>';
        return;
      }

      title.textContent = quickViewTitle;
    };

    Q.bindQuickViewHeader = function () {
      var drawer = Q.getDrawer();
      if (!drawer || drawer.__quickViewHeaderBound) return;

      drawer.__quickViewHeaderBound = true;

      drawer.addEventListener('click', function (event) {
        var back = event.target.closest('[data-quick-view-header-back]');
        if (!back) return;

        event.preventDefault();

        var root = drawer.querySelector('[data-quick-view-product]');
        if (!root) return;

        Q.showQuickViewMainState(root);
      });
    };

    Q.showQuickViewNotifyState = function (root, variant, selection) {
      var state = Q.getQuickViewState(root);
      var mainState = root.querySelector('[data-quick-view-main-state]');
      var notifyState = root.querySelector('[data-quick-view-notify-state]');

      state.currentVariant = variant || state.currentVariant;
      state.currentSelection = selection || state.currentSelection;

      Q.resetQuickViewNotifyFeedback(root);
      Q.updateNotifySummary(root, state.currentVariant, state.currentSelection);
      Q.syncFooter(root, '[data-quick-view-notify-footer-source]');
      Q.setQuickViewHeader('notify');

      Q.fadeSwap(mainState, notifyState, Q.resetQuickViewScroll);
    };

    Q.showQuickViewMainState = function (root) {
      var mainState = root.querySelector('[data-quick-view-main-state]');
      var notifyState = root.querySelector('[data-quick-view-notify-state]');
      if (!mainState || !notifyState) return;
      Q.resetQuickViewNotifyFeedback(root);
      Q.syncFooter(root, '[data-quick-view-footer-source]');
      Q.syncQuickViewSubmitState(root);
      Q.setQuickViewHeader('default');
      Q.fadeSwap(notifyState, mainState, Q.resetQuickViewScroll);
    };

    Q.closeQuickViewAndOpenMiniBag = function (trigger) {
      var quickViewDrawer = Q.getDrawer();
      var closeButton = quickViewDrawer ? quickViewDrawer.querySelector('[data-drawer-close]') : null;
      Q.previousDrawerId = null;
      Q.previousDrawerTrigger = null;

      if (closeButton) {
        closeButton.click();
      }
      window.requestAnimationFrame(function () {
        if (window.__drawerOpen) {
          window.__drawerOpen('mini-bag', trigger);
        }
      });
    };

    Q.submitQuickViewAddToBundle = function (root, event) {
      event.preventDefault();
      var state = Q.getQuickViewState(root);
      var variant = state.currentVariant;
      if (!variant) return;
      // Refinement A: descriptor = the selected variant's option values (size + grind),
      // so the slot row reflects what was actually chosen in the Quick View.
      var descriptor =
        variant.option_summary || (state.currentSelection || []).filter(Boolean).join(' / ');
      document.dispatchEvent(
        new CustomEvent('custom-bundle:select', {
          bubbles: true,
          detail: {
            slot: Q.activeBundleSlot,
            productId: root.getAttribute('data-product-id'),
            variantId: variant.id,
            descriptor: descriptor,
          },
        })
      );
      // The custom-bundle engine writes the pick into the slot; close the Quick View.
      var drawer = Q.getDrawer();
      var closeButton = drawer ? drawer.querySelector('[data-drawer-close]') : null;
      if (closeButton) closeButton.click();
    };

    Q.submitQuickViewAddToCart = function (root, event) {
      if (Q.activeBundleSlot != null) {
        return Q.submitQuickViewAddToBundle(root, event);
      }
      event.preventDefault();
      var form = root.querySelector('[data-quick-view-product-form]');
      var footer = Q.getFooter();
      var submit = footer ? footer.querySelector('[data-quick-view-submit]') : null;
      if (!form || !submit || submit.disabled) return;
      Q.setButtonDisabled(submit, true);
      var formData = new FormData(form);
      var miniBagSectionId = window.MiniBag && typeof window.MiniBag.getSectionId === 'function'
        ? window.MiniBag.getSectionId()
        : 'mini-bag';
      formData.append('sections', miniBagSectionId);
      var addedSections = null;
      var addedProductId = null;
      var fellBackToNativeSubmit = false;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart_add_failed');
          return response.json();
        })
        .then(function (added) {
          addedSections = added && added.sections;
          addedProductId = added && added.product_id;
          return fetch('/cart.js');
        })
        .then(function (response) {
          if (!response.ok) throw new Error('cart_fetch_failed');
          return response.json();
        })
        .then(function (cart) {
          cart.sections = addedSections;

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: {
                cart: cart,
                addedProductId: addedProductId,
              },
            })
          );
          Q.closeQuickViewAndOpenMiniBag(submit);
        })
        .catch(function () {
          fellBackToNativeSubmit = true;
          form.submit();
        })
        .finally(function () {
          if (!fellBackToNativeSubmit) {
            Q.setButtonDisabled(submit, false);
          }
        });
    };

    Q.bindQuickViewFooter = function () {
      var footer = Q.getFooter();
      if (!footer || footer.__quickViewFooterBound) return;
      footer.__quickViewFooterBound = true;
      footer.addEventListener('click', function (event) {
        var notifyTrigger = event.target.closest('[data-quick-view-notify-trigger]');
        if (!notifyTrigger) return;
        event.preventDefault();
        var activeRoot = footer.__quickViewRoot;
        if (!activeRoot) return;
        var state = Q.getQuickViewState(activeRoot);
        Q.showQuickViewNotifyState(activeRoot, state.currentVariant, state.currentSelection);
      });
    };

    Q.initFloatingLabels = function (root) {
      if (!root) return;
      root.querySelectorAll('[data-float-field]').forEach(function (field) {
        if (field.__quickViewFloatReady) return;
        var input = field.querySelector('[data-float-input]');
        if (!input) return;
        field.__quickViewFloatReady = true;
        function sync() {
          field.classList.toggle('is-floated', document.activeElement === input || input.value.length > 0);
        }
        input.addEventListener('focus', sync);
        input.addEventListener('blur', sync);
        input.addEventListener('input', sync);
        sync();
      });
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quick-view-script-selling"] && !Shopify.designMode) return;
  try {
    (function () {
    window.WhittardQuickView = window.WhittardQuickView || {};

    var Q = window.WhittardQuickView;

    Q.syncQuickViewPurchaseOptionStyles = function (root) {
      var purchaseType = Q.selectedPurchaseType(root);

      root.querySelectorAll('[data-quick-view-purchase-option]').forEach(function (option) {
        var isSelected = option.getAttribute('data-quick-view-purchase-option') === purchaseType;

        option.classList.toggle('bg-black/3', isSelected);
      });
    };

    Q.scrollToQuickViewSubscription = function (root) {
      var elements = Q.getSellingPlanElements(root);

      if (!elements.ui || elements.ui.classList.contains('hidden')) return;

      window.requestAnimationFrame(function () {
        elements.ui.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      });
    };

    Q.getSellingPlanElements = function (root) {
      return {
        prompt: root.querySelector('[data-quick-view-subscription-prompt]'),
        ui: root.querySelector('[data-quick-view-selling-plan-ui]'),
        input: root.querySelector('[data-quick-view-selling-plan]'),
        select: root.querySelector('[data-quick-view-selling-plan-select]'),
        delivery: root.querySelector('[data-quick-view-delivery-message]'),
        subscribePrice: root.querySelector('[data-quick-view-subscribe-price]'),
        oncePrice: root.querySelector('[data-quick-view-once-price]'),
        purchaseTypes: root.querySelectorAll('[data-quick-view-purchase-type]'),
      };
    };

    Q.findSellingPlan = function (variant, sellingPlanId) {
      var plans = variant && variant.selling_plans ? variant.selling_plans : [];

      return (
        plans.find(function (plan) {
          return String(plan.id) === String(sellingPlanId);
        }) || null
      );
    };

    Q.selectedPurchaseType = function (root) {
      var checked = root.querySelector('[data-quick-view-purchase-type]:checked');

      return checked ? checked.value : 'once';
    };

    Q.selectedSellingPlan = function (root) {
      var state = Q.getQuickViewState(root);
      var elements = Q.getSellingPlanElements(root);

      if (!state.currentVariant || !elements.select) return null;

      return Q.findSellingPlan(state.currentVariant, elements.select.value);
    };

    Q.renderQuickViewSellingPlans = function (root, variant, shouldScroll) {
      var state = Q.getQuickViewState(root);
      var elements = Q.getSellingPlanElements(root);
      var plans = variant && variant.selling_plans ? variant.selling_plans : [];

      if (!elements.input || !elements.select) return;

      // Subscriptions are out of scope for the custom bundle flow (bundle lines are
      // never subscribable, and submitQuickViewAddToBundle never reads the selected
      // plan anyway) — hide the widget outright rather than offer a choice that would
      // silently be discarded on add.
      if (Q.activeBundleSlot != null) {
        if (elements.prompt) elements.prompt.classList.add('hidden');
        if (elements.ui) elements.ui.classList.add('hidden');
        if (elements.delivery) elements.delivery.classList.add('hidden');

        elements.input.value = '';
        elements.input.disabled = true;
        elements.select.innerHTML = '';
        return;
      }

      if (!variant) {
        if (elements.prompt) elements.prompt.classList.remove('hidden');
        if (elements.ui) elements.ui.classList.add('hidden');
        if (elements.delivery) elements.delivery.classList.add('hidden');

        elements.input.value = '';
        elements.input.disabled = true;
        elements.select.innerHTML = '';
        return;
      }

      if (!plans.length) {
        if (elements.prompt) elements.prompt.classList.add('hidden');
        if (elements.ui) elements.ui.classList.add('hidden');
        if (elements.delivery) elements.delivery.classList.add('hidden');

        elements.input.value = '';
        elements.input.disabled = true;
        elements.select.innerHTML = '';
        return;
      }

      var wasHidden = elements.ui && elements.ui.classList.contains('hidden');

      if (elements.prompt) elements.prompt.classList.add('hidden');
      if (elements.ui) elements.ui.classList.remove('hidden');
      if (elements.delivery) elements.delivery.classList.remove('hidden');

      if (wasHidden && shouldScroll) {
        Q.scrollToQuickViewSubscription(root);
      }

      if (elements.oncePrice) {
        elements.oncePrice.textContent = variant.price || '';
      }

      var variantChanged = state.sellingPlanVariantId !== variant.id;

      if (variantChanged) {
        state.sellingPlanVariantId = variant.id;

        /* One-time is the default purchase type: a shopper who opens a quick view to add
           a single item should not have to notice and undo a subscription first. Matches
           Q.selectedPurchaseType's own fallback, so the initial state and the
           no-radio-checked state now agree.

           sellingPlanId is still pre-populated from the first plan even though nothing is
           subscribed yet — it seeds the frequency dropdown, so switching to Subscribe has
           a valid selection immediately and does not need a second interaction. */
        state.purchaseType = 'once';
        state.sellingPlanId = plans[0].id;

        elements.select.innerHTML = plans
          .map(function (plan) {
            return '<option value="' + Q.escapeHtml(String(plan.id)) + '">' + Q.escapeHtml(plan.name) + '</option>';
          })
          .join('');

        elements.purchaseTypes.forEach(function (radio) {
          radio.checked = radio.value === 'once';
        });
      }

      if (state.sellingPlanId) {
        elements.select.value = state.sellingPlanId;
      }

      Q.syncQuickViewSellingPlan(root);
    };

    Q.syncQuickViewSellingPlan = function (root) {
      var state = Q.getQuickViewState(root);
      var elements = Q.getSellingPlanElements(root);

      if (!elements.input) return;

      var variant = state.currentVariant;
      var purchaseType = Q.selectedPurchaseType(root);
      var plan = Q.selectedSellingPlan(root);

      Q.syncQuickViewPurchaseOptionStyles(root);

      state.purchaseType = purchaseType;
      state.sellingPlanId = plan ? plan.id : '';

      if (!variant) {
        elements.input.value = '';
        elements.input.disabled = true;
        return;
      }

      /* Both rows carry their own price at all times, whichever one is selected. This
         used to be written only on the subscribe path, which was fine while subscribe was
         the default; with one-time as the default the Subscribe row would render blank
         until the shopper picked it. Keyed off the selected plan rather than the purchase
         type so changing frequency keeps it current either way. */
      if (elements.subscribePrice) {
        elements.subscribePrice.textContent = plan ? plan.price || '' : '';
      }

      if (purchaseType === 'subscribe' && plan) {
        elements.input.value = plan.id;
        elements.input.disabled = false;

        Q.syncQuickViewPrice(root, {
          price: plan.price,
          compare_at_price: plan.compare_at_price,
        });

        return;
      }

      elements.input.value = '';
      elements.input.disabled = true;

      Q.syncQuickViewPrice(root, variant);
    };

    /* Per the confirmed client decision: warehouse stock of exactly zero ALWAYS
       means unavailable, regardless of retail-store stock. An unknown (not yet
       backfilled) figure falls back to the blended signal - there is no better
       answer available. Warehouse stock never LOOSENS availability either: a
       known-positive figure only confirms the blend, it does not override a
       blend that is independently false (market exclusion, scheduled release,
       sales-channel removal). Correct formula: blended AND (unknown OR
       warehouse > 0). Published on Q so product-quick-view-script-notify.liquid
       reuses the identical rule; both snippets share one window.WhittardQuickView
       object, and every call happens from an event handler, so bundle execution
       order is irrelevant (FAILS_INDEX.md section 3). Product-bundle exception:
       variant.bundle_exempt (from custom.is_bundle / is_custom_bundle) skips the
       warehouse check entirely - a bundle always ships as one gift-wrapped unit
       regardless of any one line's own stock. Same shape for
       variant.gift_card_exempt (product.gift_card?) - a native gift card is
       never held in the Warehouse location, so warehouse_stock is not a real
       signal for it either; see warehouse-available.liquid's matching
       exception. */
    Q.warehouseAvailable = function (variant) {
      if (!variant) return false;
      var blended = Boolean(variant.available);
      if (variant.bundle_exempt || variant.gift_card_exempt) return blended;
      var raw = variant.warehouse_stock;
      if (raw === null || raw === undefined || raw === '') return blended;
      var n = Number(raw);
      if (!Number.isFinite(n)) return blended;
      return blended && n > 0;
    };

    Q.syncQuickViewSubmitState = function (root) {
      var state = Q.getQuickViewState(root);
      var shouldScrollToSubscription = Boolean(state.shouldScrollToSubscription);
      state.shouldScrollToSubscription = false;

      var form = root.querySelector('[data-quick-view-product-form]');
      var idInput = root.querySelector('[data-quick-view-variant-id]');
      var footer = Q.getFooter();
      var submit = footer ? footer.querySelector('[data-quick-view-submit]') : null;
      var addWrap = footer ? footer.querySelector('[data-quick-view-add-to-cart]') : null;
      var notifyWrap = footer ? footer.querySelector('[data-quick-view-notify-trigger-wrap]') : null;

      if (!form || !submit) return;

      var labelAdd = form.getAttribute('data-cta-add') || 'Add to bag';
      if (Q.activeBundleSlot != null && Q.bundleAddLabel) labelAdd = Q.bundleAddLabel;
      var labelChooseSize = form.getAttribute('data-cta-choose-size') || 'Choose a size';
      var labelUnavailable = form.getAttribute('data-cta-unavailable') || 'Unavailable';
      var notifyEnabled = form.getAttribute('data-notify-enabled') === 'true';

      var sizeMissing = Q.hasUnselectedSize(root);
      var selection = Q.currentSelection(root);
      var variant = sizeMissing ? null : Q.matchVariantFromSelection(state.variants, selection);
      var isAddable = variant && Q.warehouseAvailable(variant);

      if (variant && !isAddable) {
        shouldScrollToSubscription = false;
      }

      state.currentSelection = selection;
      state.currentVariant = variant;

      Q.syncSelectedLabels(root, selection);

      if (variant) {
        if (idInput) idInput.value = variant.id;
        Q.syncQuickViewPrice(root, variant);
      }

      Q.renderQuickViewSellingPlans(root, variant, shouldScrollToSubscription);

      if (notifyWrap) notifyWrap.classList.add('hidden');
      if (addWrap) addWrap.classList.remove('hidden');

      if (sizeMissing) {
        Q.renderQuickViewSellingPlans(root, null, false);
        Q.setButtonLabel(submit, labelChooseSize);
        Q.setButtonDisabled(submit, true);
        return;
      }

      if (isAddable) {
        Q.setButtonLabel(submit, labelAdd);
        Q.setButtonDisabled(submit, false);
        return;
      }

      if (variant && !isAddable && notifyEnabled) {
        if (addWrap) addWrap.classList.add('hidden');
        if (notifyWrap) {
          notifyWrap.classList.remove('hidden');
        }
        return;
      }

      Q.setButtonLabel(submit, labelUnavailable);
      Q.setButtonDisabled(submit, true);
    };
  })();

  (function () {
    window.WhittardQuickView = window.WhittardQuickView || {};

    var Q = window.WhittardQuickView;

    Q.getQuickViewOptionIndicatorItem = function (target) {
      return target.closest('label, a, button, span[aria-current]');
    };

    Q.setQuickViewOptionIndicator = function (root, item) {
      var picker = root.querySelector('[data-variant-picker]');
      var group = item && item.closest('[data-option-underline-group]');

      if (!group || !picker || !picker.contains(group)) return;

      if (group._optionResetFrame) {
        window.cancelAnimationFrame(group._optionResetFrame);
        group._optionResetFrame = 0;
      }

      group.style.setProperty('--option-indicator-x', item.offsetLeft + 'px');
      group.style.setProperty('--option-indicator-w', item.offsetWidth + 'px');
      group.setAttribute('data-option-indicator-ready', '');
      group.setAttribute('data-option-indicator-visible', 'true');
    };

    Q.resetQuickViewOptionIndicator = function (root, group) {
      if (!group) return;

      var checked = group.querySelector('input[data-option-position]:checked');
      var item = checked ? checked.closest('label, button') : group.querySelector('span[aria-current]');

      if (item) {
        Q.setQuickViewOptionIndicator(root, item);
      } else {
        group.setAttribute('data-option-indicator-ready', '');
        group.setAttribute('data-option-indicator-visible', 'false');
      }
    };

    Q.refreshQuickViewOptionIndicators = function (root) {
      var picker = root.querySelector('[data-variant-picker]');
      if (!picker) return;

      picker.querySelectorAll('[data-option-underline-group]').forEach(function (group) {
        Q.resetQuickViewOptionIndicator(root, group);
      });
    };

    Q.bindQuickViewOptionIndicators = function (root) {
      var picker = root.querySelector('[data-variant-picker]');
      if (!picker || picker.__quickViewOptionIndicatorsBound) return;

      picker.__quickViewOptionIndicatorsBound = true;

      picker.addEventListener('pointerover', function (event) {
        var item = Q.getQuickViewOptionIndicatorItem(event.target);
        if (item) Q.setQuickViewOptionIndicator(root, item);
      });

      picker.addEventListener('focusin', function (event) {
        var item = Q.getQuickViewOptionIndicatorItem(event.target);
        if (item) Q.setQuickViewOptionIndicator(root, item);
      });

      function handleOptionIndicatorLeave(event) {
        var group = event.target.closest('[data-option-underline-group]');
        if (!group) return;
        if (event.relatedTarget && group.contains(event.relatedTarget)) return;

        var isFocusLeave = event.type === 'focusout';
        if (group._optionResetFrame) {
          window.cancelAnimationFrame(group._optionResetFrame);
        }
        group._optionResetFrame = window.requestAnimationFrame(function () {
          group._optionResetFrame = 0;
          if (isFocusLeave && (group.matches(':hover') || group.contains(document.activeElement))) {
            return;
          }

          Q.resetQuickViewOptionIndicator(root, group);
        });
      }

      picker.addEventListener('focusout', handleOptionIndicatorLeave);
      picker
        .querySelectorAll('[data-option-underline-group]')
        .forEach(function (group) {
          group.addEventListener('pointerleave', handleOptionIndicatorLeave);
        });

      Q.refreshQuickViewOptionIndicators(root);
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quick-view-script"] && !Shopify.designMode) return;
  try {
    (function () {
    window.WhittardQuickView = window.WhittardQuickView || {};

    var Q = window.WhittardQuickView;

    Q.initQuickViewProduct = function (container) {
      var root = container.querySelector('[data-quick-view-product]');
      if (!root || root.__quickViewInitialised) return;

      root.__quickViewInitialised = true;

      var isAllOutOfStock = root.getAttribute('data-quick-view-all-out-of-stock') === 'true';

      if (isAllOutOfStock) {
        var allOosState = Q.getQuickViewState(root);
        var currentVariantId = root.getAttribute('data-current-variant-id');
        var allOosVariant = Q.findVariantById(allOosState.variants, currentVariantId) || allOosState.variants[0] || null;

        allOosState.currentVariant = allOosVariant;
        allOosState.currentSelection = allOosVariant && allOosVariant.options ? allOosVariant.options.slice() : [];

        Q.bindQuickViewHeader();
        Q.setQuickViewHeader('notify-static');
        Q.initFloatingLabels(root);
        Q.syncFooter(root, '[data-quick-view-notify-footer-source]');
        Q.bindQuickViewFooter();
        Q.updateNotifySummary(root, allOosState.currentVariant, allOosState.currentSelection);

        var allOosNotifyForm = root.querySelector('[data-quick-view-notify-form]');

        if (allOosNotifyForm) {
          allOosNotifyForm.addEventListener('submit', function (event) {
            Q.submitQuickViewNotify(root, event);
          });
        }

        return;
      }

      Q.bindQuickViewHeader();
      Q.setQuickViewHeader('default');

      Q.initFloatingLabels(root);
      Q.syncFooter(root, '[data-quick-view-footer-source]');
      Q.applyBundleVariantRestrictions(
        root
      );
      Q.syncQuickViewSubmitState(root);
      Q.bindQuickViewFooter();
      Q.bindQuickViewOptionIndicators(root);

      root.addEventListener('change', function (event) {
        if (event.target.matches('input[data-option-position]')) {
          var state = Q.getQuickViewState(root);
          var sizeAxis = root.querySelector('[data-size-axis]');

          state.shouldScrollToSubscription = Boolean(sizeAxis && sizeAxis.contains(event.target));
          Q.syncQuickViewSubmitState(root);
          Q.refreshQuickViewOptionIndicators(root);
          return;
        }

        if (
          event.target.matches('[data-quick-view-purchase-type]') ||
          event.target.matches('[data-quick-view-selling-plan-select]')
        ) {
          Q.syncQuickViewSellingPlan(root);
        }
      });

      root.addEventListener('click', function (event) {
        var oosButton = event.target.closest('[data-oos-notify]');

        if (oosButton) {
          event.preventDefault();
          event.stopPropagation();

          var state = Q.getQuickViewState(root);
          var selection = Q.optionSelectionFromOosButton(root, oosButton);
          var variant =
            Q.matchVariantFromSelection(state.variants, selection) ||
            Q.findVariantById(state.variants, oosButton.getAttribute('data-oos-variant-id'));

          Q.showQuickViewNotifyState(root, variant, selection);
          return;
        }

        var notifyTrigger = event.target.closest('[data-quick-view-notify-trigger]');

        if (notifyTrigger) {
          event.preventDefault();

          var currentState = Q.getQuickViewState(root);
          Q.showQuickViewNotifyState(root, currentState.currentVariant, currentState.currentSelection);
          return;
        }

        var back = event.target.closest('[data-quick-view-notify-back]');

        if (back) {
          event.preventDefault();
          Q.showQuickViewMainState(root);
        }

        var purchaseOption = event.target.closest('[data-quick-view-purchase-option]');

        if (purchaseOption && !event.target.matches('select')) {
          var radio = purchaseOption.querySelector('[data-quick-view-purchase-type]');

          if (radio && !radio.checked) {
            radio.checked = true;
            Q.syncQuickViewSellingPlan(root);
          }
        }
      });

      var productForm = root.querySelector('[data-quick-view-product-form]');

      if (productForm) {
        productForm.addEventListener('submit', function (event) {
          Q.submitQuickViewAddToCart(root, event);
        });
      }

      var notifyForm = root.querySelector('[data-quick-view-notify-form]');

      if (notifyForm) {
        notifyForm.addEventListener('submit', function (event) {
          Q.submitQuickViewNotify(root, event);
        });
      }
    };
  })();


  (function () {
    window.WhittardQuickView = window.WhittardQuickView || {};

    var Q = window.WhittardQuickView;

    if (Q.ready) return;
    Q.ready = true;

    Q.setLoaded = function (html, productUrl) {
      var target = Q.getContent();
      if (!target) return;

      target.removeAttribute('aria-busy');
      target.setAttribute('data-product-url', productUrl || '');
      target.innerHTML = Q.extractQuickViewHtml(html);

      Q.resetQuickViewScroll();

      Q.syncRating(target);
      Q.initQuickViewProduct(target);
    };

    Q.setError = function (productUrl) {
      var target = Q.getContent();
      if (!target) return;

      target.removeAttribute('aria-busy');
      target.setAttribute('data-product-url', productUrl || '');

      var message =
        target.getAttribute('data-quick-view-load-error') || 'Unable to load product details. Please try again.';

      target.innerHTML =
        '<div class="p-24 md:p-32 text-b2 text-semantic-red" role="alert">' + Q.escapeHtml(message) + '</div>';

      Q.resetFooter();
    };

    Q.previousDrawerId = null;
    Q.previousDrawerTrigger = null;

    Q.closeOpenDrawersBeforeQuickView = function () {
      Q.previousDrawerId = null;
      Q.previousDrawerTrigger = null;

      document.querySelectorAll('[data-drawer]:not([aria-hidden])').forEach(function (drawer) {
        if (drawer.id === Q.drawerId) return;

        Q.previousDrawerId = drawer.id;
        Q.previousDrawerTrigger = drawer._trigger || null;

        var closeButton = drawer.querySelector('[data-drawer-close]');

        if (closeButton) {
          closeButton.click();
        }
      });
    };

    Q.openQuickView = function (trigger) {
      Q.closeOpenDrawersBeforeQuickView();
      Q.resetQuickViewScroll();

      window.requestAnimationFrame(function () {
        if (window.__drawerOpen) {
          window.__drawerOpen(Q.drawerId, trigger);
        }

        Q.resetQuickViewScroll();
      });
    };

    document.addEventListener('drawer:close', function (event) {
      if (!event.detail || event.detail.id !== Q.drawerId) return;

      var previousId = Q.previousDrawerId;
      var previousTrigger = Q.previousDrawerTrigger;
      Q.previousDrawerId = null;
      Q.previousDrawerTrigger = null;

      if (!previousId || !window.__drawerOpen) return;

      window.requestAnimationFrame(function () {
        window.__drawerOpen(previousId, previousTrigger);
      });
    });

    Q.fetchQuickView = function (productUrl) {
      var cacheKey = Q.normaliseProductUrl(productUrl);

      if (Q.cache[cacheKey]) {
        return Q.cache[cacheKey];
      }

      Q.cache[cacheKey] = fetch(Q.buildSectionUrl(productUrl), {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('quick_view_failed');
          return response.text();
        })
        .then(function (html) {
          if (!html || !html.trim()) {
            throw new Error('quick_view_empty');
          }

          Q.cache[cacheKey] = Promise.resolve(html);
          return html;
        })
        .catch(function (error) {
          delete Q.cache[cacheKey];
          throw error;
        });

      return Q.cache[cacheKey];
    };

    Q.prefetchQuickView = function (productUrl) {
      if (!productUrl) return;

      var cacheKey = Q.normaliseProductUrl(productUrl);
      if (Q.cache[cacheKey]) return;

      Q.fetchQuickView(productUrl).catch(function () {});
    };

    Q.loadQuickView = function (productUrl, trigger) {
      var requestId = ++Q.activeRequestId;
      var target = Q.getContent();

      if (target) {
        target.setAttribute('aria-busy', 'true');
        target.innerHTML = '';
      }

      Q.resetFooter();

      Q.fetchQuickView(productUrl)
        .then(function (html) {
          if (requestId !== Q.activeRequestId) return;

          /*
          * Customisable bundles must be configured on their PDP rather
          * than through standard Quick View.
          *
          * Tagalys does not expose Shopify product metafields, so the
          * fetched Shopify Quick View section is the source of truth.
          *
          * Keep bundle-picker Quick View unchanged.
          */
          if (Q.activeBundleSlot == null && Q.isCustomBundleResponse(html)) {
            window.location.assign(productUrl);
            return;
          }

          Q.setLoaded(html, productUrl);
          Q.openQuickView(trigger);
        })
        .catch(function () {
          if (requestId !== Q.activeRequestId) return;

          Q.setError(productUrl);
          Q.openQuickView(trigger);
        });
    };

    Q.handleQuickViewPrefetch = function (event) {
      var trigger = event.target.closest('[data-quick-view-open], [data-product-card]');
      if (!trigger) return;

      var productUrl = trigger.getAttribute('data-product-url');
      if (!productUrl) return;

      window.clearTimeout(Q.prefetchTimer);

      Q.prefetchTimer = window.setTimeout(function () {
        Q.prefetchQuickView(productUrl);
      }, Q.prefetchDelay);
    };

    Q.cancelQuickViewPrefetch = function (event) {
      var trigger = event.target.closest('[data-quick-view-open], [data-product-card]');
      if (!trigger) return;
      if (event.relatedTarget && trigger.contains(event.relatedTarget)) return;

      window.clearTimeout(Q.prefetchTimer);
    };

    document.addEventListener('pointerout', Q.cancelQuickViewPrefetch);
    document.addEventListener('pointerover', Q.handleQuickViewPrefetch);
    document.addEventListener('focusin', Q.handleQuickViewPrefetch);
    document.addEventListener('touchstart', Q.handleQuickViewPrefetch, { passive: true });

    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest('[data-quick-view-open]');
        if (!trigger) return;

        event.preventDefault();
        event.stopPropagation();

        var productUrl = trigger.getAttribute('data-product-url');
        if (!productUrl) return;

        // Bundle mode: a picker card trigger carries data-cb-qv-trigger. Route this
        // session to the active bundle slot (exposed by the custom-bundle engine) and
        // remember the trigger for focus restore on close. A normal QV clears both.
        var isBundleTrigger = trigger.hasAttribute('data-cb-qv-trigger');
        Q.activeBundleSlot = isBundleTrigger ? Q.bundleSlot : null;
        Q.bundleTrigger = Q.activeBundleSlot != null ? trigger : null;
        Q.allowedBundleVariantIds = isBundleTrigger ? Q.parseBundleAllowedVariantIds(trigger) : [];

        Q.loadQuickView(productUrl, trigger);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-recharge-select"] && !Shopify.designMode) return;
  try {
    (function () {
    function findSelect(shadowRoot) {
      return shadowRoot.querySelector(
        'select[name="rc_plan"], select[name*="rc_plan"], select[name="selling_plan"], select[name*="selling_plan"]'
      );
    }

    /*
     * Recharge re-renders its widget after first paint (loading pricing/policy
     * copy async), swapping in a new <select> node — the old one's overlay is
     * then orphaned. That used to get cleaned up incidentally, almost as soon
     * as it happened, by the scroll listener's isConnected check; now that
     * position no longer needs tracking on scroll, nothing else was pruning
     * it, so a leftover overlay could sit visible, slightly offset from the
     * new one, until the next resize. Pruned instead right when a shadow-DOM
     * change is observed — the actual moment a swap can happen — not on an
     * unrelated timer.
     */
    var activeMirrors = [];
    function pruneMirrors() {
      activeMirrors = activeMirrors.filter(function (entry) {
        if (entry.select.isConnected) return true;
        entry.wrap.remove();
        return false;
      });
    }

    function buildOverlayWrap() {
      /* div, not span: custom-select.js appends a <ul> into this wrap in the
         Recharge branch, and a <ul> is flow content, invalid inside a span's
         phrasing content. */
      var wrap = document.createElement('div');
      wrap.className =
        'group absolute flex cursor-pointer items-center justify-between gap-8 border border-border-secondary bg-black/3 px-16 transition-colours hover:bg-black/5 focus-within:bg-black/5 aria-expanded:bg-black/5';
      wrap.setAttribute('data-custom-select-wrap', '');
      /* Marks this as the subscription frequency control specifically. The page
         can carry several custom selects and they are otherwise identical, so
         assets/analytics-subscription.js has no other way to tell which one is
         "Deliver every" for the subscription_frequency event, and custom-select.js
         uses it to route this wrap's open list through the same in-flow anchoring
         as a drawer's, instead of the fixed/body-portal path. */
      wrap.setAttribute('data-recharge-frequency', '');
      wrap.setAttribute('tabindex', '0');

      var label = document.createElement('span');
      label.className = 'whitespace-nowrap text-b2 text-primary';
      label.setAttribute('data-custom-select-label', '');

      var chevron = document.createElement('span');
      chevron.className = 'pointer-events-none shrink-0 transition-transform group-aria-expanded:rotate-180';
      chevron.setAttribute('aria-hidden', 'true');
      chevron.innerHTML =
        '<svg style="width:12px;height:12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">' +
        '<path d="M19 8.5L12 15.5L5 8.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      wrap.appendChild(label);
      wrap.appendChild(chevron);
      /* Not appended here — anchor() appends it into the resolved host, once
         that host is known. */
      return wrap;
    }

    function outermostHost(el) {
      var node = el;
      var root = node.getRootNode();
      while (root !== document) {
        node = root.host;
        root = node.getRootNode();
      }
      return node;
    }

    /*
     * `host` is any light-DOM ancestor shared by the select and by
     * [data-product-primary-actions] — [data-buy-panel-content] wraps the
     * whole buy panel, including both. Scrolling moves host, the real select
     * and the action area together as one rigid unit, so an offset measured
     * against host stays correct through any amount of scrolling; only an
     * actual layout change (resize, a Recharge re-render) invalidates it.
     */
    function anchor(wrap, select) {
      var rect = select.getBoundingClientRect();
      /* Its parent, not [data-add-to-cart]: product.liquid hides that row when out of stock, and display:none measures all zeros (TASK-54502). */
      var container = document.querySelector('[data-product-primary-actions]') || outermostHost(select).parentElement || outermostHost(select);
      var containerRect = container.getBoundingClientRect();
      /* Nothing measurable to anchor against, so keep the last good offsets. Not on the first pass: the real select is hidden by then, so returning would leave no control at all. */
      if (!containerRect.width && wrap.parentNode) return;
      var host = outermostHost(select).closest('[data-buy-panel-content]') || outermostHost(select).parentElement || outermostHost(select);
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      if (wrap.parentNode !== host) host.appendChild(wrap);
      var hostRect = host.getBoundingClientRect();
      wrap.style.top = (rect.top - hostRect.top + 8) + 'px';
      wrap.style.left = (containerRect.left - hostRect.left) + 'px';
      wrap.style.width = containerRect.width + 'px';
      wrap.style.height = rect.height + 'px';
    }

    function hideNativeIcon(select) {
      var root = select.getRootNode();
      var icon = root.querySelector ? root.querySelector('.rc-plans-dropdown__icon') : null;
      if (icon) icon.style.display = 'none';
    }

    function mirror(select) {
      if (select.__customSelectMirrored) return;
      pruneMirrors();
      select.__customSelectMirrored = true;
      select.style.opacity = '0';
      select.style.pointerEvents = 'none';
      hideNativeIcon(select);

      var wrap = buildOverlayWrap();
      anchor(wrap, select);
      if (window.CustomSelect) window.CustomSelect.enhance(wrap, select);
      activeMirrors.push({ select: select, wrap: wrap });

      /*
       * No scroll listener: wrap is a plain in-flow `absolute` element inside
       * [data-buy-panel-content] now, so it moves with the page for free.
       * Only resize and an actual size change (to the select, or to the
       * widget host as a whole, e.g. Recharge re-rendering after a plan
       * change) can invalidate the offset anchor() computed.
       */
      var raf = null;
      function reposition() {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          if (!select.isConnected) {
            window.removeEventListener('resize', reposition);
            pruneMirrors();
            return;
          }
          anchor(wrap, select);
        });
      }
      window.addEventListener('resize', reposition, { passive: true });
      if (window.ResizeObserver) {
        new ResizeObserver(reposition).observe(select);
        new ResizeObserver(reposition).observe(outermostHost(select));
      }
    }

    function watchSellingPlansHost(host) {
      if (host.__rechargeSelectWatched) return;
      host.__rechargeSelectWatched = true;
      var select = findSelect(host.shadowRoot);
      if (select) mirror(select);
      new MutationObserver(function () {
        pruneMirrors();
        var found = findSelect(host.shadowRoot);
        if (found) mirror(found);
      }).observe(host.shadowRoot, { childList: true, subtree: true });
    }

    function watchWidgetHost(host) {
      if (host.__rechargeWidgetWatched) return;
      host.__rechargeWidgetWatched = true;
      Array.prototype.forEach.call(host.shadowRoot.querySelectorAll('rc-selling-plans'), function (plansHost) {
        if (plansHost.shadowRoot) watchSellingPlansHost(plansHost);
      });
      new MutationObserver(function () {
        Array.prototype.forEach.call(host.shadowRoot.querySelectorAll('rc-selling-plans'), function (plansHost) {
          if (plansHost.shadowRoot) watchSellingPlansHost(plansHost);
        });
      }).observe(host.shadowRoot, { childList: true, subtree: true });
    }

    function scan() {
      Array.prototype.forEach.call(
        document.querySelectorAll('recharge-subscription-widget'),
        function (widget) {
          if (widget.shadowRoot) watchWidgetHost(widget);
        }
      );
    }

    scan();
    [500, 1500, 3000].forEach(function (delay) {
      window.setTimeout(scan, delay);
    });

    if (window.MutationObserver) {
      new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-reviews-script"] && !Shopify.designMode) return;
  try {
    /*
   * Yotpo reviews module (API-driven, no widget). One module instance per
   * [data-product-reviews]. Reads config + i18n from data-* and an inline JSON
   * block, lazy-fetches on scroll (IntersectionObserver), session-caches the JSON
   * per product id on window, re-fetches with AbortController (8s timeout) on
   * rating-filter/page change, and surfaces all four async states. The free-text
   * search and the with-media toggle filter the CURRENTLY-LOADED page client-side
   * (the per-product Yotpo CDN endpoint has no free-text search). All user-facing
   * strings come from the JSON i18n block (no hard-coded English here).
   */
  document.querySelectorAll('[data-product-reviews]').forEach(function (root) {
    if (root.__reviewsReady) return;
    root.__reviewsReady = true;

    var appKey = root.getAttribute('data-yotpo-app-key');
    var productId = root.getAttribute('data-product-id');
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 10;

    var i18nEl = root.querySelector('[data-reviews-i18n]');
    var t = {};
    try { t = JSON.parse(i18nEl.textContent); } catch (e) { t = {}; }
    function fmt(str, map) {
      if (!str) return '';
      return str.replace(/__([A-Z]+)__/g, function (m, key) {
        var k = key.toLowerCase();
        return map && map[k] != null ? map[k] : m;
      });
    }

    // ── Element references ──
    var loadingEl = root.querySelector('[data-reviews-loading]');
    var emptyEl = root.querySelector('[data-reviews-empty]');
    var errorEl = root.querySelector('[data-reviews-error]');
    var errorMsgEl = root.querySelector('[data-reviews-error-message]');
    var emptyHeadingEl = root.querySelector('[data-reviews-empty-heading]');
    var emptyBodyEl = root.querySelector('[data-reviews-empty-body]');
    var listEl = root.querySelector('[data-reviews-list]');
    var aiSummaryEl = root.querySelector('[data-ai-summary]');
    var aiSummaryTextEl = root.querySelector('[data-ai-summary-text]');
    var topicsTriggerEl = root.querySelector('[data-ai-summary-topics-trigger]');

    /*
     * The topics drawer is resolved from `document` at render time, not scoped to
     * `root` at setup like every other reference here. snippets/drawer.liquid hoists
     * every [data-drawer] element to <body> (see hoistDrawers there) so drawers escape
     * ancestor stacking contexts — which means the panel is not a descendant of this
     * section, and a scoped query returns null depending only on whether that hoist
     * happened before or after this module ran. Same reasoning as the one sanctioned
     * document-level lookup in sections/store-finder.liquid.
     *
     * The id is read off the trigger so it is declared once, in the markup.
     */
    function topicsDrawerEl() {
      var id = topicsTriggerEl && topicsTriggerEl.getAttribute('data-drawer-open');
      return id ? document.getElementById(id) : null;
    }
    var paginationEl = root.querySelector('[data-reviews-pagination]');
    var paginationListEl = root.querySelector('[data-reviews-pagination-list]');
    // The shared arrows trio stamps these onto the buttons themselves (product-carousel-arrows.liquid).
    var prevBtn = root.querySelector('button[data-reviews-prev]');
    var nextBtn = root.querySelector('button[data-reviews-next]');
    var scoreEl = root.querySelector('[data-summary-score]');
    var starsEl = root.querySelector('[data-summary-stars]');
    var countEl = root.querySelector('[data-summary-count]');
    var cardTemplate = root.querySelector('[data-review-card-template]');
    var ratingControls = root.querySelectorAll('[data-filter-rating]');
    var ratingControlLabels = root.querySelectorAll('[data-filter-rating-label]');
    var mediaControls = root.querySelectorAll('[data-filter-media]');
    var searchControl = root.querySelector('[data-reviews-search]');
    var summaryEl = root.querySelector('[data-reviews-summary]');
    var dividerEl = root.querySelector('[data-reviews-divider]');
    var reviewsBodyEl = root.querySelector('[data-reviews-body]');

    // Header summary lives outside this root (in the buy panel) — update it too.
    var headerRating = document.querySelector('[data-product-rating]');

    // ── State ──
    var state = { page: 1, star: '', sort: 'date', direction: 'desc', withMedia: false, search: '' };
    var controller = null;
    var hasFetched = false;
    var currentReviews = []; // reviews for the loaded page (search/media filter over this)
    var totalPages = 1;

    function showState(name) {
      [['loading', loadingEl], ['empty', emptyEl], ['error', errorEl]].forEach(function (pair) {
        if (pair[1]) pair[1].classList.toggle('hidden', pair[0] !== name);
        if (pair[1]) pair[1].classList.toggle('flex', pair[0] === name);
      });
      if (listEl) {
        listEl.classList.toggle('hidden', name !== 'loaded');
        listEl.classList.toggle('flex', name === 'loaded');
      }
      if (loadingEl && name === 'loading') loadingEl.classList.add('flex');
    }

    /*
     * Whether the PRODUCT has any reviews, as opposed to whether the current filter
     * matched any. Read from the unfiltered summary response that fetchSummary caches.
     *
     * These were the same thing while filtering was client-side, because `total` always
     * came from an unfiltered response. Now that media and free-text filters are applied
     * by the API, a filter matching nothing returns total: 0 — and feeding that to
     * setReviewsLayoutHasContent hid [data-reviews-body], which contains the search
     * field, the filter controls AND the empty-state message. The controls that created
     * the filter disappeared along with everything else, leaving no way to clear it.
     *
     * Returns null while the summary is still in flight, so callers can fall back.
     */
    function productReviewCount() {
      var cached = getCache()['summary|' + productId];
      var bottomline = cached && (cached.response || {}).bottomline;
      if (!bottomline) return null;
      var n = parseInt(bottomline.total_review, 10);
      return isFinite(n) ? n : null;
    }

    function setReviewsLayoutHasContent(hasReviews) {
      if (summaryEl) {
        summaryEl.classList.toggle('gap-40', hasReviews);
      }

      if (dividerEl) {
        dividerEl.classList.toggle('hidden', !hasReviews);
      }

      if (reviewsBodyEl) {
        reviewsBodyEl.classList.toggle('hidden', !hasReviews);
      }
    }

    // ── Star rendering (proportional fill: full / partial / empty) ──
    var STAR_SVG = root.querySelector('[data-summary-stars] svg');
    function makeStar(colorClass) {
      var star = STAR_SVG ? STAR_SVG.cloneNode(true) : document.createElement('span');
      if (star.setAttribute) star.setAttribute('class', colorClass);
      star.style.width = '16px';
      star.style.height = '16px';
      star.style.maxWidth = 'none'; // never let an inherited reset scale it down
      star.style.flex = '0 0 auto'; // never let a flex parent shrink it
      star.style.display = 'block';
      return star;
    }
    function renderStars(target, score, ariaLabel) {
      target.textContent = '';
      var s = Math.max(0, Math.min(5, score || 0));
      for (var i = 1; i <= 5; i++) {
        var fill = Math.max(0, Math.min(1, s - (i - 1))); // 0..1 for this star
        if (fill >= 1) {
          // whole filled star (navy — matches the PDP header rating, Figma 6771:7093)
          target.appendChild(makeStar('text-brand-primary-blue'));
        } else if (fill <= 0) {
          target.appendChild(makeStar('text-border-secondary'));
        } else {
          // partial star: grey base + a left-anchored navy overlay, clipped to fill%.
          // The overlay is absolutely pinned to the clip's left edge at full width, so
          // the clip's overflow does the trimming — the glyph is never squashed.
          var wrap = document.createElement('span');
          wrap.style.position = 'relative';
          wrap.style.display = 'block';
          wrap.style.width = '16px';
          wrap.style.height = '16px';
          wrap.style.flex = '0 0 auto';
          var base = makeStar('text-border-secondary');
          base.style.position = 'absolute';
          base.style.top = '0';
          base.style.left = '0';
          var clip = document.createElement('span');
          clip.style.position = 'absolute';
          clip.style.top = '0';
          clip.style.left = '0';
          clip.style.height = '100%';
          clip.style.width = (fill * 100) + '%';
          clip.style.overflow = 'hidden';
          var overlay = makeStar('text-brand-primary-blue');
          overlay.style.position = 'absolute';
          overlay.style.top = '0';
          overlay.style.left = '0';
          clip.appendChild(overlay);
          wrap.appendChild(base);
          wrap.appendChild(clip);
          target.appendChild(wrap);
        }
      }
      if (ariaLabel) target.setAttribute('aria-label', ariaLabel);
    }

    // ── Summary (bottomline) ──
    function renderSummary(bottomline) {
      var score = bottomline && bottomline.average_score ? bottomline.average_score : 0;
      var total = bottomline && bottomline.total_review ? bottomline.total_review : 0;
      if (scoreEl) scoreEl.textContent = score.toFixed(1);
      if (starsEl) renderStars(starsEl, score, fmt(t.ratingValue, { rating: score.toFixed(1) }));
      if (countEl) {
        countEl.textContent = fmt(total === 1 ? t.basedOnCountOne : t.basedOnCount, { count: total });
      }
      syncHeaderSummary(score, total);
    }

    function syncHeaderSummary(score, total) {
      if (!headerRating) return;
      if (!total) {
        headerRating.classList.add('hidden');
        return;
      }
      headerRating.classList.remove('hidden');
      var v = headerRating.querySelector('[data-rating-value]');
      var c = headerRating.querySelector('[data-rating-count]');
      if (v) v.textContent = score.toFixed(1);
      headerRating.setAttribute('aria-label', fmt(t.ratingValue, { rating: score.toFixed(1) }));
      if (c) {
        c.textContent = fmt(t.reviewsCount, { count: total });
        c.classList.remove('hidden');
      }
    }

    // ── Review cards ──
    function setEmptyCopy(mode) {
      if (!emptyHeadingEl || !emptyBodyEl) return;
      if (mode === 'filtered') {
        emptyHeadingEl.textContent = t.emptyFilteredHeading || t.emptyHeading || '';
        emptyBodyEl.textContent = t.emptyFilteredBody || t.emptyBody || '';
        return;
      }
      emptyHeadingEl.textContent = t.emptyHeading || '';
      emptyBodyEl.textContent = t.emptyBody || '';
    }

    function renderList(rows) {
      listEl.textContent = '';
      // No client-side filtering: rating, media and free text are all applied by the
      // API now, so whatever came back is exactly what should render.
      if (!rows.length) {
        setEmptyCopy('filtered');
        showState('empty');
        return;
      }
      rows.forEach(function (review) {
        var node = cardTemplate.content.firstElementChild.cloneNode(true);
        renderStars(node.querySelector('[data-card-stars]'), review.score || 0,
          fmt(t.ratingValue, { rating: review.score || 0 }));
        node.querySelectorAll('[data-card-date]').forEach(function (dateEl) {
          dateEl.textContent = formatDate(review.created_at);
        });
        node.querySelector('[data-card-title]').textContent = review.title || '';
        node.querySelector('[data-card-content]').textContent = review.content || '';
        node.querySelector('[data-card-author]').textContent =
          (review.user && review.user.display_name) ? review.user.display_name : '';
        if (review.verified_buyer) {
          var v = node.querySelector('[data-card-verified]');
          v.classList.remove('hidden');
          v.classList.add('flex');
        }
        renderMedia(node.querySelector('[data-card-media]'), review.images_data);
        listEl.appendChild(node);
      });
      showState('loaded');
    }

    function renderMedia(target, images) {
      if (!target || !images || !images.length) return;
      // A SINGLE thumbnail — the first image only (Figma review cells 6728:74332).
      var img = images[0];
      var url = img.thumb_url || img.original_url;
      if (!url) return;
      target.classList.remove('hidden');
      // Review media are EXTERNAL Yotpo URLs — plain <img>, NOT snippets/image.liquid.
      var el = document.createElement('img');
      el.src = url;
      el.loading = 'lazy';
      el.width = 105;
      el.height = 140;
      el.alt = '';
      el.className = 'w-full h-full object-cover';
      target.appendChild(el);
    }

    function formatDate(iso) {
      if (!iso) return '';
      var d = new Date(iso);
      if (isNaN(d)) return '';
      var dd = ('0' + d.getDate()).slice(-2);
      var mm = ('0' + (d.getMonth() + 1)).slice(-2);
      var yy = ('' + d.getFullYear()).slice(-2);
      return dd + '/' + mm + '/' + yy;
    }

    // ── Pagination ──
    function setArrowDisabled(btn, disabled) {
      if (!btn) return;
      btn.disabled = disabled;
      if (disabled) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    }
    function goToPage(page) {
      if (page < 1 || page > totalPages || page === state.page) return;
      state.page = page;
      fetchReviews();
    }
    var ELLIPSIS = '...';

    // Which cells the control draws, per Figma 6728:75203. That frame is five cells
    // wide — "1 2 3 ... 6", the current page filled — and five 36px cells plus the
    // 24px gap and the 72px arrows is exactly its 276px width, so five is treated as
    // the design's cell budget rather than an artefact of it being drawn at six pages.
    // Holding to it also means the control cannot outgrow its column: at 3 reviews a
    // page, 476 reviews is 159 pages, which is what previously rendered 159 cells and
    // pushed the row off screen.
    //
    // First and last are always reachable; the pages the budget omits collapse into
    // '...'. Only the "current page is early" case has a Figma frame — with page 1 of 6
    // this returns [1, 2, 3, '...', 6], the frame exactly. The late and middle cases
    // below have no frame and are a reasoned extension of the same vocabulary, not a
    // design; stepping through the omitted pages is what the arrows are for.
    function pageSlots(current, total) {
      if (total <= 5) {
        var all = [];
        for (var p = 1; p <= total; p++) all.push(p);
        return all;
      }
      if (current <= 3) return [1, 2, 3, ELLIPSIS, total];
      if (current >= total - 2) return [1, ELLIPSIS, total - 2, total - 1, total];
      return [1, ELLIPSIS, current, ELLIPSIS, total];
    }

    // Figma's own border model: every cell draws its top, bottom and left edge, and
    // only the last cell draws a right edge — so the shared verticals are single
    // hairlines, and an active cell needs no border at all because its fill defines
    // its edges.
    function cellClass(active, first, last) {
      return [
        'flex items-center justify-center w-36 h-28 py-8 text-f2 uppercase transition-btn-primary',
        first ? 'rounded-l-xs' : '',
        last ? 'rounded-r-xs' : '',
        active
          ? 'bg-surface-secondary-blue text-invert'
          : 'border-y border-l border-border-secondary text-secondary' + (last ? ' border-r' : '')
      ].filter(Boolean).join(' ');
    }

    function renderPagination(total) {
      if (!paginationEl || !paginationListEl) return;
      paginationListEl.textContent = '';
      totalPages = Math.ceil(total / perPage) || 1;
      if (totalPages <= 1) { paginationEl.classList.add('hidden'); return; }
      paginationEl.classList.remove('hidden');
      paginationEl.classList.add('flex');

      var slots = pageSlots(state.page, totalPages);
      slots.forEach(function (slot, index) {
        var first = index === 0;
        var last = index === slots.length - 1;
        var li = document.createElement('li');

        if (slot === ELLIPSIS) {
          // A cell, not a control: it carries the same box as its neighbours but is
          // inert, and hidden from assistive tech — the pages it stands for are still
          // reachable through the arrows, so there is nothing here to announce.
          var gap = document.createElement('span');
          gap.className = cellClass(false, first, last);
          gap.textContent = ELLIPSIS;
          gap.setAttribute('aria-hidden', 'true');
          li.appendChild(gap);
          paginationListEl.appendChild(li);
          return;
        }

        var page = slot;
        var active = page === state.page;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = cellClass(active, first, last) +
          ' cursor-pointer' +
          (active ? '' : ' hover:border-surface-blue hover:bg-surface-blue hover:text-invert');
        btn.textContent = page;
        btn.setAttribute('aria-label', fmt(active ? t.paginationCurrentPage : t.paginationPage, { page: page }));
        if (active) btn.setAttribute('aria-current', 'page');
        btn.addEventListener('click', function () { goToPage(page); });
        li.appendChild(btn);
        paginationListEl.appendChild(li);
      });

      setArrowDisabled(prevBtn, state.page <= 1);
      setArrowDisabled(nextBtn, state.page >= totalPages);
    }

    // ── Fetch ──
    /*
     * Server-side filters are part of the key: media and free-text results are now
     * fetched rather than derived from the loaded page, so two different filter states
     * are genuinely different responses.
     */
    function cacheKey() {
      return [productId, state.page, state.star, state.sort, state.direction,
              state.withMedia ? 'media' : '', (state.search || '').trim().toLowerCase()].join('|');
    }

    /*
     * Whether the request has to go to the filter endpoint rather than the CDN feed.
     *
     * The CDN feed (api-cdn .../reviews.json) has no media or free-text parameters, so
     * both filters used to run client-side over the loaded page only — with per_page
     * defaulting to 3 that made them close to useless, and "with media" all but always
     * empty. POST /v1/reviews/{app_key}/filter.json does both server-side across every
     * page, needs no token, and returns a real pagination total.
     *
     * The CDN feed stays the default because it is CDN-cached and carries `bottomline`,
     * which drives the header score; filter.json returns bottomline: null.
     */
    function hasServerFilters() {
      return Boolean(state.withMedia || (state.search || '').trim());
    }
    function getCache() {
      window.__yotpoReviewsCache = window.__yotpoReviewsCache || {};
      return window.__yotpoReviewsCache;
    }

    function applyResponse(data) {
      var resp = (data && data.response) || {};
      // Only when present: filter.json returns bottomline: null, and renderSummary(null)
      // would reset the header score and count to 0.0 / 0 reviews.
      if (resp.bottomline) renderSummary(resp.bottomline);
      currentReviews = resp.reviews || [];
      var paginationTotal = resp.pagination
        ? Number(resp.pagination.total)
        : NaN;
      var bottomlineTotal = resp.bottomline
        ? Number(resp.bottomline.total_review)
        : NaN;
      var total = isFinite(paginationTotal) && paginationTotal > 0
        ? paginationTotal
        : (isFinite(bottomlineTotal) ? bottomlineTotal : currentReviews.length);
      var hasReviews = total > 0;

      /*
       * Layout collapse is reserved for products with no reviews at all. A filter that
       * matches nothing must keep the body — and therefore the controls — on screen so
       * the filter can be cleared. Falls back to the response total only while the
       * summary is still loading.
       */
      var productTotal = productReviewCount();
      setReviewsLayoutHasContent(productTotal === null ? hasReviews : productTotal > 0);

      renderPagination(total);
      if (!hasReviews || !currentReviews.length) {
        setEmptyCopy(hasServerFilters() || state.star ? 'filtered' : 'default');
        showState('empty');
        return;
      }
      renderList(currentReviews);
    }

    function fetchReviews() {
      var key = cacheKey();
      var cache = getCache();
      if (cache[key]) { applyResponse(cache[key]); return; }

      if (controller) controller.abort();
      controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 8000);
      showState('loading');

      var url, options;

      if (hasServerFilters()) {
        /*
         * Filtered read — POST /v1/reviews/{app_key}/filter.json.
         *
         * Documented as needing an X-Yotpo-Token, but it answers 200 with the public app
         * key alone as the store id, same as the v3 productData endpoint. `pictured`
         * returns only reviews carrying pictures and `free_text_search` searches the
         * whole review set, both across every page, and `pagination.total` reflects the
         * filtered count so the pager stays honest.
         */
        var body = {
          domain_key: productId,
          page: state.page,
          per_page: perPage,
          sortings: [{ sort_by: state.sort, ascending: state.direction === 'asc' }]
        };
        if (state.star) body.scores = [parseInt(state.star, 10)];
        if (state.withMedia) body.pictured = true;
        var term = (state.search || '').trim();
        if (term) body.free_text_search = term;

        url = 'https://api.yotpo.com/v1/reviews/' + encodeURIComponent(appKey) + '/filter.json';
        options = {
          method: 'POST',
          signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        };
      } else {
        // Unfiltered read — the CDN feed. Cached at the edge and carries `bottomline`,
        // which filter.json does not return.
        url = 'https://api-cdn.yotpo.com/v1/widget/' + encodeURIComponent(appKey) +
          '/products/' + encodeURIComponent(productId) + '/reviews.json' +
          '?page=' + state.page + '&per_page=' + perPage +
          '&sort=' + encodeURIComponent(state.sort) + '&direction=' + encodeURIComponent(state.direction) +
          (state.star ? '&star=' + encodeURIComponent(state.star) : '');
        options = { signal: controller.signal, headers: { Accept: 'application/json' } };
      }

      fetch(url, options)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          cache[key] = data;
          applyResponse(data);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') {
            if (errorMsgEl) errorMsgEl.textContent = t.errorTimeout || '';
          } else {
            if (errorMsgEl) errorMsgEl.textContent = t.errorBody || '';
          }
          showState('error');
        })
        .finally(function () {
          clearTimeout(timeout);
        });
    }

    // Eager summary-only fetch (per_page=1) so the above-the-fold header rating
    // shows the real Yotpo score/count on landing, without waiting for the
    // reviews section to scroll into view. The full list stays lazy (below).
    function fetchSummary() {
      var key = 'summary|' + productId;
      var cache = getCache();
      if (cache[key]) { renderSummary((cache[key].response || {}).bottomline); return; }
      var url = 'https://api-cdn.yotpo.com/v1/widget/' + encodeURIComponent(appKey) +
        '/products/' + encodeURIComponent(productId) + '/reviews.json?page=1&per_page=1';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) { cache[key] = data; renderSummary((data.response || {}).bottomline); })
        .catch(function () { /* header keeps its server-rendered fallback */ });
    }

    /*
     * AI "Customers Say" paragraph — Yotpo v3 storefront productData.
     *
     * A different service from the reviews CDN feed above: the public app key is the
     * store id, no X-Yotpo-Token is required, and it is CORS-open to the storefront.
     * It resolves the Shopify product id through its own externalId, so productId is
     * passed through unchanged.
     *
     * Fetched lazily with the list rather than eagerly like fetchSummary: this copy
     * sits inside the reviews section (below the fold), and the endpoint responds
     * cache-control: no-store, so there is nothing to gain from requesting it on
     * landing.
     *
     * Failure is silent and the block stays hidden. A product with too few reviews
     * returns paragraphSummary: null, which is a normal state rather than an error.
     */
    /*
     * "What customers say" drawer — summaryTopics + summaryHighlights from the same
     * productData response as the paragraph above. Server-rendered as empty shells in
     * product-reviews-topics-drawer.liquid and filled here, so the drawer stays inert
     * until the response lands.
     *
     * The trigger ships hidden and is only revealed when there is at least one topic:
     * plenty of products have a paragraph but no topics, and an empty drawer is worse
     * than no control.
     */
    function renderReviewTopics(res) {
      var drawerEl = topicsDrawerEl();
      if (!drawerEl) return;

      var topicsListEl = drawerEl.querySelector('[data-review-topics-list]');
      var topicTemplate = drawerEl.querySelector('[data-review-topic-template]');
      var topicsIntroEl = drawerEl.querySelector('[data-review-topics-intro]');
      var topicsHighlightsEl = drawerEl.querySelector('[data-review-topics-highlights]');
      var topicsHighlightsListEl = drawerEl.querySelector('[data-review-topics-highlights-list]');
      var highlightTemplate = drawerEl.querySelector('[data-review-highlight-template]');
      if (!topicsListEl || !topicTemplate) return;

      var topics = (res.summaryTopics || []).filter(function (topic) {
        return topic && String(topic.displayTopic || '').trim() && String(topic.summary || '').trim();
      });
      if (!topics.length) return;

      topicsListEl.textContent = '';
      topics.forEach(function (topic) {
        var node = topicTemplate.content.firstElementChild.cloneNode(true);
        var nameEl = node.querySelector('[data-review-topic-name]');
        var summaryEl = node.querySelector('[data-review-topic-summary]');
        var coverageEl = node.querySelector('[data-review-topic-coverage]');

        if (nameEl) nameEl.textContent = String(topic.displayTopic).trim();
        if (summaryEl) summaryEl.textContent = String(topic.summary).trim();

        // coverage arrives as a string percentage ("29"). Hide the line rather than
        // print "Mentioned in % of reviews" when it is missing.
        var coverage = parseFloat(topic.coverage);
        if (coverageEl) {
          if (Number.isFinite(coverage)) {
            coverageEl.textContent = fmt(t.topicsMentioned, { percent: coverage });
          } else {
            coverageEl.remove();
          }
        }
        topicsListEl.appendChild(node);
      });

      // Intro count comes from the reviews bottomline, which fetchSummary has already
      // cached by the time the drawer can be opened; fall back to omitting the count.
      if (topicsIntroEl) {
        var summaryCache = getCache()['summary|' + productId];
        var bottomline = summaryCache && (summaryCache.response || {}).bottomline;
        var total = bottomline ? parseInt(bottomline.total_review, 10) : NaN;
        if (Number.isFinite(total)) {
          topicsIntroEl.textContent = fmt(t.topicsIntro, { count: total });
        } else {
          // Without a count the sentence reads "based on  customer reviews" — drop the
          // line rather than render the gap.
          topicsIntroEl.remove();
        }
      }

      var highlights = (res.summaryHighlights || []).filter(function (h) {
        return h && String(h.highlight || '').trim();
      });
      if (highlights.length && topicsHighlightsListEl && highlightTemplate) {
        topicsHighlightsListEl.textContent = '';
        highlights.forEach(function (h) {
          var node = highlightTemplate.content.firstElementChild.cloneNode(true);
          var quoteEl = node.querySelector('[data-review-highlight-quote]');
          var authorEl = node.querySelector('[data-review-highlight-author]');
          // Quotation marks are content, not decoration — the design shows the copy
          // wrapped in curly quotes and Yotpo returns it unquoted.
          if (quoteEl) quoteEl.textContent = '\u201C' + String(h.highlight).trim() + '\u201D';
          if (authorEl) {
            var name = String(h.reviewerName || '').trim();
            if (name) { authorEl.textContent = name; } else { authorEl.parentNode.remove(); }
          }
          topicsHighlightsListEl.appendChild(node);
        });
        if (topicsHighlightsEl) {
          topicsHighlightsEl.classList.remove('hidden');
          topicsHighlightsEl.classList.add('flex');
        }
      }

      if (topicsTriggerEl) topicsTriggerEl.classList.remove('hidden');
    }

    function renderAiSummary(data) {
      if (!aiSummaryEl || !aiSummaryTextEl) return;

      var paragraph = ((data || {}).response || {}).paragraphSummary;
      if (typeof paragraph !== 'string') return;
      paragraph = paragraph.trim();
      if (!paragraph) return;

      aiSummaryTextEl.textContent = paragraph;
      // The block ships as `hidden flex-col gap-24`; swapping hidden for flex keeps
      // the column layout the markup already declares.
      aiSummaryEl.classList.remove('hidden');
      aiSummaryEl.classList.add('flex');
    }

    function fetchAiSummary() {
      if (!aiSummaryEl || !aiSummaryTextEl || !appKey || !productId) return;

      var key = 'aiSummary|' + productId;
      var cache = getCache();
      if (cache[key]) {
        renderAiSummary(cache[key]);
        renderReviewTopics((cache[key] || {}).response || {});
        return;
      }

      var url = 'https://api.yotpo.com/v3/storefront/stores/' + encodeURIComponent(appKey) +
        '/products/' + encodeURIComponent(productId) + '/productData?include=reviewsSummary';

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          cache[key] = data;
          renderAiSummary(data);
          renderReviewTopics((data || {}).response || {});
        })
        .catch(function () { /* no summary is a valid state — leave the block hidden */ });
    }

    // ── Control wiring ──
    function setAll(nodes, value, prop) {
      nodes.forEach(function (n) { n[prop] = value; });
    }
    function syncRatingFilterLabel(value) {
      var text = '';
      if (value) {
        var activeControl = root.querySelector('[data-filter-rating]');
        if (activeControl) {
          var activeOption = activeControl.querySelector('option[value="' + value + '"]');
          text = activeOption ? activeOption.textContent : '';
        }
      }
      ratingControlLabels.forEach(function (label) {
        label.textContent = text;
        label.classList.toggle('text-secondary', !text);
        label.classList.toggle('text-primary', !!text);
      });
    }
    ratingControls.forEach(function (sel) {
      sel.addEventListener('change', function () {
        state.star = sel.value;
        state.page = 1;
        setAll(ratingControls, sel.value, 'value');
        syncRatingFilterLabel(sel.value);
        fetchReviews();
      });
    });
    syncRatingFilterLabel(state.star);
    mediaControls.forEach(function (box) {
      box.addEventListener('change', function () {
        state.withMedia = box.checked;
        state.page = 1;
        setAll(mediaControls, box.checked, 'checked');
        fetchReviews();
      });
    });
    if (searchControl) {
      // Debounced: each keystroke is now a request rather than a re-filter of what is
      // already loaded. 300ms matches the store-finder search control.
      var searchTimer = null;
      searchControl.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          var next = searchControl.value;
          if (next === state.search) return;
          state.search = next;
          state.page = 1;
          fetchReviews();
        }, 300);
      });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { goToPage(state.page - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToPage(state.page + 1); });

    var retry = root.querySelector('[data-reviews-retry]');
    if (retry) retry.addEventListener('click', function () { fetchReviews(); });

    // ── Write-a-review submit ──
    // The form lives in a drawer that the drawer controller hoists to <body>, so it
    // is no longer a descendant of this root — look it up document-wide. We cannot key
    // off productId either: that is the SKU-based Yotpo identifier, whereas the form's
    // element id is review-form-<numeric product.id>, so they never match.
    var form = document.querySelector('[data-review-form]');
    if (form) wireForm(form);

    function wireForm(form) {
      var statusEl = form.querySelector('[data-form-status]');
      var successEl = form.querySelector('[data-form-success]');
      var formFields = form.querySelector('[data-form-fields]');
      var privacyEl = form.querySelector('[data-form-privacy]');
      var submitBtn = document.querySelector('[data-review-form-submit][form="' + form.id + '"]')
        || root.querySelector('[data-review-form-submit]');
      var ratingError = form.querySelector('[data-error-rating]');
      var ratingInput = form.querySelector('[data-rating-value]');
      var ratingButtons = form.querySelectorAll('[data-rating-star]');
      var reviewContent = form.querySelector('[data-review-content]');
      var reviewCount = form.querySelector('[data-review-count]');
      var submitLabel = submitBtn ? submitBtn.getAttribute('data-submit-label') : '';
      var successLabel = submitBtn ? submitBtn.getAttribute('data-success-label') : '';
      var reviewDrawer = document.getElementById('review-form-drawer');

      function reviewFormIsComplete() {
        var requiredFields = Array.prototype.slice.call(
          form.querySelectorAll('input[required], textarea[required], select[required]')
        );
        var fieldsComplete = requiredFields.every(function (field) {
          if (field.disabled) return true;
          if (typeof field.value === 'string' && !field.value.trim()) {
            return false;
          }
          return field.validity.valid;
        });
        var hasRating = Boolean(ratingInput && ratingInput.value);
        return hasRating && fieldsComplete;
      }

      function syncReviewSubmitState() {
        if (!submitBtn) return;
        if (submitBtn.hasAttribute('data-drawer-close')) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-disabled');
          return;
        }
        var canSubmit = reviewFormIsComplete();
        submitBtn.disabled = !canSubmit;
        if (canSubmit) {
          submitBtn.removeAttribute('aria-disabled');
        } else {
          submitBtn.setAttribute('aria-disabled', 'true');
        }
      }

      function updateCharacterCount() {
        if (!reviewContent || !reviewCount) return;
        reviewCount.textContent = fmt(t.formCharacterCount, { count: reviewContent.value.length });
      }

      function validationMessage(field) {
        if (!field || field.name === 'review-score') return '';
        if (field.name === 'display_name' && field.validity.valueMissing) return t.formErrorName || '';
        if (field.name === 'email' && (field.validity.valueMissing || field.validity.typeMismatch)) return t.formErrorEmail || '';
        if (field.name === 'review_title' && field.validity.valueMissing) return t.formErrorTitle || '';
        if (field.name === 'review_content' && field.validity.valueMissing) return t.formErrorContent || '';
        return '';
      }

      Array.prototype.forEach.call(form.querySelectorAll('input, textarea'), function (field) {
        if (field.name === 'review-score') return;
        field.addEventListener('input', function () {
          field.setCustomValidity('');
          field.removeAttribute('aria-invalid');
          syncReviewSubmitState();
        });
        field.addEventListener('change', syncReviewSubmitState);
        field.addEventListener('blur', syncReviewSubmitState);
        field.addEventListener('invalid', function () {
          field.setCustomValidity(validationMessage(field));
          field.setAttribute('aria-invalid', 'true');
          syncReviewSubmitState();
        });
      });

      if (reviewContent) {
        updateCharacterCount();
        reviewContent.addEventListener('input', updateCharacterCount);
      }

      function paintRatingButtons(value, selectedValue) {
        ratingButtons.forEach(function (button) {
          var score = parseInt(button.getAttribute('data-rating-score'), 10) || 0;
          var filled = score <= value;
          var selected = score === selectedValue;
          button.classList.toggle('text-brand-primary-blue', filled);
          button.classList.toggle('text-border-secondary', !filled);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      }

      function syncRatingButtons(value) {
        var selectedValue = value || 0;
        paintRatingButtons(selectedValue, selectedValue);
        if (ratingInput) {
          ratingInput.value = selectedValue ? String(selectedValue) : '';
        }
      }

      ratingButtons.forEach(function (button) {
        var value = parseInt(button.getAttribute('data-rating-score'), 10) || 0;
        button.addEventListener('mouseenter', function () {
          var selectedValue = parseInt(ratingInput && ratingInput.value, 10) || 0;
          paintRatingButtons(value, selectedValue);
        });
        button.addEventListener('focus', function () {
          var selectedValue = parseInt(ratingInput && ratingInput.value, 10) || 0;
          paintRatingButtons(value, selectedValue);
        });
        button.addEventListener('mouseleave', function () {
          syncRatingButtons(parseInt(ratingInput && ratingInput.value, 10) || 0);
        });
        button.addEventListener('blur', function () {
          syncRatingButtons(parseInt(ratingInput && ratingInput.value, 10) || 0);
        });
        button.addEventListener('click', function () {
          syncRatingButtons(value);
          if (ratingError) {
            ratingError.classList.add('hidden');
          }
          syncReviewSubmitState();
        });
      });
      syncRatingButtons(parseInt(ratingInput && ratingInput.value, 10) || 0);
      syncReviewSubmitState();

      function resetReviewForm() {
        form.reset();
        Array.prototype.forEach.call(
          form.querySelectorAll('input, textarea, select'),
          function (field) {
            field.setCustomValidity('');
            field.removeAttribute('aria-invalid');
            field.dispatchEvent(
              new Event('input', { bubbles: true })
            );
            field.dispatchEvent(
              new Event('change', { bubbles: true })
            );
            field.blur();
          }
        );
        if (ratingError) {
          ratingError.classList.add('hidden');
        }
        syncRatingButtons(0);
        if (reviewCount) {
          reviewCount.textContent = fmt(t.formCharacterCount, {
            count: 0
          });
        }
        if (statusEl) {
          statusEl.textContent = '';
        }
        if (formFields) {
          formFields.classList.remove('hidden');
        }
        if (privacyEl) {
          privacyEl.classList.remove('hidden');
        }
        if (successEl) {
          successEl.classList.add('hidden');
          successEl.classList.remove('flex');
        }
        if (submitBtn) {
          submitBtn.textContent = submitLabel;
          submitBtn.setAttribute('type', 'submit');
          submitBtn.setAttribute('form', form.id);
          submitBtn.removeAttribute('data-drawer-close');
          submitBtn.removeAttribute('aria-busy');
        }
        syncReviewSubmitState();
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var data = new FormData(form);
        var score = data.get('review-score');
        var valid = true;
        if (!score) { if (ratingError) ratingError.classList.remove('hidden'); valid = false; }
        if (!form.checkValidity()) valid = false;
        if (!valid) { form.reportValidity(); return; }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.textContent = t.formSubmitting || submitLabel;
        }
        if (statusEl) statusEl.textContent = t.formSubmitting || '';

        var body = {
          appkey: appKey,
          sku: root.getAttribute('data-product-sku'),
          product_title: root.getAttribute('data-product-title'),
          product_url: root.getAttribute('data-product-url'),
          display_name: data.get('display_name'),
          email: data.get('email'),
          review_content: data.get('review_content'),
          review_title: data.get('review_title'),
          review_score: parseInt(score, 10)
        };

        var ctrl = new AbortController();
        var to = setTimeout(function () { ctrl.abort(); }, 8000);

        fetch('https://api.yotpo.com/v1/widget/reviews', {
          method: 'POST',
          signal: ctrl.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function () {
            if (formFields) formFields.classList.add('hidden');
            if (privacyEl) privacyEl.classList.add('hidden');
            if (successEl) {
              successEl.classList.remove('hidden');
              successEl.classList.add('flex');
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-disabled');
              submitBtn.removeAttribute('form');
              submitBtn.setAttribute('type', 'button');
              submitBtn.setAttribute('data-drawer-close', '');
              submitBtn.textContent = successLabel || submitLabel;
            }
            if (statusEl) statusEl.textContent = '';
          })
          .catch(function () {
            if (statusEl) statusEl.textContent = t.formErrorSubmit || '';
          })
          .finally(function () {
            clearTimeout(to);
            if (submitBtn && submitBtn.getAttribute('data-drawer-close') == null) {
              submitBtn.textContent = submitLabel;
              syncReviewSubmitState();
            }
          });
      });

      if (reviewDrawer && window.MutationObserver) {
        var wasOpen = !reviewDrawer.hasAttribute('aria-hidden');
        new MutationObserver(function () {
          var isOpen = !reviewDrawer.hasAttribute('aria-hidden');
          if (wasOpen && !isOpen) {
            resetReviewForm();
          }
          wasOpen = isOpen;
        }).observe(reviewDrawer, {
          attributes: true,
          attributeFilter: ['aria-hidden']
        });
      }
    }

    // Populate the header rating immediately (does not gate the lazy list fetch).
    fetchSummary();

    // ── Lazy fetch on scroll-into-view ──
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !hasFetched) {
            hasFetched = true;
            io.disconnect();
            fetchReviews();
            fetchAiSummary();
          }
        });
      }, { rootMargin: '200px' });
      io.observe(root);
    } else {
      fetchReviews();
      fetchAiSummary();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-zoom-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-zoom-gallery]').forEach(function (overlay) {
    var scroller = overlay.querySelector('[data-zoom-scroll]');
    var slides = overlay.querySelectorAll('[data-zoom-slide]');
    var thumbs = overlay.querySelectorAll('[data-zoom-thumb]');
    var closeBtn = overlay.querySelector('[data-zoom-close]');
    var triggers = document.querySelectorAll('[data-zoom-trigger]');
    if (!slides.length) return;
    var syncEnabled = overlay.getAttribute('data-variant-sync') !== 'false';

    // The overlay renders inside #main-content, which is a z-index:1 stacking
    // context sitting *below* the fixed header-group (z-index:50). z-index alone
    // can't lift it out, so move it to <body> — there its z-modal (60) competes
    // at the root level and renders above the header.
    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    var desktop = window.matchMedia('(min-width: 1024px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var openLabel = overlay.getAttribute('data-open-label') || '';
    var trap = (typeof createFocusTrap === 'function') ? createFocusTrap(overlay) : null;
    var lastTrigger = null;
    var suppressObserver = false;

    function isOpen() {
      return !overlay.hasAttribute('aria-hidden');
    }

    function setActive(index) {
      thumbs.forEach(function (thumb) {
        var on = parseInt(thumb.getAttribute('data-index'), 10) === index;
        thumb.classList.toggle('border-border-primary', on);
        thumb.classList.toggle('border-transparent', !on);
        thumb.classList.toggle('opacity-50', !on);
        if (on) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    function scrollToIndex(index, smooth) {
      var slide = slides[index];
      if (!slide) return;
      var behavior = (smooth && !reduceMotion.matches) ? 'smooth' : 'auto';
      // Suppress the scroll observer briefly so the programmatic scroll doesn't
      // fight the explicit selection.
      suppressObserver = true;
      slide.scrollIntoView({ behavior: behavior, block: 'start' });
      setActive(index);
      window.setTimeout(function () { suppressObserver = false; }, 400);
    }

    function open(index) {
      if (isOpen()) return;
      lastTrigger = document.activeElement;
      overlay.removeAttribute('inert');
      overlay.removeAttribute('aria-hidden');
      overlay.style.opacity = '1';
      overlay.style.pointerEvents = 'auto';
      document.body.style.overflow = 'hidden';
      scrollToIndex(index || 0, false);
      if (trap) trap.activate();
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!isOpen()) return;
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('inert', '');
      overlay.style.opacity = '';
      overlay.style.pointerEvents = '';
      document.body.style.overflow = '';
      if (trap) trap.deactivate();
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      lastTrigger = null;
    }

    // Promote each gallery image to a keyboard-operable opener on desktop only.
    triggers.forEach(function (trigger, i) {
      function syncRole() {
        if (desktop.matches) {
          trigger.setAttribute('role', 'button');
          trigger.setAttribute('tabindex', '0');
          if (openLabel) trigger.setAttribute('aria-label', openLabel.replace('%%INDEX%%', i + 1));
        } else {
          trigger.removeAttribute('role');
          trigger.removeAttribute('tabindex');
          trigger.removeAttribute('aria-label');
        }
      }
      syncRole();
      desktop.addEventListener('change', syncRole);

      trigger.addEventListener('click', function (event) {
        if (!desktop.matches) return;
        event.preventDefault();
        open(i);
      });
      trigger.addEventListener('keydown', function (event) {
        if (!desktop.matches) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open(i);
        }
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        scrollToIndex(parseInt(thumb.getAttribute('data-index'), 10), false);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) close();
    });

    // Keep the overlay's active slide/thumb aligned to the selected variant. The section
    // dispatches a bubbling variant:changed event; the overlay is reparented to <body>, so
    // listen at document scope. A variant with no featured media is a no-op.
    document.addEventListener('variant:changed', function (event) {
      if (!syncEnabled) return;
      var mid = event.detail && event.detail.variant && event.detail.variant.featured_media_id;
      if (mid == null) return;
      var slide = overlay.querySelector(
        '[data-zoom-slide][data-media-id="' + CSS.escape(String(mid)) + '"]'
      );
      if (!slide) return;
      var index = parseInt(slide.getAttribute('data-index'), 10);
      setActive(index);
      if (isOpen()) scrollToIndex(index, false);
    });

    // Active thumbnail follows the scroll position.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (suppressObserver || !isOpen()) return;
          var best = null;
          entries.forEach(function (entry) {
            if (entry.isIntersecting && (!best || entry.intersectionRatio > best.intersectionRatio)) {
              best = entry;
            }
          });
          if (best) setActive(parseInt(best.target.getAttribute('data-index'), 10));
        },
        { root: scroller, threshold: [0.25, 0.5, 0.75] }
      );
      slides.forEach(function (slide) { observer.observe(slide); });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiz-filter-bridge"] && !Shopify.designMode) return;
  try {
    ;(function () {
    var root = document.querySelector('[data-quiz-nav]');
    if (!root) return;

    function itemFor(step) {
      return root.querySelector('[data-quiz-item][data-quiz-step="' + CSS.escape(step) + '"]');
    }

    /* Writes both bounds and lets the driver's own debounced input delegate do
       the rest. An absent bound is written as the empty string, which that
       delegate reads as "no bound". Hence hidden inputs rather than sliders,
       which cannot hold an empty value. */
    function sendRange(item, min, max) {
      var wrap = item.querySelector('[data-price-range]');
      var minE = wrap && wrap.querySelector('[data-price-min]');
      var maxE = wrap && wrap.querySelector('[data-price-max]');
      if (!minE || !maxE) return;
      minE.value = min == null ? '' : String(min);
      maxE.value = max == null ? '' : String(max);
      minE.dispatchEvent(new Event('input', { bubbles: true }));
    }

    /* Unchecks first, then checks, so the driver sees a replace. `wanted` is
       never true when the answer carries no value of its own: an answer that
       applies no filter (for example an "anything" option) clears the question
       instead of filtering on an empty string. */
    function sendCheckbox(item, value) {
      var inputs = item.querySelectorAll('[data-quiz-transport-for]');
      var incoming = null;

      Array.prototype.forEach.call(inputs, function (input) {
        var wanted = value !== '' && input.getAttribute('data-quiz-transport-for') === value;
        if (wanted) incoming = input;
        if (wanted || !input.checked) return;
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (!incoming || incoming.checked) return;
      incoming.checked = true;
      incoming.dispatchEvent(new Event('change', { bubbles: true }));
    }

    root.addEventListener('quiz:answer', function (e) {
      var detail = e.detail;
      if (!detail) return;
      var item = itemFor(detail.step);
      if (!item) return;

      if (detail.facetType === 'range') sendRange(item, detail.rangeMin, detail.rangeMax);
      else sendCheckbox(item, detail.value || '');
    });

    /* Removing one answer from its badge has to reach Tagalys too, or the grid
       keeps the filter the nav has just stopped showing. */
    root.addEventListener('quiz:clear', function (e) {
      var detail = e.detail;
      if (!detail) return;
      var item = itemFor(detail.step);
      if (!item) return;

      if (detail.facetType === 'range') sendRange(item, null, null);
      else sendCheckbox(item, '');
    });

    /* Document-level because Clear all belongs to the shared filter/sort bar,
       a sibling of the quiz nav, so a root-scoped listener would never see it.
       The driver has already emptied its own state, so the transports are reset
       without dispatching (that would refetch the grid twice) and the nav is
       told to drop its answers. */
    document.addEventListener('click', function (e) {
      var button = e.target && e.target.closest && e.target.closest('[data-clear-filters]');
      if (!button || button.getAttribute('aria-disabled') === 'true') return;

      var transports = root.querySelectorAll('[data-quiz-transport-for]');
      Array.prototype.forEach.call(transports, function (input) {
        input.checked = false;
      });

      var bounds = root.querySelectorAll('[data-price-range] [data-price-min], [data-price-range] [data-price-max]');
      Array.prototype.forEach.call(bounds, function (input) {
        input.value = '';
      });

      root.dispatchEvent(new CustomEvent('quiz:reset', { bubbles: true }));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiz-filter-script"] && !Shopify.designMode) return;
  try {
    ;(function () {
    var root = document.querySelector('[data-quiz-nav]');
    if (!root) return;

    /* 1024 is this project's md: breakpoint. There is no lg:. */
    var desktop = window.matchMedia('(min-width: 1024px)');

    /* step -> true for every question currently answered. Only used to pick the
       next question to open on mobile; the badge track's own attribute is the
       rendered source of truth. */
    var answered = {};

    function items() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-quiz-item]'));
    }

    function itemFor(step) {
      return root.querySelector('[data-quiz-item][data-quiz-step="' + CSS.escape(step) + '"]');
    }

    function numOrNull(raw) {
      if (raw == null) return null;
      var trimmed = String(raw).trim();
      if (trimmed === '') return null;
      var n = parseInt(trimmed, 10);
      return isNaN(n) ? null : n;
    }

    /* ── Panels ───────────────────────────────────────────────────────────── */

    /* The panel is an attribute state machine, not a class or a hidden
       attribute: quiz-panel's grid-rows clip opens on [data-quiz-open]. Mixing
       in a hidden attribute or a display utility here would defeat it (FAILS
       §2, both directions). Concealment is three things at once: out of the
       accessibility tree, out of tab order, and out of reach of a tap, because
       inert's pass-through is not reliable cross-engine (FAILS §6). */
    function showPanel(item) {
      var panel = item.querySelector('[data-quiz-panel]');
      if (!panel) return;
      var trigger = item.querySelector('[data-quiz-trigger]');
      var options = item.querySelector('[data-quiz-options]');
      panel.removeAttribute('aria-hidden');
      panel.removeAttribute('inert');
      panel.setAttribute('data-quiz-open', '');
      item.setAttribute('data-quiz-open', '');
      if (options) options.classList.remove('pointer-events-none');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      _syncRoving(item);
    }

    function hidePanel(item) {
      var panel = item.querySelector('[data-quiz-panel]');
      if (!panel) return;
      var trigger = item.querySelector('[data-quiz-trigger]');
      var options = item.querySelector('[data-quiz-options]');
      panel.setAttribute('aria-hidden', 'true');
      panel.setAttribute('inert', '');
      panel.removeAttribute('data-quiz-open');
      item.removeAttribute('data-quiz-open');
      if (options) options.classList.add('pointer-events-none');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function isOpen(item) {
      return item.hasAttribute('data-quiz-open');
    }

    function closeAll(except) {
      items().forEach(function (item) {
        if (item !== except) hidePanel(item);
      });
    }

    /* The trigger button and the card around it toggle the same question the
       same way, so both click branches resolve their item through here. */
    function toggleFrom(node) {
      var item = node.closest('[data-quiz-item]');
      if (!item) return;
      if (isOpen(item)) hidePanel(item);
      else {
        closeAll(item);
        showPanel(item);
      }
    }

    /* ── Badges ───────────────────────────────────────────────────────────── */

    /* A step owns two badge instances: the desktop meta row inside its own
       column, and the mobile strip column that replaces the accordion once the
       nav is minimised. Both carry the step on their own wrapper, so one
       attribute query reaches the pair. */
    function setBadge(step, label) {
      var holders = root.querySelectorAll('[data-quiz-step="' + CSS.escape(step) + '"]');
      Array.prototype.forEach.call(holders, function (holder) {
        var track = holder.querySelector('[data-quiz-badge-track]');
        var text = holder.querySelector('[data-quiz-badge-label]');
        if (text) text.textContent = label == null ? '' : label;

        /* Substitute the chosen answer into the remove button's accessible
           name (data-quiz-remove-label-template, __ANSWER__ token). Left at its
           Liquid-rendered default when nothing is selected. */
        var removeButton = holder.querySelector('[data-quiz-remove]');
        if (removeButton && label != null) {
          var template = removeButton.getAttribute('data-quiz-remove-label-template');
          if (template) removeButton.setAttribute('aria-label', template.replace('__ANSWER__', label));
        }

        if (!track) return;
        if (label == null) track.removeAttribute('data-quiz-answered');
        else track.setAttribute('data-quiz-answered', '');
      });
    }

    /* ── Conditional wording ──────────────────────────────────────────────── */

    /* A question may carry an alternate heading triggered by another question's
       answer (Figma 20758:215409: picking "Myself" on step 1 rewrites step 2).
       The trigger is merchant-set, so both halves are read off the DOM rather
       than hardcoded to step 1, and the swap only runs when the alternate is
       actually non-empty: a merchant who clears it must keep the default
       heading, never an empty one. */
    function syncWording(step, value) {
      items().forEach(function (item) {
        var triggerStep = item.getAttribute('data-quiz-alt-trigger-step');
        var triggerValue = item.getAttribute('data-quiz-alt-trigger-value');
        if (!triggerStep || !triggerValue) return;
        if (String(triggerStep) !== String(step)) return;

        var heading = item.querySelector('[data-quiz-question]');
        if (!heading) return;
        var alt = (heading.getAttribute('data-quiz-question-alt') || '').trim();
        var fallback = (heading.getAttribute('data-quiz-question-default') || '').trim();

        if (value != null && String(triggerValue) === String(value) && alt) heading.textContent = alt;
        else if (fallback) heading.textContent = fallback;
      });
    }

    /* ── Roving focus ─────────────────────────────────────────────────────── */

    /* One tab stop per radio group, as the radiogroup pattern requires: the
       checked answer if there is one, otherwise the first. */
    function _syncRoving(item) {
      var buttons = item.querySelectorAll('[data-quiz-answer]');
      if (!buttons.length) return;
      var active = item.querySelector('[data-quiz-answer][aria-checked="true"]') || buttons[0];
      Array.prototype.forEach.call(buttons, function (btn) {
        btn.setAttribute('tabindex', btn === active ? '0' : '-1');
      });
    }

    function _move(current, delta) {
      var item = current.closest('[data-quiz-item]');
      if (!item) return;
      var buttons = Array.prototype.slice.call(item.querySelectorAll('[data-quiz-answer]'));
      var at = buttons.indexOf(current);
      if (at < 0) return;
      var next = buttons[(at + delta + buttons.length) % buttons.length];
      Array.prototype.forEach.call(buttons, function (btn) {
        btn.setAttribute('tabindex', btn === next ? '0' : '-1');
      });
      next.focus();
    }

    /* ── Selection ────────────────────────────────────────────────────────── */

    function nextUnanswered(from) {
      var all = items();
      var at = all.indexOf(from);
      for (var i = 1; i <= all.length; i++) {
        var candidate = all[(at + i) % all.length];
        if (candidate === from) continue;
        if (!answered[candidate.getAttribute('data-quiz-step')]) return candidate;
      }
      return null;
    }

    /* Everything a chosen answer changes about the nav's own UI, with no
       Tagalys/URL side effect. select() and restoreFromURL() both resolve
       here; only select() goes on to dispatch quiz:answer. */
    function applySelectionState(button, step) {
      var item = button.closest('[data-quiz-item]');
      if (!item) return;
      var group = button.closest('[data-quiz-options]') || item;
      var siblings = group.querySelectorAll('[data-quiz-answer]');

      Array.prototype.forEach.call(siblings, function (btn) {
        btn.setAttribute('aria-checked', btn === button ? 'true' : 'false');
      });

      var value = button.getAttribute('data-quiz-value') || '';
      var label = button.getAttribute('data-quiz-label') || '';

      answered[step] = true;
      setBadge(step, label);
      syncWording(step, value);
      _syncRoving(item);
    }

    function select(button) {
      var item = button.closest('[data-quiz-item]');
      if (!item) return;
      var step = item.getAttribute('data-quiz-step');

      applySelectionState(button, step);

      root.dispatchEvent(new CustomEvent('quiz:answer', {
        bubbles: true,
        detail: {
          step: step,
          facetKey: item.getAttribute('data-quiz-facet-key') || '',
          facetType: item.getAttribute('data-quiz-facet-type') || 'checkbox',
          value: button.getAttribute('data-quiz-value') || '',
          rangeMin: numOrNull(button.getAttribute('data-quiz-range-min')),
          rangeMax: numOrNull(button.getAttribute('data-quiz-range-max'))
        }
      }));

      /* Figma 20758:215409: answering closes this dropdown at every width, and
         on mobile only it opens the next unanswered one. Focus moves to a
         trigger because hidePanel inerts the focused answer's panel, which
         would otherwise drop focus to <body>. */
      var next = desktop.matches ? null : nextUnanswered(item);
      var focusTarget = next
        ? next.querySelector('[data-quiz-trigger]')
        : item.querySelector('[data-quiz-trigger]');

      hidePanel(item);
      if (next) showPanel(next);
      if (focusTarget) focusTarget.focus();
    }

    /* ── Restore from URL ─────────────────────────────────────────────────── */

    /* A facet_value setting is either a plain string or a JSON array (quiz
       answers that map to more than one facet value, e.g.
       ["equipment","drinkware"]; see templates/collection.quiz.json). Kept
       aligned with the collection driver's own parseFacetValues rather than
       assuming JSON: a plain value that happens not to parse is the far more
       common case and must not be dropped. */
    function parseFacetValues(raw) {
      if (!raw) return [];
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed.map(String);
      } catch (e) { /* not JSON: a single plain value */ }
      return [raw];
    }

    function sameValues(a, b) {
      if (!a.length || a.length !== b.length) return false;
      var sortedA = a.slice().sort();
      var sortedB = b.slice().sort();
      for (var i = 0; i < sortedA.length; i++) {
        if (sortedA[i] !== sortedB[i]) return false;
      }
      return true;
    }

    /* A reload, shared link or back-navigation can land on a URL the
       collection driver already filters by (collection-tagalys.liquid's
       _urlState). This reads the same URL state through a second instance
       (filtersFromURL is a pure read of location.search) and applies the
       matching answer visually only, without quiz:answer, since Tagalys
       already has the filter. A URL value that matches no answer leaves the
       question unanswered: the quiz never claims a filter it did not apply. */
    function restoreFromURL() {
      if (!window.TagalysUrlState) return;
      var filters = window.TagalysUrlState({ priceMinKey: 'min', priceMaxKey: 'max' }).filtersFromURL();

      items().forEach(function (item) {
        var facetKey = item.getAttribute('data-quiz-facet-key');
        if (!facetKey) return;
        var current = filters[facetKey];
        if (!current) return;

        var step = item.getAttribute('data-quiz-step');
        var facetType = item.getAttribute('data-quiz-facet-type') || 'checkbox';
        var buttons = item.querySelectorAll('[data-quiz-answer]');
        var match = null;

        if (facetType === 'range') {
          var urlMin = current.min != null ? current.min : null;
          var urlMax = current.max != null ? current.max : null;
          if (urlMin == null && urlMax == null) return;
          Array.prototype.some.call(buttons, function (btn) {
            var btnMin = numOrNull(btn.getAttribute('data-quiz-range-min'));
            var btnMax = numOrNull(btn.getAttribute('data-quiz-range-max'));
            if (btnMin === urlMin && btnMax === urlMax) {
              match = btn;
              return true;
            }
            return false;
          });
        } else if (Array.isArray(current) && current.length) {
          Array.prototype.some.call(buttons, function (btn) {
            var btnValues = parseFacetValues(btn.getAttribute('data-quiz-value') || '');
            if (sameValues(btnValues, current)) {
              match = btn;
              return true;
            }
            return false;
          });
        }

        if (match) applySelectionState(match, step);
      });
    }

    function clearStep(step, silent) {
      var item = itemFor(step);
      if (!item) return;
      var buttons = item.querySelectorAll('[data-quiz-answer]');
      Array.prototype.forEach.call(buttons, function (btn) {
        btn.setAttribute('aria-checked', 'false');
      });
      delete answered[step];
      setBadge(step, null);
      syncWording(step, null);
      _syncRoving(item);
      if (silent) return;
      root.dispatchEvent(new CustomEvent('quiz:clear', {
        bubbles: true,
        detail: {
          step: step,
          facetKey: item.getAttribute('data-quiz-facet-key') || '',
          facetType: item.getAttribute('data-quiz-facet-type') || 'checkbox'
        }
      }));
    }

    /* ── Wiring ───────────────────────────────────────────────────────────── */

    root.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      var remove = target.closest('[data-quiz-remove]');
      if (remove) {
        var holder = remove.closest('[data-quiz-step]');
        if (holder) {
          /* clearStep() strips data-quiz-answered, which hides this very
             button in the same tick, so focus moves to the question's trigger,
             or the mobile trigger for a strip badge. */
          var removeStep = holder.getAttribute('data-quiz-step');
          var removeItem = itemFor(removeStep);
          var removeFocusTarget = (removeItem && removeItem.querySelector('[data-quiz-trigger]'))
            || root.querySelector('[data-quiz-mobile-trigger]');
          clearStep(removeStep, false);
          if (removeFocusTarget) removeFocusTarget.focus();
        }
        return;
      }

      var answer = target.closest('[data-quiz-answer]');
      if (answer) {
        select(answer);
        return;
      }

      var trigger = target.closest('[data-quiz-trigger]');
      if (trigger) {
        toggleFrom(trigger);
        return;
      }

      /* Figma draws the whole card as one hit target (20693:154374), but a
         nested <button> does not parse, so this widens the pointer area only.
         Keyboard activation matches the [data-quiz-trigger] branch first, so
         nothing double-fires; anchoring on the card, not the item root, keeps
         clicks inside the open panel out of it. */
      var card = target.closest('[data-quiz-card]');
      if (card) {
        toggleFrom(card);
        return;
      }

      /* The minimised mobile bar's own expand control. Its aria-expanded is
         what the stylesheet reads to swap the applied-answer strip for the
         accordion, so it is a real state, not a decoration. */
      var mobile = target.closest('[data-quiz-mobile-trigger]');
      if (mobile) {
        var wasOpen = mobile.getAttribute('aria-expanded') === 'true';
        mobile.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
        if (wasOpen) closeAll(null);
      }
    });

    /* From 1024 up a panel is an overlay (quiz-filter-item.liquid's
       md:absolute), so an outside click must dismiss it. Mirrors the PLP sort
       dropdown's document-level handler (snippets/plp-ui.liquid, _openSort).
       Desktop only: below 1024 the accordion is in flow and Figma
       20758:215409 gives it no outside-click rule. */
    document.addEventListener('click', function (e) {
      if (!desktop.matches) return;
      var openItem = root.querySelector('[data-quiz-item][data-quiz-open]');
      if (!openItem || openItem.contains(e.target)) return;
      hidePanel(openItem);
    });

    root.addEventListener('keydown', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (e.key === 'Escape') {
        var openItem = root.querySelector('[data-quiz-item][data-quiz-open]');
        if (!openItem) return;
        e.preventDefault();
        var itemTrigger = openItem.querySelector('[data-quiz-trigger]');
        hidePanel(openItem);
        if (itemTrigger) itemTrigger.focus();
        return;
      }

      var answer = target.closest('[data-quiz-answer]');
      if (!answer) return;

      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        _move(answer, 1);
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        _move(answer, -1);
      }
    });

    /* The shared "Clear all" control empties every Tagalys filter, quiz and
       non-quiz alike, so the quiz must drop its own answers with it or the nav
       would keep claiming filters the grid no longer has. The bridge owns the
       listener on that control and republishes it here. */
    root.addEventListener('quiz:reset', function () {
      items().forEach(function (item) {
        clearStep(item.getAttribute('data-quiz-step'), true);
      });
      closeAll(null);
    });

    /* Restore before the roving-tabindex sync below, so a question already
       answered from the URL starts tabbing at its checked answer rather than
       its first. The server-rendered panels already carry aria-hidden and
       inert, so no opening or closing call is needed on load either way. */
    restoreFromURL();
    items().forEach(_syncRoving);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiz-filter-sticky-script"] && !Shopify.designMode) return;
  try {
    ;(function () {
    var nav = document.querySelector('[data-quiz-nav]');
    if (!nav) return;

    var parent = nav.parentElement;
    if (!parent) return;
    var sentinel = parent.querySelector('[data-quiz-sentinel]');
    var placeholder = parent.querySelector('[data-quiz-placeholder]');
    if (!sentinel || !placeholder) return;

    var header = document.getElementById('site-header');
    var raf = null;

    /* Same offsets and same header-hidden branch as the PLP and blog bars: when
       the header has been translated out of view its height no longer needs
       clearing, so the nav rides at the bare inset instead. */
    function _computeTop() {
      var offset = window.innerWidth >= 1024 ? 12 : 8;
      if (!header || header.style.transform) return offset + 'px';
      return (offset + header.offsetHeight - 1) + 'px';
    }

    /* The header drops its own shadow while a filter surface is pinned
       immediately beneath it, so the two read as one band. */
    function _syncHeaderShadow() {
      if (!header) return;
      var visible = nav.classList.contains('is-sticky') && !header.style.transform;
      if (visible) header.setAttribute('data-filter-below', '');
      else header.removeAttribute('data-filter-below');
    }

    /* Height of any question panel open in flow. Below 1024 only: from 1024 up
       panels are overlays and take no space in the page. */
    function _openPanelHeight() {
      if (window.innerWidth >= 1024) return 0;
      var total = 0;
      nav.querySelectorAll('[data-quiz-panel][data-quiz-open]').forEach(function (panel) {
        total += panel.offsetHeight;
      });
      return total;
    }

    /* When sticking or unsticking changes the page's height above the
       viewport, scroll anchoring (Chromium) scrolls by the same amount, which
       moves the sentinel back across the edge and flips the nav straight back.
       Off for the two frames the change takes to lay out. */
    function _holdScrollAnchoring(needed) {
      if (!needed) return;
      var scroller = document.documentElement;
      scroller.style.overflowAnchor = 'none';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { scroller.style.overflowAnchor = ''; });
      });
    }

    function _setStuck(on) {
      var was = nav.classList.contains('is-sticky');
      if (on === was) {
        if (on) {
          nav.style.top = _computeTop();
          _syncHeaderShadow();
        }
        return;
      }

      if (on) {
        /* Measured while the nav is still in flow and still at its at-rest
           composition. That is the height the document is about to lose, and
           it is not the height the nav will have a moment later: going stuck
           also minimises it. Reading it after either change reserves the wrong
           gap.

           Below 1024 an open question panel is in flow, but the stuck bar
           hides it, so reserving its height left a large empty gap under the
           bar. Its height is left out of the reservation, but the panel itself
           stays open, so the question the shopper opened is still open in the
           stuck accordion and again once the nav unsticks. From 1024 up panels
           are overlays and add nothing. */
        var reserved = nav.offsetHeight - _openPanelHeight();
        _holdScrollAnchoring(reserved !== nav.offsetHeight);
        placeholder.style.height = reserved + 'px';
        placeholder.style.display = '';
        nav.style.top = _computeTop();
        nav.classList.add('is-sticky', 'quiz-nav--stuck');
        nav.setAttribute('data-quiz-minimised', '');
      } else {
        /* Unsticking with a question open puts its panel back in flow, which
           the reservation above left out, so the page below moves down. Tested
           by presence, not height: while stuck the panel sits inside the
           collapsed accordion. */
        _holdScrollAnchoring(
          window.innerWidth < 1024 && !!nav.querySelector('[data-quiz-panel][data-quiz-open]')
        );
        nav.classList.remove('is-sticky', 'quiz-nav--stuck');
        nav.removeAttribute('data-quiz-minimised');
        nav.style.top = '';
        placeholder.style.display = 'none';
        placeholder.style.height = '';
      }

      _syncHeaderShadow();
    }

    /* Stuck only once the sentinel has scrolled above the viewport. One-sided on
       purpose: a sentinel still below the fold (short viewports, where the hero
       pushes the nav down) must leave the nav in flow. Block axis only, since a
       sub-pixel horizontal overhang could otherwise pin it permanently. */
    function _syncStuck() {
      _setStuck(sentinel.getBoundingClientRect().top < 0);
    }

    /* _setStuck is the one place that sets top and syncs the shadow. */
    function tick() {
      raf = null;
      _syncStuck();
    }

    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(tick);
    }, { passive: true });

    /* Unlike the blog bar, the placeholder is not re-measured on resize: this
       nav minimises when it sticks, so its at-rest height is only readable at
       the next unstick/stick cycle. Shares the scroll rAF gate so a resize
       during a pending scroll frame does not run a second tick. */
    window.addEventListener('resize', function () {
      if (raf) return;
      raf = requestAnimationFrame(tick);
    }, { passive: true });

    /* First run, synchronous: the rectangle read forces layout anyway, so a
       frame of deferral would buy nothing. */
    tick();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quiz-mobile-strip-script"] && !Shopify.designMode) return;
  try {
    ;(function () {
    var AT_START_THRESHOLD = 1; // sub-pixel scroll rounding, not a real offset

    document.querySelectorAll('[data-quiz-mobile-strip]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-quiz-mobile-strip-scroll]');
      if (!track) return;

      function sync() {
        wrap.toggleAttribute('data-at-start', track.scrollLeft <= AT_START_THRESHOLD);
      }

      track.addEventListener('scroll', sync, { passive: true });
      sync();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-recommendations-script"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var searchGrid = document.getElementById('tagalys-search-grid');
    var block      = document.querySelector('[data-search-recommendations]');
    if (!searchGrid || !block) return;
    var grid = block.querySelector('[data-search-recommendations-grid]');
    if (!grid) return;

    function attr(name) { return searchGrid.getAttribute(name) || ''; }

    /* Figma has no frame for this feed, so nothing about its appearance is
       invented. The grid classes are the results-found grid's, copied verbatim
       by the markup; the count is 12 because that is what both existing callers
       of the shared wrapper already request, it is the wrapper's own default,
       and it is the only value that fills whole rows at every column count this
       grid uses (2 / 3 / 4). */
    var COUNT = 12;

    /* Same six strings the results grid already renders its cards with, read off
       the same element, so no new escaped attribute and no new card locale key
       is introduced. addToBag is deliberately not read: the results grid does not
       pass it either, so both grids fall back identically. */
    var i18n = {
      quickView: attr('data-i18n-quick-view'),
      notify:    attr('data-i18n-notify'),
      fromPrice: attr('data-i18n-from-price'),
      rating:    attr('data-i18n-rating'),
      currency:  attr('data-currency'),
      rootUrl:   attr('data-root-url')
    };

    var requested = false;
    var feed      = null;

    /* Two conditions, both required. The readiness attribute is not a
       convenience: the search script renders an intermediate empty grid on its
       URL-restore path and returns BEFORE setting that attribute, and every
       failure path (SDK never loads, connector throws, request fails) never sets
       it at all. Gating on it therefore excludes the intermediate response and
       leaves every degraded path byte-identical to today, with no extra request
       and nothing new on screen. */
    function isZeroResultState() {
      return searchGrid.hasAttribute('data-tagalys-ready') &&
        !!searchGrid.querySelector('[data-empty-state]');
    }

    function conceal() {
      block.classList.add('hidden');
    }

    function reveal() {
      if (!feed || !feed.length) return;
      var shown = feed.slice(0, COUNT);
      grid.innerHTML = '';
      shown.forEach(function (p, i) {
        if (typeof window.TagalysCard === 'function') {
          grid.insertAdjacentHTML('beforeend', window.TagalysCard(p, i < 4, i18n));
        }
      });
      if (!grid.children.length) return;
      if (window.TagalysBadgeHydration) window.TagalysBadgeHydration.hydrate(shown, grid);
      if (window.TagalysRatingHydration) window.TagalysRatingHydration.hydrate(shown, grid, i18n.rating);
      block.classList.remove('hidden');
    }

    /* The empty and failure callbacks are deliberate no-ops: the block simply
       stays concealed, which is what the page shows today. The shared wrapper
       already console-warns on an empty result, console-errors on a failure and
       enforces its own 8s timeout, so nothing is silent to a developer. A
       shopper-facing message here would be markup no Figma frame shows. */
    function request() {
      if (requested) return;
      if (!window.TagalysRecommendations) return;
      requested = true;
      window.TagalysRecommendations.fetch({
        recommendationId: grid.getAttribute('data-tagalys-recommendation-id'),
        count:  COUNT,
        token:  attr('data-tagalys-token'),
        domain: attr('data-tagalys-domain'),
        sdkUrl: attr('data-tagalys-sdk-url'),
        onProducts: function (products) { feed = products; evaluate(); },
        onEmpty: function () {},
        onError: function () {}
      });
    }

    function evaluate() {
      if (!isZeroResultState()) { conceal(); return; }
      if (feed) { reveal(); return; }
      request();
    }

    /* Observes the search grid and never writes to it. Both elements this file
       does write to are OUTSIDE the observed subtree (they are siblings of it),
       so a render can never re-enter this callback. The attribute filter below
       narrows it so the search script's inline opacity writes never wake it. */
    new MutationObserver(evaluate).observe(searchGrid, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-tagalys-ready']
    });

    evaluate();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-tagalys-connectors"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    window.TagalysSearchConnectors = function (options) {
      options = options || {};

      /* SDK failover to the Shopify-backed sibling connector, consulted at
         CONSTRUCTION time only — never from onFailure (TASK-47920, SP6). Adding it
         here does not arm the SDK's health check or its filter-dropping page reload:
         only the Collection connector does that, and it is deliberately left without
         a failover. Both construction sites share this one definition so a future
         edit cannot arm one path and not the other. */
      function searchFailover(params) {
        return function () {
          return Tagalys.APIConnector.ShopifySearchResults.new({
            params: params,
            onSuccess: options.onSuccess,
            onFailure: function (r) {
              console.error('[Tagalys Search] Shopify failover search call failed', JSON.stringify(r));
              options.onLoadError();
            }
          });
        };
      }

      /* Shared by reload() and the bootstrap, whose two constructions were
         byte-identical. Deliberately does NOT catch: the two callers log two
         different diagnostic strings and each needs its own return, so both
         catch blocks stay with them. */
      function buildSearchResults(params) {
        return Tagalys.APIConnector.SearchResults.new({
          params: params,
          failover: searchFailover(params),
          onSuccess: options.onSuccess,
          onFailure: function (r) {
            console.error('[Tagalys Search] search call failed', JSON.stringify(r));
            options.onLoadError();
          }
        });
      }

      function applyConfiguration(token, domain) {
        Tagalys.setConfiguration({
          api: { serverUrl: 'https://api-r4.tagalys.com' },
          currency: {
            fractionalDigits: 2,
            forceFractionalDigits: true
          },
          analyticsStorageConsentProvided: function () {
            return window.Shopify && window.Shopify.customerPrivacy
              ? window.Shopify.customerPrivacy.analyticsProcessingAllowed() : false;
          },
          track: true
        });
        /* countryCode is the customer's ACTIVE market — read from
           data-market-country (layout/theme.liquid, sourced from
           localization.country.iso_code, the theme's own authoritative
           server-resolved market signal), not window.Shopify.country. This
           theme never sets that global itself and it isn't part of Shopify's
           documented storefront JS API, so relying on it left every request
           pinned to whatever it happened to resolve to rather than the
           shopper's actual selected market (TASK-47920). */
        var marketCountry = (document.body && document.body.getAttribute('data-market-country')) || 'GB';
        Tagalys.setPlatformConfiguration({
          storefrontAPI: {
            accessToken:     token,
            myShopifyDomain: domain
          },
          countryCode:     marketCountry,
          baseCountryCode: 'GB',
          metafields: { products: [
            { namespace: 'custom', key: 'product_type' },
            { namespace: 'custom', key: 'product_types' },
            { namespace: 'custom', key: 'taste_notes' },
            { namespace: 'custom', key: 'format' },
            { namespace: 'custom', key: 'flavour' },
            { namespace: 'custom', key: 'organic' },
            { namespace: 'custom', key: 'caffeine_free' },
            { namespace: 'custom', key: 'format_label' },
            { namespace: 'custom', key: 'origin' },
            { namespace: 'custom', key: 'gift_type' },
            { namespace: 'custom', key: 'good_for' },
            { namespace: 'custom', key: 'category' },
            { namespace: 'custom', key: 'limited_edition' },
            { namespace: 'custom', key: 'collection_campaign' }
          ]}
        });
      }

      /* No idempotence guard, deliberately: the function this replaced had none
         and is called from exactly one site. Adding one here would be a
         behaviour change smuggled into a pure extraction (TASK-47920, SP7). */
      function configure(token, domain) {
        applyConfiguration(token, domain);
        if (window.TagalysConsent) window.TagalysConsent.onChange(function () { applyConfiguration(token, domain); });
      }

      return {
        configure:           configure,
        applyConfiguration:  applyConfiguration,
        buildSearchResults:  buildSearchResults
      };
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-tagalys-render"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    // Shared with collection-tagalys-facets.liquid, collection-tagalys-card.liquid,
    // and mini-bag-recommendations-script.liquid via assets/tagalys-recommendations.js
    // (window.TagalysProductFormat) — was a byte-for-byte duplicate here before
    // this dedupe (TASK-47920).
    var escHtml = window.TagalysProductFormat.escHtml;

    window.TagalysSearchRender = function (options) {
      options = options || {};
      var i18n = options.i18n;

      function emptyStateHtml() {
        return '<div class="py-104 text-center px-24 sm:px-0" data-empty-state>' +
          '<p class="text-d3 text-primary mb-16">' + escHtml(i18n.emptyTitle) + '</p>' +
          '<p class="text-b2 text-secondary">' + escHtml(i18n.emptyDesc) + '</p>' +
          '</div>';
      }

      function renderGrid(r, append, total, pp, outlineBtnClass) {
        var wrap = document.getElementById('tagalys-search-grid');
        if (!wrap) return;

        var prods = r.products || [];
        if (!append) wrap.innerHTML = '';

        if (!prods.length && !append) {
          wrap.innerHTML = emptyStateHtml();
          return;
        }

        var grid = append ? wrap.querySelector('[data-product-grid]') : null;
        if (!grid) {
          grid = document.createElement('div');
          grid.className = 'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4';
          grid.setAttribute('data-product-grid', '');
          wrap.appendChild(grid);
        }

        var appendFrom = append ? grid.children.length : 0;

        prods.forEach(function (p, i) {
          if (typeof window.TagalysCard === 'function') {
            grid.insertAdjacentHTML('beforeend', window.TagalysCard(p, !append && i < 4, i18n));
          }
        });

        if (window.TagalysBadgeHydration) window.TagalysBadgeHydration.hydrate(prods, grid);
        if (window.TagalysRatingHydration) window.TagalysRatingHydration.hydrate(prods, grid, i18n.rating);

        if (append) {
          for (var ci = appendFrom; ci < grid.children.length; ci++) {
            grid.children[ci].classList.add('plp-card-in');
          }
          // window.TagalysCard's root is a <div data-product-card>, not the focusable
          // <a> it used to be — focus the anchor/button inside it, not the wrapper.
          var firstNew = grid.children[appendFrom];
          var focusTarget = firstNew && (firstNew.matches('a, button') ? firstNew : firstNew.querySelector('a, button'));
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        }

        var old = wrap.querySelector('[data-grid-footer]');
        if (old) old.remove();
        if (total) {
          var viewed  = grid.querySelectorAll('[data-product-card]').length;
          var hasMore = (r.page || 1) < (r.total_pages || 1);
          var nextBatchCount = hasMore ? Math.max(1, Math.min(pp, total - viewed)) : 0;
          var foot    = document.createElement('div');
          foot.className = 'pt-80 md:pt-104 px-24 md:px-0 flex flex-col items-center gap-16';
          foot.setAttribute('data-grid-footer', '');
          foot.innerHTML =
            '<p class="text-b2 text-primary text-center" data-viewed-of>' + escHtml(i18n.viewedOf.replace('__VIEWED__', viewed).replace('__TOTAL__', total)) + '</p>' +
            (hasMore
              ? '<button type="button" class="' + outlineBtnClass + '" data-load-more data-page="' + ((r.page || 1) + 1) + '">' + escHtml(i18n.loadMore.replace('__COUNT__', nextBatchCount)) + '</button>'
              : '');
          wrap.appendChild(foot);
        }
      }

      return {
        emptyStateHtml: emptyStateHtml,
        renderGrid:     renderGrid
      };
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-tagalys"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function safeUrl(url) {
      url = String(url || '');
      return (/^https:\/\//.test(url) || /^\/(?!\/)/.test(url)) ? url : '';
    }

    function revealHero() {
      var heroCount = document.querySelector('[data-hero-result-count]');
      if (heroCount) heroCount.style.opacity = '1';
    }

    /* Shared by both the reload() onFailure and the bootstrap's catch — surfaces
       the grid, reveals the hero count so nothing stays permanently hidden, and
       announces the error via the same [data-grid-status] aria-live region the
       success path already writes its result count into. Also the failure path
       for a failed Load more (same instance/onFailure as the initial search
       call) — without resetting appending and the button here, it stays true
       forever (silently ignoring every further click) and the button is left
       showing its loading-dots spinner with no label. */
    function showLoadError() {
      var g = document.getElementById('tagalys-search-grid');
      if (g) g.style.opacity = '1';
      revealHero();
      var status = document.querySelector('[data-grid-status]');
      if (status) status.textContent = i18n.loadError;
      if (appending) {
        appending = false;
        var more = document.querySelector('[data-load-more]');
        if (more) {
          more.removeAttribute('aria-busy');
          var label = more.getAttribute('aria-label');
          if (label) more.textContent = label;
        }
      }
    }

    /* ── Tagalys integration ── */

    var term      = '';
    var pp        = 24;
    var token     = '';
    var domain    = '';
    /* Single-sourced from search-grid.liquid's outline button — see its data-btn-class-outline. */
    var outlineBtnClass = 'inline-flex items-center justify-center w-full h-48 px-24 border border-border-secondary bg-transparent text-primary text-f2 uppercase cursor-pointer select-none transition-btn-primary hover:bg-surface-tertiary hover:border-border-primary focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2 aria-disabled:opacity-40 aria-disabled:cursor-not-allowed aria-disabled:pointer-events-none sm:w-393';
    var i18n      = {
      emptyTitle:     'No products found',
      emptyDesc:      'Try adjusting your filters or browse our other collections.',
      viewedOf:       'Viewed __VIEWED__ of __TOTAL__ results.',
      loadMore:       'Load __COUNT__ more',
      quickView:      'Quick view',
      notify:         'Notify',
      outOfStock:     'Out of stock',
      fromPrice:      'From __PRICE__',
      rating:         'Rated __RATING__ out of 5',
      priceMin:       'Min price',
      priceMax:       'Max price',
      /* No hardcoded literal — overwritten from data-currency (gridEl,
         itself sourced from cart.currency.iso_code | default: shop.currency
         in Liquid) below before first use; money() degrades to a plain
         number if this is ever still empty when called. */
      currency:       '',
      loadError:      'Something went wrong loading results. Please try again.',
      rootUrl:        ''
    };
    var total     = 0;
    var instance  = null;
    var appending = false;
    /* Authoritative local record of applied filters/sort — see the doc comment
       at the top of this file. Price entries use {selected_min, selected_max},
       the shape the SearchResults connector accepts (confirmed via the
       URL-restore path) and collection-tagalys-facets.liquid's shared
       TagalysFacets factory defaults its priceMinKey/priceMaxKey options to. */
    var state = { filters: {}, sort: null };
    var facetPriorityGridEl = document.getElementById('tagalys-search-grid');
    var facetPriority = ((facetPriorityGridEl && facetPriorityGridEl.getAttribute('data-facet-priority')) || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var maxFacetLinks = parseInt((facetPriorityGridEl && facetPriorityGridEl.getAttribute('data-max-filters-shown')) || '0', 10) || 0;
    var facets = window.TagalysFacets({ i18n: i18n, state: state, facetPriority: facetPriority, maxFacetLinks: maxFacetLinks });
    // Also shared with collection-tagalys.liquid (see collection-tagalys-price-events.liquid).
    window.TagalysPriceEvents({
      state:          state,
      syncPriceRange: facets.syncPriceRange
    }).bind(reload);

    /* Both factories are rendered by this file's own render calls above, so
       their bundles are always concatenated first — the same guarantee this
       file already relies on for window.TagalysUrlState and
       window.TagalysPriceEvents. No typeof guard: a missing global here must
       fail loudly, not degrade to a silently empty grid. */
    var connectors = window.TagalysSearchConnectors({
      onSuccess:   onTagalysSuccess,
      onLoadError: showLoadError
    });
    var gridRender = window.TagalysSearchRender({ i18n: i18n });

    function onTagalysReady(cb) {
      if (window.Tagalys) return cb();
      var gridEl = document.getElementById('tagalys-search-grid');
      var url = gridEl && gridEl.getAttribute('data-tagalys-sdk-url');
      var done = false;
      var timeoutId = setTimeout(function () {
        if (done) return;
        done = true;
        var g = document.getElementById('tagalys-search-grid');
        if (g && !g.hasAttribute('data-tagalys-ready')) {
          if (!g.querySelector('[data-product-grid], [data-empty-state]')) {
            g.innerHTML = gridRender.emptyStateHtml();
          }
          g.style.opacity = '1';
          revealHero();
        }
      }, 5000);
      window.ensureTagalysSdk(url, function () {
        if (done) return;
        done = true;
        clearTimeout(timeoutId);
        cb();
      });
    }

    /* Filters/sort URL round-trip — shared with collection-tagalys.liquid via
       collection-tagalys-url-state.liquid (see that file's doc header). Search's
       own `q` search-term param is preserved through preserveKeys, never
       overwritten. */
    var urlState = window.TagalysUrlState({ priceMinKey: 'selected_min', priceMaxKey: 'selected_max', preserveKeys: ['q'] });

    /* Reissues one combined-state search call from `state.filters`/`state.sort` —
       see the doc comment at the top of this file for why this replaces
       Tagalys's incremental applyFilter()/clearFilter()/applySortOption()
       helpers for every ongoing interaction. Pagination is the one exception:
       it still calls instance.helpers.goToNextPage() directly (see the
       data-load-more click handler below) since it isn't implicated in the
       SDK crash and doesn't need a fresh connector. */
    function reload() {
      if (!instance) return;
      var params = { query: term, perPage: pp, page: 1, sort: state.sort || '', filters: state.filters };
      try {
        instance = connectors.buildSearchResults(params);
      } catch (err) {
        console.error('[Tagalys Search] APIConnector.SearchResults.new() threw', err);
        showLoadError();
        return;
      }
      instance.helpers.call();
      urlState.syncURL(state.filters, state.sort);
    }

    /* Set before the initial (always-unfiltered) bootstrap call when the URL
       has filters/sort to restore — the first response's only job is then to
       seed the facet caches with the full, unfiltered option set (exactly
       like a fresh visit) before the real filtered request replaces it, so
       nothing is ever missing from the cache to fall back to. */
    var _pendingURLRestore = null;

    function onTagalysSuccess(response, helpers) {
      /* Merchandiser-configured search-term redirects (e.g. "returns" → the
         delivery/returns page), confirmed live against the real SDK:
         helpers.isRedirected()/getRedirectURL() are documented accessors
         (enumerated directly off a live helpers object, not inferred), backed
         by a plain redirect_url field on the raw response. Checked first and
         unconditionally, before any grid/facet work below — a redirect only
         ever matters on the initial (always-unfiltered) bootstrap call for
         the term as typed, and short-circuits the rest of this function since
         the page is navigating away regardless. Guarded on Shopify.designMode
         (same convention as layout/theme.liquid's rewards-page redirect) so
         merchants editing this template in the theme editor are never bounced
         off it. location.replace(), not .href, so the redirect doesn't leave
         the dead-end search URL in browser history to bounce back to. */
      if (typeof helpers.isRedirected === 'function' && helpers.isRedirected()) {
        var redirectUrl = safeUrl(helpers.getRedirectURL());
        if (redirectUrl && !(window.Shopify && window.Shopify.designMode)) {
          window.location.replace(redirectUrl);
          return;
        }
      }

      var products = helpers.getProducts() || [];
      var page = helpers.getCurrentPage() || 1;
      var totalPages = helpers.getTotalPages() || 1;
      total = helpers.getTotalProductsCount() || 0;
      gridRender.renderGrid({ products: products, page: page, total_pages: totalPages }, appending, total, pp, outlineBtnClass);
      appending = false;
      /* collection-tagalys-badges.liquid's own doc header documents hydrate()
         as called after every Tagalys render on collection, search AND
         mini-search - this call was missing here, leaving search results
         without the live warehouse-aware availability correction that
         collection-tagalys.liquid and mini-search-render.liquid already get
         (search fell back to TagalysBundleAvailability.correct() alone, a
         narrower, blended-only, bundle-scoped check). */
      if (window.TagalysBadgeHydration) {
        var searchGridEl = document.getElementById('tagalys-search-grid');
        if (searchGridEl) window.TagalysBadgeHydration.hydrate(products, searchGridEl);
      }
      if (window.TagalysBundleAvailability) window.TagalysBundleAvailability.correct(products, 'tagalys-search-grid');
      var filters = helpers.getFilters() || [];
      var sortOptions = helpers.getSortOptions() || [];
      /* renderFacets() returns the MERGED facet list (via the facet-level cache
         built earlier so a facet stays visible/greyed even when a response
         temporarily omits it) — use that, not the raw `filters` response,
         for anything summing/deriving across all facets. Confirmed live:
         Tagalys sends a partial `filters` array (sometimes just the one facet
         that just changed) rather than the full set on every response, so
         reading raw `filters` here dropped other facets' contributions —
         e.g. the price facet's activeCount vanishing from the "All Filters"
         total the moment a later response only echoed back the checkbox
         facet that had just been toggled. */
      var merged = facets.renderFacets(filters);
      facets.renderSort(sortOptions);
      var totalActive = merged.reduce(function (sum, f) { return sum + facets.facetActiveCount(f); }, 0);
      if (window.PlpFilters) window.PlpFilters.update(totalActive, total, merged.length > 0);

      if (_pendingURLRestore) {
        var restore = _pendingURLRestore;
        _pendingURLRestore = null;
        state.filters = restore.filters;
        state.sort    = restore.sort;
        reload();
        return; // real filtered response is on its way — don't reveal this intermediate one
      }

      var g = document.getElementById('tagalys-search-grid');
      if (g) {
        g.setAttribute('data-tagalys-ready', '');
        g.style.opacity = '1';
      }
      var heroCount = document.querySelector('[data-hero-result-count]');
      if (heroCount) {
        // Zero matches gets its own copy ("No results found for …"), not the
        // counted format rendered with a literal 0. Partial-match/spelling-
        // corrected take priority over the plain count copy whenever Tagalys
        // reports them AND the (possibly corrected) query actually has matches —
        // a corrected query that itself has zero results falls through to the
        // plain empty copy rather than claiming results that aren't there.
        // isPartialResults/isSpellingCorrectedQuery are read defensively (a
        // future SDK without them just never shows the differentiated copy)
        // matching this file's existing helpers.getX() || [] pattern.
        var heroEmpty     = heroCount.getAttribute('data-i18n-heading-empty');
        var heroFmt       = heroCount.getAttribute('data-i18n-heading') || '';
        var heroPartial   = heroCount.getAttribute('data-i18n-heading-partial');
        var heroCorrected = heroCount.getAttribute('data-i18n-heading-corrected');
        var isSpellingCorrected = typeof helpers.isSpellingCorrectedQuery === 'function' && helpers.isSpellingCorrectedQuery();
        var isPartial = typeof helpers.isPartialResults === 'function' && helpers.isPartialResults();

        if (total > 0 && isSpellingCorrected && heroCorrected) {
          var correctedQuery = (typeof helpers.getQuery === 'function' && helpers.getQuery()) || term;
          heroCount.textContent = heroCorrected.replace('__CORRECTED__', correctedQuery);
        } else if (total > 0 && isPartial && heroPartial) {
          heroCount.textContent = heroPartial;
        } else {
          heroCount.textContent = (total === 0 && heroEmpty)
            ? heroEmpty
            : heroFmt.replace('__COUNT__', total);
        }

        // Tab title mirrors this same heading exactly, once Tagalys's real
        // total is known — sections/search.liquid's server-rendered
        // page_title is deliberately count-free (Shopify's own auto count
        // is against its native search index, not Tagalys, and would be
        // wrong the moment this runs), so this is the only place the title
        // ever reflects an actual result count.
        var shopName = (g && g.getAttribute('data-shop-name')) || '';
        document.title = (shopName && heroCount.textContent.indexOf(shopName) === -1)
          ? heroCount.textContent + ' – ' + shopName
          : heroCount.textContent;
      }
      var status = document.querySelector('[data-grid-status]');
      if (status) {
        var fmt = g && g.getAttribute('data-i18n-result-count') || '__COUNT__ results';
        status.textContent = heroCount ? heroCount.textContent
          : (total > 0 ? fmt.replace('__COUNT__', total) : i18n.emptyTitle);
      }
      revealHero();
    }

    /* ── Event delegation — each handler updates the local `state` object, then
       reload() reissues one combined-state request (see the doc comment at the
       top of this file). Pagination alone still calls the documented
       goToNextPage() helper directly on the existing instance. ── */

    document.addEventListener('change', function (e) {
      var el = e.target, key = el.getAttribute('data-facet-key');
      if (el.type !== 'checkbox' || !key) return;
      // A checkbox can represent several ids merged under one label
      // (groupFacetItems, TASK-54365) — toggle them all together.
      var vals = window.TagalysFacetFormat.parseFacetValues(el.getAttribute('data-facet-value'));
      var current = state.filters[key] || [];
      if (el.checked) {
        vals.forEach(function (val) { if (current.indexOf(val) < 0) current = current.concat([val]); });
        state.filters[key] = current;
      } else {
        var updated = current.filter(function (v) { return vals.indexOf(v) < 0; });
        if (updated.length) state.filters[key] = updated;
        else delete state.filters[key];
      }
      reload();
    });

    document.addEventListener('click', function (e) {
      var grid = document.getElementById('tagalys-search-grid');
      var live = grid && grid.hasAttribute('data-tagalys-ready');

      var clearBtn = e.target.closest('[data-clear-filters]');
      if (clearBtn) {
        // aria-disabled (not disabled) keeps the button focusable — its own
        // aria-disabled: classes (snippets/button.liquid) stop a mouse click,
        // but not a keyboard Enter/Space activation, which still fires a real
        // click on a focusable, non-disabled <button>. Guard here too.
        if (clearBtn.getAttribute('aria-disabled') === 'true') return;
        state.filters = {}; state.sort = null; reload(); return;
      }

      var tile = e.target.closest('[data-image-tile]');
      if (tile) {
        var k = tile.getAttribute('data-facet-key'), v = tile.getAttribute('data-facet-value');
        var cur = state.filters[k] || [];
        var idx = cur.indexOf(v);
        if (idx >= 0) {
          var upd = cur.filter(function (x) { return x !== v; });
          if (upd.length) state.filters[k] = upd; else delete state.filters[k];
          tile.setAttribute('aria-pressed', 'false');
        } else {
          state.filters[k] = cur.concat([v]);
          tile.setAttribute('aria-pressed', 'true');
        }
        reload();
        return;
      }

      var sortBtn = e.target.closest('[data-sort-option]');
      if (sortBtn && live) { state.sort = sortBtn.getAttribute('data-sort-option'); reload(); return; }

      var more = e.target.closest('[data-load-more]');
      if (more && live) {
        if (appending || !instance) return;
        e.preventDefault();
        more.setAttribute('aria-busy', 'true');
        more.setAttribute('aria-label', more.textContent.trim());
        more.innerHTML = '<span data-load-dots aria-hidden="true"><span></span><span></span><span></span></span>';
        appending = true;
        instance.helpers.goToNextPage();
      }
    });

    /* ── Bootstrap — reads config from data-* attributes on the grid element ── */

    onTagalysReady(function () {
      var gridEl = document.getElementById('tagalys-search-grid');
      term    = (gridEl && gridEl.getAttribute('data-search-term'))       || '';
      pp      = parseInt((gridEl && gridEl.getAttribute('data-per-page')) || '24', 10);
      token   = (gridEl && gridEl.getAttribute('data-tagalys-token'))     || token;
      domain  = (gridEl && gridEl.getAttribute('data-tagalys-domain'))    || domain;
      outlineBtnClass = (gridEl && gridEl.getAttribute('data-btn-class-outline')) || outlineBtnClass;
      i18n.emptyTitle     = (gridEl && gridEl.getAttribute('data-i18n-empty-title'))     || i18n.emptyTitle;
      i18n.emptyDesc      = (gridEl && gridEl.getAttribute('data-i18n-empty-desc'))      || i18n.emptyDesc;
      i18n.viewedOf       = (gridEl && gridEl.getAttribute('data-i18n-viewed-of'))       || i18n.viewedOf;
      i18n.loadMore       = (gridEl && gridEl.getAttribute('data-i18n-load-more'))       || i18n.loadMore;
      i18n.quickView      = (gridEl && gridEl.getAttribute('data-i18n-quick-view'))      || i18n.quickView;
      i18n.notify         = (gridEl && gridEl.getAttribute('data-i18n-notify'))          || i18n.notify;
      i18n.outOfStock     = (gridEl && gridEl.getAttribute('data-i18n-out-of-stock'))    || i18n.outOfStock;
      i18n.fromPrice      = (gridEl && gridEl.getAttribute('data-i18n-from-price'))      || i18n.fromPrice;
      i18n.rating         = (gridEl && gridEl.getAttribute('data-i18n-rating'))          || i18n.rating;
      i18n.priceMin       = (gridEl && gridEl.getAttribute('data-i18n-price-min'))       || i18n.priceMin;
      i18n.priceMax       = (gridEl && gridEl.getAttribute('data-i18n-price-max'))       || i18n.priceMax;
      i18n.currency       = (gridEl && gridEl.getAttribute('data-currency'))             || i18n.currency;
      i18n.rootUrl        = (gridEl && gridEl.getAttribute('data-root-url'))             || i18n.rootUrl;
      i18n.loadError      = (gridEl && gridEl.getAttribute('data-i18n-load-error'))      || i18n.loadError;

      var urlFilters = urlState.filtersFromURL(), urlSort = urlState.sortFromURL();
      if (Object.keys(urlFilters).length || urlSort) _pendingURLRestore = { filters: urlFilters, sort: urlSort };

      connectors.configure(token, domain);
      if (term) {
        var params = { query: term, perPage: pp, page: 1 };
        try {
          instance = connectors.buildSearchResults(params);
        } catch (err) {
          console.error('[Tagalys Search] APIConnector.SearchResults.new() threw — connector not initialised', err);
          showLoadError();
          return;
        }
        instance.helpers.call();
        setTimeout(function () {
          var g = document.getElementById('tagalys-search-grid');
          if (g && !g.hasAttribute('data-tagalys-ready')) { g.style.opacity = '1'; revealHero(); }
        }, 3000);
      } else {
        var g = document.getElementById('tagalys-search-grid');
        if (g) g.style.opacity = '1';
        revealHero();
      }
    });

  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-finder-list"] && !Shopify.designMode) return;
  try {
    ;(function () {
    var KM_TO_MILES = 0.621371;

    function numberAttribute(el, name) {
      var value = parseFloat(el.getAttribute(name));
      return Number.isFinite(value) ? value : null;
    }

    function setupStoreFinderList(list) {
      if (list.__storeFinderListReady) return;

      var results = list.querySelector('[data-store-finder-results]');
      if (!results) return;

      list.__storeFinderListReady = true;

      var section = list.closest('[data-store-finder]');
      var target = section || list;
      var statusEl = target.querySelector('[data-store-finder-status]');
      var moreWrapper = list.querySelector('[data-store-finder-more]');
      var moreTrigger = moreWrapper ? moreWrapper.querySelector('[data-store-finder-more-trigger]') : null;

      // Server order IS tier order, so it doubles as the restore target on Clear.
      var tierOrder = Array.prototype.slice.call(results.querySelectorAll('[data-store-finder-card]'));
      var order = tierOrder.slice();

      var batchSize = parseInt(list.getAttribute('data-store-finder-initial-count'), 10);
      if (!Number.isFinite(batchSize) || batchSize < 1) batchSize = tierOrder.length;

      var distanceTemplate = list.getAttribute('data-store-finder-distance-label') || '';
      var statusTemplate = list.getAttribute('data-store-finder-results-status') || '';
      var visibleCount = Math.min(batchSize, order.length);

      function announce(message) {
        if (statusEl) statusEl.textContent = message;
      }

      function emit(name, detail) {
        target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
      }

      // Re-appending a live child moves it, so this both reorders and re-collapses.
      function render() {
        for (var i = 0; i < order.length; i++) {
          results.appendChild(order[i]);
          order[i].hidden = i >= visibleCount;
        }
        if (moreWrapper) moreWrapper.hidden = visibleCount >= order.length;
      }

      function resetDistances() {
        for (var i = 0; i < tierOrder.length; i++) {
          var el = tierOrder[i].querySelector('[data-store-finder-distance]');
          if (!el) continue;
          el.textContent = '';
          el.hidden = true;
        }
      }

      function applyOrigin(origin) {
        // Referenced at the point of use, never at the top level of this block:
        // this snippet and store-search-loqate both land in snippet-scripts.js
        // and their execution order is not guaranteed (FAILS §3).
        var helpers = window.WhittardStoreSearch;

        if (!origin || !helpers || typeof helpers.distanceBetween !== 'function') {
          order = tierOrder.slice();
          resetDistances();
          visibleCount = Math.min(batchSize, order.length);
          render();
          emit('store-finder:store-deselected');
          return;
        }

        var rows = [];
        for (var i = 0; i < tierOrder.length; i++) {
          var card = tierOrder[i];
          var latitude = numberAttribute(card, 'data-store-lat');
          var longitude = numberAttribute(card, 'data-store-lng');
          var km = Infinity;

          if (latitude !== null && longitude !== null) {
            km = helpers.distanceBetween(origin, { latitude: latitude, longitude: longitude });
          }

          rows.push({ card: card, km: km, index: i });
        }

        // Ties fall back to tier order, so an un-geocoded store never jumps rank.
        rows.sort(function (a, b) {
          if (a.km === b.km) return a.index - b.index;
          return a.km - b.km;
        });

        order = [];

        for (var j = 0; j < rows.length; j++) {
          order.push(rows[j].card);

          var distanceEl = rows[j].card.querySelector('[data-store-finder-distance]');
          if (!distanceEl) continue;

          if (Number.isFinite(rows[j].km)) {
            distanceEl.textContent = distanceTemplate.replace('__DISTANCE__', (rows[j].km * KM_TO_MILES).toFixed(1));
            distanceEl.hidden = false;
          } else {
            distanceEl.textContent = '';
            distanceEl.hidden = true;
          }
        }

        visibleCount = Math.min(batchSize, order.length);
        render();
        // order.length, not measured: every store is rendered as a card regardless of
        // whether it geocoded, so the announced count must match what's actually shown,
        // not just the subset with a valid computed distance.
        announce(statusTemplate.replace('__COUNT__', order.length));

        // Selecting the nearest result opens its map pin the same way clicking the
        // pin itself does — store-finder-map.liquid listens for this same event.
        // Only when a real distance was measured: an un-geocoded "nearest" store
        // would open a callout for a store nowhere near where the visitor searched.
        if (rows.length && Number.isFinite(rows[0].km)) {
          var nearestHandle = rows[0].card.getAttribute('data-store-handle');
          if (nearestHandle) emit('store-finder:store-selected', { handle: nearestHandle, source: 'search' });
        } else {
          emit('store-finder:store-deselected');
        }
      }

      function setActive(handle) {
        for (var i = 0; i < tierOrder.length; i++) {
          var card = tierOrder[i];
          // Compared as a value rather than built into a selector, so no handle
          // ever reaches a query string and CSS.escape is not needed (§4.9).
          var isActive = !!handle && card.getAttribute('data-store-handle') === handle;
          card.classList.toggle('bg-surface-tertiary', isActive);
          card.classList.toggle('bg-surface-secondary', !isActive);
        }
      }

      // Clicking a card opens its map popup, same as clicking the pin — wanted
      // behaviour even though neither A&I block on 16639:315339 documents it.
      results.addEventListener('click', function (event) {
        // The card's own links and buttons keep their default behaviour.
        if (event.target.closest('a, button')) return;

        var card = event.target.closest('[data-store-finder-card]');
        if (!card) return;

        var handle = card.getAttribute('data-store-handle');
        if (!handle) return;

        // source: 'card' lets store-finder-map.liquid's desktop auto-pan/zoom
        // (§ "Only act when the pin genuinely isn't usable") tell this apart
        // from a pin click or a search's auto-selected nearest result.
        emit('store-finder:store-selected', { handle: handle, source: 'card' });
      });

      target.addEventListener('store-finder:store-selected', function (event) {
        var handle = event.detail && event.detail.handle;
        if (handle) setActive(handle);
      });

      target.addEventListener('store-finder:store-deselected', function () {
        setActive(null);
      });

      target.addEventListener('store-finder:origin-changed', function (event) {
        var detail = event.detail || {};
        if (detail.latitude == null || detail.longitude == null) {
          applyOrigin(null);
          return;
        }
        applyOrigin({ latitude: detail.latitude, longitude: detail.longitude });
      });

      if (moreTrigger) {
        moreTrigger.addEventListener('click', function () {
          visibleCount = Math.min(visibleCount + batchSize, order.length);
          render();
        });
      }

      setupSearchHeaderNavOffset(list);
      render();
    }

    // Below md only: sections/header.liquid's own nav hides on scroll down and
    // reappears on scroll up (both immediately at page load, tracking scroll
    // 1:1 with no easing, and later via an eased hide()/show() once scrolled
    // past its own height). This mirrors the nav's OWN live position every
    // relevant frame, rather than inferring "is the nav visible" from this
    // file's own scroll-delta heuristic — two earlier rounds of that
    // heuristic (edge-triggered, then hysteresis-gated) both fixed real
    // flapping bugs but never handled the page-load/top-of-page case, where
    // the nav is visible for a different reason than "scrolled back up" and
    // has no discrete edge to trigger on. Full history: docs/snags/2026-08-25-store-finder.md #12.
    function setupSearchHeaderNavOffset(list) {
      var searchHeader = list.querySelector('[data-store-finder-search-header]');
      var offsetTarget = list.querySelector('[data-store-finder-search-header-offset]');
      if (!searchHeader) return;

      // Matches --spacing-8, the token sections/header.liquid's own gap
      // tokens use — the breathing room below the nav, not part of the nav's
      // own measured position.
      var NAV_GAP = 8;

      var siteHeader = document.getElementById('site-header');
      var desktopQuery = window.matchMedia('(min-width: 1024px)');
      var lastOffset = null; // last applied px value, so a sub-pixel wobble isn't a fresh write

      // Reserves only the search header's OWN height — the nav's height is
      // ALREADY reserved for this block by #header-spacer (layout/theme.liquid;
      // store-finder's page template isn't in settings.overlay_header_templates,
      // so needs_spacer is true here), which pushes the whole list column down
      // in normal flow before this margin is even added. Adding the nav's
      // translate offset on top of that (an earlier version of this fix did)
      // double-reserves it: the column already starts below the nav, so
      // stacking a second nav's-worth of margin on the first thing inside it
      // just pushed the intro paragraph an extra ~118px down the page — a gap
      // confirmed on-device, that only ever grows at the very moment the
      // gap wouldn't otherwise be visible. Verified frame-by-frame against
      // the dev server: this stays exactly flush with the search header's
      // live bottom edge (0px gap) through the whole nav hide/reveal range,
      // not just the two rest states.
      function updateOffsetMargin() {
        if (!offsetTarget) return;
        offsetTarget.style.marginTop = desktopQuery.matches ? '' : searchHeader.offsetHeight + 'px';
      }

      updateOffsetMargin();
      if (offsetTarget && window.ResizeObserver) {
        new ResizeObserver(updateOffsetMargin).observe(searchHeader);
      }

      function currentOffset() {
        if (!siteHeader) return 0;
        var bottom = siteHeader.getBoundingClientRect().bottom;
        return bottom > 0 ? bottom + NAV_GAP : 0;
      }

      // Below md the search header is `fixed`, which — unlike `sticky` — has
      // no containing block to bound it: once the visitor scrolls past
      // [data-store-finder-list]'s own end, a `fixed` header keeps floating
      // over whatever comes next (the map column, then the footer), because
      // nothing in `fixed` positioning knows the column that logically
      // "owns" it has itself scrolled out of view. `sticky` naturally stops
      // there instead (TASK-53198 Q11/Q7). Reproducing that stop by hand:
      // hide the header once the column's own bottom edge has scrolled
      // above the viewport top, i.e. exactly where a `sticky` element bound
      // to this column would have released. `display`, not `visibility` or
      // an attribute, because Tailwind's `flex` utility on this same element
      // would otherwise win the cascade tie against `[hidden]` (FAILS §4).
      var isBounded = null; // tri-state: null forces the first real write
      function updateBounding() {
        var pastColumn = list.getBoundingClientRect().bottom <= 0;
        if (pastColumn === isBounded) return;
        isBounded = pastColumn;
        searchHeader.style.display = pastColumn ? 'none' : '';
      }

      function applyOffset() {
        if (!searchHeader.isConnected) return;
        // At md+ the header is md:sticky INSIDE the list column's own scroller
        // and needs no nav offset at all — it is not viewport-fixed there, so
        // the nav's position is irrelevant to it. keepAlive() below already
        // bails at md+, so this guard exists for the desktopQuery change
        // handler and the direct scrollend call, neither of which check first
        // — without it, a page loaded at 1024px+ would write a translate of
        // the nav's own height onto the sticky header and never clear it —
        // gapping it away from the column top and painting it over the intro
        // paragraph below. TASK-53198 re-test Q10/Q12.
        if (desktopQuery.matches) return;
        updateBounding();
        var offset = currentOffset();
        if (lastOffset !== null && Math.abs(offset - lastOffset) < 1) return;
        lastOffset = offset;

        if (offset > 0) {
          searchHeader.setAttribute('data-nav-visible', '');
          searchHeader.style.translate = '0 ' + offset + 'px';
        } else {
          searchHeader.removeAttribute('data-nav-visible');
          searchHeader.style.translate = '';
        }
      }

      // D76's ratified shape: an rAF-throttled 'scroll'/'resize' listener,
      // kept alive for SETTLE_MS after the last event rather than a permanent
      // per-frame poll (code review, TASK-53198 — the poll this replaced ran
      // unconditionally even at rest). Real touch/momentum scrolling on
      // mobile browsers can coalesce or delay 'scroll' dispatch during the
      // native fling animation, which is what motivated polling in the first
      // place — the on-device "hidden, then a sudden jump" report no desktop/
      // programmatic-scroll test reproduced (those fire 'scroll' synchronously
      // every call). 'scrollend' below closes that specific gap directly
      // instead: applyOffset() already no-ops on its own lastOffset guard
      // above if nothing was actually missed.
      var running = false;
      var settleTimer = null;
      var SETTLE_MS = 400;

      function loop() {
        applyOffset();
        if (running) requestAnimationFrame(loop);
      }

      function keepAlive() {
        if (desktopQuery.matches) return;
        if (!running) {
          running = true;
          requestAnimationFrame(loop);
        }
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          running = false;
        }, SETTLE_MS);
      }

      window.addEventListener('scroll', keepAlive, { passive: true });
      window.addEventListener('resize', keepAlive, { passive: true });

      if ('onscrollend' in window) {
        window.addEventListener('scrollend', applyOffset, { passive: true });
      }

      requestAnimationFrame(applyOffset);

      desktopQuery.addEventListener('change', function () {
        lastOffset = null;
        running = false;
        if (settleTimer) clearTimeout(settleTimer);
        if (!searchHeader.isConnected) return;
        if (desktopQuery.matches) {
          searchHeader.removeAttribute('data-nav-visible');
          searchHeader.style.translate = '';
          searchHeader.style.display = '';
          isBounded = null;
        } else {
          applyOffset();
        }
        updateOffsetMargin();
      });
    }

    window.initStoreFinderList = window.initStoreFinderList || function (scope) {
      var scopeRoot = scope || document;
      Array.prototype.forEach.call(scopeRoot.querySelectorAll('[data-store-finder-list]'), setupStoreFinderList);
    };

    window.initStoreFinderList();
    document.addEventListener('shopify:section:load', function (event) {
      window.initStoreFinderList(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-finder-map-controls"] && !Shopify.designMode) return;
  try {
    ;(function () {
    // Purely delegated: no top-level DOM query, so nothing here throws on a
    // page without the section, and nothing re-binds when the map column is
    // re-parented into the fullscreen surface or the section is re-rendered.
    // Each handler carries its own guard in place of a root early-return.

    // The controls live inside the map column, which is re-parented into the
    // fullscreen surface on toggle. Resolving the owning container this way
    // (rather than walking to a hard-coded section root) keeps the lookup
    // correct in both placements — orch §4.4.2, as ratified at build time.
    function containerOf(el) {
      return el.closest('[data-store-finder-fullscreen]') || el.closest('[data-store-finder]');
    }

    function eachControl(scope, fn) {
      var controls = scope.querySelectorAll(
        '[data-store-finder-zoom-in], [data-store-finder-zoom-out], [data-store-finder-fullscreen-open], [data-store-finder-fullscreen-close]'
      );
      Array.prototype.forEach.call(controls, fn);
    }

    // Enabled only once the map is interactive, so no control is ever dead.
    document.addEventListener('store-finder:map-ready', function (event) {
      var scope = containerOf(event.target) || document;
      eachControl(scope, function (control) { control.disabled = false; });
    });

    document.addEventListener('click', function (event) {
      var zoomIn = event.target.closest('[data-store-finder-zoom-in]');
      var zoomOut = zoomIn ? null : event.target.closest('[data-store-finder-zoom-out]');
      if (!zoomIn && !zoomOut) return;

      // Referenced at the point of use, never at the top level — the section
      // bundle runs before the snippet bundle that defines it (FAILS §3).
      var adapter = window.WhittardMapAdapter;
      if (!adapter || typeof adapter.setZoom !== 'function') return;

      adapter.setZoom(zoomIn ? 1 : -1);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-finder-map-sdk-styles"] && !Shopify.designMode) return;
  try {
    ;(function () {
    function token(name) {
      return window.getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    }

    function remToPx(value) {
      if (!value) return '';
      if (value.indexOf('rem') === -1) return value;
      var root = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
      if (!Number.isFinite(root)) return '';
      return (parseFloat(value) * root) + 'px';
    }

    // PB-8 branded basemap, all four tone families from theme tokens. A literal
    // hex is the last-resort fallback on each, not just an alternate token name —
    // if this runs before theme.css's custom properties resolve on :root (a
    // real load-order race, not hypothetical: confirmed live by manually
    // re-applying the same road rule via the console, which worked), every
    // token() read here returns '', silently dropping that rule and leaving
    // Google's own default styling for that feature. Land/water default close
    // enough to this palette to look fine in a screenshot; road's default is
    // Google's bold highway colour, which is the "blue lines" bug.
    function mapStyles() {
      var land = token('--color-surface-tertiary') || token('--color-grey-150') || '#e9e5db';
      var water = token('--color-border-secondary') || token('--color-grey-200') || '#c5c4c1';
      // Figma's roads read as the same soft, muted tone as the water, not the
      // darker mid-grey --color-secondary carries for body text — matched
      // directly to the water token rather than a separate lookup for the
      // same value.
      var road = water;
      var label = token('--color-secondary') || token('--color-grey-500') || '#616161';
      var styles = [];

      function push(featureType, elementType, stylers) {
        var rule = { stylers: stylers };
        if (featureType) rule.featureType = featureType;
        if (elementType) rule.elementType = elementType;
        styles.push(rule);
      }

      // Land first — later feature rules override it.
      if (land) push(null, 'geometry', [{ color: land }]);

      if (label) push(null, 'labels.text.fill', [{ color: label }]);
      if (land) push(null, 'labels.text.stroke', [{ color: land }]);
      push(null, 'labels.icon', [{ visibility: 'off' }]);
      push('administrative', 'geometry', [{ visibility: 'off' }]);

      push('poi', null, [{ visibility: 'off' }]);
      push('poi.park', null, [{ visibility: 'off' }]);
      push('transit', null, [{ visibility: 'off' }]);

      if (road) push('road', 'geometry', [{ color: road }]);
      push('road', 'geometry.stroke', [{ visibility: 'off' }]);
      push('road', 'labels.icon', [{ visibility: 'off' }]);

      if (water) push('water', 'geometry', [{ color: water }]);
      if (label) push('water', 'labels.text.fill', [{ color: label }]);

      return styles;
    }

    window.WhittardMapSdkStyles = {
      mapStyles: mapStyles,
      remToPx: remToPx,
      token: token
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-finder-map-sdk"] && !Shopify.designMode) return;
  try {
    ;(function () {
    // TECH-DEBT #24: validated key, hard-coded host, never a selector.
    var SDK_HOST = 'https://maps.googleapis.com/maps/api/js';
    var KEY_PATTERN = /^[A-Za-z0-9._-]+$/;
    var LOAD_TIMEOUT = 8000;
    var CALLBACK_NAME = '__whittardMapSdkReady';
    // fitBounds() has no zoom ceiling of its own: for one store, or several with
    // near-identical coordinates, Google zooms in to whatever level tightly frames
    // the points — sometimes past street level. Town/city-level is the useful floor
    // for "find your nearest store".
    var MAX_FIT_ZOOM = 14;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var map = null;
    var overlay = null;
    var markers = [];
    // Set once in setMarkers, read in selectMarker/clearSelection — the
    // selected store's pin swaps to --color-primary (#1D1D1D, Figma) while
    // every other pin stays the default brand colour.
    var pinIcon = null;
    var activePinIcon = null;
    var clusterer = null;
    var listeners = { 'marker-click': [], 'background-click': [], 'camera-idle': [] };
    var mapListeners = [];
    var loadPromise = null;
    var clustererPromise = null;
    var clusteringWanted = false;
    var configEl = null;

    function assetUrl(name) {
      return configEl ? configEl.getAttribute(name) || '' : '';
    }

    // From store-finder-map-sdk-styles.liquid, rendered above this file's own
    // bundled script so it's already defined here. Fallbacks below are
    // defensive only (matches the adapter-consumer type-check pattern used
    // throughout this feature, FAILS §3) — the render order guarantees the
    // real implementation is present in practice.
    var mapSdkStyles = window.WhittardMapSdkStyles || {
      mapStyles: function () { return []; },
      remToPx: function (value) { return value || ''; },
      token: function () { return ''; }
    };

    function sdkAlreadyRequested() {
      for (var i = 0; i < document.scripts.length; i++) {
        var src = document.scripts[i].src || '';
        if (src.indexOf(SDK_HOST) === 0) return true;
      }
      return false;
    }

    function loadSdk(key) {
      if (loadPromise) return loadPromise;

      loadPromise = new Promise(function (resolve, reject) {
        if (window.google && window.google.maps) return resolve();

        if (!KEY_PATTERN.test(key)) return reject(new Error('invalid-key'));

        var settled = false;
        var timer = window.setTimeout(function () {
          if (!settled) { settled = true; reject(new Error('timeout')); }
        }, LOAD_TIMEOUT);

        window[CALLBACK_NAME] = function () {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          resolve();
        };

        if (sdkAlreadyRequested()) return;

        var script = document.createElement('script');
        script.src = SDK_HOST + '?key=' + encodeURIComponent(key) + '&v=weekly&loading=async&callback=' + CALLBACK_NAME;
        script.async = true;
        script.defer = true;
        script.onerror = function () {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          reject(new Error('network'));
        };
        document.head.appendChild(script);
      });

      return loadPromise;
    }

    // Parallel-safe: this build copies OverlayView's prototype in its
    // constructor, not via top-level extends, so google.maps is needed
    // only at construction (map-ready), never at load.
    function loadClusterer(src) {
      if (clustererPromise) return clustererPromise;

      clustererPromise = new Promise(function (resolve, reject) {
        if (window.markerClusterer) return resolve();
        if (!src) return reject(new Error('no-src'));

        for (var i = 0; i < document.scripts.length; i++) {
          if ((document.scripts[i].src || '').indexOf(src) === 0) return;
        }

        var settled = false;
        var timer = window.setTimeout(function () {
          if (!settled) { settled = true; reject(new Error('timeout')); }
        }, LOAD_TIMEOUT);

        var script = document.createElement('script');
        script.src = src;
        script.defer = true;
        script.onload = function () {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          resolve();
        };
        script.onerror = function () {
          if (settled) return;
          settled = true;
          window.clearTimeout(timer);
          reject(new Error('network'));
        };
        document.head.appendChild(script);
      });

      return clustererPromise;
    }

    function emit(name, payload) {
      listeners[name].forEach(function (fn) { fn(payload); });
    }

    // Detached markers attached here: correct in any call order, with or
    // without the clusterer.
    function applyMarkerDisplay() {
      if (!map) return;

      var canCluster = clusteringWanted && window.markerClusterer && window.markerClusterer.MarkerClusterer;

      if (clusterer && typeof clusterer.clearMarkers === 'function') {
        clusterer.clearMarkers();
        clusterer = null;
      }

      if (!canCluster) {
        markers.forEach(function (marker) { marker.setMap(map); });
        return;
      }

      markers.forEach(function (marker) { marker.setMap(null); });

      var clusterUrl = assetUrl('data-cluster-icon');
      var labelColour = mapSdkStyles.token('--color-invert') || mapSdkStyles.token('--color-grey-0');
      var labelFamily = mapSdkStyles.token('--font-body');
      var labelSize = mapSdkStyles.remToPx(mapSdkStyles.token('--font-size-b1'));

      clusterer = new window.markerClusterer.MarkerClusterer({
        map: map,
        markers: markers,
        // Figma cluster badge, not the library default.
        renderer: {
          render: function (cluster) {
            var label = { text: String(cluster.count) };
            if (labelColour) label.color = labelColour;
            if (labelFamily) label.fontFamily = labelFamily;
            if (labelSize) label.fontSize = labelSize;

            return new google.maps.Marker({
              position: cluster.position,
              label: label,
              icon: clusterUrl ? {
                url: clusterUrl,
                scaledSize: new google.maps.Size(40, 40),
                anchor: new google.maps.Point(20, 20)
              } : undefined,
              zIndex: 1000 + cluster.count
            });
          }
        }
      });
    }

    function clearMarkers() {
      if (clusterer && typeof clusterer.clearMarkers === 'function') clusterer.clearMarkers();
      markers.forEach(function (marker) { marker.setMap(null); });
      markers = [];
    }

    var adapter = {
      init: function (canvasEl, options) {
        var opts = options || {};

        // Clustering is an enhancement — its failure must not fail the map, and
        // now its LOAD TIME must not delay the map either: fetched independently
        // rather than inside the Promise.all the map used to wait on, so a slow
        // vendor-markerclusterer.js fetch no longer holds up map construction.
        // applyMarkerDisplay() re-runs once it resolves, upgrading any
        // already-placed individual markers to clustered display — otherwise a
        // clusterer that finishes after the first setMarkers() call would leave
        // the map stuck un-clustered for the rest of the pageview.
        loadClusterer(opts.clusterLib).then(function () {
          applyMarkerDisplay();
        }).catch(function () {});

        return loadSdk(opts.key).then(function () {
          map = new google.maps.Map(canvasEl, {
            center: { lat: 54.5, lng: -3 },
            zoom: 6,
            styles: mapSdkStyles.mapStyles(),
            // All native controls off — ours are the only set (§4.5.4).
            disableDefaultUI: true,
            zoomControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            rotateControl: false,
            scaleControl: false,
            clickableIcons: false,
            gestureHandling: 'cooperative'
          });

          // Bare OverlayView = the only projection source (§4.8.2 gap).
          overlay = new google.maps.OverlayView();
          overlay.onAdd = function () {};
          overlay.draw = function () {};
          overlay.onRemove = function () {};
          overlay.setMap(map);

          mapListeners.push(map.addListener('click', function () { emit('background-click'); }));
          mapListeners.push(map.addListener('idle', function () { emit('camera-idle'); }));

          return map;
        });
      },

      destroy: function () {
        clearMarkers();
        mapListeners.forEach(function (listener) {
          if (listener && typeof listener.remove === 'function') listener.remove();
        });
        mapListeners = [];
        // Also reset the on()/emit() callback registry — every consumer
        // (store-finder-map.liquid, store-detail-map.liquid) re-registers a
        // fresh set on re-init, and without this the previous instance's
        // callbacks stayed subscribed forever, running against its own
        // detached DOM and stale closures on every camera-idle after each
        // theme-editor section reload.
        listeners = { 'marker-click': [], 'background-click': [], 'camera-idle': [] };
        if (overlay) { overlay.setMap(null); overlay = null; }
        clusterer = null;
        map = null;
      },

      resize: function () {
        if (!map) return;
        var centre = map.getCenter();
        google.maps.event.trigger(map, 'resize');
        if (centre) map.setCenter(centre);
      },

      setMarkers: function (stores) {
        if (!map) return;
        clearMarkers();

        var pinUrl = assetUrl('data-pin-icon');
        var activePinUrl = assetUrl('data-pin-icon-active');

        pinIcon = pinUrl ? {
          url: pinUrl,
          scaledSize: new google.maps.Size(32, 32),
          anchor: new google.maps.Point(16, 32)
        } : undefined;
        activePinIcon = activePinUrl ? {
          url: activePinUrl,
          scaledSize: new google.maps.Size(32, 32),
          anchor: new google.maps.Point(16, 32)
        } : pinIcon;

        markers = (stores || []).map(function (store) {
          var marker = new google.maps.Marker({
            position: { lat: store.lat, lng: store.lng },
            title: store.name,
            icon: pinIcon
          });
          marker.__handle = store.handle;
          marker.addListener('click', function () { emit('marker-click', store.handle); });
          return marker;
        });

        applyMarkerDisplay();
      },

      setClusteringEnabled: function (enabled) {
        clusteringWanted = !!enabled;
        applyMarkerDisplay();
      },

      selectMarker: function (handle) {
        markers.forEach(function (marker) {
          var isSelected = marker.__handle === handle;
          marker.setZIndex(isSelected ? 1000 : 1);
          marker.setIcon(isSelected ? activePinIcon : pinIcon);
        });
      },

      clearSelection: function () {
        markers.forEach(function (marker) {
          marker.setZIndex(1);
          marker.setIcon(pinIcon);
        });
      },

      fitBounds: function (stores) {
        if (!map || !stores || !stores.length) return;

        var bounds = new google.maps.LatLngBounds();
        stores.forEach(function (store) { bounds.extend({ lat: store.lat, lng: store.lng }); });

        google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
          if (map.getZoom() > MAX_FIT_ZOOM) map.setZoom(MAX_FIT_ZOOM);
        });

        if (reducedMotion) {
          map.fitBounds(bounds, 0);
          map.setCenter(bounds.getCenter());
        } else {
          map.fitBounds(bounds);
        }
      },

      panTo: function (lat, lng, options) {
        if (!map) return;

        var opts = options || {};
        var animate = opts.animate !== false && !reducedMotion;
        var target = new google.maps.LatLng(lat, lng);
        var projection = overlay && overlay.getProjection();

        if (opts.offsetY && projection) {
          var point = projection.fromLatLngToContainerPixel(target);
          if (point) {
            point.y -= opts.offsetY;
            target = projection.fromContainerPixelToLatLng(point) || target;
          }
        }

        if (animate) map.panTo(target); else map.setCenter(target);
      },

      setZoom: function (delta) {
        if (!map) return;
        map.setZoom(map.getZoom() + delta);
      },

      // Generic reads, not raw map/bounds objects — callers stay provider-agnostic.
      // Added for desktop's "select a store that's off-screen or still clustered"
      // handling in snippets/store-finder-map.liquid: getZoom() lets a caller
      // compute a relative setZoom() delta toward a known target level without
      // needing an absolute-zoom method of its own; isVisible() answers "is this
      // point on-screen right now" so a caller only pans when it actually needs to.
      getZoom: function () {
        return map ? map.getZoom() : null;
      },

      // Lets a caller save/restore the camera position around an unrequested pan.
      getCenter: function () {
        var centre = map ? map.getCenter() : null;
        return centre ? { lat: centre.lat(), lng: centre.lng() } : null;
      },

      isVisible: function (lat, lng) {
        if (!map) return true;
        var bounds = map.getBounds();
        if (!bounds) return true;
        return bounds.contains(new google.maps.LatLng(lat, lng));
      },

      setGestureMode: function (mode) {
        if (!map) return;
        map.setOptions({ gestureHandling: mode });
      },

      // §4.8.2 extensions: place the callout over its marker, keep it there.
      projectToContainerPixel: function (lat, lng) {
        var projection = overlay && overlay.getProjection();
        if (!projection) return null;
        var point = projection.fromLatLngToContainerPixel(new google.maps.LatLng(lat, lng));
        return point ? { x: point.x, y: point.y } : null;
      },

      on: function (name, fn) {
        if (listeners[name] && typeof fn === 'function') listeners[name].push(fn);
      }
    };

    window.WhittardMapAdapter = adapter;

    function showError(config) {
      var section = config.closest('[data-store-finder]');
      var mapEl = config.closest('[data-store-finder-map]');
      if (!section || !mapEl) return;

      var errorEl = section.querySelector('[data-store-finder-error]');
      var message = mapEl.getAttribute('data-store-finder-map-error-message') || '';
      // Reserved map box left standing: collapsing it is a CLS regression.
      if (errorEl && message) errorEl.textContent = message;
    }

    function bootStoreFinderMapSdk(config) {
      if (config.__storeFinderSdkReady) return;
      config.__storeFinderSdkReady = true;
      configEl = config;

      var mapEl = config.closest('[data-store-finder-map]');
      var section = config.closest('[data-store-finder]');
      if (!mapEl || !section) return;

      var canvas = mapEl.querySelector('[data-store-finder-canvas]');
      if (!canvas) return;

      adapter.init(canvas, {
        key: config.getAttribute('data-map-key') || '',
        clusterLib: config.getAttribute('data-cluster-lib') || ''
      })
        .then(function () {
          section.dispatchEvent(new CustomEvent('store-finder:map-ready', { bubbles: true }));
        })
        .catch(function () {
          showError(config);
        });

      // A&I-4: fullscreen = single-finger. The resize prevents a clipped canvas.
      section.addEventListener('store-finder:fullscreen-changed', function (event) {
        var open = !!(event.detail && event.detail.open);
        adapter.resize();
        adapter.setGestureMode(open ? 'greedy' : 'cooperative');
      });
    }

    window.initStoreFinderMapSdk = window.initStoreFinderMapSdk || function (scope) {
      var root = scope || document;
      Array.prototype.forEach.call(root.querySelectorAll('[data-store-finder-map-sdk]'), bootStoreFinderMapSdk);
    };

    window.initStoreFinderMapSdk();

    // Theme editor replaces the section: tear down, rebuild, re-init search.
    document.addEventListener('shopify:section:load', function (event) {
      var scope = event.target || document;
      if (!scope.querySelector || !scope.querySelector('[data-store-finder]')) return;

      if (window.Shopify && window.Shopify.designMode) adapter.destroy();

      if (typeof window.initStoreFinderSearch === 'function') window.initStoreFinderSearch(scope);
      if (typeof window.initStoreFinderMap === 'function') window.initStoreFinderMap(scope);
      window.initStoreFinderMapSdk(scope);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-finder-map"] && !Shopify.designMode) return;
  try {
    ;(function () {
    // Town/city-level — the same "useful floor" reasoning as MAX_FIT_ZOOM in
    // snippets/store-finder-map-sdk.liquid (that one caps zoom when fitting
    // several stores; this one is the minimum zoom for focusing one), so a
    // selected store is never left inside a cluster badge at this level or
    // deeper.
    var MIN_SELECT_ZOOM = 14;
    var CAMERA_FOLLOW_MS = 800;

    function setupStoreFinderMap(mapEl) {
      if (mapEl.__storeFinderMapReady) return;
      mapEl.__storeFinderMapReady = true;

      var canvas = mapEl.querySelector('[data-store-finder-canvas]');
      var callout = mapEl.querySelector('[data-store-finder-pin-card]');
      if (!canvas || !callout) return;

      var section = mapEl.closest('[data-store-finder]');
      var directionsLabel = mapEl.getAttribute('data-store-finder-map-directions-label') || '';

      var nameEl = callout.querySelector('[data-store-finder-pin-name]');
      var addressEl = callout.querySelector('[data-store-finder-pin-address]');
      var phoneLink = callout.querySelector('[data-store-finder-pin-phone-link]');
      var phoneText = callout.querySelector('[data-store-finder-pin-phone-text]');
      var hoursEl = callout.querySelector('[data-store-finder-pin-hours]');
      var directionsEl = callout.querySelector('[data-store-finder-pin-directions]');
      var closeEl = callout.querySelector('[data-store-finder-pin-close]');

      var stores = [];
      var byHandle = {};
      var sources = mapEl.querySelectorAll('[data-store-finder-pin-data]');
      Array.prototype.forEach.call(sources, function (el) {
        var lat = Number(el.getAttribute('data-store-lat'));
        var lng = Number(el.getAttribute('data-store-lng'));
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

        var store = {
          handle: el.getAttribute('data-store-handle') || '',
          lat: lat,
          lng: lng,
          name: el.getAttribute('data-store-name') || '',
          address: el.getAttribute('data-store-address') || '',
          phone: el.getAttribute('data-store-phone') || '',
          phoneHref: el.getAttribute('data-store-phone-href') || '',
          directions: el.getAttribute('data-store-directions') || '',
          hours: el.querySelector('[data-store-finder-pin-hours-source]')
        };
        stores.push(store);
        byHandle[store.handle] = store;
      });

      var selected = null;
      var restoreCamera = null;
      var followUntil = 0;
      var following = false;

      function emit(name, detail) {
        (section || mapEl).dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
      }

      function hideCallout() {
        callout.setAttribute('aria-hidden', 'true');
        callout.setAttribute('inert', '');
        callout.classList.remove('opacity-100', 'pointer-events-auto');
        callout.classList.add('opacity-0', 'pointer-events-none');
      }

      function showCallout() {
        callout.removeAttribute('aria-hidden');
        callout.removeAttribute('inert');
        callout.classList.remove('opacity-0', 'pointer-events-none');
        callout.classList.add('opacity-100', 'pointer-events-auto');
      }

      function positionCallout(store) {
        var adapter = window.WhittardMapAdapter;
        if (!adapter || typeof adapter.projectToContainerPixel !== 'function') return;

        var point = adapter.projectToContainerPixel(store.lat, store.lng);
        if (!point) return;

        var width = callout.offsetWidth;
        var height = callout.offsetHeight;
        var maxLeft = Math.max(16, mapEl.clientWidth - width - 16);
        var maxTop = Math.max(16, mapEl.clientHeight - height - 16);

        // 40px clears the pin glyph's anchor point (store-finder-pin.svg, anchor (16,32)
        // in a 32x32 box) — measured against Figma's Pin Open frames, where the
        // marker-to-callout gap is ~39px at 1366 and ~87px at 390/744; 40 reproduces the
        // 1366 frame exactly and undershoots less than the previous 24 did everywhere.
        callout.style.left = Math.min(Math.max(16, point.x - width / 2), maxLeft) + 'px';
        callout.style.top = Math.min(Math.max(16, point.y - height - 40), maxTop) + 'px';
      }

      function followCamera() {
        followUntil = Date.now() + CAMERA_FOLLOW_MS;
        if (following) return;
        following = true;
        (function step() {
          // selected is nulled by deselect(), so closing the callout stops the
          // loop on the next frame rather than needing its own teardown.
          if (!selected || !mapEl.isConnected || Date.now() > followUntil) {
            following = false;
            return;
          }
          positionCallout(selected);
          requestAnimationFrame(step);
        })();
      }

      function fillCallout(store) {
        if (nameEl) nameEl.textContent = store.name;
        if (addressEl) addressEl.textContent = store.address;

        if (phoneLink) {
          phoneLink.textContent = store.phone;
          phoneLink.href = store.phoneHref;
          phoneLink.hidden = !store.phone;
        }
        if (phoneText) {
          phoneText.textContent = store.phone;
          phoneText.hidden = !store.phone;
        }

        if (hoursEl) {
          hoursEl.replaceChildren();
          if (store.hours) {
            Array.prototype.forEach.call(store.hours.children, function (row) {
              hoursEl.appendChild(row.cloneNode(true));
            });
          }
        }

        if (directionsEl) {
          directionsEl.textContent = directionsLabel;
          directionsEl.href = store.directions;
        }
      }

      function select(handle, source) {
        var store = byHandle[handle];
        if (!store) return;

        selected = store;
        fillCallout(store);

        var adapter = window.WhittardMapAdapter;
        if (adapter && typeof adapter.selectMarker === 'function') adapter.selectMarker(store.handle);

        var isDesktop = window.matchMedia('(min-width: 1024px)').matches;

        if (restoreCamera === null && adapter && typeof adapter.getCenter === 'function' && typeof adapter.getZoom === 'function') {
          restoreCamera = { center: adapter.getCenter(), zoom: adapter.getZoom() };
        }

        // A&I-8: below md the map always centres the pin so the expanded callout
        // fits — unconditional, regardless of whether the pin was already visible.
        if (adapter && typeof adapter.panTo === 'function' && !isDesktop) {
          adapter.panTo(store.lat, store.lng, { offsetY: callout.offsetHeight / 2 });
        }

        // Not Figma/A&I-documented — a deliberate addition, not a spec
        // requirement. Below md the map sits below the list in page flow
        // (sections/store-finder.liquid renders list-then-map), so a
        // selection whose origin isn't the map itself would otherwise open
        // a callout the visitor can't see, with no feedback anything
        // happened: a card click (source 'card') or a search's auto-selected
        // nearest result (source 'search', TASK-53198 Q5 — a raw marker
        // click carries no source and is excluded here on purpose, since the
        // visitor is already looking at the map in that case).
        if (!isDesktop && (source === 'card' || source === 'search')) {
          var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          mapEl.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        }

        // Desktop has no equivalent of A&I-8 in Figma — the list and map columns
        // sit side by side there, so nothing needs to move purely to make room
        // for a callout. But nothing moved the map at all before this, so a card
        // click for a pin that's off-screen or still grouped into a cluster badge
        // at the current zoom produced no visible change. Only act when the pin
        // genuinely isn't usable where it is: pan to it when it's off-screen,
        // and/or zoom in to MIN_SELECT_ZOOM when the current zoom would still
        // show it clustered rather than as its own marker.
        //
        // source === 'card' || 'search': a raw pin click carries no source and
        // is excluded — the pin is already visible and already its own marker
        // (a clustered pin has no individual marker to click), so this would
        // be a no-op there anyway. TASK-53198 Q4 added 'search': a search's
        // auto-selected nearest result can genuinely be off-screen or
        // clustered, and restoreCamera above (Q4/Q8) already puts the camera
        // back on close, so zooming in here is no longer a one-way move.
        if (adapter && isDesktop && (source === 'card' || source === 'search')) {
          var isVisible = typeof adapter.isVisible === 'function' ? adapter.isVisible(store.lat, store.lng) : true;
          var currentZoom = typeof adapter.getZoom === 'function' ? adapter.getZoom() : null;
          var needsZoom = currentZoom !== null && currentZoom < MIN_SELECT_ZOOM;

          if (!isVisible || needsZoom) {
            if (needsZoom && typeof adapter.setZoom === 'function') {
              adapter.setZoom(MIN_SELECT_ZOOM - currentZoom);
            }
            if (typeof adapter.panTo === 'function') adapter.panTo(store.lat, store.lng);
          }
        }

        showCallout();
        positionCallout(store);
        followCamera();
      }

      function deselect() {
        selected = null;
        hideCallout();
        var adapter = window.WhittardMapAdapter;
        if (adapter && typeof adapter.clearSelection === 'function') adapter.clearSelection();

        if (restoreCamera && adapter) {
          if (restoreCamera.center && typeof adapter.panTo === 'function') {
            adapter.panTo(restoreCamera.center.lat, restoreCamera.center.lng);
          }
          if (restoreCamera.zoom !== null && typeof adapter.setZoom === 'function' && typeof adapter.getZoom === 'function') {
            var currentZoom = adapter.getZoom();
            if (currentZoom !== null) adapter.setZoom(restoreCamera.zoom - currentZoom);
          }
        }
        restoreCamera = null;
      }

      if (closeEl) {
        closeEl.addEventListener('click', function () { emit('store-finder:store-deselected'); });
      }

      // Selection is event-driven so a card click and a pin click are one path.
      (section || mapEl).addEventListener('store-finder:store-selected', function (event) {
        var handle = event.detail && event.detail.handle;
        var source = event.detail && event.detail.source;
        if (handle) select(handle, source);
      });

      (section || mapEl).addEventListener('store-finder:store-deselected', function () { deselect(); });

      (section || mapEl).addEventListener('store-finder:origin-changed', function () {
        var adapter = window.WhittardMapAdapter;
        if (adapter && typeof adapter.fitBounds === 'function') adapter.fitBounds(stores);
      });

      // Theme-editor section reloads replace mapEl with a fresh node and call
      // setupStoreFinderMap again, but never remove these document-level
      // listeners from the outgoing instance — isConnected turns the stale
      // instance's copy into a no-op instead of a redundant duplicate pass
      // acting on detached DOM/stale closures.
      document.addEventListener('store-finder:map-ready', function () {
        if (!mapEl.isConnected) return;

        var adapter = window.WhittardMapAdapter;
        if (!adapter) return;

        if (typeof adapter.setMarkers === 'function') adapter.setMarkers(stores);
        if (typeof adapter.setClusteringEnabled === 'function') adapter.setClusteringEnabled(true);
        if (typeof adapter.fitBounds === 'function') adapter.fitBounds(stores);

        if (typeof adapter.on === 'function') {
          adapter.on('marker-click', function (handle) { emit('store-finder:store-selected', { handle: handle }); });
          adapter.on('background-click', function () { emit('store-finder:store-deselected'); });
          adapter.on('camera-idle', function () { if (selected) positionCallout(selected); });
        }
      });

      // The column is re-parented on fullscreen toggle, so the callout's
      // pixel placement has to be recomputed against the new box.
      document.addEventListener('store-finder:fullscreen-changed', function () {
        if (!mapEl.isConnected) return;
        if (selected) window.setTimeout(function () { positionCallout(selected); }, 0);
      });
    }

    window.initStoreFinderMap = window.initStoreFinderMap || function (scope) {
      var root = scope || document;
      Array.prototype.forEach.call(root.querySelectorAll('[data-store-finder-map]'), setupStoreFinderMap);
    };

    window.initStoreFinderMap();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-finder-search-requests"] && !Shopify.designMode) return;
  try {
    ;(function () {
    var REQUEST_TIMEOUT_MS = 8000;

    /*
     * window.WhittardStoreSearch (store-search-loqate.liquid) is a genuine
     * page-wide singleton, shared with the PDP drawer. This is not that: the
     * request-cancellation state below (`current`) must be private PER
     * control instance, so this factory returns a fresh controller on every
     * call rather than attaching methods to that shared object.
     *
     * `context` supplies everything this layer touches on the caller's DOM:
     * root, input, dropdown, geolocate, messages, announce, fail,
     * renderSuggestions, show, hide, emitOrigin, commitSelection — all
     * defined in setupStoreFinderSearch (store-finder-search.liquid).
     *
     * Called lazily, from inside that file's event handlers rather than at
     * its own setup time — same reason store-search-loqate.liquid's helpers
     * are read from window inside handlers only, stated there: snippet
     * script blocks are bundled in an order that is not guaranteed, so a
     * synchronous setup-time call could run before this file's own script
     * has executed. By the time a real user interaction can fire a handler,
     * the whole bundle has already finished loading, so the lazy read here
     * always succeeds.
     */
    window.createStoreFinderSearchRequests = window.createStoreFinderSearchRequests || function (context) {
      var current = null;

      function abortInFlight() {
        if (!current) return;
        clearTimeout(current.timer);
        current.controller.abort();
        current = null;
      }

      function startRequest() {
        abortInFlight();
        var state = { controller: new AbortController(), timer: null, timedOut: false };
        state.timer = setTimeout(function () {
          state.timedOut = true;
          state.controller.abort();
        }, REQUEST_TIMEOUT_MS);
        current = state;
        return state;
      }

      function settle(state) {
        clearTimeout(state.timer);
        if (current === state) current = null;
      }

      async function search(query) {
        var helpers = window.WhittardStoreSearch;
        if (!helpers) return;

        var state = startRequest();
        var key = context.root.getAttribute('data-loqate-key');
        var country = context.root.getAttribute('data-search-country') || 'GBR';
        context.announce(context.messages.searching);
        context.fail('');

        try {
          var rawItems = await helpers.loqateFindPlaceNames({
            key: key,
            query: query,
            matchType: context.root.getAttribute('data-search-match-type') || 'Similar',
            country: country,
            signal: state.controller.signal,
            fallbackError: context.messages.error
          });
          // Drops POI rows and the fuzzy near-misses Loqate returns for nonsense
          // input — see relevantPlaceMatches in store-search-loqate.liquid.
          var items = helpers.relevantPlaceMatches(query, rawItems);

          // Tier 2. FindPlaceNames' postcode index misses ~12-15% of real UK
          // postcodes and never matches an outward code on its own, so a valid
          // postcode fell through to "no results" with nothing to click. The
          // geocode fallback answers with one already-resolved match, offered as a
          // single row so selection stays the same interaction either way. Gated on
          // postcode shape because this runs per debounced keystroke — a half-typed
          // postcode is not worth a second lookup.
          if (!items.length &&
              typeof helpers.loqateGeocode === 'function' &&
              helpers.isUkPostcodeQuery(query)) {
            var geocoded = await helpers.loqateGeocode({
              key: key,
              query: query,
              country: country,
              signal: state.controller.signal,
              fallbackError: context.messages.error
            });
            if (geocoded) {
              items = [{
                label: helpers.formattedPlaceLabel(geocoded.name) || query,
                latitude: geocoded.latitude,
                longitude: geocoded.longitude
              }];
            }
          }

          context.renderSuggestions(items);
          context.show();
          context.announce(items.length ? '' : context.messages.noResults);
        } catch (err) {
          if (err && err.name === 'AbortError' && !state.timedOut) return;
          context.announce('');
          context.fail(context.messages.error);
        } finally {
          settle(state);
        }
      }

      async function selectSuggestion(trigger) {
        var helpers = window.WhittardStoreSearch;
        if (!helpers) return;

        // Geocode-fallback rows arrive with coordinates already attached, so
        // selecting one needs no second request and cannot go stale. Presence is
        // tested with hasAttribute, not Number(): a missing attribute reads back as
        // null, and Number(null) is 0, which Number.isFinite would accept — sending
        // every ordinary row to the equator.
        var hasPreset = trigger.hasAttribute('data-latitude') && trigger.hasAttribute('data-longitude');
        var presetLat = Number(trigger.getAttribute('data-latitude'));
        var presetLng = Number(trigger.getAttribute('data-longitude'));
        if (hasPreset && Number.isFinite(presetLat) && Number.isFinite(presetLng)) {
          context.fail('');
          context.commitSelection(trigger, presetLat, presetLng);
          return;
        }

        var loqateId = trigger.getAttribute('data-loqate-id');
        if (!loqateId) return;

        var state = startRequest();
        // Focus moves to input BEFORE disabling trigger, not after: disabling
        // the currently-focused element auto-blurs it to <body>, which the
        // root's focusout listener (store-finder-search.liquid) reads as focus
        // leaving the component and dismisses the panel mid-request.
        context.input.focus();
        trigger.disabled = true;
        context.announce(context.messages.searching);
        context.fail('');

        try {
          var place = await helpers.loqateRetrieveCoordinates({
            key: context.root.getAttribute('data-loqate-key'),
            id: loqateId,
            signal: state.controller.signal,
            fallbackError: context.messages.error
          });
          /* Stale-response guard: a newer query may have replaced the panel while
             this was in flight. Loqate ids carry "|" and other CSS-significant
             characters, so the selector must be escaped before use. */
          if (!context.dropdown.querySelector('[data-loqate-id="' + CSS.escape(loqateId) + '"]')) return;
          if (!place) {
            context.announce(context.messages.noResults);
            return;
          }
          context.commitSelection(trigger, place.latitude, place.longitude);
        } catch (err) {
          if (err && err.name === 'AbortError' && !state.timedOut) return;
          context.announce('');
          context.fail(context.messages.error);
        } finally {
          settle(state);
          trigger.disabled = false;
        }
      }

      function useCurrentLocation() {
        context.fail('');
        if (!('geolocation' in navigator)) {
          context.fail(context.messages.unavailable);
          return;
        }
        // Same reason as selectSuggestion(): focus input before disabling the
        // just-clicked geolocate button, so it doesn't auto-blur to <body> and
        // trip the root's focusout dismissal mid-request.
        context.input.focus();
        context.geolocate.disabled = true;
        context.announce(context.messages.searching);
        navigator.geolocation.getCurrentPosition(function (position) {
          context.geolocate.disabled = false;
          context.announce('');
          context.hide();
          context.emitOrigin(position.coords.latitude, position.coords.longitude);
        }, function () {
          context.geolocate.disabled = false;
          context.announce('');
          context.fail(context.messages.denied);
        }, { timeout: REQUEST_TIMEOUT_MS });
      }

      return {
        search: search,
        selectSuggestion: selectSuggestion,
        useCurrentLocation: useCurrentLocation,
        abortInFlight: abortInFlight
      };
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-finder-search"] && !Shopify.designMode) return;
  try {
    /*
   * Store Finder search control.
   *
   * Instances are enumerated with the same (scope || document).querySelectorAll
   * pattern snippets/input.liquid uses, so every sub-query below is scoped to the
   * snippet's own [data-store-finder-search] wrapper. The one sanctioned
   * document-level lookup in this feature belongs to the fullscreen surface in
   * sections/stores.liquid, which is a body child; nothing here copies it.
   *
   * The Loqate request layer (search/selectSuggestion/useCurrentLocation) lives
   * in snippets/store-finder-search-requests.liquid — created lazily via
   * window.createStoreFinderSearchRequests, read from window inside handlers
   * only, for the same bundle-ordering reason store-search-loqate.liquid's own
   * helpers are read that way.
   */
  ;(function () {
    var SEARCH_DEBOUNCE_MS = 300;
    var OPTION_ID_PREFIX = 'StoreFinderSuggestion-';
    var SUGGESTION_CELL_CLASS = 'flex w-full items-center gap-8 border-b border-border-secondary bg-surface-primary px-20 py-16 text-b2 text-primary text-left whitespace-nowrap opacity-75 cursor-pointer transition-colours motion-reduce:transition-none hover:bg-surface-tertiary focus-visible:outline-2 focus-visible:outline-primary focus-visible:-outline-offset-2';

    function setupStoreFinderSearch(root) {
      if (root.__storeFinderSearchReady) return;

      var input = root.querySelector('[data-store-finder-input]');
      var dropdown = root.querySelector('[data-store-finder-dropdown]');
      var clearControl = root.querySelector('[data-store-finder-clear]');
      var geolocate = root.querySelector('[data-store-finder-geolocate]');
      if (!input || !dropdown || !clearControl || !geolocate) return;

      root.__storeFinderSearchReady = true;
      var desktopQuery = window.matchMedia('(min-width: 1024px)');

      var section = root.closest('[data-store-finder]');
      // At md+ the store list column is its OWN scroll container
      // (h-store-finder-column + md:overflow-y-scroll), so the body-level lock
      // below does not reach it — the column kept scrolling behind the open
      // panel on desktop while mobile locked correctly, which is exactly the
      // split QA reported. Locked alongside the body lock, not instead of it.
      var listColumn = root.closest('[data-store-finder-list]');
      var statusEl = section ? section.querySelector('[data-store-finder-status]') : null;
      var errorEl = section ? section.querySelector('[data-store-finder-error]') : null;
      var locationCell = geolocate.closest('[role="option"]');

      var messages = {
        searching: root.getAttribute('data-message-searching') || '',
        noResults: root.getAttribute('data-message-no-results') || '',
        error: root.getAttribute('data-message-error') || '',
        denied: root.getAttribute('data-message-location-denied') || '',
        unavailable: root.getAttribute('data-message-location-unavailable') || ''
      };

      var debounceTimer = null;
      var activeIndex = -1;
      var isDropdownOpen = false;
      var requests = null;

      function announce(text) { if (statusEl) statusEl.textContent = text || ''; }
      function fail(text) { if (errorEl) errorEl.textContent = text || ''; }
      function options() { return dropdown.querySelectorAll('[role="option"]'); }

      var NOOP_REQUESTS = {
        search: function () {},
        selectSuggestion: function () {},
        useCurrentLocation: function () {},
        abortInFlight: function () {}
      };

      function getRequests() {
        if (!requests) {
          requests = window.createStoreFinderSearchRequests
            ? window.createStoreFinderSearchRequests({
                root: root,
                input: input,
                dropdown: dropdown,
                geolocate: geolocate,
                messages: messages,
                announce: announce,
                fail: fail,
                renderSuggestions: renderSuggestions,
                show: show,
                hide: hide,
                emitOrigin: emitOrigin,
                commitSelection: commitSelection
              })
            : NOOP_REQUESTS;
        }
        return requests;
      }

      function setActive(index) {
        var cells = options();
        activeIndex = index;
        for (var i = 0; i < cells.length; i++) {
          var isActive = i === index;
          cells[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) input.setAttribute('aria-activedescendant', cells[i].id);
        }
        if (index < 0) {
          input.removeAttribute('aria-activedescendant');
          return;
        }

        var cell = cells[index];
        var top = cell.offsetTop;
        var bottom = top + cell.offsetHeight;
        if (top < dropdown.scrollTop) dropdown.scrollTop = top;
        else if (bottom > dropdown.scrollTop + dropdown.clientHeight) dropdown.scrollTop = bottom - dropdown.clientHeight;
      }

      function lockColumn() {
        if (!listColumn || !desktopQuery.matches) return;
        listColumn.style.scrollbarGutter = 'stable';
        listColumn.style.overflowY = 'hidden';
      }

      function unlockColumn() {
        if (!listColumn) return;
        listColumn.style.overflowY = '';
        listColumn.style.scrollbarGutter = '';
      }

      // Measured, not guessed: no Figma value bounds this panel's height.
      // Below md the column has no fixed height (see desktopQuery comment
      // above), so its bottom edge is not the visible boundary there — the
      // viewport is. listColumn's mere presence is not the right test.
      function applyDropdownMaxHeight() {
        var boundaryBottom = (desktopQuery.matches && listColumn) ? listColumn.getBoundingClientRect().bottom : window.innerHeight;
        var available = boundaryBottom - dropdown.getBoundingClientRect().top - 16;
        dropdown.style.maxHeight = Math.max(available, 0) + 'px';
      }

      function show() {
        applyDropdownMaxHeight();
        dropdown.removeAttribute('aria-hidden');
        dropdown.removeAttribute('inert');
        dropdown.classList.remove('opacity-0', 'pointer-events-none');
        dropdown.classList.add('opacity-100', 'pointer-events-auto');
        input.setAttribute('aria-expanded', 'true');
        if (!isDropdownOpen) {
          isDropdownOpen = true;
          if (window.WhittardScrollLock) window.WhittardScrollLock.lock();
          lockColumn();
        }
      }

      function hide() {
        dropdown.setAttribute('aria-hidden', 'true');
        dropdown.setAttribute('inert', '');
        dropdown.classList.remove('opacity-100', 'pointer-events-auto');
        dropdown.classList.add('opacity-0', 'pointer-events-none');
        dropdown.style.maxHeight = '';
        input.setAttribute('aria-expanded', 'false');
        setActive(-1);
        if (isDropdownOpen) {
          isDropdownOpen = false;
          if (window.WhittardScrollLock) window.WhittardScrollLock.unlock();
          unlockColumn();
        }
      }

      function renderSuggestions(items) {
        var existing = dropdown.querySelectorAll('[data-store-finder-suggestion]');
        for (var i = 0; i < existing.length; i++) {
          var stale = existing[i].closest('[role="option"]');
          if (stale) stale.remove();
        }
        for (var j = 0; j < items.length; j++) {
          var item = items[j];
          if (!item || !item.label) continue;
          var cell = document.createElement('li');
          cell.className = 'w-full';
          cell.id = OPTION_ID_PREFIX + j;
          cell.setAttribute('role', 'option');
          cell.setAttribute('aria-selected', 'false');
          var trigger = document.createElement('button');
          trigger.type = 'button';
          trigger.className = SUGGESTION_CELL_CLASS;
          trigger.setAttribute('data-store-finder-suggestion', '');
          // A row carries EITHER a Loqate id, needing a RetrieveCoordinates hop on
          // selection, OR coordinates already resolved by the geocode fallback.
          // selectSuggestion() branches on which of the two is present.
          if (item.id) trigger.setAttribute('data-loqate-id', item.id);
          if (item.latitude != null && item.longitude != null) {
            trigger.setAttribute('data-latitude', item.latitude);
            trigger.setAttribute('data-longitude', item.longitude);
          }
          trigger.textContent = item.label;
          cell.appendChild(trigger);
          dropdown.insertBefore(cell, locationCell);
        }
        setActive(-1);
      }

      function emitOrigin(latitude, longitude) {
        (section || root).dispatchEvent(new CustomEvent('store-finder:origin-changed', {
          bubbles: true,
          detail: { latitude: latitude, longitude: longitude }
        }));
      }

      function commitSelection(trigger, latitude, longitude) {
        input.value = trigger.textContent;
        clearControl.hidden = false;
        hide();
        announce('');
        emitOrigin(latitude, longitude);
      }

      function reset() {
        getRequests().abortInFlight();
        clearTimeout(debounceTimer);
        input.value = '';
        clearControl.hidden = true;
        renderSuggestions([]);
        hide();
        announce('');
        fail('');
        emitOrigin(null, null);
        input.focus();
      }

      input.addEventListener('input', function () {
        var query = input.value.trim();
        clearControl.hidden = query.length === 0;
        clearTimeout(debounceTimer);

        if (!query) {
          getRequests().abortInFlight();
          renderSuggestions([]);
          hide();
          announce('');
          fail('');
          return;
        }

        debounceTimer = setTimeout(function () { getRequests().search(query); }, SEARCH_DEBOUNCE_MS);
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          hide();
          input.focus();
          return;
        }

        var cells = options();
        if (!cells.length) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          show();
          setActive((activeIndex + 1) % cells.length);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          show();
          setActive(activeIndex <= 0 ? cells.length - 1 : activeIndex - 1);
        } else if (event.key === 'Enter' && activeIndex >= 0) {
          event.preventDefault();
          var active = cells[activeIndex].querySelector('button');
          if (active) active.click();
        }
      });

      dropdown.addEventListener('click', function (event) {
        var suggestion = event.target.closest('[data-store-finder-suggestion]');
        if (suggestion) {
          getRequests().selectSuggestion(suggestion);
          return;
        }
        if (event.target.closest('[data-store-finder-geolocate]')) getRequests().useCurrentLocation();
      });

      clearControl.addEventListener('click', reset);

      // Dismiss on outside click or focus leaving the component entirely.
      document.addEventListener('click', function (event) {
        if (!root.isConnected) return;
        if (isDropdownOpen && !root.contains(event.target)) hide();
      });

      root.addEventListener('focusout', function (event) {
        if (isDropdownOpen && event.relatedTarget && !root.contains(event.relatedTarget)) hide();
      });

      // A viewport change while the panel is open (orientation change, or an
      // on-screen keyboard appearing/dismissing — likely, since the panel
      // opens because the user is typing) leaves the cap stale otherwise.
      window.addEventListener('resize', function () {
        if (!root.isConnected) return;
        if (isDropdownOpen) applyDropdownMaxHeight();
      }, { passive: true });
    }

    window.initStoreFinderSearch = window.initStoreFinderSearch || function (scope) {
      (scope || document).querySelectorAll('[data-store-finder-search]').forEach(setupStoreFinderSearch);
    };

    window.initStoreFinderSearch();
    document.addEventListener('store-finder:helpers-ready', function () { window.initStoreFinderSearch(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-search-loqate"] && !Shopify.designMode) return;
  try {
    ;(function () {
    function toRadians(value) {
      return value * (Math.PI / 180);
    }

    function distanceBetween(origin, destination) {
      if (!origin || !destination) return Infinity;
      if (origin.latitude == null || origin.longitude == null) return Infinity;
      if (destination.latitude == null || destination.longitude == null) return Infinity;

      var earthRadiusKm = 6371;
      var deltaLat = toRadians(destination.latitude - origin.latitude);
      var deltaLon = toRadians(destination.longitude - origin.longitude);
      var startLat = toRadians(origin.latitude);
      var endLat = toRadians(destination.latitude);
      var haversine = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
        Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2) * Math.cos(startLat) * Math.cos(endLat);
      var arc = 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));

      return earthRadiusKm * arc;
    }

    function parsedLoqateItems(payload) {
      if (!payload) return [];
      if (Array.isArray(payload.Items)) return payload.Items;
      if (Array.isArray(payload)) return payload;
      return [];
    }

    async function loqateFindPlaceNames(options) {
      var settings = options || {};
      var fallbackError = settings.fallbackError || 'Unable to search';

      var searchUrl = new URL('https://api.addressy.com/StoreFinder/Interactive/FindPlaceNames/v1.10/json6.ws');
      searchUrl.search = new URLSearchParams({
        Key: settings.key,
        SearchTerm: settings.query,
        MatchType: settings.matchType || 'Similar',
        Country: settings.country || 'GBR'
      }).toString();

      var searchResponse = await fetch(searchUrl.toString(), { signal: settings.signal });
      if (!searchResponse.ok) throw new Error(fallbackError);

      var searchPayload = await searchResponse.json();
      var searchItems = parsedLoqateItems(searchPayload);
      if (!searchItems.length) return [];
      if (searchItems[0].Error) {
        throw new Error(searchItems[0].Description || fallbackError);
      }

      return searchItems;
    }

    async function loqateRetrieveCoordinates(options) {
      var settings = options || {};
      var fallbackError = settings.fallbackError || 'Unable to search';

      var retrieveUrl = new URL('https://api.addressy.com/StoreFinder/Interactive/RetrieveCoordinates/v1.10/json6.ws');
      retrieveUrl.search = new URLSearchParams({
        Key: settings.key,
        Id: settings.id
      }).toString();

      var retrieveResponse = await fetch(retrieveUrl.toString(), { signal: settings.signal });
      if (!retrieveResponse.ok) throw new Error(fallbackError);

      var retrievePayload = await retrieveResponse.json();
      var retrieveItems = parsedLoqateItems(retrievePayload);
      if (!retrieveItems.length) return null;
      if (retrieveItems[0].Error) {
        throw new Error(retrieveItems[0].Description || fallbackError);
      }

      var location = retrieveItems[0];
      var latitude = Number(location.Latitude);
      var longitude = Number(location.Longitude);

      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

      return {
        latitude: latitude,
        longitude: longitude
      };
    }

    /*
     * Coverage fallback for loqateFindPlaceNames.
     *
     * The StoreFinder place-name index is incomplete for UK postcodes: measured
     * against 120 real ONS postcodes it returns zero items for ~12-15% of them
     * (SE1 9SH, NE31 2BH, CH62 4SX, CT14 7UZ, NR7 7UH and others), and it never
     * matches an outward code on its own ("LS29", "NR7"). Callers then showed a
     * bare "no results" for a perfectly valid postcode.
     *
     * This endpoint resolves all of those, plus Jersey/Guernsey/Isle of Man,
     * within ~130m of the ONS centroid, and returns the coordinates in the same
     * request — so there is no RetrieveCoordinates second hop. It answers with a
     * single best match rather than a list, which is why it is a fallback tier
     * and not a replacement for the place-name search.
     */
    async function loqateGeocode(options) {
      var settings = options || {};
      var fallbackError = settings.fallbackError || 'Unable to search';

      var geocodeUrl = new URL('https://api.addressy.com/Geocoding/International/Geocode/v1.10/json3.ws');
      geocodeUrl.search = new URLSearchParams({
        Key: settings.key,
        Location: settings.query,
        Country: settings.country || 'GBR'
      }).toString();

      var geocodeResponse = await fetch(geocodeUrl.toString(), { signal: settings.signal });
      if (!geocodeResponse.ok) throw new Error(fallbackError);

      var geocodePayload = await geocodeResponse.json();
      var geocodeItems = parsedLoqateItems(geocodePayload);
      if (!geocodeItems.length) return null;
      if (geocodeItems[0].Error) {
        throw new Error(geocodeItems[0].Description || fallbackError);
      }

      var match = geocodeItems[0];
      var latitude = Number(match.Latitude);
      var longitude = Number(match.Longitude);

      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

      // Filtered here rather than in each caller: this endpoint fuzzy-matches, and
      // a wrong location is worse than none — it would silently rank the store
      // list around somewhere the visitor never asked about.
      if (!isRelevantGeocodeMatch(settings.query, match.Name)) return null;

      return {
        latitude: latitude,
        longitude: longitude,
        name: match.Name || ''
      };
    }

    /*
     * True for anything shaped like a UK postcode, complete ("LS29 8DG") or
     * outward code only ("LS29"). Callers gate the loqateGeocode fallback on this
     * so it costs one extra lookup per plausible postcode rather than one per
     * keystroke: postcodes are the whole diagnosed gap in the place-name index,
     * which handles town and city names well on its own.
     */
    function isUkPostcodeQuery(query) {
      if (typeof query !== 'string') return false;
      return /^[A-Z]{1,2}\d[A-Z\d]?\s*(\d[A-Z]{2})?$/i.test(query.trim());
    }

    /*
     * Loqate returns postcode labels with the space stripped ("LS298DG"), which
     * is what both consumers rendered into the suggestion row and the input.
     * Re-inserts the separator before the three-character inward code for
     * anything shaped like a UK postcode, and leaves every other label
     * (town, city, street) untouched.
     */
    function formattedPlaceLabel(label) {
      if (typeof label !== 'string') return '';
      var trimmed = label.trim();
      if (/^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/i.test(trimmed)) {
        return trimmed.slice(0, trimmed.length - 3).toUpperCase() + ' ' + trimmed.slice(-3).toUpperCase();
      }
      return trimmed;
    }

    /*
     * The outward code — the part before the space ("LS29" of "LS29 8DG").
     */
    function outwardCode(value) {
      var match = /^\s*([A-Z]{1,2}\d[A-Z\d]?)/.exec((value || '').toUpperCase());
      return match ? match[1] : '';
    }

    /*
     * Relevance guard for a loqateGeocode result.
     *
     * The geocoder fuzzy-matches too, and for a postcode-shaped string that is not
     * a real postcode it falls back to matching the inward code alone: "ZZ1 1ZZ"
     * answers "1 Cedric Close, Blackfield, Southampton, SO45 1ZZ", "QQ9 9QQ"
     * answers a real SN11 address. In every observed case it names the real
     * postcode it actually matched inside the label, so a returned label carrying
     * an outward code that disagrees with the one asked for is a false match.
     *
     * A genuine result either names no postcode at all ("Bruce Drive, Hebburn") or
     * names the one asked for ("London, WC1A"). Checked against 60 real postcodes
     * forced down this path: zero false rejections, and every fake rejected.
     */
    function isRelevantGeocodeMatch(query, label) {
      var asked = outwardCode(query);
      if (!asked) return false;

      // Only COMPLETE postcodes count as evidence. A bare outward-code-shaped
      // token is not reliable enough to reject on: road names carry them ("A1
      // Great North Road"), and treating those as a contradicting postcode would
      // throw away a perfectly good result.
      var pattern = /\b([A-Z]{1,2}\d[A-Z\d]?)\s*\d[A-Z]{2}\b/g;
      var text = (label || '').toUpperCase();
      var evidence = false;
      var match;

      while ((match = pattern.exec(text)) !== null) {
        if (match[1] === asked) return true;
        evidence = true;
      }

      return !evidence;
    }

    /*
     * Lowercased, alphanumerics only. Collapses the punctuation and spacing
     * differences between what a visitor types and what Loqate returns, so
     * "st peter port" matches "St. Peter Port" and "LS29 8DG" matches the
     * space-stripped "LS298DG" the API answers with.
     */
    function normalisedForMatching(value) {
      if (typeof value !== 'string') return '';
      return value.toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    /*
     * Loqate fuzzy-matches on leading characters and will answer confidently to
     * nonsense: "adfdsfsgfsgdsfgdsgsd" returns "Adforton, Shropshire" and "asdf"
     * returns "Ayside, Cumbria" and "Ascot", 35 rows deep. MatchType makes no
     * difference — Exact and Similar return byte-identical responses, so that
     * request parameter cannot be used to tighten this.
     *
     * Keeping only rows whose own label actually contains what was typed drops
     * that noise while leaving progressive typing intact ("birm" is still inside
     * "Birmingham, West Midlands") and still allowing a mid-label match
     * ("heathrow" inside "London Heathrow Airport").
     */
    function isRelevantPlaceMatch(query, label) {
      var normalisedQuery = normalisedForMatching(query);
      if (!normalisedQuery) return false;
      return normalisedForMatching(label).indexOf(normalisedQuery) !== -1;
    }

    /*
     * The shared tier-1 result shape: irrelevant fuzzy matches dropped, labels
     * formatted, and the API's field naming resolved in one place rather than twice.
     *
     * FindPlaceNames mixes localities (Id prefix "LK" — towns, cities, postcodes)
     * with points of interest (prefix "PI" — stations, airports, landmarks).
     * Postcode rows carry a country-prefixed id ("GBR|PC|883271"), so the POI test
     * reads the first two characters and must not be tightened to a whole-id match.
     *
     * options.includePointsOfInterest is per-surface, and deliberately so:
     *
     *   - The Store Finder page omits them. Searching "Birmingham" returns 3
     *     localities and 20+ unrelated POI rows, which is noise in a suggestion
     *     list someone is meant to read and pick from.
     *   - The PDP drawer keeps them. It takes one best match purely as a geocoding
     *     origin, never showing this list, and a POI is a perfectly good origin.
     *     Several queries have NO locality row at all — "Meadowhall" and "Gatwick"
     *     each return a single POI and nothing else — so excluding them there would
     *     break station, airport and shopping-centre searches outright.
     */
    function relevantPlaceMatches(query, items, options) {
      var settings = options || {};

      return (items || []).filter(function (item) {
        if (!item || !item.Id) return false;
        if (settings.includePointsOfInterest) return true;
        return item.Id.slice(0, 2) !== 'PI';
      }).map(function (item) {
        return {
          id: item.Id,
          // FindPlaceNames returns { Id, Place } per item, not { Id, Text,
          // Description } — that shape belongs to Loqate's general address Capture
          // API, not this place-name endpoint. Text/Description are kept as a
          // fallback so a future field-name change degrades to the older shape
          // instead of rendering blank.
          label: formattedPlaceLabel(item.Place || item.Text || item.Description || '')
        };
      }).filter(function (item) {
        return item.label && isRelevantPlaceMatch(query, item.label);
      });
    }

    window.WhittardStoreSearch = {
      distanceBetween: distanceBetween,
      parsedLoqateItems: parsedLoqateItems,
      loqateFindPlaceNames: loqateFindPlaceNames,
      loqateRetrieveCoordinates: loqateRetrieveCoordinates,
      loqateGeocode: loqateGeocode,
      isUkPostcodeQuery: isUkPostcodeQuery,
      formattedPlaceLabel: formattedPlaceLabel,
      isRelevantPlaceMatch: isRelevantPlaceMatch,
      isRelevantGeocodeMatch: isRelevantGeocodeMatch,
      relevantPlaceMatches: relevantPlaceMatches
    };

    document.dispatchEvent(new CustomEvent('store-finder:helpers-ready'));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tagalys-rating-hydration"] && !Shopify.designMode) return;
  try {
    ;(function () {
    'use strict';

    // productId -> true, once queued. Only tested via hasOwnProperty, to guard
    // enqueue() against re-queuing a product already resolving/resolved this
    // session. Kept separate from RATING_CACHE, which is only written once a
    // fetch settles — a product mid-flight is in this one and not that one.
    var QUEUED = {};
    // productId -> { score, total } (has a rating) | null (resolved, no
    // rating) — absent entirely while a fetch is still in flight.
    var RATING_CACHE = window.__yotpoCardRatingCache = window.__yotpoCardRatingCache || {};
    var observed = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
    var pendingIds = [];
    var scheduled = false;
    var rebuildScheduled = false;

    function fmt(str, map) {
      if (!str) return '';
      return str.replace(/__([A-Z]+)__/g, function (m, key) {
        var k = key.toLowerCase();
        return map && map[k] != null ? map[k] : m;
      });
    }

    function applyToCard(card, rating, labelTemplate) {
      var root = card.querySelector('[data-product-rating]');
      if (!root) return;
      var valueEl = root.querySelector('[data-rating-value]');
      if (!rating || !rating.total) return; // stays hidden — no rating to show
      var score = rating.score.toFixed(1);
      var label = fmt(labelTemplate, { rating: score });
      // Write only what differs. Every write here is a DOM mutation even when
      // the value is unchanged (textContent always replaces the text node), and
      // the textContent write re-fires observeRebuilds()' childList observer.
      // Unguarded, reapply() and that observer retriggered each other on every
      // animation frame for as long as the page stayed open.
      if (valueEl && valueEl.textContent !== score) valueEl.textContent = score;
      if (root.getAttribute('aria-label') !== label) root.setAttribute('aria-label', label);
      // classList.toggle, not a bare remove: 'hidden' and 'flex' both set
      // display and must never both be present as static+added classes at
      // once (the reverse of collection-tagalys-api.liquid's own
      // hidden/flex toggle pairs).
      if (root.classList.contains('hidden')) root.classList.remove('hidden');
      if (!root.classList.contains('flex')) root.classList.add('flex');
    }

    // Reveals a resolved rating on every card CURRENTLY matching this product
    // id in the whole document, by id rather than a captured element
    // reference — a Tagalys grid rebuild (Load more, a filter change) can
    // replace a card's DOM while its fetch is still in flight; sweeping by id
    // when the fetch resolves (and again on every rebuild, via reapply()
    // below) means the replacement card still gets revealed instead of only
    // updating a now-detached, invisible node.
    function applyToId(id, rating, labelTemplate) {
      var selector = '[data-product-card][data-product-id="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]';
      document.querySelectorAll(selector).forEach(function (card) {
        applyToCard(card, rating, labelTemplate);
      });
    }

    // Re-apply anything already resolved to any card lacking it. Idempotent
    // because applyToCard() writes nothing to a card already showing its
    // rating, so it safely survives Tagalys grid rebuilds without re-fetching.
    function reapply(container, labelTemplate) {
      var cards = container.querySelectorAll('[data-product-card]');
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var id = card.getAttribute('data-product-id');
        if (!id) continue;
        var cached = RATING_CACHE[id];
        if (cached) applyToCard(card, cached, labelTemplate);
      }
    }

    function scheduleReapply(container, labelTemplate) {
      if (rebuildScheduled) return;
      rebuildScheduled = true;
      var run = function () { rebuildScheduled = false; reapply(container, labelTemplate); };
      if (window.requestAnimationFrame) window.requestAnimationFrame(run); else setTimeout(run, 16);
    }

    function observeRebuilds(container, labelTemplate) {
      if (!window.MutationObserver || !observed || observed.has(container)) return;
      observed.add(container);
      new MutationObserver(function () { scheduleReapply(container, labelTemplate); }).observe(container, { childList: true, subtree: true });
    }

    // ── Yotpo bottomline, one product at a time (per-product endpoint, no bulk
    //    equivalent used anywhere in this codebase — see
    //    snippets/product-reviews-script.liquid's fetchSummary, the same call).
    //    Keyed on the Shopify product id, matching the PDP. ──
    function fetchRating(id, labelTemplate) {
      var appKey = (window.WhittardYotpo || {}).appKey;
      if (!appKey || !id) { RATING_CACHE[id] = null; return; }

      var url = 'https://api-cdn.yotpo.com/v1/widget/' + encodeURIComponent(appKey) +
        '/products/' + encodeURIComponent(id) + '/reviews.json?page=1&per_page=1';

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          var bottomline = (data && data.response && data.response.bottomline) || {};
          var total = Number(bottomline.total_review) || 0;
          var rating = total > 0 ? { score: Number(bottomline.average_score) || 0, total: total } : null;
          RATING_CACHE[id] = rating;
          if (rating) applyToId(id, rating, labelTemplate);
        })
        .catch(function () { RATING_CACHE[id] = null; });
    }

    function flush() {
      scheduled = false;
      if (!pendingIds.length) return;
      var entries = pendingIds;
      pendingIds = [];
      entries.forEach(function (e) { fetchRating(e.id, e.labelTemplate); });
    }

    function enqueue(id, labelTemplate) {
      if (Object.prototype.hasOwnProperty.call(QUEUED, id)) return; // already pending/resolved this session
      QUEUED[id] = true;
      pendingIds.push({ id: id, labelTemplate: labelTemplate });
      if (scheduled) return;
      scheduled = true;
      setTimeout(flush, 50); // short debounce — batches whatever entered the viewport together
    }

    function observeVisibility(container, labelTemplate) {
      if (!window.IntersectionObserver) {
        // No IO support — fall back to eager (still correct, just not lazy).
        container.querySelectorAll('[data-product-card][data-product-id]').forEach(function (card) {
          var id = card.getAttribute('data-product-id');
          if (id) enqueue(id, labelTemplate);
        });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          var id = entry.target.getAttribute('data-product-id');
          if (id) enqueue(id, labelTemplate);
        });
      }, { rootMargin: '200px 0px' });
      container.querySelectorAll('[data-product-card][data-product-id]').forEach(function (card) {
        if (card.querySelector('[data-product-rating].hidden')) io.observe(card);
      });
    }

    window.TagalysRatingHydration = {
      hydrate: function (products, gridEl, ratingLabelTemplate) {
        if (!gridEl) return;
        // The inner grid div is recreated on each Tagalys render; observe the
        // stable wrapper, same as collection-tagalys-badges.liquid.
        var container = (gridEl.closest && gridEl.closest('.tagalys-grid-init')) || gridEl;
        observeRebuilds(container, ratingLabelTemplate);
        reapply(container, ratingLabelTemplate); // instant re-apply of anything already cached
        observeVisibility(container, ratingLabelTemplate);
      }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["textarea"] && !Shopify.designMode) return;
  try {
    (function () {
    window.initFloatingFields = window.initFloatingFields || function (root) {
      (root || document).querySelectorAll('[data-float-field]').forEach(function (field) {
        if (field.__floatFieldReady) return;

        var input = field.querySelector('[data-float-input]');
        if (!input) return;

        field.__floatFieldReady = true;

        function sync() {
          field.classList.toggle('is-floated', document.activeElement === input || input.value.length > 0);
        }

        input.addEventListener('focus', sync);
        input.addEventListener('blur', sync);
        input.addEventListener('input', sync);

        sync();
      });
    };

    window.initFloatingFields();
  })();
  } catch(e) { console.error(e); }
})();

})();
